/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: DateString; output: DateString };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: DateTime; output: DateTime };
  /** HTML scalar */
  HTML: { input: string; output: string };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: JSON; output: JSON };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: JSONObject; output: JSONObject };
};

export enum ADDENDUM_SORT_FIELD {
  bidPackageName = 'bidPackageName',
  createdAt = 'createdAt',
  status = 'status',
}

export enum ADDENDUM_STATUS {
  approvalPending = 'approvalPending',
  approved = 'approved',
  draft = 'draft',
  objectivelyRecognized = 'objectivelyRecognized',
  rejected = 'rejected',
  withdrawn = 'withdrawn',
}

export enum ADMINS_SORT_FIELD {
  email = 'email',
  name = 'name',
}

export enum ADMIN_AI_EXPERIMENT_BOQ_PROCESSING_SCRIPT {
  linearizeAndReduceV1 = 'linearizeAndReduceV1',
  linearizeAndReduceV1NoHtml = 'linearizeAndReduceV1NoHtml',
}

export enum ADMIN_AI_PLAYGROUND_EXPERIMENT_SORT_FIELD {
  createdAt = 'createdAt',
  createdByName = 'createdByName',
  name = 'name',
  updatedAt = 'updatedAt',
}

export enum ADMIN_BID_PACKAGES_SORT_FIELD {
  biddersWithSubmittedBids = 'biddersWithSubmittedBids',
  bidsDueAt = 'bidsDueAt',
  marketplaceSuggestionsSent = 'marketplaceSuggestionsSent',
  name = 'name',
  projectName = 'projectName',
  publishedToMarketplaceAt = 'publishedToMarketplaceAt',
}

export enum ADMIN_BID_PACKAGE_BILL_OF_QUANTITIES_REVISIONS_SORT_FIELD {
  revision = 'revision',
}

export enum ADMIN_STATUS {
  active = 'active',
  inactive = 'inactive',
  inviteCanceled = 'inviteCanceled',
  inviteFailed = 'inviteFailed',
  invited = 'invited',
}

export enum ADMIN_SUBCONTRACTORS_IMPORT_REQUESTS_SORT_FIELD {
  createdAt = 'createdAt',
  status = 'status',
}

export enum ADMIN_SUBCONTRACTORS_SORT_FIELD {
  name = 'name',
}

export enum ADMIN_SUBCONTRACTOR_FILTER_TYPE {
  all = 'all',
  allExcludingLinked = 'allExcludingLinked',
  company = 'company',
  network = 'network',
  networkAndCompany = 'networkAndCompany',
}

export enum AGENT_COMPANY_ONBOARDING_ITEM_TYPE {
  addReferenceProject = 'addReferenceProject',
  completeCompanyProfile = 'completeCompanyProfile',
  createOwnRequest = 'createOwnRequest',
  discoverCosunoMarketplace = 'discoverCosunoMarketplace',
  inviteColleagues = 'inviteColleagues',
  respondToRequests = 'respondToRequests',
  saveSearch = 'saveSearch',
  specifyMainTrades = 'specifyMainTrades',
  uploadCertificates = 'uploadCertificates',
}

export type AbstractCompletableItem = {
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
};

export type AbstractContactSuggestionField = {
  changeType: CONTACT_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: CONTACT_SUGGESTION_FIELDS_FIELD_NAME;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<CONTACT_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AbstractEntity = {
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
};

export type AbstractMassDeterminationRow = {
  id: Scalars['ID']['output'];
  /** The unique, auto-increasing local ID of the row following the schema 1A0, 1B0, ...1Z0, 2A0... */
  localId: Scalars['String']['output'];
};

export type AbstractSubcontractorSuggestionField = {
  changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AddContactsToBidRequestResponse =
  | BidRequest
  | BidderAlreadyAddedError
  | BiddersLimitExceededError;

export type AddElementOperationDescriptor = {
  __typename: 'AddElementOperationDescriptor';
  index: Scalars['Int']['output'];
  isSchemaBased: Maybe<Scalars['Boolean']['output']>;
  newElementId: Scalars['String']['output'];
  newElementItemNumber: Maybe<Scalars['String']['output']>;
  newElementType: BOQ_ELEMENT_TYPE_DISCRIMINATOR;
  operation: BOQ_EDIT_OPERATION;
  operationId: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};

export type Addendum = AbstractEntity & {
  __typename: 'Addendum';
  bidPackage: BidPackage;
  billOfQuantities: BillOfQuantities;
  contractRefNumber: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  executionDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  remarks: Maybe<Scalars['String']['output']>;
  status: ADDENDUM_STATUS;
  totalGross: Scalars['Float']['output'];
};

export enum AddendumAuthActions {
  delete = 'delete',
  update = 'update',
  updateStatus = 'updateStatus',
  updateStatusApprove = 'updateStatusApprove',
  view = 'view',
}

export type AddendumAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type AddendumAuthInput = {
  action: AddendumAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AddendumAuthArgsInput>;
};

export type AddendumsResponse = {
  __typename: 'AddendumsResponse';
  addendums: Array<Addendum>;
  totalRecords: Scalars['Int']['output'];
};

export type Admin = AbstractEntity & {
  __typename: 'Admin';
  canAccessEmailLog: Scalars['Boolean']['output'];
  canEditCompanyRelationships: Scalars['Boolean']['output'];
  canImpersonateAllUsers: Scalars['Boolean']['output'];
  canImpersonateInternalUsers: Scalars['Boolean']['output'];
  canManageAdmins: Scalars['Boolean']['output'];
  canManageCertificateTypes: Scalars['Boolean']['output'];
  canManageCompanies: Scalars['Boolean']['output'];
  canManageCompanyFeatureFlags: Scalars['Boolean']['output'];
  canManageSubcontractors: Scalars['Boolean']['output'];
  canManageWorkCategories: Scalars['Boolean']['output'];
  canUseAiPlayground: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  status: ADMIN_STATUS;
};

export type AdminAdminPermissionsInput = {
  canAccessEmailLog: Scalars['Boolean']['input'];
  canEditCompanyRelationships: Scalars['Boolean']['input'];
  canImpersonateAllUsers: Scalars['Boolean']['input'];
  canImpersonateInternalUsers: Scalars['Boolean']['input'];
  canManageAdmins: Scalars['Boolean']['input'];
  canManageCertificateTypes: Scalars['Boolean']['input'];
  canManageCompanies: Scalars['Boolean']['input'];
  canManageCompanyFeatureFlags: Scalars['Boolean']['input'];
  canManageSubcontractors: Scalars['Boolean']['input'];
  canManageWorkCategories: Scalars['Boolean']['input'];
  canUseAiPlayground?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminAgentCompanyMergeResponse = {
  __typename: 'AdminAgentCompanyMergeResponse';
  relations: AdminAgentCompanyRelationsMergeResult;
};

export type AdminAgentCompanyRelationsMergeResult = {
  __typename: 'AdminAgentCompanyRelationsMergeResult';
  certificateTypes: AdminAgentCompanyRelationsSummary;
  certificates: AdminAgentCompanyRelationsSummary;
  claimedSubcontractors: AdminAgentCompanySubcontractorMergeResult;
  createdCompanies: AdminAgentCompanyRelationsSummary;
  users: AdminAgentCompanyUserRelationMergeResult;
};

export type AdminAgentCompanyRelationsSummary = {
  __typename: 'AdminAgentCompanyRelationsSummary';
  toDelete: Scalars['Int']['output'];
  toMerge: Scalars['Int']['output'];
  toTransfer: Scalars['Int']['output'];
};

export type AdminAgentCompanySubcontractorMergeResult = {
  __typename: 'AdminAgentCompanySubcontractorMergeResult';
  toDelete: Array<DeletedSubcontractor>;
  toMerge: Array<Subcontractor>;
  toTransfer: Array<Subcontractor>;
};

export type AdminAgentCompanyUserRelationMergeResult = {
  __typename: 'AdminAgentCompanyUserRelationMergeResult';
  toDelete: Array<DeletedUser>;
  toMerge: Array<User>;
  toTransfer: Array<User>;
};

export type AdminAiPlaygroundChat = {
  __typename: 'AdminAiPlaygroundChat';
  adminAiPlaygroundChatBoQs: Array<AdminAiPlaygroundChatBoQ>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  messages: Maybe<Array<Scalars['JSONObject']['output']>>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdminAiPlaygroundChatBoQ = {
  __typename: 'AdminAiPlaygroundChatBoQ';
  content: Scalars['JSON']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AdminAiPlaygroundExperiment = {
  __typename: 'AdminAiPlaygroundExperiment';
  boqProcessingScript: Maybe<ADMIN_AI_EXPERIMENT_BOQ_PROCESSING_SCRIPT>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdByName: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  structuredOutput: Maybe<Scalars['JSONObject']['output']>;
  systemInstructions: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdminAiPlaygroundExperimentsResponse = {
  __typename: 'AdminAiPlaygroundExperimentsResponse';
  experiments: Array<AdminAiPlaygroundExperiment>;
  totalRecords: Scalars['Int']['output'];
};

export type AdminAiPlaygroundModel = {
  __typename: 'AdminAiPlaygroundModel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum AdminAuthActions {
  cancelOrRestoreInvite = 'cancelOrRestoreInvite',
  deactivate = 'deactivate',
  invite = 'invite',
  reactivate = 'reactivate',
  update__permissions = 'update__permissions',
  update__personalInfo = 'update__personalInfo',
  view = 'view',
}

export type AdminAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type AdminAuthInput = {
  action: AdminAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AdminAuthArgsInput>;
};

export type AdminBillOfQuantitiesResponse = AbstractEntity & {
  __typename: 'AdminBillOfQuantitiesResponse';
  bid: Maybe<Bid>;
  bidPackage: Maybe<BidPackage>;
  changedElementIds: Maybe<Array<Scalars['String']['output']>>;
  changesToPrevious: Maybe<Array<BoQEditOperationDescriptor>>;
  comments: Array<BillOfQuantitiesComment>;
  content: Scalars['JSONObject']['output'];
  contentHash: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CURRENCY;
  editingStatus: Maybe<BOQ_EDITING_STATUS>;
  id: Scalars['ID']['output'];
  internalNotes: Array<BillOfQuantitiesInternalNote>;
  massDeterminationRowIdsNotToKeep: Array<Scalars['String']['output']>;
  originalFilename: Maybe<Scalars['String']['output']>;
  parentBoQId: Maybe<Scalars['String']['output']>;
  type: BOQ_TYPE;
  unsavedChanges: Maybe<Array<BoQEditOperationDescriptor>>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type AdminBillOfQuantitiesRevision = AbstractEntity & {
  __typename: 'AdminBillOfQuantitiesRevision';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  hasBids: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isShareableWithBidders: Scalars['Boolean']['output'];
  requestForProposalBoQ: Maybe<BillOfQuantities>;
  requestForProposalBoQId: Maybe<Scalars['ID']['output']>;
  revision: Scalars['Int']['output'];
  totalChangesToPrevious: Maybe<Scalars['Int']['output']>;
  totalUnsavedChanges: Maybe<Scalars['Int']['output']>;
  wereBiddersNotified: Maybe<Scalars['Boolean']['output']>;
};

export type AdminBillOfQuantitiesRevisionsResponse = {
  __typename: 'AdminBillOfQuantitiesRevisionsResponse';
  billOfQuantitiesRevisions: Array<AdminBillOfQuantitiesRevision>;
  totalRecords: Scalars['Int']['output'];
};

export type AdminCertificateTypesResponse = {
  __typename: 'AdminCertificateTypesResponse';
  certificateTypes: Array<CertificateType>;
  totalRecords: Scalars['Int']['output'];
};

export type AdminCompanyConfigInput = {
  additionalLanguages: Array<LANGUAGE>;
  fullUserLicenseCount?: InputMaybe<Scalars['Int']['input']>;
  guestLicenseCount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  increasedSecurityFeaturesEnabled: Scalars['Boolean']['input'];
  passwordPolicy?: InputMaybe<AdminCompanyPasswordPolicyInput>;
  premiumEnabled: Scalars['Boolean']['input'];
};

export type AdminCompanyFeatureFlagsInput = {
  enabled: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type AdminCompanyPasswordPolicyInput = {
  minLength?: InputMaybe<Scalars['Int']['input']>;
  requiresLowerCaseCharacter?: InputMaybe<Scalars['Boolean']['input']>;
  requiresNumber?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSpecialCharacter?: InputMaybe<Scalars['Boolean']['input']>;
  requiresUpperCaseCharacter?: InputMaybe<Scalars['Boolean']['input']>;
  resetIntervalInDays?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminCompanySubcontractorsResponse = {
  __typename: 'AdminCompanySubcontractorsResponse';
  subcontractors: Array<Subcontractor>;
  totalRecords: Scalars['Int']['output'];
};

export type AdminEmailTemplatesResponse = {
  __typename: 'AdminEmailTemplatesResponse';
  templates: Array<TemplateData>;
  templatesGroupName: EMAIL_TEMPLATES;
};

export type AdminInvitationResponse = {
  __typename: 'AdminInvitationResponse';
  invitee: Admin;
};

export type AdminInviteAdminInput = {
  canAccessEmailLog: Scalars['Boolean']['input'];
  canEditCompanyRelationships: Scalars['Boolean']['input'];
  canImpersonateAllUsers: Scalars['Boolean']['input'];
  canImpersonateInternalUsers: Scalars['Boolean']['input'];
  canManageAdmins: Scalars['Boolean']['input'];
  canManageCertificateTypes: Scalars['Boolean']['input'];
  canManageCompanies: Scalars['Boolean']['input'];
  canManageCompanyFeatureFlags: Scalars['Boolean']['input'];
  canManageSubcontractors: Scalars['Boolean']['input'];
  canManageWorkCategories: Scalars['Boolean']['input'];
  canUseAiPlayground?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
};

export type AdminInviteeInput = {
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AdminSubcontractorContactRelationMergeResult = {
  __typename: 'AdminSubcontractorContactRelationMergeResult';
  toDelete: Array<DeletedContact>;
  toMerge: Array<Contact>;
  toTransfer: Array<Contact>;
};

export type AdminSubcontractorEntityMergeResponse = {
  __typename: 'AdminSubcontractorEntityMergeResponse';
  aboutUs: Maybe<StringDiff>;
  agentCompanyId: Maybe<StringDiff>;
  city: Maybe<StringDiff>;
  companySize: Maybe<CompanySizeDiff>;
  countryCode: Maybe<CountryCodeDiff>;
  description: Maybe<StringDiff>;
  externalId: Maybe<StringDiff>;
  externalSource: Maybe<StringDiff>;
  foundingYear: Maybe<NumberDiff>;
  hasSustainableConstruction: Maybe<BooleanDiff>;
  imageKeys: Maybe<StringListDiff>;
  logoKey: Maybe<StringDiff>;
  modificationToken: Maybe<StringDiff>;
  moreInfo: Maybe<StringDiff>;
  nationalId: Maybe<StringDiff>;
  orderAreaCountryCode: Maybe<CountryCodeDiff>;
  orderAreaStateCodes: Maybe<StringListDiff>;
  orderAreaType: Maybe<OrderAreaTypeDiff>;
  orderRadius: Maybe<OrderRadiusDiff>;
  ownerName: Maybe<StringDiff>;
  postalCode: Maybe<StringDiff>;
  pqNumber: Maybe<StringDiff>;
  registrationCity: Maybe<StringDiff>;
  registrationPostalCode: Maybe<StringDiff>;
  revenueYear: Maybe<IntDiff>;
  street: Maybe<StringDiff>;
  sustainableConstructionDetails: Maybe<StringListDiff>;
  taxId: Maybe<StringDiff>;
  website: Maybe<StringDiff>;
  yearlyRevenue: Maybe<NumberDiff>;
};

export type AdminSubcontractorMergeResponse = {
  __typename: 'AdminSubcontractorMergeResponse';
  entity: AdminSubcontractorEntityMergeResponse;
  relations: AdminSubcontractorRelationsMergeResult;
};

export type AdminSubcontractorRelationsMergeResult = {
  __typename: 'AdminSubcontractorRelationsMergeResult';
  bidRequests: AdminSubcontractorRelationsSummary;
  certificates: AdminSubcontractorRelationsSummary;
  contacts: AdminSubcontractorContactRelationMergeResult;
  documentDownloads: AdminSubcontractorRelationsSummary;
  notes: AdminSubcontractorRelationsSummary;
  preferences: AdminSubcontractorRelationsSummary;
  subcontractorReferenceProjects: AdminSubcontractorRelationsSummary;
  workCategories: AdminSubcontractorWorkCategoryRelationMergeResult;
};

export type AdminSubcontractorRelationsSummary = {
  __typename: 'AdminSubcontractorRelationsSummary';
  toDelete: Scalars['Int']['output'];
  toMerge: Scalars['Int']['output'];
  toTransfer: Scalars['Int']['output'];
};

export type AdminSubcontractorWorkCategoryRelationMergeResult = {
  __typename: 'AdminSubcontractorWorkCategoryRelationMergeResult';
  toDelete: Array<DeletedWorkCategory>;
  toMerge: Array<WorkCategory>;
  toTransfer: Array<WorkCategory>;
};

export type AdminSubcontractorsImportRequestsResponse = {
  __typename: 'AdminSubcontractorsImportRequestsResponse';
  subcontractorImportRequests: Array<SubcontractorImportRequest>;
  totalRecords: Scalars['Int']['output'];
};

export type AdminSubcontractorsResponse = {
  __typename: 'AdminSubcontractorsResponse';
  subcontractors: Array<Subcontractor>;
  totalRecords: Scalars['Int']['output'];
  totalRecordsWithFailedEmails: Scalars['Int']['output'];
  totalRecordsWithUnconfirmedChanges: Scalars['Int']['output'];
};

export type AdminUpdateCompanyInput = {
  agentPricingTier?: InputMaybe<SUBCONTRACTOR_PRICING_TIER>;
  config: AdminCompanyConfigInput;
  hasOverdueInvoice: Scalars['Boolean']['input'];
  isTestCompany: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  optOutFromAiTraining?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  salesforceServiceId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateMeInput = {
  email: Scalars['String']['input'];
};

export type AdminUpdateUserDepartmentInput = {
  customDepartmentName?: InputMaybe<Scalars['String']['input']>;
  departmentType: DEPARTMENT_TYPE;
};

export type AdminUpdateUserEmailInput = {
  email: Scalars['String']['input'];
};

export type AdminUserPermissionConstraints = {
  __typename: 'AdminUserPermissionConstraints';
  key: Scalars['String']['output'];
};

export type AdminUserPermissionResponse = {
  __typename: 'AdminUserPermissionResponse';
  action: Array<Scalars['String']['output']>;
  constraints: Maybe<AdminUserPermissionConstraints>;
  subject: Scalars['String']['output'];
};

export type AdminUsersResponse = {
  __typename: 'AdminUsersResponse';
  totalRecords: Scalars['Int']['output'];
  users: Array<UserWithConnectedUsers>;
};

export type AdminsResponse = {
  __typename: 'AdminsResponse';
  admins: Array<Admin>;
  totalRecords: Scalars['Int']['output'];
};

export type AgentCompanyOnboardAddReferenceProject = AbstractCompletableItem & {
  __typename: 'AgentCompanyOnboardAddReferenceProject';
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
};

export type AgentCompanyOnboardCompleteCompanyProfile = AbstractCompletableItem & {
  __typename: 'AgentCompanyOnboardCompleteCompanyProfile';
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  projectsWithInvitesCount: Scalars['Float']['output'];
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
};

export type AgentCompanyOnboardCreateOwnRequest = AbstractCompletableItem & {
  __typename: 'AgentCompanyOnboardCreateOwnRequest';
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
};

export type AgentCompanyOnboardDiscoverCosunoMarketplace = AbstractCompletableItem & {
  __typename: 'AgentCompanyOnboardDiscoverCosunoMarketplace';
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  projectsInMarketplaceCount: Scalars['Float']['output'];
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
};

export type AgentCompanyOnboardIncompleteItem =
  | AgentCompanyOnboardAddReferenceProject
  | AgentCompanyOnboardCompleteCompanyProfile
  | AgentCompanyOnboardCreateOwnRequest
  | AgentCompanyOnboardDiscoverCosunoMarketplace
  | AgentCompanyOnboardInviteColleagues
  | AgentCompanyOnboardRespondToRequests
  | AgentCompanyOnboardSaveSearch
  | AgentCompanyOnboardSpecifyMainTrades
  | AgentCompanyOnboardUploadCertificates;

export type AgentCompanyOnboardInviteColleagues = AbstractCompletableItem & {
  __typename: 'AgentCompanyOnboardInviteColleagues';
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
};

export type AgentCompanyOnboardRespondToRequests = AbstractCompletableItem & {
  __typename: 'AgentCompanyOnboardRespondToRequests';
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
  unansweredRequests: Scalars['Float']['output'];
};

export type AgentCompanyOnboardSaveSearch = AbstractCompletableItem & {
  __typename: 'AgentCompanyOnboardSaveSearch';
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
};

export type AgentCompanyOnboardSpecifyMainTrades = AbstractCompletableItem & {
  __typename: 'AgentCompanyOnboardSpecifyMainTrades';
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
};

export type AgentCompanyOnboardUploadCertificates = AbstractCompletableItem & {
  __typename: 'AgentCompanyOnboardUploadCertificates';
  isCompletable: Scalars['Boolean']['output'];
  isComplete: Scalars['Boolean']['output'];
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
};

export type AgentCompanyProfilePrefillContact = {
  __typename: 'AgentCompanyProfilePrefillContact';
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  isPerson: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  mobilePhone: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  title: Maybe<CONTACT_TITLE>;
};

export type AgentCompanyProfilePrefillResponse = {
  __typename: 'AgentCompanyProfilePrefillResponse';
  aboutUs: Maybe<Scalars['HTML']['output']>;
  city: Maybe<Scalars['String']['output']>;
  companySize: Maybe<COMPANY_SIZE>;
  contacts: Array<AgentCompanyProfilePrefillContact>;
  countryCode: Maybe<COUNTRY_CODE>;
  imageKeys: Array<Scalars['String']['output']>;
  logoKey: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  orderAreaCountryCode: Maybe<COUNTRY_CODE>;
  orderAreaStateCodes: Maybe<Array<STATE_CODE>>;
  orderAreaType: Maybe<ORDER_AREA_TYPE>;
  orderRadius: Maybe<ORDER_RADIUS>;
  postalCode: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
  workCategories: Array<AgentCompanyProfilePrefillWorkCategory>;
};

export type AgentCompanyProfilePrefillWorkCategory = {
  __typename: 'AgentCompanyProfilePrefillWorkCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AgentCreatedBidRequestConfirmationEmailProps = {
  email: Scalars['String']['input'];
  intro: Scalars['String']['input'];
};

export type AgentSignupForAwardedBidInput = {
  awardedBidId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: LANGUAGE;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  verificationCodeIfPrincipalAccount?: InputMaybe<Scalars['String']['input']>;
};

export type AgentSignupForBidInviteInput = {
  bidInviteId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: LANGUAGE;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  verificationCodeIfPrincipalAccount?: InputMaybe<Scalars['String']['input']>;
};

export type AgentSignupForBidSubmissionInput = {
  bidRequestId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: LANGUAGE;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  verificationCodeIfPrincipalAccount?: InputMaybe<Scalars['String']['input']>;
};

export type AgentSignupForCertificatesSubmissionInput = {
  certificateRequestId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: LANGUAGE;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  verificationCodeIfPrincipalAccount?: InputMaybe<Scalars['String']['input']>;
};

export type AgentSignupForMarketplaceSuggestionInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: LANGUAGE;
  lastName: Scalars['String']['input'];
  marketplaceSuggestionId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  verificationCodeIfPrincipalAccount?: InputMaybe<Scalars['String']['input']>;
};

export type AgentSignupForSubcontractorSentEmailInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  language: LANGUAGE;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  sentEmailId: Scalars['ID']['input'];
  verificationCodeIfPrincipalAccount?: InputMaybe<Scalars['String']['input']>;
};

export type AgentSignupResponse = {
  __typename: 'AgentSignupResponse';
  company: Company;
  subcontractorName: Scalars['String']['output'];
};

export type AgentSignupUnsolicitedInput = {
  agentPricingTier?: InputMaybe<SUBCONTRACTOR_PRICING_TIER>;
  billingFrequency?: InputMaybe<BILLING_FREQUENCY>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isPremium?: Scalars['Boolean']['input'];
  language: LANGUAGE;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  subcontractorId?: InputMaybe<Scalars['String']['input']>;
  subcontractorName?: InputMaybe<Scalars['String']['input']>;
};

export type AlternativePositionSelection = {
  alternativeGroupId: Scalars['Int']['input'];
  billOfQuantitiesId: Scalars['String']['input'];
  positionId: Scalars['String']['input'];
};

export type AnalyticsEvent = AbstractEntity & {
  __typename: 'AnalyticsEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  deviceId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  props: Scalars['JSONObject']['output'];
};

export type AnalyticsEventInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  props: Scalars['JSONObject']['input'];
};

export type AnyNotification =
  | AwardBidderReminderNotification
  | BidPackageExportBidsNotification
  | BidPackageStatusChangedNotification
  | BidRequestDeclinedNotification
  | BiddersAwaitingResponseNotification
  | BiddingPeriodEndingNotification
  | CertificateExpiringNotification
  | CertificateExpiringSubcontractorNotification
  | CertificateNotProvidedInTimeNotification
  | CertificateUploadedBySubcontractorNotification
  | ContractAgentSignatureRequestedNotification
  | ContractMultiSigningCompletedNotification
  | ContractPrincipalSignatureRequestedNotification
  | ContractSignedByAgentNotification
  | InvoiceAwaitingApprovalNotification
  | InvoiceRejectedNotification
  | NewBidNotification
  | NewMessageNotification
  | ProjectExportCompleteNotification
  | SubcontractorImportRequestCompletedNotification
  | TaskAssignedNotification
  | TaskCompletedNotification
  | UserApprovalPendingNotification;

export type AttachableInput = {
  attachableId: Scalars['ID']['input'];
  attachableType: DOCUMENT_ENTITY;
};

export type AuthenticatorData = {
  __typename: 'AuthenticatorData';
  secret: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type AuthorizeInput = {
  Addendum?: InputMaybe<AddendumAuthInput>;
  Admin?: InputMaybe<AdminAuthInput>;
  Bid?: InputMaybe<BidAuthInput>;
  BidInvite?: InputMaybe<BidInviteAuthInput>;
  BidPackage?: InputMaybe<BidPackageAuthInput>;
  BidRequest?: InputMaybe<BidRequestAuthInput>;
  BillOfQuantities?: InputMaybe<BillOfQuantitiesAuthInput>;
  Certificate?: InputMaybe<CertificateAuthInput>;
  CertificateType?: InputMaybe<CertificateTypeAuthInput>;
  CertificateTypeTranslation?: InputMaybe<CertificateTypeTranslationAuthInput>;
  Company?: InputMaybe<CompanyAuthInput>;
  CompanySubcontractorsImport?: InputMaybe<CompanySubcontractorsImportAuthInput>;
  CompanyTemplate?: InputMaybe<CompanyTemplateAuthInput>;
  Contact?: InputMaybe<ContactAuthInput>;
  CustomCostGroupCatalog?: InputMaybe<CustomCostGroupCatalogAuthInput>;
  ExternalCredential?: InputMaybe<ExternalCredentialAuthInput>;
  Invoice?: InputMaybe<InvoiceAuthInput>;
  MarketplaceSuggestion?: InputMaybe<MarketplaceSuggestionAuthInput>;
  Office?: InputMaybe<OfficeAuthInput>;
  Project?: InputMaybe<ProjectAuthInput>;
  SentEmail?: InputMaybe<SentEmailAuthInput>;
  Signup?: InputMaybe<SignupAuthInput>;
  Subcontractor?: InputMaybe<SubcontractorAuthInput>;
  SubcontractorNote?: InputMaybe<SubcontractorNoteAuthInput>;
  Task?: InputMaybe<TaskAuthInput>;
  TaskNote?: InputMaybe<TaskNoteAuthInput>;
  User?: InputMaybe<UserAuthInput>;
  WorkCategory?: InputMaybe<WorkCategoryAuthInput>;
  WorkCategoryTranslation?: InputMaybe<WorkCategoryTranslationAuthInput>;
};

export type AwardBidRequestInput = {
  absoluteDiscount?: InputMaybe<Scalars['Float']['input']>;
  absoluteDiscountCalculated: Scalars['Float']['input'];
  additionalCosts: Scalars['Float']['input'];
  awardedSumType?: InputMaybe<BID_AWARDED_SUM_TYPE>;
  awarding: EmailTemplateNotificationInput;
  bidId: Scalars['ID']['input'];
  bidRequestId: Scalars['ID']['input'];
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  discountRateCalculated: Scalars['Float']['input'];
  mainOrderNumber?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  rejection: EmailTemplateNotificationInput;
  skontoDeadline: Scalars['Int']['input'];
  skontoRate: Scalars['Float']['input'];
  taxRate: Scalars['Float']['input'];
  taxValue: Scalars['Float']['input'];
  totalGross: Scalars['Float']['input'];
  totalGrossWithSkonto: Scalars['Float']['input'];
  totalNet: Scalars['Float']['input'];
  totalNetWithDiscount: Scalars['Float']['input'];
};

export type AwardBidderReminderNotification = AbstractEntity &
  Notification & {
    __typename: 'AwardBidderReminderNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: AwardBidderReminderNotificationProps;
  };

export type AwardBidderReminderNotificationProps = {
  __typename: 'AwardBidderReminderNotificationProps';
  bidPackageBidsDueWeeksAgo: Scalars['Int']['output'];
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type AwardedBid = AbstractEntity & {
  __typename: 'AwardedBid';
  absoluteDiscount: Maybe<Scalars['Float']['output']>;
  additionalCosts: Scalars['Float']['output'];
  awardedAt: Scalars['DateTimeISO']['output'];
  awardedSumType: Maybe<BID_AWARDED_SUM_TYPE>;
  bidRequest: BidRequest;
  billOfQuantities: Maybe<BillOfQuantities>;
  billOfQuantitiesRevision: BillOfQuantitiesRevision;
  billOfQuantitiesRevisionId: Scalars['String']['output'];
  boqEditingStatus: Maybe<BOQ_EDITING_STATUS>;
  createdAt: Scalars['DateTimeISO']['output'];
  discountRate: Maybe<Scalars['Float']['output']>;
  documentsCount: Scalars['Int']['output'];
  hasBoQ: Scalars['Boolean']['output'];
  hasHiddenTotalNet: Scalars['Boolean']['output'];
  hasOutdatedBoQ: Maybe<REASON_PROPOSAL_BOQ_IS_OUTDATED>;
  id: Scalars['ID']['output'];
  internalNote: Maybe<Scalars['String']['output']>;
  isEligibleForAwarding: Scalars['Boolean']['output'];
  isOutdatedBlindTenderBid: Scalars['Boolean']['output'];
  isSimulated: Maybe<Scalars['Boolean']['output']>;
  mainOrderNumber: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  parentBid: Maybe<Bid>;
  skontoDeadline: Scalars['Int']['output'];
  skontoRate: Scalars['Float']['output'];
  status: BID_STATUS;
  submittedAt: Maybe<Scalars['DateTimeISO']['output']>;
  submittedByUser: Maybe<User>;
  taxRate: Scalars['Float']['output'];
  taxValue: Scalars['Float']['output'];
  totalGross: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
  updatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  version: Maybe<Scalars['Int']['output']>;
  warningMetrics: BidWarningMetrics;
};

export type AwardedBidsForAgentResponse = {
  __typename: 'AwardedBidsForAgentResponse';
  bids: Array<AwardedBid>;
  totalRecords: Scalars['Int']['output'];
};

export enum BIDDER_STATUS {
  new = 'new',
  pending = 'pending',
  responsive = 'responsive',
  unresponsive = 'unresponsive',
}

export enum BIDS_SORT_FIELD {
  awardedAt = 'awardedAt',
  bidPackageName = 'bidPackageName',
  bidPackageStatus = 'bidPackageStatus',
  officeName = 'officeName',
  projectName = 'projectName',
  submittedAt = 'submittedAt',
}

export enum BID_AWARDED_SUM_TYPE {
  lumpSum = 'lumpSum',
  unitPricesFromBoQ = 'unitPricesFromBoQ',
}

export enum BID_INVITE_REMINDER_SCHEDULE {
  everyTwoWeeks = 'everyTwoWeeks',
  none = 'none',
  oneDayBeforeDue = 'oneDayBeforeDue',
  oneWeekBeforeDue = 'oneWeekBeforeDue',
  threeDaysBeforeDue = 'threeDaysBeforeDue',
  twoWeeksBeforeDue = 'twoWeeksBeforeDue',
  weekly = 'weekly',
}

export enum BID_INVITE_STATUS {
  draft = 'draft',
  failed = 'failed',
  opened = 'opened',
  sent = 'sent',
  viewed = 'viewed',
}

export enum BID_INVITE_STATUS_CHANGE_STATUS {
  draft = 'draft',
  failed = 'failed',
  opened = 'opened',
  restored = 'restored',
  sent = 'sent',
  viewed = 'viewed',
  withdrawn = 'withdrawn',
}

export enum BID_PACKAGES_MARKETPLACE_SORT_FIELD {
  bidsDueAt = 'bidsDueAt',
  distance = 'distance',
  name = 'name',
  projectName = 'projectName',
  publishedToMarketplaceAt = 'publishedToMarketplaceAt',
  recommended = 'recommended',
}

export enum BID_PACKAGES_SORT_FIELD {
  addendaTotalGross = 'addendaTotalGross',
  addendaTotalNet = 'addendaTotalNet',
  awardedBidAndAddendaTotalNet = 'awardedBidAndAddendaTotalNet',
  awardedBidTotalGross = 'awardedBidTotalGross',
  awardedBidTotalNet = 'awardedBidTotalNet',
  bidRequestsAwaitingResponseCount = 'bidRequestsAwaitingResponseCount',
  bidsDueAt = 'bidsDueAt',
  budget = 'budget',
  name = 'name',
  number = 'number',
  projectName = 'projectName',
  status = 'status',
}

export enum BID_PACKAGE_STATUS {
  bidAwarded = 'bidAwarded',
  closed = 'closed',
  contractSigning = 'contractSigning',
  contracted = 'contracted',
  draft = 'draft',
  inNegotiation = 'inNegotiation',
  published = 'published',
}

export enum BID_REQUESTS_SORT_FIELD {
  bidDueAt = 'bidDueAt',
  bidPackageName = 'bidPackageName',
  bidRequestStatus = 'bidRequestStatus',
  bidRequestStatusForAgent = 'bidRequestStatusForAgent',
  companyName = 'companyName',
  distanceInKms = 'distanceInKms',
  lastStatusChangeAt = 'lastStatusChangeAt',
  officeName = 'officeName',
  projectName = 'projectName',
  projectNumber = 'projectNumber',
  subcontractorName = 'subcontractorName',
}

export enum BID_REQUEST_DECLINED_REASON {
  companyClosed = 'companyClosed',
  distanceTooLarge = 'distanceTooLarge',
  insufficientCapacity = 'insufficientCapacity',
  notOfferingThisService = 'notOfferingThisService',
  other = 'other',
}

export enum BID_REQUEST_SOURCE {
  invite = 'invite',
  marketplace = 'marketplace',
}

export enum BID_REQUEST_STATUS {
  accepted = 'accepted',
  bidAwarded = 'bidAwarded',
  bidRejected = 'bidRejected',
  bidSubmitted = 'bidSubmitted',
  inNegotiation = 'inNegotiation',
  inviteDeclined = 'inviteDeclined',
  invited = 'invited',
  opened = 'opened',
  pendingInvite = 'pendingInvite',
  undecided = 'undecided',
  viewed = 'viewed',
  watched = 'watched',
  withdrawn = 'withdrawn',
}

export enum BID_REQUEST_STATUS_CHANGED_BY {
  anonymousSubcontractor = 'anonymousSubcontractor',
  user = 'user',
}

export enum BID_REQUEST_STATUS_FOR_AGENT {
  accepted = 'accepted',
  bidAwarded = 'bidAwarded',
  bidLost = 'bidLost',
  bidSubmitted = 'bidSubmitted',
  closed = 'closed',
  contractSigning = 'contractSigning',
  contracted = 'contracted',
  declined = 'declined',
  pending = 'pending',
  undecided = 'undecided',
  watched = 'watched',
  withdrawn = 'withdrawn',
}

export enum BID_REQUEST_TYPE {
  createdByAgent = 'createdByAgent',
  createdByPrincipal = 'createdByPrincipal',
}

export enum BID_STATUS {
  awarded = 'awarded',
  draft = 'draft',
  generated = 'generated',
  submitted = 'submitted',
}

export enum BILLING_FREQUENCY {
  monthly = 'monthly',
  quarterly = 'quarterly',
  yearly = 'yearly',
}

export enum BOQ_COMPARISON_MODE {
  average = 'average',
  customBudget = 'customBudget',
  ideal = 'ideal',
  lowest = 'lowest',
  prediction = 'prediction',
}

export enum BOQ_CONTAINER_TYPE {
  bid = 'bid',
  bidPackage = 'bidPackage',
  boqTemplate = 'boqTemplate',
}

export enum BOQ_EDITING_STATUS {
  complete = 'complete',
  empty = 'empty',
  incomplete = 'incomplete',
}

export enum BOQ_EDIT_OPERATION {
  addElement = 'addElement',
  clearField = 'clearField',
  deleteElement = 'deleteElement',
  fillOutField = 'fillOutField',
  moveElement = 'moveElement',
  renumber = 'renumber',
  togglePositionType = 'togglePositionType',
  updateProjectInformation = 'updateProjectInformation',
}

export enum BOQ_ELEMENT_TYPE_DISCRIMINATOR {
  AdditionalText = 'AdditionalText',
  ExecutionDescriptionDto = 'ExecutionDescriptionDto',
  NoteTextDto = 'NoteTextDto',
  PositionDto = 'PositionDto',
  ServiceSpecificationGroupDto = 'ServiceSpecificationGroupDto',
  SubDescriptionDto = 'SubDescriptionDto',
}

export enum BOQ_EXCHANGE_PHASE {
  alternativeProposal = 'alternativeProposal',
  contract = 'contract',
  costEstimation = 'costEstimation',
  proposal = 'proposal',
  requestForProposal = 'requestForProposal',
}

export enum BOQ_FILE_FORMAT {
  gaeb90 = 'gaeb90',
  gaebXml = 'gaebXml',
  oenorm = 'oenorm',
  xlsx = 'xlsx',
}

export enum BOQ_FILE_TYPE {
  d11 = 'd11',
  d81 = 'd81',
  d82 = 'd82',
  d83 = 'd83',
  d84 = 'd84',
  d86 = 'd86',
  dta = 'dta',
  onlv = 'onlv',
  p81 = 'p81',
  p82 = 'p82',
  p83 = 'p83',
  p84 = 'p84',
  p86 = 'p86',
  x31 = 'x31',
  x31_33 = 'x31_33',
  x81 = 'x81',
  x81_33 = 'x81_33',
  x82 = 'x82',
  x82_33 = 'x82_33',
  x83 = 'x83',
  x83_33 = 'x83_33',
  x84 = 'x84',
  x84_33 = 'x84_33',
  x86 = 'x86',
  x86_33 = 'x86_33',
  xlsxProposal = 'xlsxProposal',
  xlsxRequestForProposals = 'xlsxRequestForProposals',
}

export enum BOQ_FILE_TYPE_DOWNLOADABLE_FOR_CONTRACT {
  d86 = 'd86',
  p86 = 'p86',
  pdf = 'pdf',
  x86 = 'x86',
  x86_33 = 'x86_33',
}

export enum BOQ_FORMAL_REVIEW_ERROR_REASON {
  additionalTextNotAtBeginningOrEnd = 'additionalTextNotAtBeginningOrEnd',
  currencyDoesntMatchProject = 'currencyDoesntMatchProject',
  currencyNotSupported = 'currencyNotSupported',
  executionDescriptionExist = 'executionDescriptionExist',
  executionDescriptionNotReferencedByAnyPosition = 'executionDescriptionNotReferencedByAnyPosition',
  executionDescriptionNoteWithoutLongText = 'executionDescriptionNoteWithoutLongText',
  executionDescriptionShortTextIsMissing = 'executionDescriptionShortTextIsMissing',
  groupShortTextMissing = 'groupShortTextMissing',
  itemNumberContainsUnderscores = 'itemNumberContainsUnderscores',
  itemNumberDigitsAmountGreaterThan9GAEB90 = 'itemNumberDigitsAmountGreaterThan9GAEB90',
  itemNumberDigitsAmountGreaterThan12OENORM = 'itemNumberDigitsAmountGreaterThan12OENORM',
  itemNumberDigitsAmountGreaterThan14GAEBXML = 'itemNumberDigitsAmountGreaterThan14GAEBXML',
  itemNumberMainFragmentNotPadded = 'itemNumberMainFragmentNotPadded',
  itemNumberMustBeInAscendingOrder = 'itemNumberMustBeInAscendingOrder',
  itemNumberOfGroupIsAlphanumeric = 'itemNumberOfGroupIsAlphanumeric',
  itemNumberOfGroupIsMissing = 'itemNumberOfGroupIsMissing',
  itemNumberOfPositionIsMissing = 'itemNumberOfPositionIsMissing',
  itemNumberOfPositionIsNotUnique = 'itemNumberOfPositionIsNotUnique',
  itemNumberShouldContainParentItemNumber = 'itemNumberShouldContainParentItemNumber',
  longTextHasImage = 'longTextHasImage',
  longTextMissing = 'longTextMissing',
  noteTextShouldBeFirstChildren = 'noteTextShouldBeFirstChildren',
  positionCostGroupReferenceMissing = 'positionCostGroupReferenceMissing',
  positionHasBidderInput = 'positionHasBidderInput',
  positionHasBidderInputInShortText = 'positionHasBidderInputInShortText',
  positionLongTextLongerThan999 = 'positionLongTextLongerThan999',
  positionLongTextMissing = 'positionLongTextMissing',
  positionQuantityDecimalPartLongerThan3 = 'positionQuantityDecimalPartLongerThan3',
  positionQuantityIntegerPartLongerThan8 = 'positionQuantityIntegerPartLongerThan8',
  positionQuantityMissing = 'positionQuantityMissing',
  positionTypesAlternativePositionWithoutBasePosition = 'positionTypesAlternativePositionWithoutBasePosition',
  positionTypesBasePositionWithoutAlternatives = 'positionTypesBasePositionWithoutAlternatives',
  positionTypesLumpSumQuantityCannotBeCombinedWithFreeQuantity = 'positionTypesLumpSumQuantityCannotBeCombinedWithFreeQuantity',
  positionTypesLumpSumQuantityShouldBeOne = 'positionTypesLumpSumQuantityShouldBeOne',
  positionTypesSurchargeHasDifferentTaxRate = 'positionTypesSurchargeHasDifferentTaxRate',
  positionUnitPriceDecimalPartLongerThan3 = 'positionUnitPriceDecimalPartLongerThan3',
  positionUnitPriceIntegerPartLongerThan10 = 'positionUnitPriceIntegerPartLongerThan10',
  positionUnitTagMissing = 'positionUnitTagMissing',
  positionUnitTagNotSupportedByOENORM = 'positionUnitTagNotSupportedByOENORM',
  priceComponentsCountMoreThanExpected = 'priceComponentsCountMoreThanExpected',
  repeatingDescriptionBeforeReferralDescription = 'repeatingDescriptionBeforeReferralDescription',
  repeatingDescriptionNotReferringExistingReferralDescription = 'repeatingDescriptionNotReferringExistingReferralDescription',
  repeatingDescriptionReferringAnotherRepeatingDescription = 'repeatingDescriptionReferringAnotherRepeatingDescription',
  schemaTierCountLessThan3ForOENORM = 'schemaTierCountLessThan3ForOENORM',
  schemaTierCountMoreThan4ForGaeb90 = 'schemaTierCountMoreThan4ForGaeb90',
  schemaTierCountMoreThan5ForGaebXML = 'schemaTierCountMoreThan5ForGaebXML',
  schemaTierCountMoreThan5ForOENORM = 'schemaTierCountMoreThan5ForOENORM',
  schemaTierLengthGreaterThan2OENORM = 'schemaTierLengthGreaterThan2OENORM',
  shortTextMissing = 'shortTextMissing',
  subDescriptionIdentifierNotCompliant = 'subDescriptionIdentifierNotCompliant',
  subDescriptionIdentifierNotInAscendingOrder = 'subDescriptionIdentifierNotInAscendingOrder',
}

export enum BOQ_FORMAL_REVIEW_ISSUE_LEVEL {
  error = 'error',
  warning = 'warning',
}

export enum BOQ_FORMAL_REVIEW_RESULT {
  errors = 'errors',
  noIssues = 'noIssues',
  warnings = 'warnings',
}

export enum BOQ_MASS_DETERMINATION_STATUS {
  appliedAsQuantity = 'appliedAsQuantity',
  savedAsPartOfBoq = 'savedAsPartOfBoq',
}

export enum BOQ_POSITION_TEXT_PROVIDER {
  boqLibrary = 'boqLibrary',
  freeText = 'freeText',
  heinzeAt = 'heinzeAt',
  heinzeVob = 'heinzeVob',
  lbHochbau = 'lbHochbau',
  stlb = 'stlb',
}

export enum BOQ_POSITION_TYPE {
  Alternative = 'Alternative',
  Base = 'Base',
  FreeQuantity = 'FreeQuantity',
  LumpSum = 'LumpSum',
  NotApplicable = 'NotApplicable',
  Optional = 'Optional',
  OptionalWithTotal = 'OptionalWithTotal',
  ReferringExecutionDescription = 'ReferringExecutionDescription',
  Regular = 'Regular',
  RepeatingDescription = 'RepeatingDescription',
  Surcharge = 'Surcharge',
  ToBeSurcharged = 'ToBeSurcharged',
  UnitPriceComponents = 'UnitPriceComponents',
}

export enum BOQ_TEMPLATES_SORT_FIELD {
  name = 'name',
  updatedAt = 'updatedAt',
}

export enum BOQ_TEMPLATE_COST_CATALOG_TYPE {
  custom = 'custom',
  din276 = 'din276',
  oenorm = 'oenorm',
  stlbWorkCategory = 'stlbWorkCategory',
}

export enum BOQ_TIER_DATA_TYPE {
  Alphanumeric = 'Alphanumeric',
  Numeric = 'Numeric',
}

export enum BOQ_TIER_TYPE {
  Group = 'Group',
  Index = 'Index',
  Lot = 'Lot',
  Position = 'Position',
}

export enum BOQ_TYPE {
  addendum = 'addendum',
  customBudget = 'customBudget',
  proposal = 'proposal',
  requestForProposal = 'requestForProposal',
  template = 'template',
}

export enum BOQ_VALIDATION_ERROR_REASON {
  duplicateItemNumber = 'duplicateItemNumber',
  elementRowDoesNotMatchRequestForProposals = 'elementRowDoesNotMatchRequestForProposals',
  elementRowsNotFound = 'elementRowsNotFound',
  itemNumberContainsInvalidCharacters = 'itemNumberContainsInvalidCharacters',
  mergedCells = 'mergedCells',
  notEmptyNorNonNegativeNumber = 'notEmptyNorNonNegativeNumber',
  notEmptyNorNumber = 'notEmptyNorNumber',
  notEmptyNorPercentage = 'notEmptyNorPercentage',
  unknownElementType = 'unknownElementType',
  unrecognizedPositionCostGroup = 'unrecognizedPositionCostGroup',
}

export enum BOQ_VALIDATION_WARNING_REASON {
  doesntExist = 'doesntExist',
  duplicateTextAdditionLabel = 'duplicateTextAdditionLabel',
  notFilledIn = 'notFilledIn',
  positionHasInvalidCostGroupAssigned = 'positionHasInvalidCostGroupAssigned',
  quantitiesDontMatch = 'quantitiesDontMatch',
  quantityMissing = 'quantityMissing',
  quantityNotFilledIn = 'quantityNotFilledIn',
  unknownElementType = 'unknownElementType',
}

export enum BP_PUBLICATION_BID_PACKAGE_DURATION_ISSUE {
  endDateMissing = 'endDateMissing',
  startDateMissing = 'startDateMissing',
}

export enum BP_PUBLICATION_BOQ_INCLUDED_ISSUE {
  hasErrors = 'hasErrors',
  missingSchema = 'missingSchema',
  notProvided = 'notProvided',
}

export enum BP_PUBLICATION_CONTACT_DETAILS_INCLUDED_ISSUE {
  noPhoneUserIsContact = 'noPhoneUserIsContact',
  noPhoneUserIsNotAContact = 'noPhoneUserIsNotAContact',
}

export enum BP_PUBLICATION_DESCRIPTIVE_TENDER_SETUP_ISSUE {
  descriptionSameAsProject = 'descriptionSameAsProject',
  nameAndDescriptionSameAsProject = 'nameAndDescriptionSameAsProject',
  nameSameAsProject = 'nameSameAsProject',
  nameSameAsProjectNoDescription = 'nameSameAsProjectNoDescription',
  shortDescription = 'shortDescription',
}

export enum BP_PUBLICATION_DOCUMENTS_INCLUDED_ISSUE {
  noneUploaded = 'noneUploaded',
}

export enum BP_PUBLICATION_ENABLE_MARKETPLACE {
  notPublishedOnMarketplace = 'notPublishedOnMarketplace',
}

export enum BP_PUBLICATION_OFFICE_DETAILS_INCLUDED_ISSUE {
  notProvided = 'notProvided',
}

export enum BP_PUBLICATION_REASONABLE_BID_DUE_DATE_ISSUE {
  tooSoon = 'tooSoon',
}

export enum BP_PUBLICATION_SUFFICIENT_NUMBER_OF_BIDDERS_ISSUE {
  insufficient = 'insufficient',
}

export enum BULK_ADD_CONTACTS_AMOUNT {
  x10 = 'x10',
  x25 = 'x25',
  x50 = 'x50',
}

export type BaseBiddersAwaitingResponseNotificationProps = {
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  subcontractorNames: Array<Scalars['String']['output']>;
};

export type Bid = AbstractEntity & {
  __typename: 'Bid';
  absoluteDiscount: Maybe<Scalars['Float']['output']>;
  additionalCosts: Maybe<Scalars['Float']['output']>;
  bidRequest: BidRequest;
  billOfQuantities: Maybe<BillOfQuantities>;
  billOfQuantitiesRevision: BillOfQuantitiesRevision;
  billOfQuantitiesRevisionId: Scalars['String']['output'];
  boqEditingStatus: Maybe<BOQ_EDITING_STATUS>;
  createdAt: Scalars['DateTimeISO']['output'];
  discountRate: Maybe<Scalars['Float']['output']>;
  documentsCount: Scalars['Int']['output'];
  hasBoQ: Scalars['Boolean']['output'];
  hasHiddenTotalNet: Scalars['Boolean']['output'];
  hasOutdatedBoQ: Maybe<REASON_PROPOSAL_BOQ_IS_OUTDATED>;
  id: Scalars['ID']['output'];
  internalNote: Maybe<Scalars['String']['output']>;
  isEligibleForAwarding: Scalars['Boolean']['output'];
  isOutdatedBlindTenderBid: Scalars['Boolean']['output'];
  isSimulated: Maybe<Scalars['Boolean']['output']>;
  message: Maybe<Scalars['String']['output']>;
  parentBid: Maybe<Bid>;
  skontoDeadline: Maybe<Scalars['Int']['output']>;
  skontoRate: Maybe<Scalars['Float']['output']>;
  status: BID_STATUS;
  submittedAt: Maybe<Scalars['DateTimeISO']['output']>;
  submittedByUser: Maybe<User>;
  taxRate: Maybe<Scalars['Float']['output']>;
  totalNet: Scalars['Float']['output'];
  updatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  version: Maybe<Scalars['Int']['output']>;
  warningMetrics: BidWarningMetrics;
};

export enum BidAuthActions {
  manageDocuments = 'manageDocuments',
  signContract = 'signContract',
  update = 'update',
  update__message = 'update__message',
  view = 'view',
}

export type BidAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type BidAuthInput = {
  action: BidAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BidAuthArgsInput>;
};

export type BidColumnConfig = {
  bidId?: InputMaybe<Scalars['ID']['input']>;
  bidRequestId: Scalars['ID']['input'];
};

export type BidColumnResponse = {
  __typename: 'BidColumnResponse';
  availableBids: Array<Bid>;
  bid: SubmittedOrGeneratedSubmittedBid;
  bidRequest: BidRequest;
  billOfQuantities: Maybe<BillOfQuantities>;
  subcontractor: Subcontractor;
};

export type BidInput = {
  absoluteDiscount?: InputMaybe<Scalars['Float']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  skontoDeadline?: InputMaybe<Scalars['Int']['input']>;
  skontoRate?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  totalNet?: InputMaybe<Scalars['Float']['input']>;
};

export type BidInvite = AbstractEntity & {
  __typename: 'BidInvite';
  bidRequest: BidRequest;
  contact: Contact;
  createdAt: Scalars['DateTimeISO']['output'];
  customInvitationEmailIntro: Maybe<Scalars['HTML']['output']>;
  id: Scalars['ID']['output'];
  status: BID_INVITE_STATUS;
};

export enum BidInviteAuthActions {
  delete = 'delete',
  view = 'view',
  withdraw = 'withdraw',
}

export type BidInviteAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type BidInviteAuthInput = {
  action: BidInviteAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BidInviteAuthArgsInput>;
};

export type BidInviteCountSuggestion = {
  __typename: 'BidInviteCountSuggestion';
  averageSubmissionRateForSimilarBidPackages: Scalars['Float']['output'];
  confidence: Scalars['Float']['output'];
  configuration: BidInviteCountSuggestionConfiguration;
  similarBidPackages: Array<SimilarBidPackageDetails>;
  suggestedCount: Scalars['Float']['output'];
};

export type BidInviteCountSuggestionConfiguration = {
  __typename: 'BidInviteCountSuggestionConfiguration';
  fullConfidenceThreshold: Scalars['Int']['output'];
  minDesiredNumberOfBidRequests: Scalars['Int']['output'];
  minNumNonMarketplaceBidRequests: Scalars['Int']['output'];
  minSimilarityScore: Scalars['Float']['output'];
  searchRadiusInKm: Scalars['Int']['output'];
  weights: BidInviteCountSuggestionConfigurationWeights;
};

export type BidInviteCountSuggestionConfigurationInput = {
  fullConfidenceThreshold: Scalars['Int']['input'];
  minDesiredNumberOfBidRequests: Scalars['Int']['input'];
  minNumNonMarketplaceBidRequests: Scalars['Int']['input'];
  minSimilarityScore: Scalars['Float']['input'];
  searchRadiusInKm: Scalars['Int']['input'];
  weights: BidInviteCountSuggestionConfigurationWeightsInput;
};

export type BidInviteCountSuggestionConfigurationWeights = {
  __typename: 'BidInviteCountSuggestionConfigurationWeights';
  bidsDueAt: Scalars['Float']['output'];
  projectLocation: Scalars['Float']['output'];
  workCategory: Scalars['Float']['output'];
};

export type BidInviteCountSuggestionConfigurationWeightsInput = {
  bidsDueAt: Scalars['Float']['input'];
  projectLocation: Scalars['Float']['input'];
  workCategory: Scalars['Float']['input'];
};

export type BidInviteStatusChangeResponse = {
  __typename: 'BidInviteStatusChangeResponse';
  bidInviteStatus: BID_INVITE_STATUS_CHANGE_STATUS;
  contact: Contact;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTimeISO']['output'];
  userName: Maybe<Scalars['String']['output']>;
};

export type BidPackage = AbstractEntity & {
  __typename: 'BidPackage';
  addedContactIds: Array<Scalars['ID']['output']>;
  addendaTotalGross: Maybe<Scalars['Float']['output']>;
  addendaTotalNet: Maybe<Scalars['Float']['output']>;
  addendumNumbers: Array<Scalars['Int']['output']>;
  agentBidRequest: Maybe<BidRequest>;
  allCorrespondingWorkCategories: Array<WorkCategory>;
  allowBiddersDownloadBoQPdf: Scalars['Boolean']['output'];
  allowBidsAfterDueDate: Scalars['Boolean']['output'];
  awardedBid: Maybe<AwardedBid>;
  awardedBidRequestId: Maybe<Scalars['ID']['output']>;
  awardedBidTotalGross: Maybe<Scalars['Float']['output']>;
  awardedBidTotalNet: Maybe<Scalars['Float']['output']>;
  awardingDate: Maybe<Scalars['Date']['output']>;
  bidColumnsForPriceComparison: Array<BidColumnResponse>;
  bidInviteReminderScheduleForAccepted: BID_INVITE_REMINDER_SCHEDULE;
  bidInviteReminderScheduleForNoResponse: BID_INVITE_REMINDER_SCHEDULE;
  bidPackageUsers: Array<BidPackageUser>;
  bidRequests: Array<BidRequest>;
  bidRequestsAwaitingResponseCount: Scalars['Int']['output'];
  bidRequestsNotNotifiedOfRejection: Array<Scalars['ID']['output']>;
  bidRequestsToNotifyOfClosingCount: Scalars['Int']['output'];
  /** @deprecated No longer used */
  bidRequestsToNotifyOfDeletionCount: Scalars['Int']['output'];
  biddersWithBidsCount: Scalars['Int']['output'];
  bidsDueAt: Scalars['DateTimeISO']['output'];
  billOfQuantities: Maybe<BillOfQuantities>;
  billOfQuantitiesId: Maybe<Scalars['ID']['output']>;
  billOfQuantitiesRevision: Maybe<BillOfQuantitiesRevision>;
  billOfQuantitiesRevisions: Array<BillOfQuantitiesRevision>;
  bindingPeriod: Maybe<Scalars['Date']['output']>;
  blindTenderBidsOpenedAt: Maybe<Scalars['DateTimeISO']['output']>;
  boqPositionTextProvider: BOQ_POSITION_TEXT_PROVIDER;
  budget: Maybe<Scalars['Float']['output']>;
  contactPersons: Array<BidPackageUser>;
  contractAgentAssignee: Maybe<ContractAgentAssignee>;
  contractAssignee: Maybe<ContractAssignee>;
  contractDocumentsRequiringSignature: Array<Scalars['ID']['output']>;
  contractDocumentsRequiringSignatureTotalSize: Scalars['Float']['output'];
  contractRunAgentStepContacts: Array<Contact>;
  contractRunStepUsers: Array<User>;
  contractValueWithPredictionPercentage: Maybe<BidPackageContractValue>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CURRENCY;
  customBudgetBoQ: Maybe<BillOfQuantities>;
  customInvitationEmailIntro: Maybe<Scalars['HTML']['output']>;
  description: Maybe<Scalars['String']['output']>;
  detachedProposalBillOfQuantities: Maybe<BillOfQuantities>;
  distanceInKm: Maybe<Scalars['Float']['output']>;
  documentCount: Scalars['Int']['output'];
  endsOn: Maybe<Scalars['Date']['output']>;
  hasAttachedDocuments: Scalars['Boolean']['output'];
  hasBidders: Scalars['Boolean']['output'];
  hasBiddersFromCosunoNetwork: Scalars['Boolean']['output'];
  hasBiddersWithSubmittedBids: Scalars['Boolean']['output'];
  hasBillOfQuantitiesSchema: Scalars['Boolean']['output'];
  hasContractDocuments: Scalars['Boolean']['output'];
  hasContractDocumentsRequiringSignature: Scalars['Boolean']['output'];
  hasContractDocumentsRequiringSignatureToggling: Scalars['Boolean']['output'];
  hasOutdatedContractBoQ: Scalars['Boolean']['output'];
  hasUnsavedBillOfQuantitiesChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invitedBiddersCount: Scalars['Int']['output'];
  isBlindTender: Scalars['Boolean']['output'];
  isContractSignedByAgent: Scalars['Boolean']['output'];
  isContractSignedByPrincipal: Scalars['Boolean']['output'];
  isContractSignedDocumentPending: Scalars['Boolean']['output'];
  isContractSignedPerUpload: Scalars['Boolean']['output'];
  isContractSigningEnabled: Scalars['Boolean']['output'];
  isDocuSignEnvelopeReset: Scalars['Boolean']['output'];
  isDocuSignOpened: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isLockedDueToPendingRequest: Scalars['Boolean']['output'];
  isPublishedOnMarketplace: Scalars['Boolean']['output'];
  isVisibleOnMarketplace: Scalars['Boolean']['output'];
  lastInvoice: Maybe<Invoice>;
  lat: Maybe<Scalars['Float']['output']>;
  long: Maybe<Scalars['Float']['output']>;
  marketplaceSuggestionsSent: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  networkAwaitingResponseCountIfRestricted: Maybe<Scalars['Int']['output']>;
  networkSubcontractorBidRequestsCount: Scalars['Int']['output'];
  notes: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  openingDate: Maybe<Scalars['DateTimeISO']['output']>;
  partialInvoices: Array<PartialInvoice>;
  primaryContactPerson: Maybe<PrimaryContactPersonResponse>;
  primaryContactUser: Maybe<User>;
  primaryUser: Maybe<User>;
  project: Project;
  projectId: Scalars['ID']['output'];
  publishedAt: Maybe<Scalars['DateTimeISO']['output']>;
  publishedToMarketplaceAt: Maybe<Scalars['DateTimeISO']['output']>;
  queryMatchesBoQ: Maybe<Scalars['Boolean']['output']>;
  reasonForClosing: Maybe<Scalars['String']['output']>;
  requestStatusCounts: BidRequestStatusCounts;
  slug: Scalars['String']['output'];
  startsOn: Maybe<Scalars['Date']['output']>;
  status: BID_PACKAGE_STATUS;
  submittableBidRequests: Array<BidRequest>;
  suggestedBidInviteCount: Maybe<Scalars['Int']['output']>;
  suggestedBidInviteCountBreakdown: Maybe<BidInviteCountSuggestion>;
  suggestedBiddersCount: Scalars['Int']['output'];
  unreadMessageThreadsCount: Maybe<Scalars['Int']['output']>;
  unsavedBillOfQuantitiesAddedElementsIds: Array<Scalars['String']['output']>;
  withdrawnContactIds: Array<Scalars['ID']['output']>;
  workCategories: Array<WorkCategory>;
};

export type BidPackagebidColumnsForPriceComparisonArgs = {
  bidColumnConfigs: Array<BidColumnConfig>;
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type BidPackagebiddersWithBidsCountArgs = {
  source?: InputMaybe<BID_REQUEST_SOURCE>;
};

export type BidPackagebillOfQuantitiesRevisionArgs = {
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type BidPackagecustomBudgetBoQArgs = {
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type BidPackagesuggestedBidInviteCountBreakdownArgs = {
  configuration?: InputMaybe<BidInviteCountSuggestionConfigurationInput>;
};

export enum BidPackageAuthActions {
  addContacts = 'addContacts',
  close = 'close',
  createAddendum = 'createAddendum',
  createInvoice = 'createInvoice',
  createOrUpdateBoQ = 'createOrUpdateBoQ',
  createOrUpdateCalculationBoQ = 'createOrUpdateCalculationBoQ',
  delete = 'delete',
  deleteBoQ = 'deleteBoQ',
  duplicate = 'duplicate',
  manageInternalNotes = 'manageInternalNotes',
  modifyMarketplacePublicationConfig = 'modifyMarketplacePublicationConfig',
  openBlindTenderBids = 'openBlindTenderBids',
  openBlindTenderBidsApprove = 'openBlindTenderBidsApprove',
  predictPrices = 'predictPrices',
  prepareContract = 'prepareContract',
  previewMarketplaceSuggestion = 'previewMarketplaceSuggestion',
  printBoQ = 'printBoQ',
  publish = 'publish',
  publishApprove = 'publishApprove',
  reopen = 'reopen',
  restartBlindTender = 'restartBlindTender',
  sendMarketplaceSuggestions = 'sendMarketplaceSuggestions',
  sendMessage = 'sendMessage',
  simulatePriceComparison = 'simulatePriceComparison',
  submitContract = 'submitContract',
  submitContractApprove = 'submitContractApprove',
  update = 'update',
  updateBoQInternalNote = 'updateBoQInternalNote',
  update__internalData = 'update__internalData',
  uploadContractAgentSignature = 'uploadContractAgentSignature',
  uploadInternalDocuments = 'uploadInternalDocuments',
  uploadSharedDocuments = 'uploadSharedDocuments',
  view = 'view',
  viewMarketplaceList = 'viewMarketplaceList',
  viewOnMarketplace = 'viewOnMarketplace',
  view__documents = 'view__documents',
  view__internalData = 'view__internalData',
  view__messages = 'view__messages',
  view__priceComparison = 'view__priceComparison',
  view__priceComparisonDownloadUrl = 'view__priceComparisonDownloadUrl',
  view__reportingData = 'view__reportingData',
  withdrawContract = 'withdrawContract',
}

export type BidPackageAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type BidPackageAuthInput = {
  action: BidPackageAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BidPackageAuthArgsInput>;
};

export type BidPackageCompletionResponse =
  | BidPackageDuration
  | BoQIncluded
  | ContactDetailsIncluded
  | DescriptiveTenderSetup
  | DocumentsIncluded
  | EnableCosunoMarketplace
  | OfficeDetailsIncluded
  | ReasonableBidDueDate
  | SufficientNumberOfBidders;

export type BidPackageContractValue = {
  __typename: 'BidPackageContractValue';
  contractValue: Scalars['Float']['output'];
  predictedPositionsPercentage: Scalars['Float']['output'];
};

export type BidPackageDuration = {
  __typename: 'BidPackageDuration';
  issue: Maybe<BP_PUBLICATION_BID_PACKAGE_DURATION_ISSUE>;
};

export type BidPackageEditorActionsResponse = {
  __typename: 'BidPackageEditorActionsResponse';
  delete: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  upload: Scalars['Boolean']['output'];
};

export type BidPackageExportBidsNotification = AbstractEntity &
  Notification & {
    __typename: 'BidPackageExportBidsNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: BidPackageExportBidsNotificationProps;
  };

export type BidPackageExportBidsNotificationProps = {
  __typename: 'BidPackageExportBidsNotificationProps';
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type BidPackageInput = {
  allowBiddersDownloadBoQPdf?: InputMaybe<Scalars['Boolean']['input']>;
  allowBidsAfterDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  awardingDate?: InputMaybe<Scalars['Date']['input']>;
  bidInviteReminderScheduleForAccepted?: InputMaybe<BID_INVITE_REMINDER_SCHEDULE>;
  bidInviteReminderScheduleForNoResponse?: InputMaybe<BID_INVITE_REMINDER_SCHEDULE>;
  bidPackageUsers?: InputMaybe<Array<BidPackageUserInput>>;
  bidsDueAt: Scalars['DateTimeISO']['input'];
  bindingPeriod?: InputMaybe<Scalars['Date']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<CURRENCY>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  isBlindTender?: InputMaybe<Scalars['Boolean']['input']>;
  isPublishedOnMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  openingDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  primaryContactUserId?: InputMaybe<Scalars['ID']['input']>;
  primaryUserId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  startsOn?: InputMaybe<Scalars['Date']['input']>;
  workCategories?: InputMaybe<Array<WorkCategoryInput>>;
};

export type BidPackageStatusChangedNotification = AbstractEntity &
  Notification & {
    __typename: 'BidPackageStatusChangedNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: BidPackageStatusChangedNotificationProps;
  };

export type BidPackageStatusChangedNotificationProps = {
  __typename: 'BidPackageStatusChangedNotificationProps';
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  status: BID_PACKAGE_STATUS;
};

export type BidPackageUser = AbstractEntity & {
  __typename: 'BidPackageUser';
  createdAt: Scalars['DateTimeISO']['output'];
  hasPendingMultiUserApprovalRequest: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isContactPerson: Scalars['Boolean']['output'];
  user: User;
  userRole: Scalars['String']['output'];
};

export type BidPackageUserInput = {
  isContactPerson: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
  userRole: Scalars['String']['input'];
};

export type BidPackagesForMarketplaceDefaultFilters = {
  __typename: 'BidPackagesForMarketplaceDefaultFilters';
  address: Maybe<Scalars['String']['output']>;
  distanceInKm: Maybe<Scalars['Int']['output']>;
  geoCoords: Maybe<Scalars['String']['output']>;
  workCategoryList: Maybe<Array<WorkCategory>>;
};

export type BidPackagesForMarketplaceResponse = {
  __typename: 'BidPackagesForMarketplaceResponse';
  bidPackages: Array<BidPackage>;
  defaultFilters: Maybe<BidPackagesForMarketplaceDefaultFilters>;
  /** @deprecated Field was used by the no longer running hide-premium-exclusive-bid-packages experiment. */
  premiumExclusiveBidPackages: Array<BidPackage>;
  /** @deprecated Field was used by the no longer running hide-premium-exclusive-bid-packages experiment. */
  premiumExclusiveBidPackagesCount: Scalars['Int']['output'];
  recentBidPackagesMatchingFiltersCount: Maybe<Scalars['Int']['output']>;
  totalRecords: Scalars['Int']['output'];
};

export type BidPackagesList = {
  __typename: 'BidPackagesList';
  bidPackages: Array<BidPackage>;
  totalRecords: Scalars['Int']['output'];
};

export type BidPackagesResponse = {
  __typename: 'BidPackagesResponse';
  bidPackages: Array<BidPackage>;
  totalRecords: Scalars['Int']['output'];
};

export type BidPdfSettings = {
  includeBiddersComments: Scalars['Boolean']['input'];
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  includeExecutionDescriptions: Scalars['Boolean']['input'];
  includeLongDescriptions: Scalars['Boolean']['input'];
  includeNotes: Scalars['Boolean']['input'];
  orientation: ORIENTATION;
};

export type BidRequest = AbstractEntity & {
  __typename: 'BidRequest';
  acceptedOn: Maybe<Scalars['DateTimeISO']['output']>;
  agentCurrentBid: Maybe<SubmittedBid>;
  agentStatusSetBy: Maybe<User>;
  areDocumentsAvailable: Scalars['Boolean']['output'];
  awardedBid: Maybe<AwardedBid>;
  awardedBidId: Maybe<Scalars['ID']['output']>;
  bidInviteSentEmail: Maybe<SentEmail>;
  bidPackage: BidPackage;
  bidPackageId: Maybe<Scalars['ID']['output']>;
  bidsEligibleForAwarding: Array<SubmittedBid>;
  contacts: Array<BidRequestContact>;
  createdAt: Scalars['DateTimeISO']['output'];
  currentBid: Maybe<SubmittedBid>;
  currentBidId: Maybe<Scalars['ID']['output']>;
  customBidsDueAt: Maybe<Scalars['DateTimeISO']['output']>;
  declinedOn: Maybe<Scalars['DateTimeISO']['output']>;
  declinedReason: Maybe<BID_REQUEST_DECLINED_REASON>;
  declinedReasonOther: Maybe<Scalars['String']['output']>;
  distanceInKms: Maybe<Scalars['Float']['output']>;
  documentCount: Scalars['Float']['output'];
  historyItems: Array<HistoryItem>;
  id: Scalars['ID']['output'];
  isAgentStatusMutable: Scalars['Boolean']['output'];
  isAwaitingResponse: Scalars['Boolean']['output'];
  isProposedAwarded: Scalars['Boolean']['output'];
  isSubcontractorSignupRequired: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  lastStatusChangeAt: Scalars['DateTimeISO']['output'];
  /** @deprecated Use instead query marketplaceBidPackageSuggestions() with bidRequestId */
  marketplaceSamples: Array<MarketplaceBidPackageSample>;
  notes: Array<BidRequestNote>;
  notesCount: Scalars['Int']['output'];
  requireLoginToViewBid: Scalars['Boolean']['output'];
  showAwardedStatusToSubcontractor: Maybe<Scalars['Boolean']['output']>;
  source: BID_REQUEST_SOURCE;
  status: BID_REQUEST_STATUS;
  statusForAgent: BID_REQUEST_STATUS_FOR_AGENT;
  subcontractor: Subcontractor;
  subcontractorId: Maybe<Scalars['ID']['output']>;
  submittedBid: SubmittedBid;
  submittedBids: Array<SubmittedBid>;
  type: BID_REQUEST_TYPE;
  updatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  wasSubcontractorNotifiedOfRejection: Maybe<Scalars['Boolean']['output']>;
};

export type BidRequestsubmittedBidArgs = {
  bidId: Scalars['ID']['input'];
};

export enum BidRequestAuthActions {
  award = 'award',
  awardApprove = 'awardApprove',
  createNote = 'createNote',
  delete = 'delete',
  deleteBid = 'deleteBid',
  deleteNote = 'deleteNote',
  manageTasks = 'manageTasks',
  negotiate = 'negotiate',
  rate = 'rate',
  reject = 'reject',
  sendAwardingEmail = 'sendAwardingEmail',
  sendInvite = 'sendInvite',
  submit = 'submit',
  submitBid = 'submitBid',
  unAward = 'unAward',
  unReject = 'unReject',
  update = 'update',
  updateAgentStatus = 'updateAgentStatus',
  updateStatus = 'updateStatus',
  update__customBidsDueAt = 'update__customBidsDueAt',
  uploadBidBoQ = 'uploadBidBoQ',
  view = 'view',
}

export type BidRequestAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type BidRequestAuthInput = {
  action: BidRequestAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BidRequestAuthArgsInput>;
};

export type BidRequestByAgentInput = {
  bidPackageName: Scalars['String']['input'];
  bidsDueAt: Scalars['DateTimeISO']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  isEstimating?: Scalars['Boolean']['input'];
  location: Scalars['String']['input'];
  officeCity?: InputMaybe<Scalars['String']['input']>;
  officeCountryCode?: InputMaybe<COUNTRY_CODE>;
  officeEmail?: InputMaybe<Scalars['String']['input']>;
  officeFax?: InputMaybe<Scalars['String']['input']>;
  officeName?: Scalars['String']['input'];
  officePhone?: InputMaybe<Scalars['String']['input']>;
  officePostalCode?: InputMaybe<Scalars['String']['input']>;
  officeStreet?: InputMaybe<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
  startsOn?: InputMaybe<Scalars['Date']['input']>;
  workCategories?: InputMaybe<Array<WorkCategoryInput>>;
};

export type BidRequestContact = AbstractEntity & {
  __typename: 'BidRequestContact';
  bidInvite: Maybe<BidInvite>;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPerson: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  mobilePhone: Maybe<Scalars['String']['output']>;
  notificationConfig: ContactNotificationConfig;
  phone: Maybe<Scalars['String']['output']>;
  subcontractor: Subcontractor;
  subcontractorId: Scalars['ID']['output'];
  suggestedChanges: Array<ContactSuggestion>;
  title: Maybe<CONTACT_TITLE>;
};

export type BidRequestCustomBidsDueAtChangeResponse = {
  __typename: 'BidRequestCustomBidsDueAtChangeResponse';
  customBidsDueAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTimeISO']['output'];
  user: Maybe<User>;
};

export type BidRequestDeclinedNotification = AbstractEntity &
  Notification & {
    __typename: 'BidRequestDeclinedNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: BidRequestDeclinedNotificationProps;
  };

export type BidRequestDeclinedNotificationProps = {
  __typename: 'BidRequestDeclinedNotificationProps';
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  bidRequestId: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  subcontractorName: Scalars['String']['output'];
};

export type BidRequestNote = AbstractEntity &
  Note & {
    __typename: 'BidRequestNote';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    text: Scalars['String']['output'];
    user: User;
  };

export type BidRequestStatusChangeResponse = {
  __typename: 'BidRequestStatusChangeResponse';
  bidRequest: BidRequest;
  bidRequestStatus: BID_REQUEST_STATUS;
  changedBy: BID_REQUEST_STATUS_CHANGED_BY;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTimeISO']['output'];
  user: Maybe<User>;
};

export type BidRequestStatusCounts = {
  __typename: 'BidRequestStatusCounts';
  accepted: Scalars['Int']['output'];
  bidPackageId: Scalars['ID']['output'];
  bidders: Scalars['Int']['output'];
  bids: Scalars['Int']['output'];
  inviteDeclined: Scalars['Int']['output'];
  viewed: Scalars['Int']['output'];
};

export type BidRequestsForAgentCountsResponse = {
  __typename: 'BidRequestsForAgentCountsResponse';
  activeRecords: Scalars['Int']['output'];
  allRecords: Scalars['Int']['output'];
};

export type BidRequestsResponse = {
  __typename: 'BidRequestsResponse';
  bidRequests: Array<BidRequest>;
  totalRecords: Scalars['Int']['output'];
};

export type BidWarningMetrics = {
  __typename: 'BidWarningMetrics';
  elementsWithNotFilledBidderInputs: Array<BoQElementWithNotFilledBidderInput>;
  freeQuantityPositionsWithoutQuantitiesIds: Array<Scalars['String']['output']>;
  hasProposalInDocuments: Scalars['Boolean']['output'];
  notFilledPositionsIds: Array<Scalars['String']['output']>;
};

export type BidderAlreadyAddedError = {
  __typename: 'BidderAlreadyAddedError';
  contactId: Maybe<Scalars['ID']['output']>;
};

export type BidderStatus = {
  __typename: 'BidderStatus';
  status: BIDDER_STATUS;
  subcontractorId: Scalars['ID']['output'];
  subcontractorName: Scalars['String']['output'];
};

export type BiddersAwaitingResponseNotification = AbstractEntity &
  Notification & {
    __typename: 'BiddersAwaitingResponseNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: BiddersAwaitingResponseNotificationProps;
  };

export type BiddersAwaitingResponseNotificationProps =
  | BiddersAwaitingResponseNotificationV1Props
  | BiddersAwaitingResponseNotificationV2Props;

export type BiddersAwaitingResponseNotificationV1Props =
  BaseBiddersAwaitingResponseNotificationProps & {
    __typename: 'BiddersAwaitingResponseNotificationV1Props';
    bidPackageBidsDueWeeksAgo: Scalars['Int']['output'];
    bidPackageId: Scalars['String']['output'];
    bidPackageName: Scalars['String']['output'];
    projectId: Scalars['String']['output'];
    projectName: Scalars['String']['output'];
    subcontractorNames: Array<Scalars['String']['output']>;
  };

export type BiddersAwaitingResponseNotificationV2Props =
  BaseBiddersAwaitingResponseNotificationProps & {
    __typename: 'BiddersAwaitingResponseNotificationV2Props';
    bidPackageId: Scalars['String']['output'];
    bidPackageName: Scalars['String']['output'];
    durationSinceBidsDue: Duration;
    projectId: Scalars['String']['output'];
    projectName: Scalars['String']['output'];
    subcontractorNames: Array<Scalars['String']['output']>;
  };

export type BiddersLimitExceededError = {
  __typename: 'BiddersLimitExceededError';
  limit: Scalars['Int']['output'];
};

export type BiddersSearchInput = {
  companySizes: Array<CompanySizeInput>;
  distance: Scalars['String']['input'];
  moreInfo: Scalars['String']['input'];
  workCategories: Array<WorkCategoryInput>;
};

export type BiddingPeriodEndingNotification = AbstractEntity &
  Notification & {
    __typename: 'BiddingPeriodEndingNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: BiddingPeriodEndingNotificationProps;
  };

export type BiddingPeriodEndingNotificationProps = {
  __typename: 'BiddingPeriodEndingNotificationProps';
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  bidsCount: Scalars['Float']['output'];
  endingInDays: Scalars['Float']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type BidsResponse = {
  __typename: 'BidsResponse';
  bids: Array<SubmittedBid>;
  totalRecords: Scalars['Int']['output'];
};

export type BillOfQuantities = AbstractEntity & {
  __typename: 'BillOfQuantities';
  comments: Array<BillOfQuantitiesComment>;
  content: Scalars['JSONObject']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CURRENCY;
  editingStatus: Maybe<BOQ_EDITING_STATUS>;
  id: Scalars['ID']['output'];
  internalNotes: Array<BillOfQuantitiesInternalNote>;
};

export enum BillOfQuantitiesAuthActions {
  downloadRequestForProposalPdf = 'downloadRequestForProposalPdf',
  update = 'update',
}

export type BillOfQuantitiesAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type BillOfQuantitiesAuthInput = {
  action: BillOfQuantitiesAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BillOfQuantitiesAuthArgsInput>;
};

export type BillOfQuantitiesComment = AbstractEntity & {
  __typename: 'BillOfQuantitiesComment';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type BillOfQuantitiesForEditingResponse = {
  __typename: 'BillOfQuantitiesForEditingResponse';
  content: Scalars['JSONObject']['output'];
  hasFormalReviewErrors: Scalars['Boolean']['output'];
  id: Maybe<Scalars['ID']['output']>;
  largestTextAdditionLabel: Scalars['Int']['output'];
  /** @deprecated this field is not used */
  massDeterminationRowIdsNotToKeep: Array<Scalars['String']['output']>;
  massDeterminations: Array<MassDetermination>;
  preferredFileFormat: BOQ_FILE_FORMAT;
};

export type BillOfQuantitiesInternalNote = AbstractEntity & {
  __typename: 'BillOfQuantitiesInternalNote';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type BillOfQuantitiesRevision = AbstractEntity & {
  __typename: 'BillOfQuantitiesRevision';
  createdAt: Scalars['DateTimeISO']['output'];
  hasBids: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isShareableWithBidders: Scalars['Boolean']['output'];
  requestForProposalBoQ: Maybe<BillOfQuantities>;
  requestForProposalBoQId: Maybe<Scalars['ID']['output']>;
  revision: Scalars['Int']['output'];
  wereBiddersNotified: Maybe<Scalars['Boolean']['output']>;
};

export type BillingSubscriptionForRenewalResponse = {
  __typename: 'BillingSubscriptionForRenewalResponse';
  billingFrequency: BILLING_FREQUENCY;
  discountPercentage: Scalars['Float']['output'];
  isEligibleForRenewal: Scalars['Boolean']['output'];
  planId: Scalars['String']['output'];
  planPrice: Scalars['Float']['output'];
};

export type BlindTenderOpeningResponse = {
  __typename: 'BlindTenderOpeningResponse';
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTimeISO']['output'];
  users: Array<User>;
};

export type BoQEditOperationDescriptor =
  | AddElementOperationDescriptor
  | ClearFieldOperationDescriptor
  | DeleteElementOperationDescriptor
  | FillOutFieldOperationDescriptor
  | MoveElementOperationDescriptor
  | RenumberOperationDescriptor
  | TogglePositionTypeOperationDescriptor
  | UpdateProjectInformationOperationDescriptor;

export type BoQEditorPreSaveStateResponse = {
  __typename: 'BoQEditorPreSaveStateResponse';
  hasFormalReviewErrors: Scalars['Boolean']['output'];
  hasNotifiableChanges: Scalars['Boolean']['output'];
};

export type BoQElementWithNotFilledBidderInput = {
  __typename: 'BoQElementWithNotFilledBidderInput';
  bidderInputLabel: Maybe<Scalars['String']['output']>;
  elementId: Scalars['String']['output'];
};

export type BoQExportInput = {
  forceExchangePhase?: InputMaybe<BOQ_EXCHANGE_PHASE>;
};

export type BoQFormalReviewIssue = {
  __typename: 'BoQFormalReviewIssue';
  elementId: Maybe<Scalars['String']['output']>;
  level: BOQ_FORMAL_REVIEW_ISSUE_LEVEL;
  location: Maybe<Scalars['String']['output']>;
  reason: BOQ_FORMAL_REVIEW_ERROR_REASON;
  rowNumber: Maybe<Scalars['Int']['output']>;
};

export type BoQFormalReviewResponse = {
  __typename: 'BoQFormalReviewResponse';
  formalReviewResult: BOQ_FORMAL_REVIEW_RESULT;
  issues: Array<BoQFormalReviewIssue>;
};

export type BoQImportPrices =
  | BoQImportPricesError
  | BoQImportPricesSuccess
  | RequestEditingSessionFailure;

export type BoQImportPricesError = {
  __typename: 'BoQImportPricesError';
  errors: Array<BoqValidationError>;
};

export type BoQImportPricesSuccess = {
  __typename: 'BoQImportPricesSuccess';
  prices: Array<ImportedPrice>;
  warnings: Array<BoqValidationWarning>;
};

export type BoQIncluded = {
  __typename: 'BoQIncluded';
  issue: Maybe<BP_PUBLICATION_BOQ_INCLUDED_ISSUE>;
};

export type BoQPdfSettings = {
  includeCoverPage?: InputMaybe<Scalars['Boolean']['input']>;
  includeExecutionDescriptions: Scalars['Boolean']['input'];
  includeLongDescriptions: Scalars['Boolean']['input'];
  includeNotes: Scalars['Boolean']['input'];
  orientation: ORIENTATION;
};

export type BoQStructureInput = {
  tierDataType: BOQ_TIER_DATA_TYPE;
  tierDigits: Scalars['Float']['input'];
  tierName: Scalars['String']['input'];
  tierType: BOQ_TIER_TYPE;
};

export type BoQTemplate = AbstractEntity & {
  __typename: 'BoQTemplate';
  boqFileFormat: BOQ_FILE_FORMAT;
  changedByUser: User;
  costGroupCatalogs: Array<BoQTemplateCostGroupCatalog>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CURRENCY;
  hasUnsavedBillOfQuantitiesChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  taxRate: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type BoQTemplateBoQEditorPreSaveStateResponse = {
  __typename: 'BoQTemplateBoQEditorPreSaveStateResponse';
  hasFormalReviewErrors: Scalars['Boolean']['output'];
};

export type BoQTemplateCostGroupCatalog = {
  __typename: 'BoQTemplateCostGroupCatalog';
  catalogType: BOQ_TEMPLATE_COST_CATALOG_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  customCatalog: Maybe<CustomCostGroupCatalog>;
  customCatalogId: Maybe<Scalars['String']['output']>;
  customCatalogName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type BoQTemplateCostGroupCatalogInput = {
  catalogType: BOQ_TEMPLATE_COST_CATALOG_TYPE;
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
};

export type BoQTemplateInput = {
  billOfQuantitiesId?: InputMaybe<Scalars['ID']['input']>;
  boqFileFormat: BOQ_FILE_FORMAT;
  costGroupCatalogs: Array<BoQTemplateCostGroupCatalogInput>;
  currency: CURRENCY;
  name: Scalars['String']['input'];
};

export type BoQTemplatesResponse = {
  __typename: 'BoQTemplatesResponse';
  boqTemplates: Array<BoQTemplate>;
  totalRecords: Scalars['Int']['output'];
  totalRecordsForCompany: Scalars['Int']['output'];
};

export type BooleanDiff = {
  __typename: 'BooleanDiff';
  new: Maybe<Scalars['Boolean']['output']>;
  old: Maybe<Scalars['Boolean']['output']>;
};

export type BoqValidationError = {
  __typename: 'BoqValidationError';
  location: Maybe<Scalars['String']['output']>;
  reason: BOQ_VALIDATION_ERROR_REASON;
  rowNumber: Maybe<Scalars['Int']['output']>;
};

export type BoqValidationWarning = {
  __typename: 'BoqValidationWarning';
  location: Maybe<Scalars['String']['output']>;
  reason: BOQ_VALIDATION_WARNING_REASON;
  rowNumber: Maybe<Scalars['Int']['output']>;
};

export type BulkAddContactsResponse = {
  __typename: 'BulkAddContactsResponse';
  count: Scalars['Int']['output'];
};

export enum CERTIFICATE_AVAILABILITY {
  available = 'available',
  expired = 'expired',
  expiringSoon = 'expiringSoon',
  notAvailable = 'notAvailable',
}

export enum CERTIFICATE_FILE_TYPE {
  jpeg = 'jpeg',
  pdf = 'pdf',
  png = 'png',
  xls = 'xls',
  xlsx = 'xlsx',
}

export enum CERTIFICATE_REQUESTS_SORT_FIELD {
  company = 'company',
  dueDate = 'dueDate',
  requestedOn = 'requestedOn',
  status = 'status',
  statusForAgent = 'statusForAgent',
}

export enum CERTIFICATE_REQUEST_STATUS {
  pending = 'pending',
  rejected = 'rejected',
  submitted = 'submitted',
  withdrawn = 'withdrawn',
}

export enum CERTIFICATE_REQUEST_STATUS_FOR_AGENT {
  done = 'done',
  incomplete = 'incomplete',
  overdue = 'overdue',
  rejected = 'rejected',
}

export enum CERTIFICATE_STATUS {
  draft = 'draft',
  submitted = 'submitted',
}

export enum CERTIFICATE_TYPE_SCOPE {
  bidPackage = 'bidPackage',
  universal = 'universal',
}

export enum CERTIFICATE_TYPE_STATUS {
  available = 'available',
  expired = 'expired',
  expiringSoon = 'expiringSoon',
  notAvailable = 'notAvailable',
  rejected = 'rejected',
  requested = 'requested',
}

export enum CERTIFICATE_TYPE_TYPE {
  company = 'company',
  global = 'global',
}

export enum COMPANIES_SORT_FIELD {
  createdAt = 'createdAt',
  name = 'name',
}

export enum COMPANY_SIZE {
  size_1_4 = 'size_1_4',
  size_5_9 = 'size_5_9',
  size_10_19 = 'size_10_19',
  size_20_49 = 'size_20_49',
  size_50_99 = 'size_50_99',
  size_100_199 = 'size_100_199',
  size_200_499 = 'size_200_499',
  size_500plus = 'size_500plus',
}

export enum COMPANY_TEMPLATE_SORT_FIELD {
  name = 'name',
}

export enum COMPANY_TEMPLATE_TYPE {
  awarding = 'awarding',
  bidInviteIntroAwardProject = 'bidInviteIntroAwardProject',
  bidInviteIntroEstimateProject = 'bidInviteIntroEstimateProject',
  bidPackageClosed = 'bidPackageClosed',
  bidderIntroduction = 'bidderIntroduction',
  message = 'message',
  rejection = 'rejection',
}

export enum COMPANY_TYPE {
  agent = 'agent',
  principal = 'principal',
}

export enum CONTACT_SUGGESTION_CHANGE_TYPE {
  create = 'create',
  update = 'update',
}

export enum CONTACT_SUGGESTION_FIELDS_CHANGE_TYPE {
  append = 'append',
  remove = 'remove',
  set = 'set',
  unset = 'unset',
}

export enum CONTACT_SUGGESTION_FIELDS_FIELD_NAME {
  email = 'email',
  fax = 'fax',
  firstName = 'firstName',
  isPerson = 'isPerson',
  jobTitle = 'jobTitle',
  lastName = 'lastName',
  mobilePhone = 'mobilePhone',
  phone = 'phone',
  title = 'title',
}

export enum CONTACT_SUGGESTION_FIELDS_REVIEW_RESULT {
  approved = 'approved',
  dismissed = 'dismissed',
}

export enum CONTACT_TITLE {
  mr = 'mr',
  ms = 'ms',
}

export enum CONTRACT_REMINDER_SCHEDULE {
  everyTwoWeeks = 'everyTwoWeeks',
  none = 'none',
  weekly = 'weekly',
}

export enum COST_ANALYSIS_BREAKDOWN {
  bidPackage = 'bidPackage',
  custom = 'custom',
  din276 = 'din276',
  oenorm = 'oenorm',
  stlbWorkCategory = 'stlbWorkCategory',
}

export enum COST_ANALYSIS_TOP_LEVEL_GROUPING {
  bidPackage = 'bidPackage',
  project = 'project',
}

export enum COST_CATALOG_TYPE {
  bidPackage = 'bidPackage',
  custom = 'custom',
  din276 = 'din276',
  oenorm = 'oenorm',
  stlbWorkCategory = 'stlbWorkCategory',
}

export enum COST_GROUP_TYPE {
  din276 = 'din276',
  oenorm = 'oenorm',
}

export enum COUNTRY_CODE {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  XK = 'XK',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW',
}

export enum CURRENCY {
  ALL = 'ALL',
  AMD = 'AMD',
  AZN = 'AZN',
  BAM = 'BAM',
  BGN = 'BGN',
  BYN = 'BYN',
  CHF = 'CHF',
  CZK = 'CZK',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  GEL = 'GEL',
  HRK = 'HRK',
  HUF = 'HUF',
  ISK = 'ISK',
  MDL = 'MDL',
  MKD = 'MKD',
  NOK = 'NOK',
  PLN = 'PLN',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  SEK = 'SEK',
  TRY = 'TRY',
  UAH = 'UAH',
}

export enum CUSTOM_COST_GROUP_CATALOGS_SORT_FIELD {
  name = 'name',
}

export enum CUSTOM_COST_GROUP_CATALOG_STATUS {
  active = 'active',
  deactivated = 'deactivated',
}

export enum CUSTOM_EMAIL_VALIDATION_RESULT {
  failed = 'failed',
  pending = 'pending',
  validated = 'validated',
}

export enum CUSTOM_FIELD_ENTITY_TYPE {
  project = 'project',
  subcontractor = 'subcontractor',
}

export enum CUSTOM_FIELD_TYPE {
  checkbox = 'checkbox',
  currency = 'currency',
  date = 'date',
  dateTime = 'dateTime',
  multiSelect = 'multiSelect',
  number = 'number',
  singleSelect = 'singleSelect',
  text = 'text',
}

export type CategoryRating = {
  __typename: 'CategoryRating';
  category: RATING_CATEGORY;
  rating: Scalars['Float']['output'];
};

export type Certificate = AbstractEntity & {
  __typename: 'Certificate';
  availability: CERTIFICATE_AVAILABILITY;
  bidPackage: Maybe<BidPackage>;
  certificateType: CertificateType;
  createdAt: Scalars['DateTimeISO']['output'];
  expiryDate: Maybe<Scalars['String']['output']>;
  /** Returns a string "certificateOwner_certificateTypeName_certificateCreationDate.fileType". If a certificate has not been created yet, please use "certificateFileName" query. */
  fileName: Scalars['String']['output'];
  fileSizeBytes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  issueDate: Scalars['String']['output'];
  status: CERTIFICATE_STATUS;
};

export enum CertificateAuthActions {
  delete = 'delete',
  publish = 'publish',
  update = 'update',
  view = 'view',
}

export type CertificateAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type CertificateAuthInput = {
  action: CertificateAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CertificateAuthArgsInput>;
};

export type CertificateExpiringNotification = AbstractEntity &
  Notification & {
    __typename: 'CertificateExpiringNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: CertificateExpiringNotificationProps;
  };

export type CertificateExpiringNotificationProps = {
  __typename: 'CertificateExpiringNotificationProps';
  certificateTypeId: Maybe<Scalars['String']['output']>;
  certificateTypeName: Scalars['String']['output'];
  expiresInDays: Scalars['Float']['output'];
  subcontractorId: Scalars['String']['output'];
  subcontractorName: Scalars['String']['output'];
};

export type CertificateExpiringSubcontractorNotification = AbstractEntity &
  Notification & {
    __typename: 'CertificateExpiringSubcontractorNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: CertificateExpiringSubcontractorNotificationProps;
  };

export type CertificateExpiringSubcontractorNotificationProps = {
  __typename: 'CertificateExpiringSubcontractorNotificationProps';
  certificateTypeName: Scalars['String']['output'];
  expiresInDays: Scalars['Float']['output'];
};

export type CertificateNotProvidedInTimeNotification = AbstractEntity &
  Notification & {
    __typename: 'CertificateNotProvidedInTimeNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: CertificateNotProvidedInTimeNotificationProps;
  };

export type CertificateNotProvidedInTimeNotificationProps = {
  __typename: 'CertificateNotProvidedInTimeNotificationProps';
  certificateTypeNames: Array<Scalars['String']['output']>;
  subcontractorId: Scalars['String']['output'];
  subcontractorName: Scalars['String']['output'];
};

export type CertificateRequest = AbstractEntity & {
  __typename: 'CertificateRequest';
  bidPackage: Maybe<BidPackage>;
  certificateRequestItems: Array<CertificateRequestItem>;
  contact: Contact;
  contactId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customIntro: Maybe<Scalars['HTML']['output']>;
  dueDate: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  office: Office;
  officeId: Scalars['String']['output'];
  status: CERTIFICATE_REQUEST_STATUS;
  statusForAgent: CERTIFICATE_REQUEST_STATUS_FOR_AGENT;
  user: Maybe<User>;
};

export type CertificateRequestcertificateRequestItemsArgs = {
  excludeWithdrawn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateRequestItem = AbstractEntity & {
  __typename: 'CertificateRequestItem';
  canSaveInProfile: Scalars['Boolean']['output'];
  certificateRequest: CertificateRequest;
  certificateType: CertificateType;
  /** @deprecated Deprecated due to simplification with CertificateTypeReportResolver.pendingCertificateRequestItemsForBidPackages */
  certificates: Maybe<Array<Certificate>>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  rejectionReason: Maybe<Scalars['String']['output']>;
  withdrawn: Scalars['Boolean']['output'];
};

export type CertificateRequestItemcertificatesArgs = {
  showDrafts: Scalars['Boolean']['input'];
};

export type CertificateRequestPreviewResponse = {
  __typename: 'CertificateRequestPreviewResponse';
  content: Scalars['HTML']['output'];
  defaultIntro: Scalars['String']['output'];
  fromEmail: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  greeting: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type CertificateRequestsResponse = {
  __typename: 'CertificateRequestsResponse';
  certificateRequests: Array<CertificateRequest>;
  totalRecords: Scalars['Int']['output'];
};

export type CertificateType = AbstractEntity & {
  __typename: 'CertificateType';
  baseName: Scalars['String']['output'];
  certificateRequestCertificates: Array<Certificate>;
  /** @deprecated Deprecated in favor of CertificateTypeReportResolver.certificateRequestItems */
  certificateRequestItems: Array<CertificateRequestItem>;
  /** @deprecated Deprecated in favor of CertificateTypeReportResolver.certificates */
  certificates: Array<Certificate>;
  countryCode: Maybe<COUNTRY_CODE>;
  createdAt: Scalars['DateTimeISO']['output'];
  /** @deprecated Deprecated in favor of isInUse, so certificate types with uploaded certificates are considered. */
  hasBeenRequested: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isExpiryDateMandatory: Scalars['Boolean']['output'];
  isInUse: Scalars['Boolean']['output'];
  isSelectedByDefaultWhenRequesting: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of CertificateTypeReportResolver.requestedOn */
  lastRequestDate: Maybe<Scalars['DateTimeISO']['output']>;
  name: Scalars['String']['output'];
  scope: CERTIFICATE_TYPE_SCOPE;
  /** @deprecated Deprecated in favor of CertificateTypeReportResolver.certificates */
  subcontractorCertificates: Array<Certificate>;
  templateDocument: Maybe<Document>;
  translation: CertificateTypeTranslation;
  type: CERTIFICATE_TYPE_TYPE;
};

export type CertificateTypecertificateRequestCertificatesArgs = {
  certificateRequestId?: InputMaybe<Scalars['ID']['input']>;
  subcontractorId: Scalars['ID']['input'];
};

export type CertificateTypecertificateRequestItemsArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  subcontractorId: Scalars['ID']['input'];
};

export type CertificateTypelastRequestDateArgs = {
  subcontractorId: Scalars['ID']['input'];
};

export type CertificateTypesubcontractorCertificatesArgs = {
  showDrafts: Scalars['Boolean']['input'];
  subcontractorId: Scalars['ID']['input'];
};

export type CertificateTypetranslationArgs = {
  language: LANGUAGE;
};

export enum CertificateTypeAuthActions {
  cancelCertificateRequest = 'cancelCertificateRequest',
  createCertificate = 'createCertificate',
  createGlobalCertificateType = 'createGlobalCertificateType',
  delete = 'delete',
  select = 'select',
  sendCertificateRequest = 'sendCertificateRequest',
  update = 'update',
  view = 'view',
}

export type CertificateTypeAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type CertificateTypeAuthInput = {
  action: CertificateTypeAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CertificateTypeAuthArgsInput>;
};

export type CertificateTypeReport = AbstractEntity & {
  __typename: 'CertificateTypeReport';
  baseName: Scalars['String']['output'];
  certificateRequestCertificates: Array<Certificate>;
  certificateRequestItems: Array<CertificateRequestItem>;
  certificates: Array<Certificate>;
  countryCode: Maybe<COUNTRY_CODE>;
  createdAt: Scalars['DateTimeISO']['output'];
  /** @deprecated Deprecated in favor of isInUse, so certificate types with uploaded certificates are considered. */
  hasBeenRequested: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isExpiryDateMandatory: Scalars['Boolean']['output'];
  isInUse: Scalars['Boolean']['output'];
  isSelectedByDefaultWhenRequesting: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of CertificateTypeReportResolver.requestedOn */
  lastRequestDate: Maybe<Scalars['DateTimeISO']['output']>;
  maxExpiryDate: Maybe<Scalars['DateTimeISO']['output']>;
  name: Scalars['String']['output'];
  pendingCertificateRequestItemsForBidPackages: Array<CertificateRequestItem>;
  /** @deprecated There can be only one certificate request item per certificate request/type combination, but this field returns a generic `CertificateRequest` which contains all items for all types in the request. This makes it impossible to get information for this certificate type report that exists on the certificate request item level. Use `pendingCertificateRequestItemsForBidPackages` instead. */
  pendingCertificateRequestsForBidPackages: Array<CertificateRequest>;
  rejectionReason: Maybe<Scalars['String']['output']>;
  requestedDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  requestedOn: Maybe<Scalars['DateTimeISO']['output']>;
  scope: CERTIFICATE_TYPE_SCOPE;
  status: CERTIFICATE_TYPE_STATUS;
  /** @deprecated Simplified by merging this logic into the regular "status" when requesting reports with "bidPackageId" */
  statusForBidPackage: Maybe<CERTIFICATE_TYPE_STATUS>;
  /** @deprecated Deprecated in favor of CertificateTypeReportResolver.certificates */
  subcontractorCertificates: Array<Certificate>;
  subcontractorTypeId: Maybe<Scalars['String']['output']>;
  templateDocument: Maybe<Document>;
  translation: CertificateTypeTranslation;
  type: CERTIFICATE_TYPE_TYPE;
};

export type CertificateTypeReportcertificateRequestCertificatesArgs = {
  certificateRequestId?: InputMaybe<Scalars['ID']['input']>;
  subcontractorId: Scalars['ID']['input'];
};

export type CertificateTypeReportlastRequestDateArgs = {
  subcontractorId: Scalars['ID']['input'];
};

export type CertificateTypeReportstatusForBidPackageArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type CertificateTypeReportsubcontractorCertificatesArgs = {
  showDrafts: Scalars['Boolean']['input'];
  subcontractorId: Scalars['ID']['input'];
};

export type CertificateTypeReporttranslationArgs = {
  language: LANGUAGE;
};

export type CertificateTypeTranslation = AbstractEntity & {
  __typename: 'CertificateTypeTranslation';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CertificateTypeTranslationAuthActions {
  update = 'update',
}

export type CertificateTypeTranslationAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type CertificateTypeTranslationAuthInput = {
  action: CertificateTypeTranslationAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CertificateTypeTranslationAuthArgsInput>;
};

export type CertificateUploadedBySubcontractorNotification = AbstractEntity &
  Notification & {
    __typename: 'CertificateUploadedBySubcontractorNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: CertificateUploadedBySubcontractorNotificationProps;
  };

export type CertificateUploadedBySubcontractorNotificationProps = {
  __typename: 'CertificateUploadedBySubcontractorNotificationProps';
  certificateTypeNames: Array<Scalars['String']['output']>;
  subcontractorId: Scalars['String']['output'];
  subcontractorName: Scalars['String']['output'];
};

export type CheckCredentialsResponse = {
  __typename: 'CheckCredentialsResponse';
  companyName: Scalars['String']['output'];
  loginToken: Scalars['String']['output'];
  mfaMethod: Maybe<MFA_METHOD>;
  mfaPhoneCensored: Maybe<Scalars['String']['output']>;
  mfaRequired: Scalars['Boolean']['output'];
};

export type CheckResetPasswordTokenResponse = {
  __typename: 'CheckResetPasswordTokenResponse';
  passwordPolicy: Maybe<CompanyPasswordPolicy>;
};

export type CheckVerificationCodeResponse = {
  __typename: 'CheckVerificationCodeResponse';
  mfaToken: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ClearFieldOperationDescriptor = {
  __typename: 'ClearFieldOperationDescriptor';
  fieldName: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  operation: BOQ_EDIT_OPERATION;
  operationId: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  priceComponentIndex: Maybe<Scalars['Int']['output']>;
};

export type ColumnDefinition = {
  columnLetter: Scalars['String']['input'];
  customCatalogId?: InputMaybe<Scalars['String']['input']>;
  field: IMPORTABLE_BOQ_FIELD;
  unitPriceComponentIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type CombinedFileTreeResponse = {
  __typename: 'CombinedFileTreeResponse';
  documents: Array<Document>;
  fileTrees: Array<FileTree>;
};

export type CompaniesResponse = {
  __typename: 'CompaniesResponse';
  companies: Array<Company>;
  totalRecords: Scalars['Int']['output'];
};

export type Company = AbstractEntity & {
  __typename: 'Company';
  agentPricingTier: Maybe<SUBCONTRACTOR_PRICING_TIER>;
  arePermanentFeatureFlagsEditable: Scalars['Boolean']['output'];
  bidInviteReminderScheduleForAccepted: BID_INVITE_REMINDER_SCHEDULE;
  bidInviteReminderScheduleForNoResponse: BID_INVITE_REMINDER_SCHEDULE;
  bidRequestsCount: Scalars['Int']['output'];
  bidRequestsWithSubmittedBidsCount: Scalars['Int']['output'];
  bidsSubmittedOnMarketplace: Scalars['Int']['output'];
  claimedSubcontractors: Array<Subcontractor>;
  config: CompanyConfig;
  /** The date when the Salesforce contract expires for this company. `null` if there is no end date. See `SalesforceAccount` in Prisma schema for more info. */
  contractEndDate: Maybe<Scalars['DateTimeISO']['output']>;
  contractReminderSchedule: CONTRACT_REMINDER_SCHEDULE;
  contrastColor: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdByAgentCompanyId: Maybe<Scalars['ID']['output']>;
  customUserRoles: Array<CustomUserRole>;
  hasBillingAccount: Scalars['Boolean']['output'];
  hasNetworkSubcontractorsAssociated: Scalars['Boolean']['output'];
  hasOverdueInvoice: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAgentProfileComplete: Scalars['Boolean']['output'];
  isEnterpriseOpportunity: Maybe<Scalars['Boolean']['output']>;
  isTestCompany: Scalars['Boolean']['output'];
  licenses: CompanyLicensesResponse;
  logoKey: Maybe<Scalars['String']['output']>;
  mfaRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  optOutFromAiTraining: Scalars['Boolean']['output'];
  organization: Organization;
  packageType: Maybe<SALESFORCE_PACKAGE_TYPE>;
  permanentFeatureFlags: Scalars['JSONObject']['output'];
  primaryColor: Maybe<Scalars['String']['output']>;
  ratingCategories: Array<RATING_CATEGORY>;
  salesforceServiceId: Maybe<Scalars['String']['output']>;
  submittedCertificatesCount: Scalars['Int']['output'];
  tags: Scalars['JSONObject']['output'];
  trials: Array<Trial>;
  type: COMPANY_TYPE;
  usedSeats: CompanyUsedSeatsResponse;
  users: Array<User>;
};

export type CompanyusedSeatsArgs = {
  includeInvited?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CompanyAuthActions {
  create = 'create',
  createAgentBidRequest = 'createAgentBidRequest',
  createAgentCertificateType = 'createAgentCertificateType',
  createCompanyCertificateType = 'createCompanyCertificateType',
  createCompanySubcontractor = 'createCompanySubcontractor',
  createCompanyTemplate = 'createCompanyTemplate',
  createCustomCostGroupCatalog = 'createCustomCostGroupCatalog',
  createNetworkSubcontractor = 'createNetworkSubcontractor',
  createOffice = 'createOffice',
  createOrUpdateBoQTemplate = 'createOrUpdateBoQTemplate',
  createSubcontractorImportRequests = 'createSubcontractorImportRequests',
  createTask = 'createTask',
  createTerms = 'createTerms',
  deleteBoQTemplate = 'deleteBoQTemplate',
  deleteSubcontractorImportRequests = 'deleteSubcontractorImportRequests',
  exportSubcontractors = 'exportSubcontractors',
  generateUploadUrlForSubcontractorsImport = 'generateUploadUrlForSubcontractorsImport',
  inviteUsers = 'inviteUsers',
  managePermissions = 'managePermissions',
  merge = 'merge',
  requestProfileCompletion = 'requestProfileCompletion',
  sendInviteRequests = 'sendInviteRequests',
  sendPremiumPurchaseRequest = 'sendPremiumPurchaseRequest',
  startTrial__costEstimationAndControlling = 'startTrial__costEstimationAndControlling',
  startTrial__individualisation = 'startTrial__individualisation',
  update = 'update',
  updateSubcontractorImportRequests = 'updateSubcontractorImportRequests',
  update__featureFlags = 'update__featureFlags',
  uploadInternalDocuments = 'uploadInternalDocuments',
  usePriceLibrary = 'usePriceLibrary',
  view = 'view',
  viewUsers = 'viewUsers',
  view__allOfficeProjects = 'view__allOfficeProjects',
  view__allUsersBidPackages = 'view__allUsersBidPackages',
  view__certificates = 'view__certificates',
  view__claimedSubcontractors = 'view__claimedSubcontractors',
  view__contacts = 'view__contacts',
  view__externalApiAccessKey = 'view__externalApiAccessKey',
  view__internalDocuments = 'view__internalDocuments',
  view__prefill = 'view__prefill',
  view__subcontractorImportRequests = 'view__subcontractorImportRequests',
  view__subcontractors = 'view__subcontractors',
}

export type CompanyAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type CompanyAuthInput = {
  action: CompanyAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyAuthArgsInput>;
};

export type CompanyBrandingInput = {
  contrastColor?: InputMaybe<Scalars['String']['input']>;
  logoKey?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyConfig = AbstractEntity & {
  __typename: 'CompanyConfig';
  additionalLanguages: Array<LANGUAGE>;
  createdAt: Scalars['DateTimeISO']['output'];
  fullUserLicenseCount: Maybe<Scalars['Int']['output']>;
  guestLicenseCount: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  increasedSecurityFeaturesEnabled: Scalars['Boolean']['output'];
  passwordPolicy: Maybe<CompanyPasswordPolicy>;
  premiumEnabled: Scalars['Boolean']['output'];
  premiumEnabledReason: Maybe<PREMIUM_ENABLED_REASON>;
};

export type CompanyLicensesResponse = {
  __typename: 'CompanyLicensesResponse';
  fullUserLicenseCount: Maybe<Scalars['Int']['output']>;
  guestLicenseCount: Maybe<Scalars['Int']['output']>;
};

export type CompanyOnboardingResponse =
  | CompleteCompanyProfile
  | ImportSubcontractors
  | InviteColleagues;

export type CompanyPasswordPolicy = {
  __typename: 'CompanyPasswordPolicy';
  minLength: Scalars['Int']['output'];
  requiresLowerCaseCharacter: Scalars['Boolean']['output'];
  requiresNumber: Scalars['Boolean']['output'];
  requiresSpecialCharacter: Scalars['Boolean']['output'];
  requiresUpperCaseCharacter: Scalars['Boolean']['output'];
  resetIntervalInDays: Maybe<Scalars['Int']['output']>;
};

export type CompanySizeDiff = {
  __typename: 'CompanySizeDiff';
  new: Maybe<COMPANY_SIZE>;
  old: Maybe<COMPANY_SIZE>;
};

export type CompanySizeInput = {
  name: Scalars['String']['input'];
  size: COMPANY_SIZE;
};

export enum CompanySubcontractorsImportAuthActions {
  process = 'process',
  view = 'view',
}

export type CompanySubcontractorsImportAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type CompanySubcontractorsImportAuthInput = {
  action: CompanySubcontractorsImportAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanySubcontractorsImportAuthArgsInput>;
};

export type CompanyTemplate = AbstractEntity & {
  __typename: 'CompanyTemplate';
  content: Scalars['HTML']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: COMPANY_TEMPLATE_TYPE;
};

export enum CompanyTemplateAuthActions {
  delete = 'delete',
  update = 'update',
  view = 'view',
}

export type CompanyTemplateAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type CompanyTemplateAuthInput = {
  action: CompanyTemplateAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CompanyTemplateAuthArgsInput>;
};

export type CompanyTemplateCreateInput = {
  content: Scalars['HTML']['input'];
  name: Scalars['String']['input'];
  type: COMPANY_TEMPLATE_TYPE;
};

export type CompanyTemplateUpdateInput = {
  content?: InputMaybe<Scalars['HTML']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyTemplatesResponse = {
  __typename: 'CompanyTemplatesResponse';
  companyTemplates: Array<CompanyTemplate>;
  totalRecords: Scalars['Int']['output'];
};

export type CompanyUsedSeatsResponse = {
  __typename: 'CompanyUsedSeatsResponse';
  fullUsers: Scalars['Int']['output'];
  guests: Scalars['Int']['output'];
};

export type CompleteCompanyProfile = {
  __typename: 'CompleteCompanyProfile';
  incompleteOfficeIds: Array<Scalars['String']['output']>;
  isFulfilled: Scalars['Boolean']['output'];
};

export type ConfirmBillOfQuantitiesHasBeenUploaded =
  | ConfirmBillOfQuantitiesHasBeenUploadedError
  | ConfirmBillOfQuantitiesHasBeenUploadedSuccess;

export type ConfirmBillOfQuantitiesHasBeenUploadedError = {
  __typename: 'ConfirmBillOfQuantitiesHasBeenUploadedError';
  errors: Array<BoqValidationError>;
};

export type ConfirmBillOfQuantitiesHasBeenUploadedSuccess = {
  __typename: 'ConfirmBillOfQuantitiesHasBeenUploadedSuccess';
  billOfQuantitiesId: Scalars['ID']['output'];
  netTotal: Maybe<Scalars['Float']['output']>;
  pricePredictions: Maybe<Array<PositionPricePredictionEvaluation>>;
  warnings: Array<BoqValidationWarning>;
};

export type ConfirmRequestBoQHasBeenUploaded =
  | ConfirmBillOfQuantitiesHasBeenUploadedError
  | ConfirmBillOfQuantitiesHasBeenUploadedSuccess
  | RequestEditingSessionFailure;

export type Contact = AbstractEntity & {
  __typename: 'Contact';
  createdAt: Scalars['DateTimeISO']['output'];
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPerson: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  mobilePhone: Maybe<Scalars['String']['output']>;
  notificationConfig: ContactNotificationConfig;
  phone: Maybe<Scalars['String']['output']>;
  subcontractor: Subcontractor;
  subcontractorId: Scalars['ID']['output'];
  suggestedChanges: Array<ContactSuggestion>;
  title: Maybe<CONTACT_TITLE>;
};

export enum ContactAuthActions {
  suggestChanges = 'suggestChanges',
  update = 'update',
  update__notificationConfig = 'update__notificationConfig',
  view = 'view',
  view__notificationConfig = 'view__notificationConfig',
}

export type ContactAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type ContactAuthInput = {
  action: ContactAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContactAuthArgsInput>;
};

export type ContactCreationSuggestion = {
  __typename: 'ContactCreationSuggestion';
  comment: Maybe<Scalars['String']['output']>;
  contact: Contact;
  createdAt: Scalars['DateTimeISO']['output'];
  fieldIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  suggestedByUser: Maybe<User>;
};

export type ContactDetailsIncluded = {
  __typename: 'ContactDetailsIncluded';
  issue: Maybe<BP_PUBLICATION_CONTACT_DETAILS_INCLUDED_ISSUE>;
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isPerson: Scalars['Boolean']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<CONTACT_TITLE>;
};

export type ContactNotificationConfig = {
  __typename: 'ContactNotificationConfig';
  /** @deprecated Insurance suggestions are no longer being sent. */
  insuranceSuggestions: Scalars['Boolean']['output'];
  marketplaceSuggestions: Scalars['Boolean']['output'];
  newMessageFromPrincipal: Scalars['Boolean']['output'];
  productRecommendations: Scalars['Boolean']['output'];
  taskAssigned: Scalars['Boolean']['output'];
  taskReminder: Scalars['Boolean']['output'];
  tenderClosed: Scalars['Boolean']['output'];
  updateCompanyProfile: Scalars['Boolean']['output'];
};

export type ContactNotificationConfigInput = {
  contactId: Scalars['ID']['input'];
  /** @deprecated Insurance suggestions are no longer being sent. */
  insuranceSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceSuggestions: Scalars['Boolean']['input'];
  newMessageFromPrincipal?: InputMaybe<Scalars['Boolean']['input']>;
  productRecommendations?: InputMaybe<Scalars['Boolean']['input']>;
  taskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  taskReminder?: InputMaybe<Scalars['Boolean']['input']>;
  tenderClosed?: InputMaybe<Scalars['Boolean']['input']>;
  updateCompanyProfile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactSuggestion = AbstractEntity & {
  __typename: 'ContactSuggestion';
  changeType: CONTACT_SUGGESTION_CHANGE_TYPE;
  changes: Array<ContactSuggestionField>;
  comment: Maybe<Scalars['String']['output']>;
  contactId: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  suggestedByUser: Maybe<User>;
};

export type ContactSuggestionBooleanField = AbstractContactSuggestionField & {
  __typename: 'ContactSuggestionBooleanField';
  changeType: CONTACT_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: CONTACT_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<CONTACT_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ContactSuggestionField =
  | ContactSuggestionBooleanField
  | ContactSuggestionStringField
  | ContactSuggestionTitleField;

export type ContactSuggestionStringField = AbstractContactSuggestionField & {
  __typename: 'ContactSuggestionStringField';
  changeType: CONTACT_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: CONTACT_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<CONTACT_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ContactSuggestionTitleField = AbstractContactSuggestionField & {
  __typename: 'ContactSuggestionTitleField';
  changeType: CONTACT_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: CONTACT_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<CONTACT_TITLE>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<CONTACT_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ContactVersion = {
  __typename: 'ContactVersion';
  contact: Contact;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPerson: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  mobilePhone: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  title: Maybe<CONTACT_TITLE>;
};

export type ContractAgentAssignee = {
  __typename: 'ContractAgentAssignee';
  currentStep: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  totalStepsCount: Scalars['Int']['output'];
};

export type ContractAgentSignatureRequestedNotification = AbstractEntity &
  Notification & {
    __typename: 'ContractAgentSignatureRequestedNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: ContractAgentSignatureRequestedNotificationProps;
  };

export type ContractAgentSignatureRequestedNotificationProps = {
  __typename: 'ContractAgentSignatureRequestedNotificationProps';
  awardedBidId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  officeName: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type ContractAssignee = {
  __typename: 'ContractAssignee';
  currentStep: Scalars['Int']['output'];
  totalStepsCount: Scalars['Int']['output'];
  userFirstName: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['ID']['output']>;
  userLastName: Maybe<Scalars['String']['output']>;
};

export type ContractMultiSigningCompletedNotification = AbstractEntity &
  Notification & {
    __typename: 'ContractMultiSigningCompletedNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: ContractMultiSigningCompletedNotificationProps;
  };

export type ContractMultiSigningCompletedNotificationProps = {
  __typename: 'ContractMultiSigningCompletedNotificationProps';
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type ContractPrincipalSignatureRequestedNotification = AbstractEntity &
  Notification & {
    __typename: 'ContractPrincipalSignatureRequestedNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: ContractPrincipalSignatureRequestedNotificationProps;
  };

export type ContractPrincipalSignatureRequestedNotificationProps = {
  __typename: 'ContractPrincipalSignatureRequestedNotificationProps';
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type ContractRunAgentStep = {
  __typename: 'ContractRunAgentStep';
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
};

export type ContractSignedByAgentNotification = AbstractEntity &
  Notification & {
    __typename: 'ContractSignedByAgentNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: ContractSignedByAgentNotificationProps;
  };

export type ContractSignedByAgentNotificationProps = {
  __typename: 'ContractSignedByAgentNotificationProps';
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  subcontractorName: Scalars['String']['output'];
};

export type CostAnalysisCostGroup = {
  __typename: 'CostAnalysisCostGroup';
  actualCost: Maybe<CostAnalysisTotals>;
  addendumCost: Maybe<CostAnalysisTotals>;
  awardedBidCost: Maybe<CostAnalysisTotals>;
  bidPackageCost: Maybe<CostAnalysisTotals>;
  catalogType: Maybe<COST_CATALOG_TYPE>;
  children: Array<CostAnalysisCostGroup>;
  costEstimateCost: Maybe<CostAnalysisTotals>;
  costItem: CostItem;
  costItemId: Maybe<Scalars['String']['output']>;
  designation: Maybe<Scalars['String']['output']>;
  estimatedBudgetNet: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  invoiceCost: Maybe<CostAnalysisTotals>;
  localId: Scalars['String']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
  parentLocalId: Maybe<Scalars['String']['output']>;
  priceBenchmarkNet: Maybe<Scalars['Float']['output']>;
  projectedCost: Maybe<CostAnalysisTotals>;
  /** ID of the entity this cost groups is connected to, e.g. bidPackageId */
  referenceId: Maybe<Scalars['String']['output']>;
};

export type CostAnalysisDefaultBreakdownResponse = {
  __typename: 'CostAnalysisDefaultBreakdownResponse';
  breakdown: COST_ANALYSIS_BREAKDOWN;
  customCatalogId: Maybe<Scalars['String']['output']>;
  topLevelGrouping: COST_ANALYSIS_TOP_LEVEL_GROUPING;
};

export type CostAnalysisForProjectValidationResponse = {
  __typename: 'CostAnalysisForProjectValidationResponse';
  validations: CostAnalysisValidations;
};

export type CostAnalysisResponse = {
  __typename: 'CostAnalysisResponse';
  bidPackagesTotalCount: Scalars['Int']['output'];
  bidPackagesWithBoQCount: Scalars['Int']['output'];
  /** @deprecated The currency is now configured on the project level. Use project.currency instead. */
  currency: CURRENCY;
  groups: Array<CostAnalysisCostGroup>;
};

export type CostAnalysisTotals = {
  __typename: 'CostAnalysisTotals';
  totalGross: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
};

export type CostAnalysisValidations = {
  __typename: 'CostAnalysisValidations';
  hasMissingBimVAT: Scalars['Boolean']['output'];
  hasMissingBoqVAT: Scalars['Boolean']['output'];
  hasMissingEstimationVAT: Scalars['Boolean']['output'];
  hasUnassignedBimCostGroups: Scalars['Boolean']['output'];
  hasUnassignedBoqCostGroups: Scalars['Boolean']['output'];
};

export type CostComparisonCostGroup = {
  __typename: 'CostComparisonCostGroup';
  children: Array<CostComparisonCostGroup>;
  designation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<CostComparisonItem>;
  localId: Scalars['String']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
};

export type CostComparisonItem = {
  __typename: 'CostComparisonItem';
  bidId: Scalars['ID']['output'];
  notFilledIn: Scalars['Boolean']['output'];
  total: Maybe<Scalars['Float']['output']>;
};

export type CostComparisonResponse = {
  __typename: 'CostComparisonResponse';
  bids: Array<SubmittedOrGeneratedSubmittedBid>;
  boqHasElementsNotAssignedToCostGroups: Scalars['Boolean']['output'];
  groups: Array<CostComparisonCostGroup>;
  totals: Array<CostComparisonItem>;
};

export type CostEstimatesForProjectResponse = {
  __typename: 'CostEstimatesForProjectResponse';
  costEstimates: Array<CostEstimationEstimate>;
};

export type CostEstimationBidPackage = {
  __typename: 'CostEstimationBidPackage';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number: Maybe<Scalars['String']['output']>;
};

export type CostEstimationBidPackageCostGroup = {
  __typename: 'CostEstimationBidPackageCostGroup';
  bidPackage: CostEstimationBidPackage;
  bidPackageId: Maybe<Scalars['ID']['output']>;
  costEstimateId: Scalars['ID']['output'];
  costItem: CostItem;
  costItemId: Scalars['ID']['output'];
  draftCostItem: Maybe<CostItem>;
  id: Scalars['ID']['output'];
};

export type CostEstimationBidPackageEstimate = {
  __typename: 'CostEstimationBidPackageEstimate';
  bidPackageCostGroups: Array<CostEstimationBidPackageCostGroup>;
  catalogType: COST_CATALOG_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  customCatalogId: Maybe<Scalars['String']['output']>;
  hasUnsavedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
};

export type CostEstimationCustomCatalogCostGroup = {
  __typename: 'CostEstimationCustomCatalogCostGroup';
  childCostGroups: Array<CostEstimationCustomCatalogCostGroup>;
  costEstimateId: Scalars['ID']['output'];
  costItem: CostItem;
  costItemId: Scalars['ID']['output'];
  draftCostItem: Maybe<CostItem>;
  id: Scalars['ID']['output'];
  localId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCostGroupId: Maybe<Scalars['String']['output']>;
};

export type CostEstimationCustomCatalogEstimate = {
  __typename: 'CostEstimationCustomCatalogEstimate';
  catalogType: COST_CATALOG_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  customCatalogCostGroups: Array<CostEstimationCustomCatalogCostGroup>;
  customCatalogId: Maybe<Scalars['String']['output']>;
  hasUnsavedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
};

export type CostEstimationEstimate =
  | CostEstimationBidPackageEstimate
  | CostEstimationCustomCatalogEstimate
  | CostEstimationStandardCatalogEstimate
  | CostEstimationStlbWorkCategoryEstimate;

export type CostEstimationStandardCatalogCostGroup = {
  __typename: 'CostEstimationStandardCatalogCostGroup';
  childCostGroups: Array<CostEstimationStandardCatalogCostGroup>;
  costEstimateId: Scalars['ID']['output'];
  costGroupType: COST_GROUP_TYPE;
  costItem: CostItem;
  costItemId: Scalars['ID']['output'];
  designation: Scalars['String']['output'];
  draftCostItem: Maybe<CostItem>;
  id: Scalars['ID']['output'];
  localId: Scalars['String']['output'];
  parentCostGroupLocalId: Maybe<Scalars['String']['output']>;
};

export type CostEstimationStandardCatalogEstimate = {
  __typename: 'CostEstimationStandardCatalogEstimate';
  catalogType: COST_CATALOG_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  customCatalogId: Maybe<Scalars['String']['output']>;
  hasUnsavedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  standardCatalogCostGroups: Array<CostEstimationStandardCatalogCostGroup>;
};

export type CostEstimationStlbWorkCategoryCostGroup = {
  __typename: 'CostEstimationStlbWorkCategoryCostGroup';
  costEstimateId: Scalars['ID']['output'];
  costItem: CostItem;
  costItemId: Scalars['ID']['output'];
  draftCostItem: Maybe<CostItem>;
  id: Scalars['ID']['output'];
  localId: Scalars['String']['output'];
};

export type CostEstimationStlbWorkCategoryEstimate = {
  __typename: 'CostEstimationStlbWorkCategoryEstimate';
  catalogType: COST_CATALOG_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  customCatalogId: Maybe<Scalars['String']['output']>;
  hasUnsavedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  stlbWorkCategoryCostGroups: Array<CostEstimationStlbWorkCategoryCostGroup>;
};

export type CostGroupDefinition = {
  __typename: 'CostGroupDefinition';
  designation: Scalars['String']['output'];
  localId: Scalars['String']['output'];
  parentLocalId: Maybe<Scalars['String']['output']>;
};

export type CostGroupDefinitionparentLocalIdArgs = {
  costGroupType: COST_GROUP_TYPE;
};

export type CostGroupDefinitionResponse = {
  __typename: 'CostGroupDefinitionResponse';
  definitions: Array<CostGroupDefinition>;
  type: COST_GROUP_TYPE;
};

export type CostItem = {
  __typename: 'CostItem';
  factor: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  quantity: Maybe<Scalars['Float']['output']>;
  taxRate: Maybe<Scalars['Float']['output']>;
  unit: Maybe<Scalars['String']['output']>;
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type CountryCodeDiff = {
  __typename: 'CountryCodeDiff';
  new: Maybe<COUNTRY_CODE>;
  old: Maybe<COUNTRY_CODE>;
};

export type CreateBoQTemplateFailure = {
  __typename: 'CreateBoQTemplateFailure';
  success: Scalars['Boolean']['output'];
};

export type CreateBoQTemplateResponse = CreateBoQTemplateFailure | CreateBoQTemplateSuccess;

export type CreateBoQTemplateSuccess = {
  __typename: 'CreateBoQTemplateSuccess';
  template: BoQTemplate;
};

export type CreateCertificateResponse = {
  __typename: 'CreateCertificateResponse';
  certificate: Certificate;
  /** @deprecated Deprecated in favor of certificateUploadUrl query */
  uploadUrl: Scalars['String']['output'];
};

export type CreateCustomCostGroupCatalogFailure = {
  __typename: 'CreateCustomCostGroupCatalogFailure';
  success: Scalars['Boolean']['output'];
};

export type CreateCustomCostGroupCatalogResponse =
  | CreateCustomCostGroupCatalogFailure
  | CreateCustomCostGroupCatalogSuccess;

export type CreateCustomCostGroupCatalogSuccess = {
  __typename: 'CreateCustomCostGroupCatalogSuccess';
  catalog: CustomCostGroupCatalog;
};

export type CreateDocumentInput = {
  filename: Scalars['String']['input'];
  size: Scalars['Float']['input'];
};

export type CreateDocumentResponse = AbstractEntity & {
  __typename: 'CreateDocumentResponse';
  createdAt: Scalars['DateTimeISO']['output'];
  filename: Scalars['String']['output'];
  hasBeenDownloaded: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  parsedIfcFile: Maybe<ParsedIfcFile>;
  size: Scalars['Float']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  uploadUrl: Scalars['String']['output'];
  uploaded: Scalars['Boolean']['output'];
  user: Maybe<User>;
};

export type CreateDocumentResponsehasBeenDownloadedArgs = {
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateInvoiceInput = {
  approvedTotalNet: Scalars['Float']['input'];
  bidPackageId: Scalars['ID']['input'];
  cashDiscountDeadline?: InputMaybe<Scalars['String']['input']>;
  cashDiscountValue: Scalars['Float']['input'];
  customRows: Array<InvoiceNewCustomRow>;
  discountValue: Scalars['Float']['input'];
  fileId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  insuranceValue: Scalars['Float']['input'];
  issuedAt: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nonApprovedTotalNet: Scalars['Float']['input'];
  numberExternal?: InputMaybe<Scalars['String']['input']>;
  numberInternal?: InputMaybe<Scalars['String']['input']>;
  partialInvoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  paymentDeadline: Scalars['String']['input'];
  receiptDate?: InputMaybe<Scalars['String']['input']>;
  retentionValue: Scalars['Float']['input'];
  subcontractorBic?: InputMaybe<Scalars['String']['input']>;
  subcontractorCity?: InputMaybe<Scalars['String']['input']>;
  subcontractorCountryCode?: InputMaybe<COUNTRY_CODE>;
  subcontractorEmail?: InputMaybe<Scalars['String']['input']>;
  subcontractorIban?: InputMaybe<Scalars['String']['input']>;
  subcontractorName?: InputMaybe<Scalars['String']['input']>;
  subcontractorPhone?: InputMaybe<Scalars['String']['input']>;
  subcontractorPostalCode?: InputMaybe<Scalars['String']['input']>;
  subcontractorStreet?: InputMaybe<Scalars['String']['input']>;
  taxRate: Scalars['Float']['input'];
};

export type CreateInvoiceUploadUrlResponse = {
  __typename: 'CreateInvoiceUploadUrlResponse';
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type CreatePasswordResponse = {
  __typename: 'CreatePasswordResponse';
  companyName: Scalars['String']['output'];
  loginToken: Scalars['String']['output'];
  mfaMethod: Maybe<MFA_METHOD>;
  mfaPhoneCensored: Maybe<Scalars['String']['output']>;
  mfaRequired: Scalars['Boolean']['output'];
};

export type CreateSubcontractorImportRequestInput = {
  fileName: Scalars['String']['input'];
  fileType: SUBCONTRACTOR_IMPORT_REQUEST_FILE_TYPE;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubcontractorImportRequestResponse = {
  __typename: 'CreateSubcontractorImportRequestResponse';
  uploadUrl: Scalars['String']['output'];
};

export type CreateTermsResponse = AbstractEntity & {
  __typename: 'CreateTermsResponse';
  createdAt: Scalars['DateTimeISO']['output'];
  downloadUrls: TermsUrls;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  size: Scalars['Int']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type CustomCostGroupCatalog = AbstractEntity & {
  __typename: 'CustomCostGroupCatalog';
  changedByUser: User;
  costGroups: Array<CustomCostGroupDefinition>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  isCatalogEditable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: CUSTOM_COST_GROUP_CATALOG_STATUS;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum CustomCostGroupCatalogAuthActions {
  update = 'update',
  view = 'view',
}

export type CustomCostGroupCatalogAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type CustomCostGroupCatalogAuthInput = {
  action: CustomCostGroupCatalogAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CustomCostGroupCatalogAuthArgsInput>;
};

export type CustomCostGroupCatalogsResponse = {
  __typename: 'CustomCostGroupCatalogsResponse';
  customCostGroupCatalogs: Array<CustomCostGroupCatalog>;
  totalRecords: Scalars['Int']['output'];
};

export type CustomCostGroupDefinition = AbstractEntity & {
  __typename: 'CustomCostGroupDefinition';
  childCostGroups: Array<CustomCostGroupDefinition>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  localId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type CustomCostGroupDefinitionInput = {
  childCostGroups?: InputMaybe<Array<CustomCostGroupDefinitionInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  localId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CustomEmailState = {
  __typename: 'CustomEmailState';
  customEmail: Maybe<Scalars['String']['output']>;
  customEmailEnabled: Scalars['Boolean']['output'];
  customEmailValidation: Maybe<CustomEmailValidation>;
};

export type CustomEmailValidation = {
  __typename: 'CustomEmailValidation';
  dkimRecordName: Scalars['String']['output'];
  dkimRecordValue: Scalars['String']['output'];
  dkimStatus: CUSTOM_EMAIL_VALIDATION_RESULT;
  overallResult: CUSTOM_EMAIL_VALIDATION_RESULT;
  ownershipToken: Scalars['String']['output'];
  ownershipTokenRecordName: Scalars['String']['output'];
  senderStatus: CUSTOM_EMAIL_VALIDATION_RESULT;
  spfRecordValue: Scalars['String']['output'];
  spfStatus: CUSTOM_EMAIL_VALIDATION_RESULT;
};

export type CustomField = AbstractEntity & {
  __typename: 'CustomField';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Maybe<Array<CustomFieldOption>>;
  type: CUSTOM_FIELD_TYPE;
};

export type CustomFieldInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isRequired: Scalars['Boolean']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<CustomFieldOptionInput>>;
  type?: InputMaybe<CUSTOM_FIELD_TYPE>;
};

export type CustomFieldOption = AbstractEntity & {
  __typename: 'CustomFieldOption';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type CustomFieldOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFieldValueInput = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type CustomFieldWithValue =
  | CustomFieldWithValueCheckbox
  | CustomFieldWithValueCurrency
  | CustomFieldWithValueDate
  | CustomFieldWithValueDateTime
  | CustomFieldWithValueMultiSelect
  | CustomFieldWithValueNumber
  | CustomFieldWithValueSingleSelect
  | CustomFieldWithValueText;

export type CustomFieldWithValueBase = {
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type CustomFieldWithValueCheckbox = CustomFieldWithValueBase & {
  __typename: 'CustomFieldWithValueCheckbox';
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type CustomFieldWithValueCurrency = CustomFieldWithValueBase & {
  __typename: 'CustomFieldWithValueCurrency';
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Maybe<Scalars['Float']['output']>;
};

export type CustomFieldWithValueDate = CustomFieldWithValueBase & {
  __typename: 'CustomFieldWithValueDate';
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Maybe<Scalars['Date']['output']>;
};

export type CustomFieldWithValueDateTime = CustomFieldWithValueBase & {
  __typename: 'CustomFieldWithValueDateTime';
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CustomFieldWithValueMultiSelect = CustomFieldWithValueBase & {
  __typename: 'CustomFieldWithValueMultiSelect';
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<CustomFieldWithValueOption>;
  value: Array<Scalars['ID']['output']>;
};

export type CustomFieldWithValueNumber = CustomFieldWithValueBase & {
  __typename: 'CustomFieldWithValueNumber';
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Maybe<Scalars['Float']['output']>;
};

export type CustomFieldWithValueOption = {
  __typename: 'CustomFieldWithValueOption';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type CustomFieldWithValueSingleSelect = CustomFieldWithValueBase & {
  __typename: 'CustomFieldWithValueSingleSelect';
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<CustomFieldWithValueOption>;
  value: Maybe<Scalars['ID']['output']>;
};

export type CustomFieldWithValueText = CustomFieldWithValueBase & {
  __typename: 'CustomFieldWithValueText';
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type CustomFieldsUsage = {
  __typename: 'CustomFieldsUsage';
  count: Scalars['Int']['output'];
  entityType: CUSTOM_FIELD_ENTITY_TYPE;
};

export type CustomSignatureInput = {
  customSignature?: InputMaybe<Scalars['HTML']['input']>;
};

export type CustomUserRole = {
  __typename: 'CustomUserRole';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum DEPARTMENT_TYPE {
  architect = 'architect',
  calculation = 'calculation',
  client = 'client',
  constructionManagement = 'constructionManagement',
  managementBoard = 'managementBoard',
  other = 'other',
  preparationBackOffice = 'preparationBackOffice',
  projectManagement = 'projectManagement',
  purchasing = 'purchasing',
  specialistPlanning = 'specialistPlanning',
  technical = 'technical',
}

export enum DISCOUNT_METHOD {
  absolute = 'absolute',
  percentage = 'percentage',
}

export enum DOCUMENT_ENTITY {
  Addendum = 'Addendum',
  Bid = 'Bid',
  BidPackage = 'BidPackage',
  BidPackageInternal = 'BidPackageInternal',
  BidRequestInNegotiation = 'BidRequestInNegotiation',
  Company = 'Company',
  Contract = 'Contract',
  ContractBoQ = 'ContractBoQ',
  InitialContract = 'InitialContract',
  Project = 'Project',
  ProjectBim = 'ProjectBim',
  ProjectInternal = 'ProjectInternal',
}

export type DeleteElementOperationDescriptor = {
  __typename: 'DeleteElementOperationDescriptor';
  idsToRemove: Array<Scalars['String']['output']>;
  isSchemaBased: Maybe<Scalars['Boolean']['output']>;
  operation: BOQ_EDIT_OPERATION;
  operationId: Scalars['ID']['output'];
  pathsToRemove: Array<Scalars['String']['output']>;
};

export type DeletedContact = AbstractEntity & {
  __typename: 'DeletedContact';
  _targetId: Scalars['ID']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  email: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPerson: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  mobilePhone: Maybe<Scalars['String']['output']>;
  notificationConfig: ContactNotificationConfig;
  phone: Maybe<Scalars['String']['output']>;
  subcontractor: Subcontractor;
  subcontractorId: Scalars['ID']['output'];
  suggestedChanges: Array<ContactSuggestion>;
  title: Maybe<CONTACT_TITLE>;
};

export type DeletedSubcontractor = AbstractEntity &
  GeocodedGraphQLEntity & {
    __typename: 'DeletedSubcontractor';
    _targetId: Scalars['ID']['output'];
    aboutUs: Maybe<Scalars['HTML']['output']>;
    agentCompany: Maybe<Company>;
    agentCompanyId: Maybe<Scalars['String']['output']>;
    bidRequestsAwaitingResponseCount: Scalars['Int']['output'];
    bidRequestsCount: Maybe<Scalars['Int']['output']>;
    city: Maybe<Scalars['String']['output']>;
    company: Maybe<Company>;
    companyId: Maybe<Scalars['ID']['output']>;
    companySize: Maybe<COMPANY_SIZE>;
    confirmedByAgent: Scalars['Boolean']['output'];
    contacts: Array<Contact>;
    countryCode: Maybe<COUNTRY_CODE>;
    createdAt: Scalars['DateTimeISO']['output'];
    customFields: Maybe<Array<CustomFieldWithValue>>;
    description: Maybe<Scalars['String']['output']>;
    foundingYear: Maybe<Scalars['Float']['output']>;
    generatedDescription: Maybe<Scalars['String']['output']>;
    hasSustainableConstruction: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    imageKeys: Array<Scalars['String']['output']>;
    isBanned: Scalars['Boolean']['output'];
    isClaimedByAgentCompany: Scalars['Boolean']['output'];
    isDeleted: Scalars['Boolean']['output'];
    isFavorite: Scalars['Boolean']['output'];
    lat: Maybe<Scalars['Float']['output']>;
    logoKey: Maybe<Scalars['String']['output']>;
    long: Maybe<Scalars['Float']['output']>;
    moreInfo: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    nationalId: Maybe<Scalars['String']['output']>;
    notes: Maybe<Array<SubcontractorNote>>;
    notesCount: Maybe<Scalars['Int']['output']>;
    orderAreaCountryCode: Maybe<COUNTRY_CODE>;
    orderAreaStateCodes: Maybe<Array<STATE_CODE>>;
    orderAreaType: ORDER_AREA_TYPE;
    orderRadius: Maybe<ORDER_RADIUS>;
    ownerName: Maybe<Scalars['String']['output']>;
    postalCode: Maybe<Scalars['String']['output']>;
    pqNumber: Maybe<Scalars['String']['output']>;
    rating: Maybe<Scalars['Float']['output']>;
    referenceProjects: Array<SubcontractorReferenceProject>;
    registrationCity: Maybe<Scalars['String']['output']>;
    registrationPostalCode: Maybe<Scalars['String']['output']>;
    revenueYear: Maybe<Scalars['Float']['output']>;
    slug: Scalars['String']['output'];
    street: Maybe<Scalars['String']['output']>;
    /** Returns number of submitted certificate types (this includes certificates uploaded by both principal and agent users). Returns null if a user or company cannot access certificates */
    submittedCertificateTypesCount: Maybe<Scalars['Int']['output']>;
    suggestedChanges: Array<SubcontractorSuggestion>;
    suggestedNewContacts: Array<ContactCreationSuggestion>;
    sustainableConstructionDetails: Maybe<Scalars['String']['output']>;
    taxId: Maybe<Scalars['String']['output']>;
    type: SUBCONTRACTOR_TYPE;
    unreadMessageThreadsCount: Maybe<Scalars['Int']['output']>;
    website: Maybe<Scalars['String']['output']>;
    workCategories: Array<WorkCategoryForSubcontractor>;
    yearlyRevenue: Maybe<Scalars['Float']['output']>;
  };

export type DeletedSubcontractorbidRequestsCountArgs = {
  status?: InputMaybe<Array<BID_REQUEST_STATUS>>;
};

export type DeletedUser = AbstractEntity & {
  __typename: 'DeletedUser';
  _targetId: Scalars['ID']['output'];
  celloToken: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customDepartmentName: Maybe<Scalars['String']['output']>;
  customSignature: Maybe<Scalars['HTML']['output']>;
  departmentType: Maybe<DEPARTMENT_TYPE>;
  email: Scalars['String']['output'];
  externalApiAccessKey: Scalars['String']['output'];
  externalCompany: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  featureFlags: Scalars['JSONObject']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intercomHash: Scalars['String']['output'];
  invitationLink: Scalars['String']['output'];
  isActiveCompanyOnboarding: Maybe<Scalars['Boolean']['output']>;
  isAwaitingApproval: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isNavatticEnabled: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  language: LANGUAGE;
  lastActivityAt: Maybe<Scalars['DateTimeISO']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  mfaLastResetAt: Maybe<Scalars['DateTimeISO']['output']>;
  mfaMethod: Maybe<MFA_METHOD>;
  mfaPhoneCensored: Maybe<Scalars['String']['output']>;
  notificationConfig: UserNotificationConfig;
  offices: Array<Office>;
  passwordPolicy: Maybe<CompanyPasswordPolicy>;
  permissions: Array<AdminUserPermissionResponse>;
  phone: Maybe<Scalars['String']['output']>;
  role: UserRole;
  ssoEnabled: Scalars['Boolean']['output'];
  status: USER_STATUS;
  type: USER_TYPE;
  workspaces: Array<Workspace>;
};

export type DeletedWorkCategory = AbstractEntity & {
  __typename: 'DeletedWorkCategory';
  _targetId: Scalars['ID']['output'];
  aliasSuggestions: Array<Scalars['String']['output']>;
  aliases: Array<Scalars['String']['output']>;
  baseName: Scalars['String']['output'];
  correspondingNetworkWorkCategories: Array<WorkCategory>;
  createdAt: Scalars['DateTimeISO']['output'];
  group: Maybe<WorkCategoryGroup>;
  id: Scalars['ID']['output'];
  isNew: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  slug: Maybe<Scalars['String']['output']>;
  slugs: Array<Array<Scalars['String']['output']>>;
  translation: WorkCategoryTranslation;
  translations: Array<WorkCategoryTranslation>;
  type: WORK_CATEGORY_TYPE;
};

export type DeletedWorkCategoryaliasesArgs = {
  language: LANGUAGE;
};

export type DeletedWorkCategorynameArgs = {
  language?: InputMaybe<LANGUAGE>;
};

export type DeletedWorkCategoryslugArgs = {
  language?: InputMaybe<LANGUAGE>;
};

export type DeletedWorkCategorytranslationArgs = {
  language: LANGUAGE;
};

export type DescriptiveTenderSetup = {
  __typename: 'DescriptiveTenderSetup';
  issue: Maybe<BP_PUBLICATION_DESCRIPTIVE_TENDER_SETUP_ISSUE>;
};

export type DiscardCostEstimateForProjectResponse =
  | DiscardCostEstimateForProjectSuccess
  | RequestEditingSessionFailure;

export type DiscardCostEstimateForProjectSuccess = {
  __typename: 'DiscardCostEstimateForProjectSuccess';
  success: Scalars['Boolean']['output'];
};

export type DiscardSimulationChangesResponse =
  | DiscardSimulationChangesSuccess
  | RequestEditingSessionFailure;

export type DiscardSimulationChangesSuccess = {
  __typename: 'DiscardSimulationChangesSuccess';
  success: Scalars['Boolean']['output'];
};

export type Document = AbstractEntity & {
  __typename: 'Document';
  createdAt: Scalars['DateTimeISO']['output'];
  filename: Scalars['String']['output'];
  hasBeenDownloaded: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  parsedIfcFile: Maybe<ParsedIfcFile>;
  size: Scalars['Float']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  uploaded: Scalars['Boolean']['output'];
  user: Maybe<User>;
};

export type DocumenthasBeenDownloadedArgs = {
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentsIncluded = {
  __typename: 'DocumentsIncluded';
  issue: Maybe<BP_PUBLICATION_DOCUMENTS_INCLUDED_ISSUE>;
};

export type DraftAddendum = AbstractEntity & {
  __typename: 'DraftAddendum';
  bidPackage: BidPackage;
  billOfQuantities: BillOfQuantities;
  contractRefNumber: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  executionDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  remarks: Maybe<Scalars['String']['output']>;
  status: ADDENDUM_STATUS;
  totalGross: Maybe<Scalars['Float']['output']>;
};

export type DraftBid = AbstractEntity & {
  __typename: 'DraftBid';
  absoluteDiscount: Maybe<Scalars['Float']['output']>;
  additionalCosts: Maybe<Scalars['Float']['output']>;
  bidRequest: BidRequest;
  billOfQuantities: Maybe<BillOfQuantities>;
  billOfQuantitiesRevision: BillOfQuantitiesRevision;
  billOfQuantitiesRevisionId: Scalars['String']['output'];
  boqEditingStatus: Maybe<BOQ_EDITING_STATUS>;
  canNotifyBidderOnPrincipalSubmission: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  discountRate: Maybe<Scalars['Float']['output']>;
  documentsCount: Scalars['Int']['output'];
  hasBoQ: Scalars['Boolean']['output'];
  hasHiddenTotalNet: Scalars['Boolean']['output'];
  hasOutdatedBoQ: Maybe<REASON_PROPOSAL_BOQ_IS_OUTDATED>;
  id: Scalars['ID']['output'];
  internalNote: Maybe<Scalars['String']['output']>;
  isEligibleForAwarding: Scalars['Boolean']['output'];
  isOutdatedBlindTenderBid: Scalars['Boolean']['output'];
  isSimulated: Maybe<Scalars['Boolean']['output']>;
  message: Maybe<Scalars['String']['output']>;
  parentBid: Maybe<Bid>;
  skontoDeadline: Maybe<Scalars['Int']['output']>;
  skontoRate: Maybe<Scalars['Float']['output']>;
  status: BID_STATUS;
  submittedAt: Maybe<Scalars['DateTimeISO']['output']>;
  submittedByUser: Maybe<User>;
  taxRate: Maybe<Scalars['Float']['output']>;
  totalNet: Maybe<Scalars['Float']['output']>;
  updatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  version: Maybe<Scalars['Int']['output']>;
  warningMetrics: BidWarningMetrics;
};

export type DuplicateBidPackageInput = {
  bidsDueAt: Scalars['DateTimeISO']['input'];
  bindingPeriod?: InputMaybe<Scalars['Date']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  destinationProjectId: Scalars['ID']['input'];
  enableMarketplace: Scalars['Boolean']['input'];
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  includeBidPackageTeam: Scalars['Boolean']['input'];
  includeBoQ: Scalars['Boolean']['input'];
  includeContacts: Scalars['Boolean']['input'];
  includeDescription: Scalars['Boolean']['input'];
  includeDocuments: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  originalBidPackageId: Scalars['ID']['input'];
  startsOn?: InputMaybe<Scalars['Date']['input']>;
  workCategories: Array<WorkCategoryInput>;
};

export type DuplicateProjectInput = {
  category?: InputMaybe<PROJECT_CATEGORY>;
  enableMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  endsOn?: InputMaybe<Scalars['String']['input']>;
  includeBidPackageTeam?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesBidderList?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesBoQ?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesDescription?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesNumbering?: InputMaybe<Scalars['Boolean']['input']>;
  includeCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectDescription?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectEstimatedCost?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectImages?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectTeam?: InputMaybe<Scalars['Boolean']['input']>;
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  officeId: Scalars['ID']['input'];
  originalProjectId: Scalars['ID']['input'];
  startsOn?: InputMaybe<Scalars['String']['input']>;
};

export type Duration = {
  __typename: 'Duration';
  unit: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum EDITING_SESSION_TYPE {
  bidPackageBoqEditor = 'bidPackageBoqEditor',
  boqTemplateBoqEditor = 'boqTemplateBoqEditor',
  priceComparisonSimulationMode = 'priceComparisonSimulationMode',
  projectCostEstimation = 'projectCostEstimation',
}

export enum EMAIL_SALUTATION_MODE {
  autoPrepend = 'autoPrepend',
  editable = 'editable',
}

export enum EMAIL_STATUS {
  blocked = 'blocked',
  bounced = 'bounced',
  clicked = 'clicked',
  delivered = 'delivered',
  failed = 'failed',
  opened = 'opened',
  pending = 'pending',
  queued = 'queued',
  reportedAsSpam = 'reportedAsSpam',
  unsubscribed = 'unsubscribed',
}

export enum EMAIL_TEMPLATES {
  AdminInvite = 'AdminInvite',
  AdminResetPassword = 'AdminResetPassword',
  AgentSignupConfirmation = 'AgentSignupConfirmation',
  AgentSignupReminder = 'AgentSignupReminder',
  AgentUpdateProfileReminder = 'AgentUpdateProfileReminder',
  AgentUserInvite = 'AgentUserInvite',
  AgentUserInviteReminder = 'AgentUserInviteReminder',
  BidConfirmation = 'BidConfirmation',
  BidConfirmationAfterPrincipalSubmission = 'BidConfirmationAfterPrincipalSubmission',
  BidInvite = 'BidInvite',
  BidInviteReminder = 'BidInviteReminder',
  BidInvitesFailed = 'BidInvitesFailed',
  BidNotification = 'BidNotification',
  BidPackageChangedNotification = 'BidPackageChangedNotification',
  BidPackageClosed = 'BidPackageClosed',
  BidPackageExportBidsNotification = 'BidPackageExportBidsNotification',
  BidPackageStatusChangedNotification = 'BidPackageStatusChangedNotification',
  BidRequestAwardedNotification = 'BidRequestAwardedNotification',
  BidRequestDeclined = 'BidRequestDeclined',
  BidRequestRejectedNotification = 'BidRequestRejectedNotification',
  BidderIntroduction = 'BidderIntroduction',
  BiddersAwaitingResponse = 'BiddersAwaitingResponse',
  BiddingPeriodEnding = 'BiddingPeriodEnding',
  BoQChangedNotification = 'BoQChangedNotification',
  CertificateExpiring = 'CertificateExpiring',
  CertificateNotProvidedInTime = 'CertificateNotProvidedInTime',
  CertificateRequest = 'CertificateRequest',
  CertificatesRejectedNotification = 'CertificatesRejectedNotification',
  CertificatesUploadedNotification = 'CertificatesUploadedNotification',
  ContactSignupSuggestion = 'ContactSignupSuggestion',
  ContractAgentRequest = 'ContractAgentRequest',
  ContractSignature = 'ContractSignature',
  ContractWithdrawn = 'ContractWithdrawn',
  DocumentNotification = 'DocumentNotification',
  ExportFailed = 'ExportFailed',
  ExternalBidNotification = 'ExternalBidNotification',
  InvoiceApprovalRequired = 'InvoiceApprovalRequired',
  InvoiceForward = 'InvoiceForward',
  MarketplaceBidRequestBidsDueNotification = 'MarketplaceBidRequestBidsDueNotification',
  MarketplaceSuggestion = 'MarketplaceSuggestion',
  MarketplaceTenderClosedNotification = 'MarketplaceTenderClosedNotification',
  MfaResetNotice = 'MfaResetNotice',
  MfaResetRequest = 'MfaResetRequest',
  MfaSetupNotice = 'MfaSetupNotice',
  MultiUserApprovalRequest = 'MultiUserApprovalRequest',
  MultipleMarketplaceSuggestions = 'MultipleMarketplaceSuggestions',
  NewMessageNotification = 'NewMessageNotification',
  PasswordlessLogin = 'PasswordlessLogin',
  ProjectExportComplete = 'ProjectExportComplete',
  PublishMarketplaceRestrictedView = 'PublishMarketplaceRestrictedView',
  ReportAgentCompanyClosed = 'ReportAgentCompanyClosed',
  RequestProfileCompletion = 'RequestProfileCompletion',
  ResetPassword = 'ResetPassword',
  SalesforceAgentUnsolicitedSignupEmail = 'SalesforceAgentUnsolicitedSignupEmail',
  SalesforceNewCompanyContactImportRequest = 'SalesforceNewCompanyContactImportRequest',
  SavedSearchNotification = 'SavedSearchNotification',
  SignupConfirmation = 'SignupConfirmation',
  SignupDenial = 'SignupDenial',
  SignupSubcontractorConfirmation = 'SignupSubcontractorConfirmation',
  StaleBidPackageDraftReminder = 'StaleBidPackageDraftReminder',
  SubcontractorImportRequestCompleted = 'SubcontractorImportRequestCompleted',
  TaskAssigned = 'TaskAssigned',
  TaskCompleted = 'TaskCompleted',
  TaskInProgress = 'TaskInProgress',
  TaskReminder = 'TaskReminder',
  TrialEndingSoon = 'TrialEndingSoon',
  TrialFeedback = 'TrialFeedback',
  TrialStarting = 'TrialStarting',
  UserAddedToBidPackageTeam = 'UserAddedToBidPackageTeam',
  UserAddedToMultipleBidPackageTeams = 'UserAddedToMultipleBidPackageTeams',
  UserInvite = 'UserInvite',
  UserInviteReminder = 'UserInviteReminder',
  UserInviteRequest = 'UserInviteRequest',
  UserInvitesFailed = 'UserInvitesFailed',
  UserJoinRequest = 'UserJoinRequest',
  UserLocked = 'UserLocked',
  UserPasswordOutdatedSoon = 'UserPasswordOutdatedSoon',
  UserSignupsUncompleted = 'UserSignupsUncompleted',
  UserWelcome = 'UserWelcome',
}

export enum EMAIL_VALIDATION_STATUS {
  invalidDomain = 'invalidDomain',
  invalidFormat = 'invalidFormat',
  unknown = 'unknown',
  used = 'used',
  valid = 'valid',
}

export enum EXPERIMENT_NAME {
  dataAnalyticsUpsell = 'dataAnalyticsUpsell',
  data_analytics_upsell = 'data_analytics_upsell',
  experimentAlwaysPublishTendersOnTheMarketplace = 'experimentAlwaysPublishTendersOnTheMarketplace',
  experimentCheckboxForMarketplacePublishing = 'experimentCheckboxForMarketplacePublishing',
  experimentGoldPackageOnePager = 'experimentGoldPackageOnePager',
  experimentInContextHintsReverseTrial = 'experimentInContextHintsReverseTrial',
  experimentMarketplaceLockSpecialOffer = 'experimentMarketplaceLockSpecialOffer',
  experimentMarketplacePromptWhenSwitchingOff = 'experimentMarketplacePromptWhenSwitchingOff',
  experimentPublishRestrictedBidPackageViewOnMarketplace = 'experimentPublishRestrictedBidPackageViewOnMarketplace',
  experimentShowAiPredictedBidPackageContractValue = 'experimentShowAiPredictedBidPackageContractValue',
  experimentUpsellHintInRmList = 'experimentUpsellHintInRmList',
  experiment_always_publish_tenders_on_the_marketplace = 'experiment_always_publish_tenders_on_the_marketplace',
  experiment_checkbox_for_marketplace_publishing = 'experiment_checkbox_for_marketplace_publishing',
  experiment_gold_package_one_pager = 'experiment_gold_package_one_pager',
  experiment_in_context_hints_reverse_trial = 'experiment_in_context_hints_reverse_trial',
  experiment_marketplace_lock_special_offer = 'experiment_marketplace_lock_special_offer',
  experiment_marketplace_prompt_when_switching_off = 'experiment_marketplace_prompt_when_switching_off',
  experiment_publish_restricted_bid_package_view_on_marketplace = 'experiment_publish_restricted_bid_package_view_on_marketplace',
  experiment_show_ai_predicted_bid_package_contract_value = 'experiment_show_ai_predicted_bid_package_contract_value',
  experiment_upsell_hint_in_rm_list = 'experiment_upsell_hint_in_rm_list',
  releaseBidderInviteRecommendations = 'releaseBidderInviteRecommendations',
  releaseRestrictNetworkInvitesIfAwaitingFeedback = 'releaseRestrictNetworkInvitesIfAwaitingFeedback',
  releaseWarnBeforeInvitingBidderAwaitingFeedback = 'releaseWarnBeforeInvitingBidderAwaitingFeedback',
  release_bidder_invite_recommendations = 'release_bidder_invite_recommendations',
  release_restrict_network_invites_if_awaiting_feedback = 'release_restrict_network_invites_if_awaiting_feedback',
  release_warn_before_inviting_bidder_awaiting_feedback = 'release_warn_before_inviting_bidder_awaiting_feedback',
}

export enum EXTERNAL_CREDENTIAL_TYPE {
  heinzeVob = 'heinzeVob',
  stlb = 'stlb',
}

export type EditRequestBoQResponse = EditRequestBoQSuccess | RequestEditingSessionFailure;

export type EditRequestBoQSuccess = {
  __typename: 'EditRequestBoQSuccess';
  hasTaxRateChanges: Maybe<Scalars['Boolean']['output']>;
  hasUnitChanges: Maybe<Scalars['Boolean']['output']>;
  hasUnitPriceChanges: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EditRequestForProposalsBoQInput = {
  boqStructure?: InputMaybe<Array<BoQStructureInput>>;
  entries?: InputMaybe<Array<RenumberEntryInput>>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  idsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isSchemaBased?: InputMaybe<Scalars['Boolean']['input']>;
  labourTimeLabel?: InputMaybe<Scalars['String']['input']>;
  moves?: InputMaybe<Array<MoveOperationInput>>;
  newElementId?: InputMaybe<Scalars['String']['input']>;
  newElementItemNumber?: InputMaybe<Scalars['String']['input']>;
  newElementType?: InputMaybe<BOQ_ELEMENT_TYPE_DISCRIMINATOR>;
  newValue?: InputMaybe<Scalars['String']['input']>;
  operation: BOQ_EDIT_OPERATION;
  operationId: Scalars['ID']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  pathsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  positionType?: InputMaybe<BOQ_POSITION_TYPE>;
  priceComponentIndex?: InputMaybe<Scalars['Int']['input']>;
  priceComponents?: InputMaybe<Array<Scalars['String']['input']>>;
  skipIsSupportedCatalogueReferenceValidation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditTemplateBoQResponse = EditTemplateBoQSuccess | RequestEditingSessionFailure;

export type EditTemplateBoQSuccess = {
  __typename: 'EditTemplateBoQSuccess';
  hasTaxRateChanges: Maybe<Scalars['Boolean']['output']>;
  hasUnitChanges: Maybe<Scalars['Boolean']['output']>;
  hasUnitPriceChanges: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EditingSession = AbstractEntity & {
  __typename: 'EditingSession';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  type: EDITING_SESSION_TYPE;
  user: User;
};

export type EmailTemplateNotification = {
  __typename: 'EmailTemplateNotification';
  emailTemplate: Maybe<Scalars['String']['output']>;
  shouldSend: Scalars['Boolean']['output'];
};

export type EmailTemplateNotificationInput = {
  emailTemplate?: InputMaybe<Scalars['HTML']['input']>;
  shouldSend: Scalars['Boolean']['input'];
};

export type EmailTemplatePlaceholderInput = {
  absoluteDiscount?: InputMaybe<Scalars['Float']['input']>;
  absoluteDiscountCalculated: Scalars['Float']['input'];
  additionalCosts: Scalars['Float']['input'];
  bidRequestId: Scalars['ID']['input'];
  bidSubmittedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  discountRateCalculated: Scalars['Float']['input'];
  mainOrderNumber?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  skontoDeadline: Scalars['Int']['input'];
  skontoRate: Scalars['Float']['input'];
  taxRate: Scalars['Float']['input'];
  taxValue: Scalars['Float']['input'];
  totalGross: Scalars['Float']['input'];
  totalGrossWithSkonto: Scalars['Float']['input'];
  totalNet: Scalars['Float']['input'];
  totalNetWithDiscount: Scalars['Float']['input'];
};

export type EnableCosunoMarketplace = {
  __typename: 'EnableCosunoMarketplace';
  issue: Maybe<BP_PUBLICATION_ENABLE_MARKETPLACE>;
};

export type ExcelBoQImportOptions = {
  columnDefinitions: Array<ColumnDefinition>;
  positionTypeDefinitions: Array<PositionTypeDefinition>;
  positionTypeLabelSeparator: Scalars['String']['input'];
  skippedRows: Array<Scalars['Float']['input']>;
  startRow: Scalars['Float']['input'];
  timeTracking?: InputMaybe<Scalars['String']['input']>;
  unitPriceComponents?: InputMaybe<Array<Scalars['String']['input']>>;
  worksheetId: Scalars['Float']['input'];
};

export type ExtendedNetworkSubcontractorWithMergedIntoRedirect =
  | MergedIntoSubcontractor
  | NetworkSubcontractorWithContactAvailability;

export type ExternalBidPreviewResponse = {
  __typename: 'ExternalBidPreviewResponse';
  defaultIntro: Scalars['String']['output'];
  footer: Scalars['HTML']['output'];
  fromEmail: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  greeting: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export enum ExternalCredentialAuthActions {
  update = 'update',
  view = 'view',
}

export type ExternalCredentialAuthArgsInput = {
  companyId: Scalars['ID']['input'];
  type: EXTERNAL_CREDENTIAL_TYPE;
};

export type ExternalCredentialAuthInput = {
  action: ExternalCredentialAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalCredentialAuthArgsInput>;
};

export type ExternalCredentialInput = {
  password: Scalars['String']['input'];
  type: EXTERNAL_CREDENTIAL_TYPE;
  username: Scalars['String']['input'];
};

export type ExternalCredentialResponse = {
  __typename: 'ExternalCredentialResponse';
  type: EXTERNAL_CREDENTIAL_TYPE;
  username: Scalars['String']['output'];
};

export type FileTree = AbstractEntity & {
  __typename: 'FileTree';
  attachableId: Scalars['ID']['output'];
  attachableType: DOCUMENT_ENTITY;
  createdAt: Scalars['DateTimeISO']['output'];
  fileTree: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FileTreeAdditionsUploadDataResponse = {
  __typename: 'FileTreeAdditionsUploadDataResponse';
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type FileTreeResponse = {
  __typename: 'FileTreeResponse';
  documents: Array<Document>;
  documentsCount: Scalars['Float']['output'];
  fileTree: FileTree;
};

export type FileUploadResponse = {
  __typename: 'FileUploadResponse';
  uploadKey: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type FillOutBoQInput = {
  complementingPricePercentageUpdates: Array<UpdateFillableBoQComplementingPricePercentageInput>;
  descriptionUpdates: Array<UpdateFillableBoQDescriptionInput>;
  freeQuantityUpdates: Array<UpdateFillableBoQFreeQuantityInput>;
  priceComponentUpdates: Array<UpdateFillableBoQPriceComponentInput>;
  priceUpdates: Array<UpdateFillableBoQPriceInput>;
  surchargeOrDiscountUpdates: Array<UpdateFillableBoQSurchargeOrDiscountInput>;
  timeTrackingUpdates: Array<UpdateFillableBoQTimeTrackingInput>;
};

export type FillOutFieldOperationDescriptor = {
  __typename: 'FillOutFieldOperationDescriptor';
  fieldName: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  isSchemaBased: Maybe<Scalars['Boolean']['output']>;
  newValue: Scalars['String']['output'];
  operation: BOQ_EDIT_OPERATION;
  operationId: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  priceComponentIndex: Maybe<Scalars['Int']['output']>;
  skipIsSupportedCatalogueReferenceValidation: Maybe<Scalars['Boolean']['output']>;
};

export type GeneralValidationConstraintError = {
  __typename: 'GeneralValidationConstraintError';
  error: Maybe<Scalars['String']['output']>;
  type: NETWORK_SUBCONTRACTOR_IMPORT_GENERAL_VALIDATION_CONSTRAINT;
};

export type GenerateUrlAndIdResponse = {
  __typename: 'GenerateUrlAndIdResponse';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type GeocodedGraphQLEntity = {
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  lat: Maybe<Scalars['Float']['output']>;
  long: Maybe<Scalars['Float']['output']>;
};

export type HeaderValidationConstraintError = {
  __typename: 'HeaderValidationConstraintError';
  columns: Array<Scalars['String']['output']>;
  type: NETWORK_SUBCONTRACTOR_IMPORT_HEADER_VALIDATION_CONSTRAINT;
};

export type HeinzeGuiUrlResponse = {
  __typename: 'HeinzeGuiUrlResponse';
  baseUrl: Scalars['String']['output'];
  homeUrl: Scalars['String']['output'];
};

export type HiddenBidder = {
  id: Scalars['ID']['input'];
  index: Scalars['Int']['input'];
};

export enum HighlightPriceMode {
  extremes = 'extremes',
  outliers = 'outliers',
}

export type HistoryItem =
  | BidInviteStatusChangeResponse
  | BidRequestCustomBidsDueAtChangeResponse
  | BidRequestStatusChangeResponse
  | BlindTenderOpeningResponse
  | SentEmailForStatusHistoryResponse
  | SubmittedBidHistoryItem
  | TermsAcceptanceResponse;

export enum IMPORTABLE_BOQ_FIELD {
  customCostCatalog = 'customCostCatalog',
  descriptionLong = 'descriptionLong',
  descriptionShort = 'descriptionShort',
  din276 = 'din276',
  itemNumber = 'itemNumber',
  oenorm = 'oenorm',
  positionType = 'positionType',
  quantity = 'quantity',
  stlbWorkCategory = 'stlbWorkCategory',
  taxRate = 'taxRate',
  timeTracking = 'timeTracking',
  totalPrice = 'totalPrice',
  totalPriceGross = 'totalPriceGross',
  unitPrice = 'unitPrice',
  unitPriceComponent = 'unitPriceComponent',
  unitTag = 'unitTag',
}

export enum INVITE_REQUEST_SOURCE_TYPE {
  bidPackageUsers = 'bidPackageUsers',
  projectBillingRunUsers = 'projectBillingRunUsers',
  projectUsers = 'projectUsers',
}

export enum INVOICE_CUSTOM_ROW_TYPE {
  absolute = 'absolute',
  percent = 'percent',
}

export enum INVOICE_HISTORY_STATUS {
  approved = 'approved',
  modified = 'modified',
  rejected = 'rejected',
  rejectedAndReturnedForAdjustments = 'rejectedAndReturnedForAdjustments',
}

export enum INVOICE_SORT_FIELD {
  bidPackageName = 'bidPackageName',
  numberExternal = 'numberExternal',
  status = 'status',
}

export enum INVOICE_STATUS {
  approvalPending = 'approvalPending',
  approved = 'approved',
  paid = 'paid',
  paymentInProgress = 'paymentInProgress',
  rejected = 'rejected',
}

export type ImageUploadUrlResponse = {
  __typename: 'ImageUploadUrlResponse';
  storageKey: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ImportBidPackageResponse = {
  __typename: 'ImportBidPackageResponse';
  bidPackage: BidPackage;
};

export type ImportSubcontractors = {
  __typename: 'ImportSubcontractors';
  isFulfilled: Scalars['Boolean']['output'];
};

export type ImportedPrice = {
  __typename: 'ImportedPrice';
  complementingPricePercentageOverride: Maybe<Scalars['Float']['output']>;
  itemNumber: Scalars['String']['output'];
  price: Maybe<Scalars['Float']['output']>;
  priceComponents: Array<ImportedPriceComponent>;
  quantityOverride: Maybe<Scalars['Float']['output']>;
  taxRate: Maybe<Scalars['Float']['output']>;
};

export type ImportedPriceComponent = {
  __typename: 'ImportedPriceComponent';
  price: Scalars['Float']['output'];
};

export type IntDiff = {
  __typename: 'IntDiff';
  new: Maybe<Scalars['Int']['output']>;
  old: Maybe<Scalars['Int']['output']>;
};

export type InvitationResponse = {
  __typename: 'InvitationResponse';
  invitee: User;
  inviter: User;
  isInvitationToWorkspace: Scalars['Boolean']['output'];
  isPasswordUpdateRequired: Scalars['Boolean']['output'];
  passwordPolicy: Maybe<CompanyPasswordPolicy>;
};

export type InviteColleagues = {
  __typename: 'InviteColleagues';
  isFulfilled: Scalars['Boolean']['output'];
};

export type InviteRequestSourceInput = {
  bidPackageId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  type: INVITE_REQUEST_SOURCE_TYPE;
};

export type InviteeInput = {
  customDepartmentName?: InputMaybe<Scalars['String']['input']>;
  departmentType?: InputMaybe<DEPARTMENT_TYPE>;
  firstName: Scalars['String']['input'];
  language: LANGUAGE;
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type Invoice = {
  __typename: 'Invoice';
  approvedTotalNet: Scalars['Float']['output'];
  assignee: Maybe<InvoiceAssignee>;
  bidPackage: BidPackage;
  cashDiscountDeadline: Maybe<Scalars['String']['output']>;
  cashDiscountValue: Scalars['Float']['output'];
  customRows: Array<InvoiceCustomRow>;
  discountValue: Scalars['Float']['output'];
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insuranceValue: Scalars['Float']['output'];
  issuedAt: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  nonApprovedTotalNet: Scalars['Float']['output'];
  numberExternal: Maybe<Scalars['String']['output']>;
  numberInternal: Maybe<Scalars['String']['output']>;
  partialInvoiceNumber: Maybe<Scalars['Int']['output']>;
  paymentDeadline: Scalars['String']['output'];
  receiptDate: Maybe<Scalars['String']['output']>;
  retentionValue: Scalars['Float']['output'];
  status: INVOICE_STATUS;
  statusChanges: Array<InvoiceStatusChange>;
  subcontractorBic: Maybe<Scalars['String']['output']>;
  subcontractorCity: Maybe<Scalars['String']['output']>;
  subcontractorCountryCode: Maybe<COUNTRY_CODE>;
  subcontractorEmail: Maybe<Scalars['String']['output']>;
  subcontractorIban: Maybe<Scalars['String']['output']>;
  subcontractorName: Maybe<Scalars['String']['output']>;
  subcontractorPhone: Maybe<Scalars['String']['output']>;
  subcontractorPostalCode: Maybe<Scalars['String']['output']>;
  subcontractorStreet: Maybe<Scalars['String']['output']>;
  taxRate: Scalars['Float']['output'];
};

export type InvoiceAssignee = {
  __typename: 'InvoiceAssignee';
  currentStep: Maybe<Scalars['Int']['output']>;
  totalStepsCount: Scalars['Int']['output'];
  userFirstName: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  userLastName: Maybe<Scalars['String']['output']>;
};

export enum InvoiceAuthActions {
  createInvoiceNote = 'createInvoiceNote',
  delete = 'delete',
  update = 'update',
  view = 'view',
}

export type InvoiceAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type InvoiceAuthInput = {
  action: InvoiceAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<InvoiceAuthArgsInput>;
};

export type InvoiceAwaitingApprovalNotification = AbstractEntity &
  Notification & {
    __typename: 'InvoiceAwaitingApprovalNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: InvoiceAwaitingApprovalNotificationProps;
  };

export type InvoiceAwaitingApprovalNotificationProps = {
  __typename: 'InvoiceAwaitingApprovalNotificationProps';
  bidPackageName: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceName: Maybe<Scalars['String']['output']>;
  invoiceNumber: Maybe<Scalars['String']['output']>;
  projectName: Scalars['String']['output'];
};

export type InvoiceCustomRow = {
  __typename: 'InvoiceCustomRow';
  absoluteValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoiceId: Scalars['ID']['output'];
  isNegative: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  type: INVOICE_CUSTOM_ROW_TYPE;
};

export type InvoiceCustomRowForUpdate = {
  absoluteValue: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isNegative: Scalars['Boolean']['input'];
  position: Scalars['Int']['input'];
  rate: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  type: INVOICE_CUSTOM_ROW_TYPE;
};

export type InvoiceNewCustomRow = {
  absoluteValue: Scalars['Float']['input'];
  isNegative: Scalars['Boolean']['input'];
  position: Scalars['Int']['input'];
  rate: Scalars['Float']['input'];
  title: Scalars['String']['input'];
  type: INVOICE_CUSTOM_ROW_TYPE;
};

export type InvoiceNote = AbstractEntity &
  Note & {
    __typename: 'InvoiceNote';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    text: Scalars['String']['output'];
    user: User;
  };

export type InvoiceNotesResponse = {
  __typename: 'InvoiceNotesResponse';
  notes: Array<InvoiceNote>;
  totalRecords: Scalars['Int']['output'];
};

export type InvoiceRejectedNotification = AbstractEntity &
  Notification & {
    __typename: 'InvoiceRejectedNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: InvoiceRejectedNotificationProps;
  };

export type InvoiceRejectedNotificationProps = {
  __typename: 'InvoiceRejectedNotificationProps';
  bidPackageName: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceName: Maybe<Scalars['String']['output']>;
  invoiceNumber: Maybe<Scalars['String']['output']>;
  projectName: Scalars['String']['output'];
};

export type InvoiceStatusChange = {
  __typename: 'InvoiceStatusChange';
  createdAt: Scalars['DateTimeISO']['output'];
  currentStep: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  status: INVOICE_HISTORY_STATUS;
  totalStepsCount: Scalars['Int']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type InvoicesResponse = {
  __typename: 'InvoicesResponse';
  invoices: Array<Invoice>;
  totalRecords: Scalars['Int']['output'];
};

export type IsPrincipalUserOnlyResponse = {
  __typename: 'IsPrincipalUserOnlyResponse';
  isAccountInitialized: Scalars['Boolean']['output'];
};

export enum LANGUAGE {
  bg = 'bg',
  cs = 'cs',
  da = 'da',
  de = 'de',
  el = 'el',
  en = 'en',
  es = 'es',
  et = 'et',
  fi = 'fi',
  fr = 'fr',
  hr = 'hr',
  hu = 'hu',
  it = 'it',
  lt = 'lt',
  lv = 'lv',
  nl = 'nl',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  sk = 'sk',
  sv = 'sv',
}

export enum LONG_RUNNING_TASK_STATE {
  completed = 'completed',
  failed = 'failed',
  pending = 'pending',
}

export type LbHochbauRestrictedItemNumbersResponse = {
  __typename: 'LbHochbauRestrictedItemNumbersResponse';
  restrictedItemNumbers: Array<Scalars['String']['output']>;
};

export type LbHochbauTextProviderElementsTreeResponse = {
  __typename: 'LbHochbauTextProviderElementsTreeResponse';
  lbHochbauBoQElements: Scalars['JSONObject']['output'];
};

export type LocationFilter = {
  countryCode?: InputMaybe<COUNTRY_CODE>;
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
  stateCode?: InputMaybe<STATE_CODE>;
};

export type LoginSuggestion = {
  __typename: 'LoginSuggestion';
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
};

export type LoginTokenResponse = {
  __typename: 'LoginTokenResponse';
  loginToken: Scalars['String']['output'];
};

export type LongRunningTask = AbstractEntity & {
  __typename: 'LongRunningTask';
  createdAt: Scalars['DateTimeISO']['output'];
  error: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  percentComplete: Maybe<Scalars['Float']['output']>;
  state: LONG_RUNNING_TASK_STATE;
};

export enum MAILJET_EVENT_TYPE {
  blocked = 'blocked',
  bounce = 'bounce',
  click = 'click',
  open = 'open',
  sent = 'sent',
  spam = 'spam',
  unsub = 'unsub',
}

export enum MAILJET_MESSAGE_STATUS {
  blocked = 'blocked',
  bounce = 'bounce',
  clicked = 'clicked',
  deferred = 'deferred',
  hardbounced = 'hardbounced',
  opened = 'opened',
  queued = 'queued',
  sent = 'sent',
  softbounced = 'softbounced',
  spam = 'spam',
  unknown = 'unknown',
  unsub = 'unsub',
}

export enum MARKETPLACE_BID_REQUEST_STATUS {
  accepted = 'accepted',
  undecided = 'undecided',
  watched = 'watched',
}

export enum MARKETPLACE_SUGGESTIONS_SORT_FIELD {
  sentAt = 'sentAt',
}

export enum MARKETPLACE_SUGGESTION_STATUS {
  bidSubmitted = 'bidSubmitted',
  draft = 'draft',
  failed = 'failed',
  opened = 'opened',
  sent = 'sent',
  viewed = 'viewed',
}

export enum MESSAGE_THREAD_SORT_FIELD {
  lastMessageCreatedAt = 'lastMessageCreatedAt',
}

export enum MFA_METHOD {
  authenticator = 'authenticator',
  phone = 'phone',
}

export enum MULTI_USER_APPROVAL_ACTION {
  approveAddendum = 'approveAddendum',
  awardBid = 'awardBid',
  openBids = 'openBids',
  publishBidPackage = 'publishBidPackage',
  sendContract = 'sendContract',
}

export type MarketplaceBidPackageSample = {
  __typename: 'MarketplaceBidPackageSample';
  bidsDueDate: Scalars['DateTimeISO']['output'];
  customerName: Maybe<Scalars['String']['output']>;
  endsOn: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  officeLogoKey: Maybe<Scalars['String']['output']>;
  officeName: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  startsOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MarketplaceLockResponse = {
  __typename: 'MarketplaceLockResponse';
  availableAt: Maybe<Scalars['DateTimeISO']['output']>;
  freeUsageBidRequestsCount: Scalars['Int']['output'];
  isAboutToBeLocked: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
};

export type MarketplaceSavedSearch = AbstractEntity & {
  __typename: 'MarketplaceSavedSearch';
  address: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  distanceInKm: Maybe<Scalars['Float']['output']>;
  dueDateInMinDays: Maybe<Scalars['Int']['output']>;
  endsOn: Maybe<Scalars['Date']['output']>;
  geoCoords: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isNotificationEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  projectCategories: Array<PROJECT_CATEGORY>;
  query: Maybe<Scalars['String']['output']>;
  showExpiredTenders: Scalars['Boolean']['output'];
  sortBy: Scalars['String']['output'];
  startsOn: Maybe<Scalars['Date']['output']>;
  workCategories: Array<WorkCategory>;
};

export type MarketplaceSavedSearchInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  distanceInKm?: InputMaybe<Scalars['Float']['input']>;
  dueDateInMinDays?: InputMaybe<Scalars['Int']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  geoCoords?: InputMaybe<Scalars['String']['input']>;
  isNotificationEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  projectCategories?: Array<PROJECT_CATEGORY>;
  query?: InputMaybe<Scalars['String']['input']>;
  showExpiredTenders: Scalars['Boolean']['input'];
  sortBy: Scalars['String']['input'];
  sortDirection: SORT_DIRECTION;
  startsOn?: InputMaybe<Scalars['Date']['input']>;
  workCategoryIds?: Array<Scalars['String']['input']>;
};

export type MarketplaceSuggestion = AbstractEntity & {
  __typename: 'MarketplaceSuggestion';
  bidPackageId: Scalars['ID']['output'];
  contact: Contact;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  status: MARKETPLACE_SUGGESTION_STATUS;
};

export enum MarketplaceSuggestionAuthActions {
  view = 'view',
}

export type MarketplaceSuggestionAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type MarketplaceSuggestionAuthInput = {
  action: MarketplaceSuggestionAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MarketplaceSuggestionAuthArgsInput>;
};

export type MarketplaceSuggestionPreviewResponse = {
  __typename: 'MarketplaceSuggestionPreviewResponse';
  content: Scalars['HTML']['output'];
  defaultIntro: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  greeting: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type MarketplaceSuggestionsInput = {
  bidPackageId: Scalars['ID']['input'];
  contactIds: Array<Scalars['ID']['input']>;
  emailIntroduction: Scalars['HTML']['input'];
};

export type MarketplaceSuggestionsResponse = {
  __typename: 'MarketplaceSuggestionsResponse';
  sentSuggestions: Array<MarketplaceSuggestion>;
  totalCount: Scalars['Int']['output'];
};

export type MassDetermination = {
  __typename: 'MassDetermination';
  billOfQuantities: BillOfQuantities;
  billOfQuantitiesId: Scalars['ID']['output'];
  boqRowId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastUsedLocalId: Maybe<Scalars['String']['output']>;
  rows: Array<MassDeterminationRow>;
  status: BOQ_MASS_DETERMINATION_STATUS;
};

export type MassDeterminationCommentRow = AbstractMassDeterminationRow & {
  __typename: 'MassDeterminationCommentRow';
  comment: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The unique, auto-increasing local ID of the row following the schema 1A0, 1B0, ...1Z0, 2A0... */
  localId: Scalars['String']['output'];
};

export type MassDeterminationCustomFormulaRow = AbstractMassDeterminationRow & {
  __typename: 'MassDeterminationCustomFormulaRow';
  expression: Maybe<Scalars['String']['output']>;
  factor: Maybe<Scalars['Float']['output']>;
  formulaId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The unique, auto-increasing local ID of the row following the schema 1A0, 1B0, ...1Z0, 2A0... */
  localId: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
};

export type MassDeterminationFormulaRow = AbstractMassDeterminationRow & {
  __typename: 'MassDeterminationFormulaRow';
  factor: Maybe<Scalars['Float']['output']>;
  formulaId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The unique, auto-increasing local ID of the row following the schema 1A0, 1B0, ...1Z0, 2A0... */
  localId: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
  value1: Maybe<Scalars['Float']['output']>;
  value2: Maybe<Scalars['Float']['output']>;
  value3: Maybe<Scalars['Float']['output']>;
  value4: Maybe<Scalars['Float']['output']>;
  value5: Maybe<Scalars['Float']['output']>;
};

export type MassDeterminationRow =
  | MassDeterminationCommentRow
  | MassDeterminationCustomFormulaRow
  | MassDeterminationFormulaRow;

export type MergedIntoSubcontractor = {
  __typename: 'MergedIntoSubcontractor';
  countryCode: Maybe<COUNTRY_CODE>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
};

export type Message = AbstractEntity & {
  __typename: 'Message';
  /** Subcontractor name or general contractor office name */
  authorCompanyName: Maybe<Scalars['String']['output']>;
  authorName: Maybe<Scalars['String']['output']>;
  authorType: COMPANY_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  documents: Array<Document>;
  hasBeenRead: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isMyMessage: Scalars['Boolean']['output'];
  messageText: Scalars['HTML']['output'];
  recipients: Array<MessageRecipient>;
};

export type MessageDetails = {
  __typename: 'MessageDetails';
  arrivedAt: Scalars['String']['output'];
  attemptCount: Scalars['Int']['output'];
  state: Maybe<Scalars['String']['output']>;
  statePermanent: Scalars['Boolean']['output'];
  status: MAILJET_MESSAGE_STATUS;
};

export type MessageHistory = {
  __typename: 'MessageHistory';
  comment: Scalars['String']['output'];
  eventAt: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type MessageRecipient = {
  __typename: 'MessageRecipient';
  hasReadMessage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type MessageThread = AbstractEntity & {
  __typename: 'MessageThread';
  bidPackage: BidPackage;
  bidRequest: BidRequest;
  createdAt: Scalars['DateTimeISO']['output'];
  hasUnreadMessages: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastMessage: Message;
  messages: Array<Message>;
  participatingCompanyOffice: Office;
  respondingCompanyName: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type MessageThreadResponse = {
  __typename: 'MessageThreadResponse';
  messageThreads: Array<MessageThread>;
  totalRecords: Scalars['Int']['output'];
};

export type MoveElementOperationDescriptor = {
  __typename: 'MoveElementOperationDescriptor';
  isSchemaBased: Maybe<Scalars['Boolean']['output']>;
  moves: Array<MoveElementOperationMoveDescriptor>;
  operation: BOQ_EDIT_OPERATION;
  operationId: Scalars['ID']['output'];
  pathsToRemove: Array<Scalars['String']['output']>;
};

export type MoveElementOperationMoveDescriptor = {
  __typename: 'MoveElementOperationMoveDescriptor';
  newPath: Scalars['String']['output'];
  originalPath: Scalars['String']['output'];
};

export type MoveOperationInput = {
  newPath: Scalars['String']['input'];
  originalPath: Scalars['String']['input'];
};

export type MultiUserApprovalRequest = AbstractEntity & {
  __typename: 'MultiUserApprovalRequest';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  props: Maybe<MultiUserApprovalRequestProps>;
  requester: User;
  users: Array<MultiUserApprovalRequestUser>;
};

export type MultiUserApprovalRequestAwardBidProps = {
  __typename: 'MultiUserApprovalRequestAwardBidProps';
  absoluteDiscount: Maybe<Scalars['Float']['output']>;
  absoluteDiscountCalculated: Scalars['Float']['output'];
  additionalCosts: Scalars['Float']['output'];
  awardedSumType: BID_AWARDED_SUM_TYPE;
  awarding: EmailTemplateNotification;
  bidId: Scalars['ID']['output'];
  bidRequestId: Scalars['ID']['output'];
  discountRate: Maybe<Scalars['Float']['output']>;
  discountRateCalculated: Scalars['Float']['output'];
  mainOrderNumber: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rejection: EmailTemplateNotification;
  skontoDeadline: Scalars['Int']['output'];
  skontoRate: Scalars['Float']['output'];
  taxRate: Scalars['Float']['output'];
  taxValue: Scalars['Float']['output'];
  totalGross: Scalars['Float']['output'];
  totalGrossWithSkonto: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
  totalNetWithDiscount: Scalars['Float']['output'];
};

export type MultiUserApprovalRequestAwardBidPropsInput = {
  absoluteDiscount?: InputMaybe<Scalars['Float']['input']>;
  absoluteDiscountCalculated: Scalars['Float']['input'];
  additionalCosts: Scalars['Float']['input'];
  awardedSumType?: InputMaybe<BID_AWARDED_SUM_TYPE>;
  awarding: EmailTemplateNotificationInput;
  bidId: Scalars['ID']['input'];
  bidRequestId: Scalars['ID']['input'];
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  discountRateCalculated: Scalars['Float']['input'];
  mainOrderNumber?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  rejection: EmailTemplateNotificationInput;
  skontoDeadline: Scalars['Int']['input'];
  skontoRate: Scalars['Float']['input'];
  taxRate: Scalars['Float']['input'];
  taxValue: Scalars['Float']['input'];
  totalGross: Scalars['Float']['input'];
  totalGrossWithSkonto: Scalars['Float']['input'];
  totalNet: Scalars['Float']['input'];
  totalNetWithDiscount: Scalars['Float']['input'];
};

export type MultiUserApprovalRequestProps =
  | MultiUserApprovalRequestAwardBidProps
  | MultiUserApprovalRequestPublishBidPackageProps
  | MultiUserApprovalRequestSendContractProps;

export type MultiUserApprovalRequestPropsInput = {
  awardBid?: InputMaybe<MultiUserApprovalRequestAwardBidPropsInput>;
  publishBidPackage?: InputMaybe<MultiUserApprovalRequestPublishBidPackagePropsInput>;
  sendContract?: InputMaybe<MultiUserApprovalRequestSendContractPropsInput>;
};

export type MultiUserApprovalRequestPublishBidPackageProps = {
  __typename: 'MultiUserApprovalRequestPublishBidPackageProps';
  customInvitationEmailIntro: Maybe<Scalars['HTML']['output']>;
  introductionEmailContent: Scalars['HTML']['output'];
  introductionEmailRecipients: Array<Scalars['ID']['output']>;
  sendIntroductionEmails: Scalars['Boolean']['output'];
  skipInvitations: Scalars['Boolean']['output'];
};

export type MultiUserApprovalRequestPublishBidPackagePropsInput = {
  customInvitationEmailIntro?: InputMaybe<Scalars['HTML']['input']>;
  introductionEmailContent?: InputMaybe<Scalars['HTML']['input']>;
  introductionEmailRecipients: Array<Scalars['ID']['input']>;
  sendIntroductionEmails: Scalars['Boolean']['input'];
  skipInvitations: Scalars['Boolean']['input'];
};

export type MultiUserApprovalRequestSendContractProps = {
  __typename: 'MultiUserApprovalRequestSendContractProps';
  isContractSigningEnabled: Scalars['Boolean']['output'];
};

export type MultiUserApprovalRequestSendContractPropsInput = {
  isContractSigningEnabled: Scalars['Boolean']['input'];
};

export type MultiUserApprovalRequestUser = AbstractEntity & {
  __typename: 'MultiUserApprovalRequestUser';
  createdAt: Scalars['DateTimeISO']['output'];
  hasApproved: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export type MultiUserApprovalRule = AbstractEntity & {
  __typename: 'MultiUserApprovalRule';
  createdAt: Scalars['DateTimeISO']['output'];
  exemptedUserRoles: Array<UserRole>;
  hasPendingRequests: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  minAmount: Scalars['Float']['output'];
  minUsers: Scalars['Int']['output'];
  timeLimitMinutes: Maybe<Scalars['Int']['output']>;
  userRoles: Array<UserRole>;
};

export type MultiUserApprovalRuleInput = {
  exemptedUserRoles?: Array<UserRoleInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  minAmount: Scalars['Float']['input'];
  minUsers: Scalars['Int']['input'];
  timeLimitMinutes?: InputMaybe<Scalars['Int']['input']>;
  userRoles: Array<UserRoleInput>;
};

export type MultiUserApprovalSummary = {
  __typename: 'MultiUserApprovalSummary';
  approveAddendum: Maybe<Scalars['Int']['output']>;
  awardBid: Maybe<Scalars['Int']['output']>;
  openBids: Maybe<Scalars['Int']['output']>;
  publishBidPackage: Maybe<Scalars['Int']['output']>;
  sendContract: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename: 'Mutation';
  abandonEditingSession: Scalars['Boolean']['output'];
  acceptTerms: Scalars['Boolean']['output'];
  activateInvitee: LoginTokenResponse;
  addBidRequestNote: Scalars['Boolean']['output'];
  addContactsToBidRequest: AddContactsToBidRequestResponse;
  addFilesToFileTree: Scalars['Boolean']['output'];
  addFolderToFileTree: Scalars['Boolean']['output'];
  addSubcontractorNote: Scalars['Boolean']['output'];
  addTaskNote: Scalars['Boolean']['output'];
  addToWatchlist: Maybe<Scalars['Boolean']['output']>;
  adminActivateInvitee: Scalars['Boolean']['output'];
  adminAiPlaygroundAddBoQ: Scalars['Boolean']['output'];
  adminAiPlaygroundClearChat: Scalars['Boolean']['output'];
  adminAiPlaygroundGenerateResponse: Scalars['Boolean']['output'];
  adminAiPlaygroundSendMessage: Scalars['Boolean']['output'];
  adminApproveSignup: Scalars['Boolean']['output'];
  adminAssignWorkCategoriesToSubcontractors: Scalars['Boolean']['output'];
  adminCancelInvite: Scalars['Boolean']['output'];
  adminChangeSubcontractorAgentCompany: Scalars['Boolean']['output'];
  adminClearBackgroundJobs: Scalars['Boolean']['output'];
  adminCreateCompany: Company;
  adminCreateGlobalCertificateType: CertificateType;
  adminCreateNetworkSubcontractor: Subcontractor;
  adminCreateNetworkWorkCategory: WorkCategory;
  adminCreatePassword: Scalars['Boolean']['output'];
  adminCreateWorkCategoryGroup: WorkCategoryGroup;
  adminDeactivateAdmin: Scalars['Boolean']['output'];
  adminDeactivateUser: Scalars['Boolean']['output'];
  adminDeleteGlobalCertificateType: Scalars['Boolean']['output'];
  adminDeleteSignup: Scalars['Boolean']['output'];
  adminDeleteUser: Scalars['Boolean']['output'];
  adminDeleteWorkCategory: Scalars['Boolean']['output'];
  adminDeleteWorkCategoryGroup: Scalars['Boolean']['output'];
  adminDenyMergeRequest: Scalars['Boolean']['output'];
  adminDenySignup: Scalars['Boolean']['output'];
  adminEnforceMfaImmediately: Scalars['Boolean']['output'];
  adminGenerateResetPasswordToken: Scalars['String']['output'];
  adminInviteAdmin: Scalars['Boolean']['output'];
  adminMergeAgentCompanies: AdminAgentCompanyMergeResponse;
  adminMergeSubcontractors: AdminSubcontractorMergeResponse;
  adminOnHoldSignup: Scalars['Boolean']['output'];
  adminProcessBackgroundJobs: Scalars['Boolean']['output'];
  adminReactivateAdmin: Scalars['Boolean']['output'];
  adminReactivateUser: Scalars['Boolean']['output'];
  adminResendEmail: Scalars['Boolean']['output'];
  adminResetPassword: Scalars['Boolean']['output'];
  adminRestoreDeletedSubcontractor: Scalars['Boolean']['output'];
  adminRestoreInvite: Scalars['Boolean']['output'];
  adminSetUserSignupTokenExpiredOnce: Scalars['Boolean']['output'];
  adminSwapWorkCategoryGroupPositions: Scalars['Boolean']['output'];
  adminUpdateAdminPermissions: Scalars['Boolean']['output'];
  adminUpdateCompany: Company;
  adminUpdateCompanyFeatureFlags: Company;
  adminUpdateCorrespondingNetworkWorkCategories: Scalars['Boolean']['output'];
  adminUpdateGlobalCertificateTypeTranslations: Array<CertificateTypeTranslation>;
  adminUpdateMe: Scalars['Boolean']['output'];
  adminUpdateNetworkSubcontractor: Subcontractor;
  adminUpdateNetworkWorkCategory: WorkCategory;
  adminUpdatePassword: Scalars['Boolean']['output'];
  adminUpdateUserDepartment: Scalars['Boolean']['output'];
  adminUpdateUserEmail: Scalars['Boolean']['output'];
  adminUpdateWorkCategoryGroup: WorkCategoryGroup;
  adminUpdateWorkCategoryTranslations: Array<WorkCategoryTranslation>;
  agentSendPremiumPurchaseRequest: Scalars['Boolean']['output'];
  agentSignupForAwardedBid: LoginTokenResponse;
  agentSignupForBidInvite: LoginTokenResponse;
  agentSignupForBidSubmission: LoginTokenResponse;
  agentSignupForCertificatesSubmission: LoginTokenResponse;
  agentSignupForMarketplaceSuggestion: LoginTokenResponse;
  agentSignupForSubcontractorSentEmail: LoginTokenResponse;
  approveInvoice: Scalars['Boolean']['output'];
  approveJoinRequest: Scalars['Boolean']['output'];
  approveMultiUserApprovalRequest: Scalars['Boolean']['output'];
  awardBidRequest: Scalars['ID']['output'];
  batchCreateNetworkWorkCategories: Array<WorkCategory>;
  bulkAddContacts: BulkAddContactsResponse;
  cancelCertificateRequest: Scalars['Boolean']['output'];
  cancelInvite: Scalars['Boolean']['output'];
  changeBidRequestCustomBidsDueAt: Scalars['Boolean']['output'];
  checkCredentials: CheckCredentialsResponse;
  checkEmailVerificationCode: SignupVerifyResponse;
  checkSubcontractorVerificationCode: LoginTokenResponse;
  checkVerificationCode: CheckVerificationCodeResponse;
  claimAnonymousDraftBid: Scalars['Boolean']['output'];
  claimSubcontractorBy: Scalars['Boolean']['output'];
  claimSubcontractorByMarketplaceSuggestion: Scalars['Boolean']['output'];
  claimSubcontractorBySentEmailId: Scalars['Boolean']['output'];
  claimSubcontractorOrCreateCompany: Maybe<LoginTokenResponse>;
  closeBidPackage: Scalars['Boolean']['output'];
  closeProject: Scalars['Boolean']['output'];
  completeAgentCompanyOnboardItem: Scalars['Boolean']['output'];
  completeContractSigning: Scalars['Boolean']['output'];
  confirmBoQImportPrices: BoQImportPrices;
  confirmCustomBudgetBillOfQuantitiesHasBeenUploaded: ConfirmBillOfQuantitiesHasBeenUploaded;
  confirmExcelRequestForProposalBoQUploaded: ConfirmRequestBoQHasBeenUploaded;
  confirmExcelTemplateBoQHasBeenUploaded: ConfirmBillOfQuantitiesHasBeenUploaded;
  confirmInviteRequestByInviteeId: User;
  confirmInviteRequestByToken: User;
  confirmProposalBoQUploadedByPrincipalUser: ConfirmBillOfQuantitiesHasBeenUploaded;
  confirmProposalBoQUploadedBySubcontractor: ConfirmBillOfQuantitiesHasBeenUploaded;
  confirmRequestForProposalBoqUploaded: ConfirmRequestBoQHasBeenUploaded;
  confirmTemplateBoQHasBeenUploaded: ConfirmBillOfQuantitiesHasBeenUploaded;
  copyItemsFromAnotherFileTree: Scalars['Boolean']['output'];
  createAdminAiPlaygroundChat: AdminAiPlaygroundChat;
  createAdminAiPlaygroundExperiment: AdminAiPlaygroundExperiment;
  createAgentCompanyCertificate: CreateCertificateResponse;
  createAgentCompanyCertificateType: CertificateType;
  createAnalyticsEvent: Scalars['Boolean']['output'];
  createBidPackage: BidPackage;
  createBidRequestByAgent: BidRequest;
  createBoQTemplate: CreateBoQTemplateResponse;
  /** Creates a new certificate type with the type "company" */
  createCompanyCertificateType: CertificateType;
  createCompanySubcontractor: Subcontractor;
  createCompanyTemplate: CompanyTemplate;
  createContractBoQPDFFromUpload: Scalars['Boolean']['output'];
  createCustomCostGroupCatalog: CreateCustomCostGroupCatalogResponse;
  createDocuSignRecipientViewUrl: Scalars['String']['output'];
  createDocuSignSenderViewUrl: Scalars['String']['output'];
  createDocument: CreateDocumentResponse;
  createDraftAddendum: DraftAddendum;
  createInvoice: Scalars['ID']['output'];
  createInvoiceNote: Scalars['Boolean']['output'];
  createInvoiceUploadUrl: CreateInvoiceUploadUrlResponse;
  createMessageThread: MessageThread;
  createMultiUserApprovalRequest: Scalars['Boolean']['output'];
  createNetworkSubcontractorByAgentUser: Subcontractor;
  createNetworkSubcontractorsImport: NetworkSubcontractorsImportCreatedResponse;
  createOffice: Office;
  createPassword: CreatePasswordResponse;
  createProject: Project;
  createSubcontractorCertificate: CreateCertificateResponse;
  createSubcontractorCertificateDraft: CreateCertificateResponse;
  createSubcontractorImportRequest: CreateSubcontractorImportRequestResponse;
  createSubcontractorPrivateContact: Contact;
  createTask: Task;
  createTerms: CreateTermsResponse;
  deactivateOffice: Scalars['Boolean']['output'];
  deactivateUser: Scalars['Boolean']['output'];
  deleteAddendum: Scalars['Boolean']['output'];
  deleteBid: Scalars['Boolean']['output'];
  deleteBidNote: Scalars['Boolean']['output'];
  deleteBidPackage: Scalars['Boolean']['output'];
  deleteBidRequest: Scalars['Boolean']['output'];
  deleteBidRequestNote: Scalars['Boolean']['output'];
  deleteBidRequests: Scalars['Boolean']['output'];
  deleteBoQInBidPackage: EditRequestBoQResponse;
  deleteBoQPositionMassDetermination: Scalars['Boolean']['output'];
  deleteBoQTemplate: Scalars['Boolean']['output'];
  deleteCertificate: Scalars['Boolean']['output'];
  /** Deletes the requested certificate type with the type "company" */
  deleteCompanyCertificateType: Scalars['Boolean']['output'];
  deleteCompanyTemplate: Scalars['Boolean']['output'];
  deleteContactFromBidRequest: Scalars['Boolean']['output'];
  deleteCustomPermissionControlsConfig: Scalars['Boolean']['output'];
  /** @deprecated Deprecated due to simplification of certificate upload flow */
  deleteDraftCertificate: Scalars['Boolean']['output'];
  deleteExternalCredential: Scalars['Boolean']['output'];
  deleteFailedInvite: Scalars['Boolean']['output'];
  deleteFileTreeItem: Scalars['Boolean']['output'];
  deleteInviteRequest: Scalars['Boolean']['output'];
  deleteInvoice: Scalars['Boolean']['output'];
  deleteJoinRequest: Scalars['Boolean']['output'];
  deleteMarketplaceSavedSearch: Scalars['Boolean']['output'];
  deleteNetworkSubcontractor: Scalars['Boolean']['output'];
  deleteOffice: Scalars['Boolean']['output'];
  deleteProject: Scalars['Boolean']['output'];
  deleteSubcontractor: Scalars['Boolean']['output'];
  deleteSubcontractorImportRequest: Scalars['Boolean']['output'];
  deleteSubcontractorNote: Scalars['Boolean']['output'];
  deleteSubcontractorRating: Scalars['Boolean']['output'];
  deleteTask: Scalars['Boolean']['output'];
  deleteTaskNote: Scalars['Boolean']['output'];
  disableCustomEmail: Scalars['Boolean']['output'];
  discardCostEstimateForProject: DiscardCostEstimateForProjectResponse;
  discardDraftBid: Scalars['Boolean']['output'];
  discardDraftBoQ: Scalars['Boolean']['output'];
  discardRequestBillOfQuantities: EditRequestBoQResponse;
  discardSimulationChanges: DiscardSimulationChangesResponse;
  discardTemplateBillOfQuantities: EditTemplateBoQResponse;
  duplicateBidPackage: Scalars['Boolean']['output'];
  duplicateBoQ: Scalars['Boolean']['output'];
  duplicateCustomCostGroupCatalog: Scalars['Boolean']['output'];
  duplicateProject: Scalars['Boolean']['output'];
  editRequestBillOfQuantities: EditRequestBoQResponse;
  editTemplateBillOfQuantities: EditTemplateBoQResponse;
  enableCustomEmail: Scalars['Boolean']['output'];
  enableMarketplaceForBidPackage: Scalars['Boolean']['output'];
  exportBids: Scalars['Boolean']['output'];
  fillOutBidBoQ: UpdateBoQFieldResponse;
  fillOutCalculationBoQ: UpdateBoQFieldResponse;
  forwardInvoice: Scalars['Boolean']['output'];
  generateAuthenticatorSecret: AuthenticatorData;
  generateContractBoQ: Scalars['Boolean']['output'];
  generateUploadUrlForBidPackageImport: TemporaryUploadUrlResponse;
  generateUploadUrlForSubcontractorsImport: GenerateUrlAndIdResponse;
  getBoQEditorPreSaveState: BoQEditorPreSaveStateResponse;
  getBoQTemplateBoQEditorPreSaveState: BoQTemplateBoQEditorPreSaveStateResponse;
  getOrCreateDraftBid: DraftBid;
  getOrCreateMarketplaceBidRequest: BidRequest;
  importBidPackage: ImportBidPackageResponse;
  inviteUsers: Array<User>;
  /** @deprecated Use markThreadsAsRead instead */
  markAsRead: Scalars['Boolean']['output'];
  markDocumentAsDownloaded: Scalars['Boolean']['output'];
  markNotificationAsRead: Scalars['Boolean']['output'];
  markNotificationsAsRead: Scalars['Boolean']['output'];
  markTaskAsDone: Task;
  markTaskAsInProgress: Task;
  markTaskAsTodo: Task;
  markThreadsAsRead: Scalars['Boolean']['output'];
  moveFileTreeItem: Scalars['Boolean']['output'];
  negotiateBidRequest: Scalars['Boolean']['output'];
  negotiateSomeBidRequests: Scalars['Boolean']['output'];
  openBlindTenderBids: Scalars['Boolean']['output'];
  publishBidPackage: Scalars['Boolean']['output'];
  reactivateOffice: Scalars['Boolean']['output'];
  reactivateUser: Scalars['Boolean']['output'];
  refreshEditingSession: RefreshEditingSessionResponse;
  rejectBidRequest: Scalars['Boolean']['output'];
  rejectCertificateRequestItem: Scalars['Boolean']['output'];
  rejectInvoice: Scalars['Boolean']['output'];
  rejectMultiUserApprovalRequest: Scalars['Boolean']['output'];
  rejectSomeBidRequests: Scalars['Boolean']['output'];
  removeMfaConfig: Scalars['Boolean']['output'];
  removeOutdatedDocuments: Scalars['Boolean']['output'];
  renameContractFile: Scalars['Boolean']['output'];
  renameFileTreeItem: Scalars['Boolean']['output'];
  renewBillingSubscription: Scalars['Boolean']['output'];
  reopenBidPackage: Scalars['Boolean']['output'];
  reopenProject: Scalars['Boolean']['output'];
  replyToMessageThread: Message;
  reportAgentCompanyClosed: Scalars['Boolean']['output'];
  reportAgentCompanyClosedBySubcontractor: Scalars['Boolean']['output'];
  requestAVAToolMoreInfo: Scalars['Boolean']['output'];
  requestAdditionalLanguagesUpsell: Scalars['Boolean']['output'];
  requestBidderIntroductionEmailUpsell: Scalars['Boolean']['output'];
  requestCertificatesUpsell: Scalars['Boolean']['output'];
  requestCompanyBrandingUpsell: Scalars['Boolean']['output'];
  requestCompanyTemplatesUpsell: Scalars['Boolean']['output'];
  requestContractExtension: Scalars['Boolean']['output'];
  requestContractsUpsell: Scalars['Boolean']['output'];
  requestCustomAccountTypesUpsell: Scalars['Boolean']['output'];
  requestCustomBidInvitesUpsell: Scalars['Boolean']['output'];
  requestCustomFieldsUpsell: Scalars['Boolean']['output'];
  requestCustomSignaturesUpsell: Scalars['Boolean']['output'];
  requestDataAndAnalyticsUpsell: Scalars['Boolean']['output'];
  requestEditingSession: RequestEditingSessionResponse;
  requestGoldPlanOffer: Scalars['Boolean']['output'];
  requestInternalDocumentManagementUpsell: Scalars['Boolean']['output'];
  requestMarketplaceUsageReport: Scalars['Boolean']['output'];
  requestMfaReset: Scalars['Boolean']['output'];
  requestMultipleOfficesUpsell: Scalars['Boolean']['output'];
  requestNDAUpsell: Scalars['Boolean']['output'];
  /** Generates a verification code for passwordless login. Sends an email containing a verification code and a "magic link" with the code embedded. If redirectUrl is omitted, the email will contain a verification code only. This mutation is meant for generic login use cases, where a custom copy is not needed. */
  requestPasswordlessLoginCode: RequestPasswordlessLoginCodeResponse;
  /** Generates a verification code for passwordless login. Sends an email containing a verification code and a "magic link" with the code embedded. This mutation is meant for agent users trying to submit a bid. */
  requestPasswordlessLoginCodeForBidSubmission: RequestPasswordlessLoginCodeResponse;
  /**
   * Generates a verification code for passwordless login. Sends an email containing a verification code and a "magic link" with the code embedded. This mutation is meant for agent users trying to add an internal note.
   * @deprecated Use the generic requestPasswordlessLoginCode instead, since this variant is not using any custom copy
   */
  requestPasswordlessLoginCodeForInternalNote: RequestPasswordlessLoginCodeResponse;
  /** Generates a verification code for passwordless login. Sends an email containing a verification code and a "magic link" with the code embedded. This mutation is meant for agent users trying to view a task. */
  requestPasswordlessLoginCodeForTask: RequestPasswordlessLoginCodeResponse;
  requestPricingPlanUpsell: Scalars['Boolean']['output'];
  requestProfileCompletion: Scalars['Boolean']['output'];
  requestProjectExport: Scalars['Boolean']['output'];
  requestReverseTrialUpsell: Scalars['Boolean']['output'];
  resendOwnConfirmationEmail: Scalars['Boolean']['output'];
  resendSignupConfirmationEmail: Scalars['Boolean']['output'];
  resendUserInvite: Scalars['Boolean']['output'];
  resetContractBoQFileTree: Scalars['Boolean']['output'];
  resetMfaConfig: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  restartBlindTender: Scalars['Boolean']['output'];
  restoreInvite: Scalars['Boolean']['output'];
  revampAgentSignupUnsolicited: RevampAgentSignupResponse;
  revealContactInfo: RevealedContactInfo;
  saveCostEstimateForProject: SaveCostEstimateForProjectResponse;
  saveInProfile: Scalars['Boolean']['output'];
  saveMarketplaceSearch: Scalars['ID']['output'];
  savePriceComparisonSimulation: SavePriceComparisonResponse;
  saveRequestBillOfQuantities: EditRequestBoQResponse;
  saveTemplateBillOfQuantities: EditTemplateBoQResponse;
  /** Connects the requested certificate type with the user's company */
  selectCertificateType: CertificateType;
  /** Connects the requested global certificate type with the user's company */
  selectGlobalCertificateType: CertificateType;
  selectPricingTier: Scalars['Boolean']['output'];
  sendBidAwardingAndRejectionEmailsAfterBidRequestWasAwarded: Scalars['Boolean']['output'];
  sendBidRejectionEmailAfterBidRequestWasRejected: Scalars['Boolean']['output'];
  sendCertificateRequest: Scalars['Boolean']['output'];
  sendInvitation: Scalars['Boolean']['output'];
  sendInviteRequests: Array<User>;
  sendMarketplaceSuggestions: Scalars['Boolean']['output'];
  sendVerificationCode: Scalars['Boolean']['output'];
  setBoQPositionMassDetermination: MassDetermination;
  showInterestInMarketplaceBidPackage: BidRequest;
  startTrial: Scalars['Boolean']['output'];
  storeAuthenticatorSecret: CheckVerificationCodeResponse;
  storeMfaPhoneNumber: CheckVerificationCodeResponse;
  storeSimulationChange: StoreSimulationChangesResponse;
  subcontractorSubmitBid: Bid;
  submitBid: Bid;
  submitBidRequest: Scalars['Boolean']['output'];
  submitBiddersSearchRequest: Scalars['Boolean']['output'];
  submitCertificateRequest: Scalars['Boolean']['output'];
  submitContract: Scalars['Boolean']['output'];
  suggestChangesToNetworkSubcontractor: Scalars['Boolean']['output'];
  suggestChangesToNetworkSubcontractorContacts: Scalars['Boolean']['output'];
  suggestNetworkSubcontractorRemoval: Scalars['Boolean']['output'];
  takeOverEditingSession: Scalars['ID']['output'];
  toggleContractDocumentRequiringSignature: TOGGLE_CONTRACT_DOCUMENT_RESULT;
  trackBidInviteView: Scalars['Boolean']['output'];
  trackExperimentImpression: Scalars['Boolean']['output'];
  trackExperimentMetric: Scalars['Boolean']['output'];
  trackMarketplaceImpression: Scalars['Boolean']['output'];
  unAwardBidRequest: Scalars['Boolean']['output'];
  unRejectBidRequest: Scalars['Boolean']['output'];
  updateAddendum: Scalars['Boolean']['output'];
  updateAddendumStatus: Scalars['Boolean']['output'];
  updateAdminAiPlaygroundExperiment: Scalars['Boolean']['output'];
  updateAwardedBid: AwardedBid;
  updateBidNote: Scalars['Boolean']['output'];
  updateBidPackage: BidPackage;
  updateBidRequestAgentStatus: BidRequest;
  updateBidRequestByAgent: BidRequest;
  updateBidRequestDeclinedReasonBySubcontractor: Scalars['Boolean']['output'];
  updateBidRequestProposedAwarded: Scalars['Boolean']['output'];
  updateBidRequestStatus: Scalars['Boolean']['output'];
  updateBidRequestStatusBySubcontractor: BidRequest;
  updateBillOfQuantitiesComment: Scalars['Boolean']['output'];
  updateBillOfQuantitiesInternalNote: Scalars['Boolean']['output'];
  updateBoQPositionTextProvider: Scalars['Boolean']['output'];
  updateBoQTemplate: UpdateBoQTemplateResponse;
  updateCertificate: Scalars['Boolean']['output'];
  updateCompany: Company;
  updateCompanyBranding: Company;
  /** Edits the requested certificate type with the type "company" */
  updateCompanyCertificateType: CertificateType;
  updateCompanyMfaConfig: Scalars['Boolean']['output'];
  updateCompanyRatingCategories: Scalars['Boolean']['output'];
  updateCompanySSOConfig: Scalars['Boolean']['output'];
  updateCompanySubcontractor: Subcontractor;
  updateCompanySubcontractorReminderSchedules: Scalars['Boolean']['output'];
  updateCompanyTemplate: CompanyTemplate;
  updateContactNotificationConfigs: Array<ContactNotificationConfig>;
  updateContractRunAgentStepContactIds: Scalars['Boolean']['output'];
  updateContractRunStepUserIds: Scalars['Boolean']['output'];
  updateCostEstimateForProject: UpdateCostEstimateForProjectResponse;
  updateCurrentUserLanguage: Scalars['Boolean']['output'];
  updateCurrentUserNotificationConfig: Scalars['Boolean']['output'];
  updateCustomCostGroupCatalog: CustomCostGroupCatalog;
  updateCustomEmail: Scalars['Boolean']['output'];
  updateCustomFields: Scalars['Boolean']['output'];
  updateDocument: Document;
  updateDraftBid: DraftBid;
  updateInvoice: Scalars['Boolean']['output'];
  updateIsContractSigningEnabled: Scalars['Boolean']['output'];
  updateMarketplaceSavedSearch: MarketplaceSavedSearch;
  updateMe: User;
  updateMessagesSignature: Scalars['Boolean']['output'];
  updateMultiUserApprovalRules: Scalars['Boolean']['output'];
  updateNetworkSubcontractorByAgentUser: Subcontractor;
  updateOffice: Office;
  updateParsedIfcFileWithAssociatedCosts: UpdateParsedIfcFileWithAssociatedCostsResponse;
  updatePassword: Scalars['Boolean']['output'];
  updatePermissionControlsConfig: Scalars['Boolean']['output'];
  updateProject: Project;
  updateSomeBidRequestStatuses: Scalars['Boolean']['output'];
  updateSubcontractorCustomFields: Scalars['Boolean']['output'];
  updateSubcontractorImportRequestStatus: Scalars['Boolean']['output'];
  updateSubcontractorIsBanned: Subcontractor;
  updateSubcontractorIsFavorite: Subcontractor;
  updateSubcontractorPrivateContacts: Subcontractor;
  updateSubcontractorWorkCategories: Scalars['Boolean']['output'];
  updateSubcontractorWorkCategoriesByAgent: Scalars['Boolean']['output'];
  updateTask: Task;
  updateUser: User;
  upsertCompanySubcontractors: LongRunningTask;
  upsertExternalCredential: Scalars['Boolean']['output'];
  upsertNetworkSubcontractor: Subcontractor;
  upsertSubcontractor: Subcontractor;
  upsertSubcontractorRating: SubcontractorRating;
  useTemplateBoQInBidPackage: Scalars['Boolean']['output'];
  validateDNS: Scalars['Boolean']['output'];
  validateNetworkSubcontractorsImport: Array<NetworkSubcontractorsImportValidationResponse>;
  validatePasswordlessLoginCode: ValidatePasswordlessLoginResponse;
  validatePasswordlessLoginToken: ValidatePasswordlessLoginResponse;
  verifyMfaPhoneNumber: Scalars['Boolean']['output'];
  withdrawBidInvite: Scalars['Boolean']['output'];
  withdrawContract: Scalars['Boolean']['output'];
  withdrawMultiUserApprovalRequest: Scalars['Boolean']['output'];
};

export type MutationabandonEditingSessionArgs = {
  sessionId: Scalars['ID']['input'];
};

export type MutationacceptTermsArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
  termsId: Scalars['ID']['input'];
};

export type MutationactivateInviteeArgs = {
  input: InviteeInput;
  token: Scalars['String']['input'];
};

export type MutationaddBidRequestNoteArgs = {
  bidRequestId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationaddContactsToBidRequestArgs = {
  bidPackageId: Scalars['ID']['input'];
  contactId?: InputMaybe<Scalars['ID']['input']>;
  customBidsDueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customInvitationEmailIntro?: InputMaybe<Scalars['HTML']['input']>;
  skipInvitation: Scalars['Boolean']['input'];
  subcontractorId: Scalars['ID']['input'];
};

export type MutationaddFilesToFileTreeArgs = {
  fileTreeAdditionsId: Scalars['ID']['input'];
  fileTreeId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};

export type MutationaddFolderToFileTreeArgs = {
  fileTreeId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type MutationaddSubcontractorNoteArgs = {
  subcontractorId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationaddTaskNoteArgs = {
  taskId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationaddToWatchlistArgs = {
  suggestionId: Scalars['ID']['input'];
};

export type MutationadminActivateInviteeArgs = {
  input: AdminInviteeInput;
  token: Scalars['String']['input'];
};

export type MutationadminAiPlaygroundAddBoQArgs = {
  chatId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  uploadKey: Scalars['ID']['input'];
};

export type MutationadminAiPlaygroundClearChatArgs = {
  chatId: Scalars['ID']['input'];
};

export type MutationadminAiPlaygroundGenerateResponseArgs = {
  chatId: Scalars['ID']['input'];
};

export type MutationadminAiPlaygroundSendMessageArgs = {
  chatId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};

export type MutationadminApproveSignupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminAssignWorkCategoriesToSubcontractorsArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  subcontractorIds: Array<Scalars['ID']['input']>;
  workCategoryIds: Array<Scalars['ID']['input']>;
};

export type MutationadminCancelInviteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminChangeSubcontractorAgentCompanyArgs = {
  agentCompanyId?: InputMaybe<Scalars['ID']['input']>;
  subcontractorId: Scalars['ID']['input'];
};

export type MutationadminCreateCompanyArgs = {
  isTest: Scalars['Boolean']['input'];
  language: LANGUAGE;
  name: Scalars['String']['input'];
  salesforceServiceId?: InputMaybe<Scalars['String']['input']>;
  type: COMPANY_TYPE;
};

export type MutationadminCreateGlobalCertificateTypeArgs = {
  countryCode: COUNTRY_CODE;
  name: Scalars['String']['input'];
};

export type MutationadminCreateNetworkSubcontractorArgs = {
  input: SubcontractorInput;
};

export type MutationadminCreateNetworkWorkCategoryArgs = {
  input: NetworkWorkCategoryInput;
};

export type MutationadminCreatePasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MutationadminCreateWorkCategoryGroupArgs = {
  input: WorkCategoryGroupInput;
};

export type MutationadminDeactivateAdminArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeactivateUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteGlobalCertificateTypeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteSignupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteWorkCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDeleteWorkCategoryGroupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDenyMergeRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminDenySignupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminEnforceMfaImmediatelyArgs = {
  companyId: Scalars['ID']['input'];
};

export type MutationadminGenerateResetPasswordTokenArgs = {
  email: Scalars['String']['input'];
};

export type MutationadminInviteAdminArgs = {
  input: AdminInviteAdminInput;
};

export type MutationadminMergeAgentCompaniesArgs = {
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  validateOnly?: Scalars['Boolean']['input'];
};

export type MutationadminMergeSubcontractorsArgs = {
  skipContacts?: Scalars['Boolean']['input'];
  skipWorkCategories?: Scalars['Boolean']['input'];
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  validateOnly?: Scalars['Boolean']['input'];
};

export type MutationadminOnHoldSignupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminProcessBackgroundJobsArgs = {
  timeToProcessAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MutationadminReactivateAdminArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminReactivateUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminResendEmailArgs = {
  id: Scalars['ID']['input'];
  newRecipient?: InputMaybe<Scalars['String']['input']>;
  resendReason: Scalars['String']['input'];
};

export type MutationadminResetPasswordArgs = {
  email: Scalars['String']['input'];
  reCaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

export type MutationadminRestoreDeletedSubcontractorArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminRestoreInviteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationadminSwapWorkCategoryGroupPositionsArgs = {
  groupAId: Scalars['ID']['input'];
  groupBId: Scalars['ID']['input'];
};

export type MutationadminUpdateAdminPermissionsArgs = {
  id: Scalars['ID']['input'];
  input: AdminAdminPermissionsInput;
};

export type MutationadminUpdateCompanyArgs = {
  id: Scalars['ID']['input'];
  input: AdminUpdateCompanyInput;
};

export type MutationadminUpdateCompanyFeatureFlagsArgs = {
  flags: Array<AdminCompanyFeatureFlagsInput>;
  id: Scalars['ID']['input'];
};

export type MutationadminUpdateCorrespondingNetworkWorkCategoriesArgs = {
  companyWorkCategoryId: Scalars['ID']['input'];
  correspondingNetworkWorkCategoryIds: Array<Scalars['ID']['input']>;
};

export type MutationadminUpdateGlobalCertificateTypeTranslationsArgs = {
  translations: Array<TranslationUpdateInput>;
};

export type MutationadminUpdateMeArgs = {
  input: AdminUpdateMeInput;
};

export type MutationadminUpdateNetworkSubcontractorArgs = {
  id: Scalars['ID']['input'];
  input: SubcontractorInput;
  reason?: InputMaybe<Scalars['String']['input']>;
  reviewedSuggestions?: InputMaybe<ReviewedSuggestionsInput>;
};

export type MutationadminUpdateNetworkWorkCategoryArgs = {
  id: Scalars['ID']['input'];
  input: NetworkWorkCategoryInput;
};

export type MutationadminUpdatePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type MutationadminUpdateUserDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: AdminUpdateUserDepartmentInput;
};

export type MutationadminUpdateUserEmailArgs = {
  id: Scalars['ID']['input'];
  input: AdminUpdateUserEmailInput;
};

export type MutationadminUpdateWorkCategoryGroupArgs = {
  id: Scalars['ID']['input'];
  input: WorkCategoryGroupInput;
};

export type MutationadminUpdateWorkCategoryTranslationsArgs = {
  translations: Array<TranslationUpdateInput>;
};

export type MutationagentSendPremiumPurchaseRequestArgs = {
  notLoggedInUserId?: InputMaybe<Scalars['ID']['input']>;
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
  tier: SUBCONTRACTOR_PRICING_TIER;
};

export type MutationagentSignupForAwardedBidArgs = {
  input: AgentSignupForAwardedBidInput;
};

export type MutationagentSignupForBidInviteArgs = {
  input: AgentSignupForBidInviteInput;
};

export type MutationagentSignupForBidSubmissionArgs = {
  input: AgentSignupForBidSubmissionInput;
};

export type MutationagentSignupForCertificatesSubmissionArgs = {
  input: AgentSignupForCertificatesSubmissionInput;
};

export type MutationagentSignupForMarketplaceSuggestionArgs = {
  input: AgentSignupForMarketplaceSuggestionInput;
};

export type MutationagentSignupForSubcontractorSentEmailArgs = {
  input: AgentSignupForSubcontractorSentEmailInput;
};

export type MutationapproveInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationapproveJoinRequestArgs = {
  type?: InputMaybe<STANDARD_USER_TYPE>;
  userId: Scalars['ID']['input'];
};

export type MutationapproveMultiUserApprovalRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationawardBidRequestArgs = {
  input: AwardBidRequestInput;
};

export type MutationbatchCreateNetworkWorkCategoriesArgs = {
  input: Array<WorkCategoryWithTranslationsListInput>;
};

export type MutationbulkAddContactsArgs = {
  amount: BULK_ADD_CONTACTS_AMOUNT;
  bidPackageId: Scalars['ID']['input'];
  customBidsDueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customInvitationEmailIntro?: InputMaybe<Scalars['HTML']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  skipInvitation: Scalars['Boolean']['input'];
  sortBy?: InputMaybe<SUBCONTRACTORS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  subcontractorFilters: SubcontractorFiltersInput;
};

export type MutationcancelCertificateRequestArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  certificateTypeId: Scalars['ID']['input'];
  subcontractorId: Scalars['ID']['input'];
};

export type MutationcancelInviteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationchangeBidRequestCustomBidsDueAtArgs = {
  bidRequestId: Scalars['ID']['input'];
  customBidsDueAt: Scalars['DateTimeISO']['input'];
};

export type MutationcheckCredentialsArgs = {
  companyType?: InputMaybe<COMPANY_TYPE>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  preferredCompanyId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationcheckEmailVerificationCodeArgs = {
  code: Scalars['String']['input'];
  signupId: Scalars['ID']['input'];
};

export type MutationcheckSubcontractorVerificationCodeArgs = {
  code: Scalars['String']['input'];
  signupId: Scalars['ID']['input'];
};

export type MutationcheckVerificationCodeArgs = {
  code: Scalars['String']['input'];
  loginToken: Scalars['String']['input'];
};

export type MutationclaimAnonymousDraftBidArgs = {
  bidId?: InputMaybe<Scalars['ID']['input']>;
  bidRequestId: Scalars['ID']['input'];
};

export type MutationclaimSubcontractorByArgs = {
  id: Scalars['ID']['input'];
  type: SUBCONTRACTOR_CLAIM_REFERENCE;
};

export type MutationclaimSubcontractorByMarketplaceSuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
};

export type MutationclaimSubcontractorBySentEmailIdArgs = {
  sentEmailId: Scalars['ID']['input'];
};

export type MutationclaimSubcontractorOrCreateCompanyArgs = {
  loginToken: Scalars['String']['input'];
  shouldClaim: Scalars['Boolean']['input'];
  subcontractorId: Scalars['ID']['input'];
};

export type MutationcloseBidPackageArgs = {
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationcloseProjectArgs = {
  emailTemplate?: InputMaybe<Scalars['HTML']['input']>;
  emailType: PROJECT_CLOSE_EMAIL_TYPE;
  id: Scalars['ID']['input'];
  shouldNotifyBidders: Scalars['Boolean']['input'];
};

export type MutationcompleteAgentCompanyOnboardItemArgs = {
  type: AGENT_COMPANY_ONBOARDING_ITEM_TYPE;
};

export type MutationcompleteContractSigningArgs = {
  bidPackageId: Scalars['ID']['input'];
  contractRunAgentStepId?: InputMaybe<Scalars['ID']['input']>;
  signedDocumentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationconfirmBoQImportPricesArgs = {
  boqContainerId: Scalars['ID']['input'];
  boqContainerType: BOQ_CONTAINER_TYPE;
  filename: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  uploadKey: Scalars['ID']['input'];
};

export type MutationconfirmCustomBudgetBillOfQuantitiesHasBeenUploadedArgs = {
  bidPackageId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  revision?: InputMaybe<Scalars['Int']['input']>;
  uploadKey: Scalars['ID']['input'];
};

export type MutationconfirmExcelRequestForProposalBoQUploadedArgs = {
  bidPackageId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  options: ExcelBoQImportOptions;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  uploadKey: Scalars['ID']['input'];
};

export type MutationconfirmExcelTemplateBoQHasBeenUploadedArgs = {
  filename: Scalars['String']['input'];
  options: ExcelBoQImportOptions;
  uploadKey: Scalars['ID']['input'];
};

export type MutationconfirmInviteRequestByInviteeIdArgs = {
  inviteeId: Scalars['ID']['input'];
};

export type MutationconfirmInviteRequestByTokenArgs = {
  token: Scalars['String']['input'];
};

export type MutationconfirmProposalBoQUploadedByPrincipalUserArgs = {
  bidRequestId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  uploadKey: Scalars['ID']['input'];
};

export type MutationconfirmProposalBoQUploadedBySubcontractorArgs = {
  bidRequestId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  uploadKey: Scalars['ID']['input'];
};

export type MutationconfirmRequestForProposalBoqUploadedArgs = {
  bidPackageId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  uploadKey: Scalars['ID']['input'];
};

export type MutationconfirmTemplateBoQHasBeenUploadedArgs = {
  filename: Scalars['String']['input'];
  uploadKey: Scalars['ID']['input'];
};

export type MutationcopyItemsFromAnotherFileTreeArgs = {
  paths: Array<Scalars['String']['input']>;
  sourceAttachable: AttachableInput;
  targetAttachable: AttachableInput;
};

export type MutationcreateAdminAiPlaygroundChatArgs = {
  experimentId: Scalars['ID']['input'];
};

export type MutationcreateAdminAiPlaygroundExperimentArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type MutationcreateAgentCompanyCertificateArgs = {
  certificateTypeId: Scalars['ID']['input'];
  fileSizeBytes: Scalars['Int']['input'];
  fileType: CERTIFICATE_FILE_TYPE;
  uploadKey?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationcreateAgentCompanyCertificateTypeArgs = {
  name: Scalars['String']['input'];
};

export type MutationcreateAnalyticsEventArgs = {
  input: AnalyticsEventInput;
  trackInLaunchDarkly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationcreateBidPackageArgs = {
  input: BidPackageInput;
};

export type MutationcreateBidRequestByAgentArgs = {
  input: BidRequestByAgentInput;
};

export type MutationcreateBoQTemplateArgs = {
  input: BoQTemplateInput;
};

export type MutationcreateCompanyCertificateTypeArgs = {
  isExpiryDateMandatory?: Scalars['Boolean']['input'];
  isSelectedByDefaultWhenRequesting: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  scope?: InputMaybe<CERTIFICATE_TYPE_SCOPE>;
  templateDocumentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationcreateCompanySubcontractorArgs = {
  input: SubcontractorInput;
};

export type MutationcreateCompanyTemplateArgs = {
  input: CompanyTemplateCreateInput;
};

export type MutationcreateContractBoQPDFFromUploadArgs = {
  bidPackageId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  pdfSettings?: InputMaybe<BidPdfSettings>;
};

export type MutationcreateCustomCostGroupCatalogArgs = {
  customCostGroups: Array<CustomCostGroupDefinitionInput>;
  name: Scalars['String']['input'];
};

export type MutationcreateDocuSignRecipientViewUrlArgs = {
  bidPackageId: Scalars['ID']['input'];
  contractRunAgentStepId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<LANGUAGE>;
};

export type MutationcreateDocuSignSenderViewUrlArgs = {
  bidPackageId: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type MutationcreateDocumentArgs = {
  input: CreateDocumentInput;
};

export type MutationcreateDraftAddendumArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type MutationcreateInvoiceArgs = {
  input: CreateInvoiceInput;
};

export type MutationcreateInvoiceNoteArgs = {
  invoiceId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationcreateInvoiceUploadUrlArgs = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationcreateMessageThreadArgs = {
  authorType: COMPANY_TYPE;
  bidPackageId: Scalars['ID']['input'];
  bidRequestIds: Array<Scalars['ID']['input']>;
  documentIds: Array<Scalars['String']['input']>;
  messageText: Scalars['HTML']['input'];
  subject: Scalars['String']['input'];
};

export type MutationcreateMultiUserApprovalRequestArgs = {
  entityId: Scalars['ID']['input'];
  requestProps?: InputMaybe<MultiUserApprovalRequestPropsInput>;
  ruleId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type MutationcreateNetworkSubcontractorByAgentUserArgs = {
  input: SubcontractorInput;
};

export type MutationcreateNetworkSubcontractorsImportArgs = {
  input: NetworkSubcontractorsImportCreateInput;
};

export type MutationcreateOfficeArgs = {
  input: OfficeInput;
};

export type MutationcreatePasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MutationcreateProjectArgs = {
  input: ProjectInput;
  projectTemplateInput?: InputMaybe<ProjectTemplateInput>;
};

export type MutationcreateSubcontractorCertificateArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  certificateRequestItemId?: InputMaybe<Scalars['ID']['input']>;
  certificateTypeId: Scalars['ID']['input'];
  fileSizeBytes: Scalars['Int']['input'];
  fileType: CERTIFICATE_FILE_TYPE;
  subcontractorId: Scalars['ID']['input'];
  uploadKey?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationcreateSubcontractorCertificateDraftArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  certificateRequestItemId?: InputMaybe<Scalars['ID']['input']>;
  certificateTypeId: Scalars['ID']['input'];
  fileSizeBytes: Scalars['Int']['input'];
  fileType: CERTIFICATE_FILE_TYPE;
  subcontractorId: Scalars['ID']['input'];
  uploadKey?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationcreateSubcontractorImportRequestArgs = {
  input: CreateSubcontractorImportRequestInput;
};

export type MutationcreateSubcontractorPrivateContactArgs = {
  contact: ContactInput;
  id: Scalars['ID']['input'];
};

export type MutationcreateTaskArgs = {
  input: TaskInput;
};

export type MutationcreateTermsArgs = {
  filename: Scalars['String']['input'];
  officeId?: InputMaybe<Scalars['ID']['input']>;
  size: Scalars['Int']['input'];
};

export type MutationdeactivateOfficeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeactivateUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteAddendumArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteBidArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteBidNoteArgs = {
  bidId: Scalars['ID']['input'];
};

export type MutationdeleteBidPackageArgs = {
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationdeleteBidRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteBidRequestNoteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteBidRequestsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type MutationdeleteBoQInBidPackageArgs = {
  bidPackageId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationdeleteBoQPositionMassDeterminationArgs = {
  billOfQuantitiesId: Scalars['ID']['input'];
  boqContainerId: Scalars['ID']['input'];
  boqContainerType: BOQ_CONTAINER_TYPE;
  boqRowId: Scalars['ID']['input'];
};

export type MutationdeleteBoQTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteCertificateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteCompanyCertificateTypeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteCompanyTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteContactFromBidRequestArgs = {
  bidInviteId: Scalars['ID']['input'];
};

export type MutationdeleteCustomPermissionControlsConfigArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteDraftCertificateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteExternalCredentialArgs = {
  externalCredentialType: EXTERNAL_CREDENTIAL_TYPE;
};

export type MutationdeleteFailedInviteArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationdeleteFileTreeItemArgs = {
  fileTreeId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};

export type MutationdeleteInviteRequestArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationdeleteInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteJoinRequestArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationdeleteMarketplaceSavedSearchArgs = {
  savedSearchId: Scalars['ID']['input'];
};

export type MutationdeleteNetworkSubcontractorArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationdeleteOfficeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteProjectArgs = {
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationdeleteSubcontractorArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteSubcontractorImportRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteSubcontractorNoteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteSubcontractorRatingArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteTaskArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteTaskNoteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdiscardCostEstimateForProjectArgs = {
  costEstimateId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationdiscardDraftBidArgs = {
  bidRequestId: Scalars['ID']['input'];
  draftBidId: Scalars['ID']['input'];
};

export type MutationdiscardDraftBoQArgs = {
  bidRequestId: Scalars['ID']['input'];
  billOfQuantitiesRevisionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationdiscardRequestBillOfQuantitiesArgs = {
  bidPackageId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  verifyEditOperationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationdiscardSimulationChangesArgs = {
  bidPackageId: Scalars['ID']['input'];
  editingSessionId?: InputMaybe<Scalars['ID']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationdiscardTemplateBillOfQuantitiesArgs = {
  boqTemplateId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  verifyEditOperationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationduplicateBidPackageArgs = {
  input: DuplicateBidPackageInput;
};

export type MutationduplicateBoQArgs = {
  destinationBidPackageId: Scalars['ID']['input'];
  sourceBidPackageId: Scalars['ID']['input'];
};

export type MutationduplicateCustomCostGroupCatalogArgs = {
  catalogId: Scalars['ID']['input'];
};

export type MutationduplicateProjectArgs = {
  input: DuplicateProjectInput;
};

export type MutationeditRequestBillOfQuantitiesArgs = {
  bidPackageId: Scalars['ID']['input'];
  inputs: Array<EditRequestForProposalsBoQInput>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  verifyEditOperationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationeditTemplateBillOfQuantitiesArgs = {
  boqTemplateId: Scalars['ID']['input'];
  inputs: Array<EditRequestForProposalsBoQInput>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  verifyEditOperationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationenableMarketplaceForBidPackageArgs = {
  id: Scalars['ID']['input'];
};

export type MutationexportBidsArgs = {
  bidPackageId: Scalars['ID']['input'];
  boqFileType: BOQ_FILE_TYPE;
};

export type MutationfillOutBidBoQArgs = {
  id: Scalars['ID']['input'];
  input: FillOutBoQInput;
};

export type MutationfillOutCalculationBoQArgs = {
  id: Scalars['ID']['input'];
  input: FillOutBoQInput;
};

export type MutationforwardInvoiceArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type MutationgenerateAuthenticatorSecretArgs = {
  loginToken?: InputMaybe<Scalars['String']['input']>;
};

export type MutationgenerateContractBoQArgs = {
  bidPackageId: Scalars['ID']['input'];
  boqFileType: BOQ_FILE_TYPE_DOWNLOADABLE_FOR_CONTRACT;
  pdfSettings?: InputMaybe<BidPdfSettings>;
};

export type MutationgenerateUploadUrlForBidPackageImportArgs = {
  filename: Scalars['String']['input'];
};

export type MutationgenerateUploadUrlForSubcontractorsImportArgs = {
  allowDuplicateSubcontractors: Scalars['Boolean']['input'];
  companyId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
};

export type MutationgetBoQEditorPreSaveStateArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type MutationgetBoQTemplateBoQEditorPreSaveStateArgs = {
  boqTemplateId: Scalars['ID']['input'];
};

export type MutationgetOrCreateDraftBidArgs = {
  bidRequestId: Scalars['ID']['input'];
};

export type MutationgetOrCreateMarketplaceBidRequestArgs = {
  bidPackageId: Scalars['ID']['input'];
  subcontractorId: Scalars['ID']['input'];
};

export type MutationimportBidPackageArgs = {
  projectId: Scalars['ID']['input'];
  storageKey: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationinviteUsersArgs = {
  bidPackageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  users: Array<UserToInviteInput>;
};

export type MutationmarkAsReadArgs = {
  messageThreadId: Scalars['ID']['input'];
};

export type MutationmarkDocumentAsDownloadedArgs = {
  id: Scalars['ID']['input'];
  subcontractorId: Scalars['ID']['input'];
};

export type MutationmarkNotificationAsReadArgs = {
  id: Scalars['ID']['input'];
};

export type MutationmarkTaskAsDoneArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationmarkTaskAsInProgressArgs = {
  id: Scalars['ID']['input'];
};

export type MutationmarkTaskAsTodoArgs = {
  id: Scalars['ID']['input'];
};

export type MutationmarkThreadsAsReadArgs = {
  messageThreadIds: Array<Scalars['ID']['input']>;
};

export type MutationmoveFileTreeItemArgs = {
  sourceFileTreeId: Scalars['ID']['input'];
  sourcePath: Scalars['String']['input'];
  targetFileTreeId: Scalars['ID']['input'];
  targetPath: Scalars['String']['input'];
};

export type MutationnegotiateBidRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationnegotiateSomeBidRequestsArgs = {
  bidRequestIds: Array<Scalars['ID']['input']>;
};

export type MutationopenBlindTenderBidsArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type MutationpublishBidPackageArgs = {
  customInvitationEmailIntro?: InputMaybe<Scalars['HTML']['input']>;
  id: Scalars['ID']['input'];
  introductionEmailContent: Scalars['HTML']['input'];
  introductionEmailRecipients: Array<Scalars['ID']['input']>;
  sendIntroductionEmails: Scalars['Boolean']['input'];
  skipInvitations: Scalars['Boolean']['input'];
};

export type MutationreactivateOfficeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationreactivateUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationrefreshEditingSessionArgs = {
  resourceId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  type: EDITING_SESSION_TYPE;
};

export type MutationrejectBidRequestArgs = {
  emailTemplate?: InputMaybe<Scalars['HTML']['input']>;
  id: Scalars['ID']['input'];
  shouldSendNotification: Scalars['Boolean']['input'];
};

export type MutationrejectCertificateRequestItemArgs = {
  certificateRequestItemId: Scalars['ID']['input'];
  rejectionReason: Scalars['String']['input'];
};

export type MutationrejectInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationrejectMultiUserApprovalRequestArgs = {
  id: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationrejectSomeBidRequestsArgs = {
  bidRequestIds: Array<Scalars['ID']['input']>;
  emailTemplate?: InputMaybe<Scalars['HTML']['input']>;
  shouldSendNotification: Scalars['Boolean']['input'];
};

export type MutationremoveOutdatedDocumentsArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type MutationrenameContractFileArgs = {
  bidPackageId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type MutationrenameFileTreeItemArgs = {
  fileTreeId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MutationrenewBillingSubscriptionArgs = {
  coupon: Scalars['String']['input'];
  planId: Scalars['String']['input'];
};

export type MutationreopenBidPackageArgs = {
  id: Scalars['ID']['input'];
};

export type MutationreopenProjectArgs = {
  id: Scalars['ID']['input'];
};

export type MutationreplyToMessageThreadArgs = {
  authorType: COMPANY_TYPE;
  documentIds: Array<Scalars['String']['input']>;
  messageText: Scalars['HTML']['input'];
  messageThreadId: Scalars['ID']['input'];
};

export type MutationreportAgentCompanyClosedArgs = {
  bidRequestId: Scalars['ID']['input'];
};

export type MutationreportAgentCompanyClosedBySubcontractorArgs = {
  modificationToken: Scalars['ID']['input'];
  subcontractorId: Scalars['ID']['input'];
};

export type MutationrequestEditingSessionArgs = {
  resourceId: Scalars['ID']['input'];
  type: EDITING_SESSION_TYPE;
};

export type MutationrequestMfaResetArgs = {
  loginToken: Scalars['String']['input'];
};

export type MutationrequestPasswordlessLoginCodeArgs = {
  email: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  skipUserInactiveCheck?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationrequestPasswordlessLoginCodeForBidSubmissionArgs = {
  bidPackageId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type MutationrequestPasswordlessLoginCodeForInternalNoteArgs = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type MutationrequestPasswordlessLoginCodeForTaskArgs = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type MutationrequestPricingPlanUpsellArgs = {
  pricingAddOn?: InputMaybe<PRICING_ADD_ON>;
  pricingPlan?: InputMaybe<PRICING_PLAN>;
};

export type MutationrequestProjectExportArgs = {
  boqType: BOQ_FILE_TYPE;
  projectId: Scalars['ID']['input'];
};

export type MutationresendOwnConfirmationEmailArgs = {
  email: Scalars['String']['input'];
};

export type MutationresendSignupConfirmationEmailArgs = {
  signupId: Scalars['ID']['input'];
};

export type MutationresendUserInviteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationresetContractBoQFileTreeArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type MutationresetMfaConfigArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationresetPasswordArgs = {
  email: Scalars['String']['input'];
  reCaptchaToken?: InputMaybe<Scalars['String']['input']>;
};

export type MutationrestartBlindTenderArgs = {
  bidPackageId: Scalars['ID']['input'];
  bidsDueAt: Scalars['DateTimeISO']['input'];
  bindingPeriod?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customInvitationEmailIntro: Scalars['String']['input'];
  openingDate: Scalars['DateTimeISO']['input'];
};

export type MutationrestoreInviteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationrevampAgentSignupUnsolicitedArgs = {
  input: AgentSignupUnsolicitedInput;
};

export type MutationrevealContactInfoArgs = {
  input: RevealContactInfoInput;
};

export type MutationsaveCostEstimateForProjectArgs = {
  costEstimateId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationsaveInProfileArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsaveMarketplaceSearchArgs = {
  input: MarketplaceSavedSearchInput;
};

export type MutationsavePriceComparisonSimulationArgs = {
  bidPackageId: Scalars['ID']['input'];
  editingSessionId?: InputMaybe<Scalars['ID']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  saveOptions: SaveSimulationOptionsInput;
};

export type MutationsaveRequestBillOfQuantitiesArgs = {
  bidPackageId: Scalars['ID']['input'];
  isShareableWithBidders?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  verifyEditOperationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationsaveTemplateBillOfQuantitiesArgs = {
  boqTemplateId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  verifyEditOperationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationselectCertificateTypeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationselectGlobalCertificateTypeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationselectPricingTierArgs = {
  tier: SUBCONTRACTOR_PRICING_TIER;
};

export type MutationsendBidAwardingAndRejectionEmailsAfterBidRequestWasAwardedArgs = {
  input: SendAwardingEmailInput;
};

export type MutationsendBidRejectionEmailAfterBidRequestWasRejectedArgs = {
  input: SendRejectionEmailInput;
};

export type MutationsendCertificateRequestArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  certificateTypeIds: Array<Scalars['ID']['input']>;
  contactId: Scalars['ID']['input'];
  dueDate?: InputMaybe<Scalars['String']['input']>;
  emailIntro?: InputMaybe<Scalars['HTML']['input']>;
  officeId: Scalars['ID']['input'];
};

export type MutationsendInvitationArgs = {
  bidInviteId: Scalars['ID']['input'];
  customInvitationEmailIntro?: InputMaybe<Scalars['HTML']['input']>;
};

export type MutationsendInviteRequestsArgs = {
  source: InviteRequestSourceInput;
  users: Array<UserToInviteInput>;
};

export type MutationsendMarketplaceSuggestionsArgs = {
  input: MarketplaceSuggestionsInput;
};

export type MutationsendVerificationCodeArgs = {
  loginToken: Scalars['String']['input'];
};

export type MutationsetBoQPositionMassDeterminationArgs = {
  billOfQuantitiesId: Scalars['ID']['input'];
  boqContainerId: Scalars['ID']['input'];
  boqContainerType: BOQ_CONTAINER_TYPE;
  boqPositionRowId: Scalars['ID']['input'];
  input: Array<SetMassDeterminationRowInput>;
  lastUsedLocalId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationshowInterestInMarketplaceBidPackageArgs = {
  bidPackageId: Scalars['ID']['input'];
  status: MARKETPLACE_BID_REQUEST_STATUS;
  subcontractorId: Scalars['ID']['input'];
};

export type MutationstartTrialArgs = {
  module: TRIAL_MODULE;
};

export type MutationstoreAuthenticatorSecretArgs = {
  code: Scalars['String']['input'];
  loginToken?: InputMaybe<Scalars['String']['input']>;
  secret: Scalars['String']['input'];
};

export type MutationstoreMfaPhoneNumberArgs = {
  code: Scalars['String']['input'];
  loginToken?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type MutationstoreSimulationChangeArgs = {
  bidPackageId: Scalars['ID']['input'];
  editingSessionId?: InputMaybe<Scalars['ID']['input']>;
  input: SimulationChangeInput;
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationsubcontractorSubmitBidArgs = {
  agentCreatedBidRequestConfirmationEmailProps?: InputMaybe<AgentCreatedBidRequestConfirmationEmailProps>;
  bidId?: InputMaybe<Scalars['ID']['input']>;
  bidRequestId: Scalars['ID']['input'];
  input?: InputMaybe<BidInput>;
};

export type MutationsubmitBidArgs = {
  bidRequestId: Scalars['ID']['input'];
  input?: InputMaybe<PrincipalSubmitBidInput>;
};

export type MutationsubmitBidRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationsubmitBiddersSearchRequestArgs = {
  bidPackageId: Scalars['ID']['input'];
  input: BiddersSearchInput;
};

export type MutationsubmitCertificateRequestArgs = {
  certificateId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationsubmitContractArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type MutationsuggestChangesToNetworkSubcontractorArgs = {
  id: Scalars['ID']['input'];
  input: SubcontractorSuggestionInput;
};

export type MutationsuggestChangesToNetworkSubcontractorContactsArgs = {
  contacts: Array<ContactInput>;
  id: Scalars['ID']['input'];
  suggestionComment: Scalars['String']['input'];
};

export type MutationsuggestNetworkSubcontractorRemovalArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationtakeOverEditingSessionArgs = {
  resourceId: Scalars['ID']['input'];
  type: EDITING_SESSION_TYPE;
};

export type MutationtoggleContractDocumentRequiringSignatureArgs = {
  bidPackageId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
};

export type MutationtrackBidInviteViewArgs = {
  bidInviteId: Scalars['ID']['input'];
};

export type MutationtrackExperimentImpressionArgs = {
  experimentFlagName: EXPERIMENT_NAME;
};

export type MutationtrackExperimentMetricArgs = {
  metricName: Scalars['String']['input'];
};

export type MutationtrackMarketplaceImpressionArgs = {
  bidPackageId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationunAwardBidRequestArgs = {
  id: Scalars['ID']['input'];
  newStatus: BID_REQUEST_STATUS;
};

export type MutationunRejectBidRequestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationupdateAddendumArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAddendumInput;
};

export type MutationupdateAddendumStatusArgs = {
  id: Scalars['ID']['input'];
  newStatus: ADDENDUM_STATUS;
};

export type MutationupdateAdminAiPlaygroundExperimentArgs = {
  boqProcessingScript?: InputMaybe<ADMIN_AI_EXPERIMENT_BOQ_PROCESSING_SCRIPT>;
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  modelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  structuredOutput?: InputMaybe<Scalars['JSONObject']['input']>;
  systemInstructions: Scalars['String']['input'];
};

export type MutationupdateAwardedBidArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAwardedBidInput;
};

export type MutationupdateBidNoteArgs = {
  bidId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationupdateBidPackageArgs = {
  comment?: InputMaybe<Scalars['HTML']['input']>;
  id: Scalars['ID']['input'];
  input: BidPackageInput;
  notifyBidders: Scalars['Boolean']['input'];
};

export type MutationupdateBidRequestAgentStatusArgs = {
  id: Scalars['ID']['input'];
  status: BID_REQUEST_STATUS_FOR_AGENT;
};

export type MutationupdateBidRequestByAgentArgs = {
  id: Scalars['ID']['input'];
  input: BidRequestByAgentInput;
};

export type MutationupdateBidRequestDeclinedReasonBySubcontractorArgs = {
  input: UpdateBidRequestDeclinedReasonByAgentInput;
};

export type MutationupdateBidRequestProposedAwardedArgs = {
  id: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
};

export type MutationupdateBidRequestStatusArgs = {
  declinedReason?: InputMaybe<BID_REQUEST_DECLINED_REASON>;
  declinedReasonOther?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: BID_REQUEST_STATUS;
};

export type MutationupdateBidRequestStatusBySubcontractorArgs = {
  id: Scalars['ID']['input'];
  status: BID_REQUEST_STATUS;
};

export type MutationupdateBillOfQuantitiesCommentArgs = {
  id: Scalars['ID']['input'];
  path: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type MutationupdateBillOfQuantitiesInternalNoteArgs = {
  id: Scalars['ID']['input'];
  path: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type MutationupdateBoQPositionTextProviderArgs = {
  id: Scalars['ID']['input'];
  textProvider: BOQ_POSITION_TEXT_PROVIDER;
};

export type MutationupdateBoQTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBoQTemplateInput;
};

export type MutationupdateCertificateArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  issueDate: Scalars['String']['input'];
};

export type MutationupdateCompanyArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type MutationupdateCompanyBrandingArgs = {
  input: CompanyBrandingInput;
};

export type MutationupdateCompanyCertificateTypeArgs = {
  id: Scalars['ID']['input'];
  isExpiryDateMandatory?: Scalars['Boolean']['input'];
  isSelectedByDefaultWhenRequesting: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  scope?: InputMaybe<CERTIFICATE_TYPE_SCOPE>;
  templateDocumentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationupdateCompanyMfaConfigArgs = {
  mfaRequired: Scalars['Boolean']['input'];
};

export type MutationupdateCompanyRatingCategoriesArgs = {
  ratingCategories: Array<RATING_CATEGORY>;
};

export type MutationupdateCompanySSOConfigArgs = {
  identityProviderEntityId: Scalars['String']['input'];
  identityProviderTargetUrl: Scalars['String']['input'];
  signingCertificate: Scalars['String']['input'];
  ssoDomains?: InputMaybe<Array<SSODomainInput>>;
  ssoFilterDomains: Scalars['Boolean']['input'];
  ssoRequired: Scalars['Boolean']['input'];
};

export type MutationupdateCompanySubcontractorArgs = {
  id: Scalars['ID']['input'];
  input: SubcontractorInput;
};

export type MutationupdateCompanySubcontractorReminderSchedulesArgs = {
  forAcceptedInvites: BID_INVITE_REMINDER_SCHEDULE;
  forContracts: CONTRACT_REMINDER_SCHEDULE;
  forInvitesWithNoResponse: BID_INVITE_REMINDER_SCHEDULE;
  id: Scalars['ID']['input'];
};

export type MutationupdateCompanyTemplateArgs = {
  id: Scalars['ID']['input'];
  input: CompanyTemplateUpdateInput;
};

export type MutationupdateContactNotificationConfigsArgs = {
  input: Array<ContactNotificationConfigInput>;
};

export type MutationupdateContractRunAgentStepContactIdsArgs = {
  bidPackageId: Scalars['ID']['input'];
  contactIds: Array<Scalars['ID']['input']>;
};

export type MutationupdateContractRunStepUserIdsArgs = {
  bidPackageId: Scalars['ID']['input'];
  contractRunStepUserIds: Array<Scalars['ID']['input']>;
};

export type MutationupdateCostEstimateForProjectArgs = {
  costEstimateId: Scalars['ID']['input'];
  costGroupLocalId: Scalars['String']['input'];
  input: UpdateCostItemInput;
  sessionId: Scalars['ID']['input'];
};

export type MutationupdateCurrentUserLanguageArgs = {
  language: LANGUAGE;
};

export type MutationupdateCurrentUserNotificationConfigArgs = {
  input: UserNotificationConfigInput;
};

export type MutationupdateCustomCostGroupCatalogArgs = {
  catalogId: Scalars['ID']['input'];
  input: UpdateCustomCostGroupCatalogInput;
};

export type MutationupdateCustomEmailArgs = {
  email: Scalars['String']['input'];
};

export type MutationupdateCustomFieldsArgs = {
  entityType: CUSTOM_FIELD_ENTITY_TYPE;
  fields: Array<CustomFieldInput>;
};

export type MutationupdateDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentInput;
};

export type MutationupdateDraftBidArgs = {
  bidRequestId: Scalars['ID']['input'];
  input: BidInput;
};

export type MutationupdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};

export type MutationupdateIsContractSigningEnabledArgs = {
  bidPackageId: Scalars['ID']['input'];
  isContractSigningEnabled: Scalars['Boolean']['input'];
};

export type MutationupdateMarketplaceSavedSearchArgs = {
  id: Scalars['ID']['input'];
  isNotificationEnabled: Scalars['Boolean']['input'];
};

export type MutationupdateMeArgs = {
  input: UpdateMeInput;
};

export type MutationupdateMessagesSignatureArgs = {
  input: CustomSignatureInput;
};

export type MutationupdateMultiUserApprovalRulesArgs = {
  action: MULTI_USER_APPROVAL_ACTION;
  inputs: Array<MultiUserApprovalRuleInput>;
};

export type MutationupdateNetworkSubcontractorByAgentUserArgs = {
  id: Scalars['ID']['input'];
  input: SubcontractorInput;
};

export type MutationupdateOfficeArgs = {
  id: Scalars['ID']['input'];
  input: OfficeInput;
};

export type MutationupdateParsedIfcFileWithAssociatedCostsArgs = {
  documentId: Scalars['ID']['input'];
  input: UpdateParsedIfcFileNodeAssociatedCost;
  nodeLocalId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type MutationupdatePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type MutationupdatePermissionControlsConfigArgs = {
  config: PermissionControlsConfigInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userType: USER_TYPE;
};

export type MutationupdateProjectArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  input: ProjectInput;
  notifyBidders: Scalars['Boolean']['input'];
};

export type MutationupdateSomeBidRequestStatusesArgs = {
  bidRequestIds: Array<Scalars['ID']['input']>;
  status: BID_REQUEST_STATUS;
};

export type MutationupdateSubcontractorCustomFieldsArgs = {
  customFields: Array<CustomFieldValueInput>;
  id: Scalars['ID']['input'];
};

export type MutationupdateSubcontractorImportRequestStatusArgs = {
  id: Scalars['ID']['input'];
  status: SUBCONTRACTOR_IMPORT_REQUEST_STATUS;
};

export type MutationupdateSubcontractorIsBannedArgs = {
  id: Scalars['ID']['input'];
  isBanned: Scalars['Boolean']['input'];
};

export type MutationupdateSubcontractorIsFavoriteArgs = {
  id: Scalars['ID']['input'];
  isFavorite: Scalars['Boolean']['input'];
};

export type MutationupdateSubcontractorPrivateContactsArgs = {
  contacts: Array<ContactInput>;
  id: Scalars['ID']['input'];
};

export type MutationupdateSubcontractorWorkCategoriesArgs = {
  confirmWorkCategoriesModal?: InputMaybe<Scalars['Boolean']['input']>;
  modificationToken: Scalars['ID']['input'];
  subcontractorId: Scalars['ID']['input'];
  workCategories?: InputMaybe<Array<WorkCategoryInput>>;
};

export type MutationupdateSubcontractorWorkCategoriesByAgentArgs = {
  bidRequestId: Scalars['ID']['input'];
  confirmWorkCategoriesModal?: InputMaybe<Scalars['Boolean']['input']>;
  workCategories?: InputMaybe<Array<WorkCategoryInput>>;
};

export type MutationupdateTaskArgs = {
  id: Scalars['ID']['input'];
  input: TaskInput;
};

export type MutationupdateUserArgs = {
  customUserRoleId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  officeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: USER_TYPE;
};

export type MutationupsertCompanySubcontractorsArgs = {
  allowDuplicateSubcontractors: Scalars['Boolean']['input'];
  importId: Scalars['ID']['input'];
  importToUpdateId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationupsertExternalCredentialArgs = {
  externalCredentialInput: ExternalCredentialInput;
};

export type MutationupsertNetworkSubcontractorArgs = {
  input: UpsertSubcontractorInput;
};

export type MutationupsertSubcontractorArgs = {
  input: UpsertSubcontractorInput;
};

export type MutationupsertSubcontractorRatingArgs = {
  input: SubcontractorRatingInput;
};

export type MutationuseTemplateBoQInBidPackageArgs = {
  costGroupCatalogsToImport: TemplateBoQCostGroupCatalogsToImportInput;
  destinationBidPackageId: Scalars['ID']['input'];
  fieldsToImport: TemplateBoQFieldsToImportInput;
  sourceBoQTemplateId: Scalars['ID']['input'];
};

export type MutationvalidateNetworkSubcontractorsImportArgs = {
  id: Scalars['ID']['input'];
};

export type MutationvalidatePasswordlessLoginCodeArgs = {
  companyType?: InputMaybe<COMPANY_TYPE>;
  email: Scalars['String']['input'];
  preferredCompanyId?: InputMaybe<Scalars['ID']['input']>;
  verificationCode: Scalars['String']['input'];
};

export type MutationvalidatePasswordlessLoginTokenArgs = {
  companyType?: InputMaybe<COMPANY_TYPE>;
  preferredCompanyId?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
};

export type MutationverifyMfaPhoneNumberArgs = {
  loginToken?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type MutationwithdrawBidInviteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationwithdrawContractArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type MutationwithdrawMultiUserApprovalRequestArgs = {
  id: Scalars['ID']['input'];
};

export enum NETWORK_SUBCONTRACTOR_IMPORT_GENERAL_VALIDATION_CONSTRAINT {
  empty = 'empty',
  invalid = 'invalid',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_HEADER_VALIDATION_CONSTRAINT {
  missingColumns = 'missingColumns',
  unknownColumns = 'unknownColumns',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_OPERATION {
  create = 'create',
  update = 'update',
  upsert = 'upsert',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_RELATIONS_STRATEGY {
  appendOnly = 'appendOnly',
  override = 'override',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_ROW_VALIDATION_CONSTRAINT {
  deleted = 'deleted',
  invalidType = 'invalidType',
  invalidValue = 'invalidValue',
  missingIdentifier = 'missingIdentifier',
  missingProperties = 'missingProperties',
  notFound = 'notFound',
}

export enum NETWORK_SUBCONTRACTOR_IMPORT_STATUS {
  created = 'created',
  processing = 'processing',
  processingCompleted = 'processingCompleted',
  validationFailed = 'validationFailed',
  validationSuccessful = 'validationSuccessful',
}

export type NetworkSubcontractor = AbstractEntity & {
  __typename: 'NetworkSubcontractor';
  aboutUs: Maybe<Scalars['String']['output']>;
  certificatesCount: Scalars['Int']['output'];
  city: Maybe<Scalars['String']['output']>;
  companySize: Maybe<COMPANY_SIZE>;
  countryCode: Maybe<COUNTRY_CODE>;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Maybe<Scalars['String']['output']>;
  generatedDescription: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageKeys: Array<Scalars['String']['output']>;
  lat: Maybe<Scalars['Float']['output']>;
  logoKey: Maybe<Scalars['String']['output']>;
  long: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  orderAreaCountryCode: Maybe<COUNTRY_CODE>;
  orderAreaStateCodes: Maybe<Array<STATE_CODE>>;
  orderAreaType: ORDER_AREA_TYPE;
  orderRadius: Maybe<ORDER_RADIUS>;
  postalCode: Maybe<Scalars['String']['output']>;
  referenceProject: Maybe<SubcontractorReferenceProject>;
  referenceProjects: Array<SubcontractorReferenceProject>;
  slug: Scalars['String']['output'];
  workCategories: Array<WorkCategory>;
};

export type NetworkSubcontractordescriptionArgs = {
  language: LANGUAGE;
};

export type NetworkSubcontractorreferenceProjectArgs = {
  position: Scalars['Int']['input'];
};

export type NetworkSubcontractorWithContactAvailability = AbstractEntity & {
  __typename: 'NetworkSubcontractorWithContactAvailability';
  aboutUs: Maybe<Scalars['String']['output']>;
  certificatesCount: Scalars['Int']['output'];
  city: Maybe<Scalars['String']['output']>;
  companySize: Maybe<COMPANY_SIZE>;
  countryCode: Maybe<COUNTRY_CODE>;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Maybe<Scalars['String']['output']>;
  generatedDescription: Maybe<Scalars['String']['output']>;
  hasEmail: Scalars['Boolean']['output'];
  hasPhone: Scalars['Boolean']['output'];
  hasStreet: Scalars['Boolean']['output'];
  hasWebsite: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageKeys: Array<Scalars['String']['output']>;
  lat: Maybe<Scalars['Float']['output']>;
  logoKey: Maybe<Scalars['String']['output']>;
  long: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  orderAreaCountryCode: Maybe<COUNTRY_CODE>;
  orderAreaStateCodes: Maybe<Array<STATE_CODE>>;
  orderAreaType: ORDER_AREA_TYPE;
  orderRadius: Maybe<ORDER_RADIUS>;
  postalCode: Maybe<Scalars['String']['output']>;
  referenceProject: Maybe<SubcontractorReferenceProject>;
  referenceProjects: Array<SubcontractorReferenceProject>;
  slug: Scalars['String']['output'];
  workCategories: Array<WorkCategory>;
};

export type NetworkSubcontractorWithContactAvailabilitydescriptionArgs = {
  language: LANGUAGE;
};

export type NetworkSubcontractorWithContactAvailabilityreferenceProjectArgs = {
  position: Scalars['Int']['input'];
};

export type NetworkSubcontractorsByWorkCategoryResponse = {
  __typename: 'NetworkSubcontractorsByWorkCategoryResponse';
  /** This field returns the correct work category object even if it has already a new slug for given language */
  selectedWorkCategory: WorkCategory;
  /** This field returns the correct work category id even if it has already a new slug for given language */
  selectedWorkCategoryId: Scalars['String']['output'];
  subcontractors: Array<NetworkSubcontractor>;
  totalRecords: Scalars['Int']['output'];
};

export type NetworkSubcontractorsImport = AbstractEntity & {
  __typename: 'NetworkSubcontractorsImport';
  createdAt: Scalars['DateTimeISO']['output'];
  dryRun: Maybe<Scalars['Boolean']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  operation: NETWORK_SUBCONTRACTOR_IMPORT_OPERATION;
  percentComplete: Maybe<Scalars['Int']['output']>;
  relationsStrategy: NETWORK_SUBCONTRACTOR_IMPORT_RELATIONS_STRATEGY;
  reportUrl: Maybe<Scalars['String']['output']>;
  skipEmpty: Maybe<Scalars['Boolean']['output']>;
  status: NETWORK_SUBCONTRACTOR_IMPORT_STATUS;
  validateOnly: Maybe<Scalars['Boolean']['output']>;
};

export type NetworkSubcontractorsImportCreateInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filename: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  operation: NETWORK_SUBCONTRACTOR_IMPORT_OPERATION;
  relationsStrategy: NETWORK_SUBCONTRACTOR_IMPORT_RELATIONS_STRATEGY;
  skipEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  validateOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NetworkSubcontractorsImportCreatedResponse = AbstractEntity & {
  __typename: 'NetworkSubcontractorsImportCreatedResponse';
  createdAt: Scalars['DateTimeISO']['output'];
  dryRun: Maybe<Scalars['Boolean']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  operation: NETWORK_SUBCONTRACTOR_IMPORT_OPERATION;
  percentComplete: Maybe<Scalars['Int']['output']>;
  relationsStrategy: NETWORK_SUBCONTRACTOR_IMPORT_RELATIONS_STRATEGY;
  reportUrl: Maybe<Scalars['String']['output']>;
  skipEmpty: Maybe<Scalars['Boolean']['output']>;
  status: NETWORK_SUBCONTRACTOR_IMPORT_STATUS;
  uploadUrl: Scalars['String']['output'];
  validateOnly: Maybe<Scalars['Boolean']['output']>;
};

export type NetworkSubcontractorsImportValidationResponse =
  | GeneralValidationConstraintError
  | HeaderValidationConstraintError
  | RowValidationConstraintError;

export type NetworkSubcontractorsResponse = {
  __typename: 'NetworkSubcontractorsResponse';
  subcontractors: Array<NetworkSubcontractor>;
  totalRecords: Scalars['Int']['output'];
};

export type NetworkWorkCategoryInput = {
  groupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  translations: Array<WorkCategoryTranslationInput>;
};

export type NewBidNotification = AbstractEntity &
  Notification & {
    __typename: 'NewBidNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: NewBidNotificationProps;
  };

export type NewBidNotificationProps = {
  __typename: 'NewBidNotificationProps';
  absoluteDiscount: Maybe<Scalars['Float']['output']>;
  additionalCosts: Maybe<Scalars['Float']['output']>;
  bidId: Scalars['String']['output'];
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  bidRequestId: Scalars['String']['output'];
  currency: Maybe<CURRENCY>;
  discountRate: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  skontoDeadline: Maybe<Scalars['Float']['output']>;
  skontoRate: Maybe<Scalars['Float']['output']>;
  subcontractorName: Scalars['String']['output'];
  taxRate: Maybe<Scalars['Float']['output']>;
  teamMemberName: Maybe<Scalars['String']['output']>;
  totalNet: Maybe<Scalars['Float']['output']>;
};

export type NewMessageNotification = AbstractEntity &
  Notification & {
    __typename: 'NewMessageNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: NewMessageNotificationProps;
  };

export type NewMessageNotificationProps = {
  __typename: 'NewMessageNotificationProps';
  authorId: Scalars['String']['output'];
  authorName: Scalars['String']['output'];
  authorType: COMPANY_TYPE;
  bidPackageId: Scalars['String']['output'];
  bidPackageName: Scalars['String']['output'];
  bidRequestId: Scalars['String']['output'];
  messageThreadId: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type Note = {
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  user: Maybe<User>;
};

export type Notification = {
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
};

export type NotificationsResponse = {
  __typename: 'NotificationsResponse';
  notifications: Array<AnyNotification>;
  totalRecords: Scalars['Int']['output'];
  totalUnread: Scalars['Int']['output'];
};

export type NumberDiff = {
  __typename: 'NumberDiff';
  new: Maybe<Scalars['Float']['output']>;
  old: Maybe<Scalars['Float']['output']>;
};

export enum OFFICE_DEFAULT_MARKETPLACE_OPTIONS {
  disabled = 'disabled',
  enabled = 'enabled',
  forced = 'forced',
}

export enum OFFICE_REQUIRE_TERMS_OPTION {
  none = 'none',
  requiredAlways = 'requiredAlways',
  requiredPerProject = 'requiredPerProject',
}

export enum OFFICE_STATUS {
  active = 'active',
  inactive = 'inactive',
}

export enum ORDER_AREA_TYPE {
  country = 'country',
  radius = 'radius',
  state = 'state',
  worldwide = 'worldwide',
}

export enum ORDER_RADIUS {
  km_20 = 'km_20',
  km_50 = 'km_50',
  km_100 = 'km_100',
  km_200 = 'km_200',
  km_350 = 'km_350',
  km_500 = 'km_500',
  km_750 = 'km_750',
  km_1000 = 'km_1000',
  km_2000 = 'km_2000',
  km_3000 = 'km_3000',
  unlimited = 'unlimited',
}

export enum ORIENTATION {
  landscape = 'landscape',
  portrait = 'portrait',
}

export type Office = AbstractEntity &
  GeocodedGraphQLEntity & {
    __typename: 'Office';
    aboutUs: Maybe<Scalars['HTML']['output']>;
    aboutUsImageKeys: Array<Scalars['String']['output']>;
    acceptingTerms: OFFICE_REQUIRE_TERMS_OPTION;
    city: Maybe<Scalars['String']['output']>;
    company: Company;
    companySize: Maybe<COMPANY_SIZE>;
    countryCode: Maybe<COUNTRY_CODE>;
    createdAt: Scalars['DateTimeISO']['output'];
    creditreformLink: Maybe<Scalars['String']['output']>;
    currency: CURRENCY;
    currentTerms: Maybe<Terms>;
    email: Maybe<Scalars['String']['output']>;
    fax: Maybe<Scalars['String']['output']>;
    foundingYear: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    language: LANGUAGE;
    lat: Maybe<Scalars['Float']['output']>;
    legalDisclosure: Maybe<Scalars['String']['output']>;
    logoKey: Maybe<Scalars['String']['output']>;
    long: Maybe<Scalars['Float']['output']>;
    marketplaceDefaultForAwarding: OFFICE_DEFAULT_MARKETPLACE_OPTIONS;
    marketplaceDefaultForEstimation: OFFICE_DEFAULT_MARKETPLACE_OPTIONS;
    marketplacePublishedBidPackagesCount: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    ownerName: Maybe<Scalars['String']['output']>;
    phone: Maybe<Scalars['String']['output']>;
    postalCode: Maybe<Scalars['String']['output']>;
    registrationCity: Maybe<Scalars['String']['output']>;
    registrationNumber: Maybe<Scalars['String']['output']>;
    registrationPostalCode: Maybe<Scalars['String']['output']>;
    status: OFFICE_STATUS;
    street: Maybe<Scalars['String']['output']>;
    tradeRegisterLink: Maybe<Scalars['String']['output']>;
    website: Maybe<Scalars['String']['output']>;
  };

export enum OfficeAuthActions {
  createProject = 'createProject',
  createTerms = 'createTerms',
  deactivateOrReactivate = 'deactivateOrReactivate',
  delete = 'delete',
  update = 'update',
  view = 'view',
}

export type OfficeAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type OfficeAuthInput = {
  action: OfficeAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OfficeAuthArgsInput>;
};

export type OfficeDetailsIncluded = {
  __typename: 'OfficeDetailsIncluded';
  issue: Maybe<BP_PUBLICATION_OFFICE_DETAILS_INCLUDED_ISSUE>;
};

export type OfficeInput = {
  aboutUs?: InputMaybe<Scalars['HTML']['input']>;
  aboutUsImageKeys: Array<Scalars['String']['input']>;
  acceptingTerms: OFFICE_REQUIRE_TERMS_OPTION;
  city?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<COMPANY_SIZE>;
  countryCode?: InputMaybe<COUNTRY_CODE>;
  creditreformLink?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CURRENCY>;
  currentTermsId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  foundingYear?: InputMaybe<Scalars['Int']['input']>;
  language: LANGUAGE;
  legalDisclosure?: InputMaybe<Scalars['HTML']['input']>;
  logoKey?: InputMaybe<Scalars['String']['input']>;
  marketplaceDefaultForAwarding?: InputMaybe<OFFICE_DEFAULT_MARKETPLACE_OPTIONS>;
  marketplaceDefaultForEstimation?: InputMaybe<OFFICE_DEFAULT_MARKETPLACE_OPTIONS>;
  name: Scalars['String']['input'];
  ownerName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  registrationCity?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  registrationPostalCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  tradeRegisterLink?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type OrderAreaTypeDiff = {
  __typename: 'OrderAreaTypeDiff';
  new: Maybe<ORDER_AREA_TYPE>;
  old: Maybe<ORDER_AREA_TYPE>;
};

export type OrderRadiusDiff = {
  __typename: 'OrderRadiusDiff';
  new: Maybe<ORDER_RADIUS>;
  old: Maybe<ORDER_RADIUS>;
};

export type Organization = AbstractEntity & {
  __typename: 'Organization';
  companies: Array<Company>;
  companiesNames: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  identityProviderEntityId: Maybe<Scalars['String']['output']>;
  identityProviderTargetUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serviceProviderAcsUrl: Scalars['String']['output'];
  serviceProviderEntityId: Scalars['String']['output'];
  signingCertificate: Maybe<Scalars['String']['output']>;
  ssoDirectLoginUrl: Scalars['String']['output'];
  ssoDomains: Maybe<Array<SSODomain>>;
  ssoFilterDomains: Scalars['Boolean']['output'];
  ssoNameId: Scalars['String']['output'];
  ssoRequired: Scalars['Boolean']['output'];
};

export enum PARSED_IFC_FILE_AUTODESK_PROCESSING_STATE {
  error = 'error',
  pending = 'pending',
  success = 'success',
}

export enum PARSED_IFC_FILE_NODE_BASE_QUANTITY_TYPE {
  crossSectionArea = 'crossSectionArea',
  grossArea = 'grossArea',
  grossFootprintArea = 'grossFootprintArea',
  grossVolume = 'grossVolume',
  length = 'length',
  netArea = 'netArea',
  netVolume = 'netVolume',
  netWeight = 'netWeight',
  outerSurfaceArea = 'outerSurfaceArea',
  width = 'width',
}

export type PCTPdfSettings = {
  includeBiddersComments: Scalars['Boolean']['input'];
  includeExecutionDescriptions: Scalars['Boolean']['input'];
  includeInternalNotes: Scalars['Boolean']['input'];
  includeLongDescriptions: Scalars['Boolean']['input'];
  includeNotes: Scalars['Boolean']['input'];
  orientation: ORIENTATION;
};

export enum PREMIUM_ENABLED_REASON {
  organization = 'organization',
  subscription = 'subscription',
}

export enum PRICE_LIBRARY_BOQ_ELEMENT_TYPE {
  note = 'note',
  position = 'position',
}

export enum PRICE_LIBRARY_POSITIONS_SORT_FIELD {
  submittedAt = 'submittedAt',
}

export enum PRICE_PREDICTION_CONTEXT {
  pct = 'pct',
  proposalDraft = 'proposalDraft',
  requestForProposals = 'requestForProposals',
  requestForProposalsDraft = 'requestForProposalsDraft',
}

export enum PRICE_PREDICTION_EVALUATION_STATUS {
  high = 'high',
  low = 'low',
  noPrice = 'noPrice',
  within = 'within',
}

export enum PRICE_PREDICTION_RANGE {
  high = 'high',
  low = 'low',
  medium = 'medium',
}

export enum PRICING_ADD_ON {
  ai = 'ai',
  analytics = 'analytics',
}

export enum PRICING_PLAN {
  bronze = 'bronze',
  enterprise = 'enterprise',
  gold = 'gold',
  silver = 'silver',
}

export enum PROJECTS_SORT_FIELD {
  createdAt = 'createdAt',
  customField = 'customField',
  customer = 'customer',
  endsOn = 'endsOn',
  name = 'name',
  number = 'number',
  officeName = 'officeName',
  primaryUser = 'primaryUser',
  startsOn = 'startsOn',
}

export enum PROJECT_CATEGORY {
  masterAgreement = 'masterAgreement',
  modification = 'modification',
  newBuilding = 'newBuilding',
  other = 'other',
  rehabilitation = 'rehabilitation',
  renovation = 'renovation',
}

export enum PROJECT_CLOSE_EMAIL_TYPE {
  projectClosed = 'projectClosed',
  rejection = 'rejection',
}

export enum PROJECT_COST_CATALOG_TYPE {
  custom = 'custom',
  din276 = 'din276',
  oenorm = 'oenorm',
  stlbWorkCategory = 'stlbWorkCategory',
}

export enum PROJECT_PHASE {
  allPhases = 'allPhases',
  estimation = 'estimation',
  tendering = 'tendering',
}

export enum PROJECT_STATUS {
  closed = 'closed',
  completed = 'completed',
  draft = 'draft',
  published = 'published',
}

export type ParsedIfcFile = AbstractEntity & {
  __typename: 'ParsedIfcFile';
  autodeskObjectId: Scalars['String']['output'];
  autodeskProcessingState: PARSED_IFC_FILE_AUTODESK_PROCESSING_STATE;
  createdAt: Scalars['DateTimeISO']['output'];
  document: Document;
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  nodes: Maybe<Array<ParsedIfcFileNode>>;
};

export type ParsedIfcFileNode = {
  __typename: 'ParsedIfcFileNode';
  associatedCost: Maybe<ParsedIfcFileNodeAssociatedCost>;
  baseQuantities: Maybe<Array<ParsedIfcFileNodeBaseQuantity>>;
  id: Scalars['ID']['output'];
  localId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentNodeLocalId: Maybe<Scalars['String']['output']>;
  sourceParsedFileId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type ParsedIfcFileNodeAssociatedCost = {
  __typename: 'ParsedIfcFileNodeAssociatedCost';
  bidPackageId: Maybe<Scalars['ID']['output']>;
  costGroupLocalId: Maybe<Scalars['String']['output']>;
  factor: Maybe<Scalars['Float']['output']>;
  quantity: Maybe<Scalars['Float']['output']>;
  quantityFormula: Maybe<Scalars['String']['output']>;
  taxRate: Maybe<Scalars['Float']['output']>;
  unit: Maybe<Scalars['String']['output']>;
  unitPrice: Maybe<Scalars['Float']['output']>;
};

export type ParsedIfcFileNodeBaseQuantity = {
  __typename: 'ParsedIfcFileNodeBaseQuantity';
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  type: PARSED_IFC_FILE_NODE_BASE_QUANTITY_TYPE;
  unit: Maybe<Scalars['String']['output']>;
};

export type ParsedStlbDataResponse = {
  __typename: 'ParsedStlbDataResponse';
  costGroupId: Maybe<Scalars['String']['output']>;
  htmlLongText: Scalars['String']['output'];
  shortText: Scalars['String']['output'];
  standardizedDescription: StandardizedDescriptionResponse;
  unitPrice: Scalars['Float']['output'];
  unitTag: Scalars['String']['output'];
};

export type PartialInvoice = {
  __typename: 'PartialInvoice';
  approvedTotalNet: Scalars['Float']['output'];
  assignee: Maybe<InvoiceAssignee>;
  bidPackage: BidPackage;
  cashDiscountDeadline: Maybe<Scalars['String']['output']>;
  cashDiscountValue: Scalars['Float']['output'];
  customRows: Array<InvoiceCustomRow>;
  discountValue: Scalars['Float']['output'];
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insuranceValue: Scalars['Float']['output'];
  issuedAt: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  nonApprovedTotalNet: Scalars['Float']['output'];
  numberExternal: Maybe<Scalars['String']['output']>;
  numberInternal: Maybe<Scalars['String']['output']>;
  partialInvoiceNumber: Scalars['Int']['output'];
  paymentDeadline: Scalars['String']['output'];
  receiptDate: Maybe<Scalars['String']['output']>;
  retentionValue: Scalars['Float']['output'];
  status: INVOICE_STATUS;
  statusChanges: Array<InvoiceStatusChange>;
  subcontractorBic: Maybe<Scalars['String']['output']>;
  subcontractorCity: Maybe<Scalars['String']['output']>;
  subcontractorCountryCode: Maybe<COUNTRY_CODE>;
  subcontractorEmail: Maybe<Scalars['String']['output']>;
  subcontractorIban: Maybe<Scalars['String']['output']>;
  subcontractorName: Maybe<Scalars['String']['output']>;
  subcontractorPhone: Maybe<Scalars['String']['output']>;
  subcontractorPostalCode: Maybe<Scalars['String']['output']>;
  subcontractorStreet: Maybe<Scalars['String']['output']>;
  taxRate: Scalars['Float']['output'];
};

export type PermissionControlsConfig = {
  __typename: 'PermissionControlsConfig';
  bidPackageCreateEditPublish: Scalars['Boolean']['output'];
  bidPackageDelete: Scalars['Boolean']['output'];
  bidPackageInternalDataView: Scalars['Boolean']['output'];
  bidPackageModifyMarketplacePublishing: Scalars['Boolean']['output'];
  bidPackageProjectDocumentsViewDownload: Scalars['Boolean']['output'];
  bidPackageView: Scalars['Boolean']['output'];
  /** @deprecated No longer used */
  bidPackagesCanDeletePublished: Scalars['Boolean']['output'];
  bidderDeleteBids: Scalars['Boolean']['output'];
  bidderInviteManageBids: Scalars['Boolean']['output'];
  boqDelete: Scalars['Boolean']['output'];
  boqImportEdit: Scalars['Boolean']['output'];
  boqPriceBenchmark: Scalars['Boolean']['output'];
  boqPriceLibrary: Scalars['Boolean']['output'];
  boqTemplateCreateEdit: Scalars['Boolean']['output'];
  boqTemplateDelete: Scalars['Boolean']['output'];
  certificateTypesCreate: Scalars['Boolean']['output'];
  companyDocumentsViewDownload: Scalars['Boolean']['output'];
  companySubcontractorsExport: Scalars['Boolean']['output'];
  companySubcontractorsView: Scalars['Boolean']['output'];
  companyUploadInternalFilingDocuments: Scalars['Boolean']['output'];
  contractPrepare: Scalars['Boolean']['output'];
  contractSend: Scalars['Boolean']['output'];
  invoicesDeleteApprovedRejected: Scalars['Boolean']['output'];
  messageSend: Scalars['Boolean']['output'];
  messageView: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  pctExport: Scalars['Boolean']['output'];
  pctView: Scalars['Boolean']['output'];
  projectCloseReopen: Scalars['Boolean']['output'];
  projectCreateEdit: Scalars['Boolean']['output'];
  projectDelete: Scalars['Boolean']['output'];
  projectInternalDataView: Scalars['Boolean']['output'];
  /** @deprecated No longer used */
  projectsAllowDeletingWithNonDraftBidPackages: Scalars['Boolean']['output'];
  projectsFromAccessibleOffices: Scalars['Boolean']['output'];
  reportingView: Scalars['Boolean']['output'];
  subcontractorAddEdit: Scalars['Boolean']['output'];
  subcontractorBanFavorite: Scalars['Boolean']['output'];
  subcontractorBidRequestsView: Scalars['Boolean']['output'];
  subcontractorCertificatesRequest: Scalars['Boolean']['output'];
  subcontractorCertificatesUpdateDelete: Scalars['Boolean']['output'];
  subcontractorCertificatesView: Scalars['Boolean']['output'];
  subcontractorDelete: Scalars['Boolean']['output'];
  subcontractorNotesViewUpdateCreate: Scalars['Boolean']['output'];
  subcontractorRate: Scalars['Boolean']['output'];
  userAddEditDeactivate: Scalars['Boolean']['output'];
};

export type PermissionControlsConfigInput = {
  bidPackageCreateEditPublish: Scalars['Boolean']['input'];
  bidPackageDelete: Scalars['Boolean']['input'];
  bidPackageInternalDataView: Scalars['Boolean']['input'];
  bidPackageModifyMarketplacePublishing: Scalars['Boolean']['input'];
  bidPackageProjectDocumentsViewDownload: Scalars['Boolean']['input'];
  bidPackageView: Scalars['Boolean']['input'];
  /** @deprecated No longer used */
  bidPackagesCanDeletePublished?: InputMaybe<Scalars['Boolean']['input']>;
  bidderDeleteBids: Scalars['Boolean']['input'];
  bidderInviteManageBids: Scalars['Boolean']['input'];
  boqDelete: Scalars['Boolean']['input'];
  boqImportEdit: Scalars['Boolean']['input'];
  boqPriceBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  boqPriceLibrary?: InputMaybe<Scalars['Boolean']['input']>;
  boqTemplateCreateEdit: Scalars['Boolean']['input'];
  boqTemplateDelete: Scalars['Boolean']['input'];
  certificateTypesCreate?: InputMaybe<Scalars['Boolean']['input']>;
  companyDocumentsViewDownload: Scalars['Boolean']['input'];
  companySubcontractorsExport: Scalars['Boolean']['input'];
  companySubcontractorsView: Scalars['Boolean']['input'];
  companyUploadInternalFilingDocuments: Scalars['Boolean']['input'];
  contractPrepare: Scalars['Boolean']['input'];
  contractSend: Scalars['Boolean']['input'];
  invoicesDeleteApprovedRejected: Scalars['Boolean']['input'];
  messageSend: Scalars['Boolean']['input'];
  messageView: Scalars['Boolean']['input'];
  pctExport: Scalars['Boolean']['input'];
  pctView: Scalars['Boolean']['input'];
  projectCloseReopen: Scalars['Boolean']['input'];
  projectCreateEdit: Scalars['Boolean']['input'];
  projectDelete: Scalars['Boolean']['input'];
  projectInternalDataView: Scalars['Boolean']['input'];
  /** @deprecated No longer used */
  projectsAllowDeletingWithNonDraftBidPackages?: InputMaybe<Scalars['Boolean']['input']>;
  projectsFromAccessibleOffices: Scalars['Boolean']['input'];
  reportingView: Scalars['Boolean']['input'];
  subcontractorAddEdit: Scalars['Boolean']['input'];
  subcontractorBanFavorite: Scalars['Boolean']['input'];
  subcontractorBidRequestsView: Scalars['Boolean']['input'];
  subcontractorCertificatesRequest: Scalars['Boolean']['input'];
  subcontractorCertificatesUpdateDelete: Scalars['Boolean']['input'];
  subcontractorCertificatesView: Scalars['Boolean']['input'];
  subcontractorDelete: Scalars['Boolean']['input'];
  subcontractorNotesViewUpdateCreate: Scalars['Boolean']['input'];
  subcontractorRate: Scalars['Boolean']['input'];
  userAddEditDeactivate: Scalars['Boolean']['input'];
};

export type PositionPricePredictionEvaluation = {
  __typename: 'PositionPricePredictionEvaluation';
  location: Scalars['String']['output'];
  positionId: Scalars['String']['output'];
  prediction: Maybe<PriceRange>;
  rowNumber: Maybe<Scalars['Int']['output']>;
  status: Maybe<PRICE_PREDICTION_EVALUATION_STATUS>;
  totalPredictedMax: Maybe<Scalars['Float']['output']>;
  totalPredictedMin: Maybe<Scalars['Float']['output']>;
  totalProvided: Maybe<Scalars['Float']['output']>;
};

export type PositionTypeDefinition = {
  label: Scalars['String']['input'];
  positionType: BOQ_POSITION_TYPE;
};

export type PriceComparisonOutlierSettings = {
  aboveAverage?: InputMaybe<Scalars['String']['input']>;
  belowAverage?: InputMaybe<Scalars['String']['input']>;
};

export type PriceComparisonSpreadsheetIncludeOptions = {
  bidderComments: Scalars['Boolean']['input'];
  discountsAndSurcharges?: InputMaybe<Scalars['Boolean']['input']>;
  executionDescriptions: Scalars['Boolean']['input'];
  internalNotes: Scalars['Boolean']['input'];
  longDescriptions: Scalars['Boolean']['input'];
  notes: Scalars['Boolean']['input'];
  unitPrices: Scalars['Boolean']['input'];
};

/** Basic interface for a BoQ element in the Price Library. */
export type PriceLibraryBaseElement = {
  createdAt: Scalars['DateTimeISO']['output'];
  htmlLongText: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText: Maybe<Scalars['String']['output']>;
  shortText: Scalars['String']['output'];
};

export type PriceLibraryElementUnion =
  | PriceLibraryRequestForProposalNote
  | PriceLibraryRequestForProposalPosition
  | PriceLibraryTemplateNote
  | PriceLibraryTemplatePosition;

export type PriceLibraryElementsResponse = {
  __typename: 'PriceLibraryElementsResponse';
  priceLibraryElements: Array<PriceLibraryElementUnion>;
  totalRecords: Scalars['Int']['output'];
};

/** This Price Library element is an info text. */
export type PriceLibraryNote = {
  createdAt: Scalars['DateTimeISO']['output'];
  htmlLongText: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText: Maybe<Scalars['String']['output']>;
  shortText: Scalars['String']['output'];
};

/** This Price Library element is a position. */
export type PriceLibraryPosition = {
  createdAt: Scalars['DateTimeISO']['output'];
  htmlLongText: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText: Maybe<Scalars['String']['output']>;
  shortText: Scalars['String']['output'];
  unitTag: Scalars['String']['output'];
};

export type PriceLibraryPositionUnion =
  | PriceLibraryRequestForProposalPosition
  | PriceLibraryTemplatePosition;

export type PriceLibraryPositionsResponseV2 = {
  __typename: 'PriceLibraryPositionsResponseV2';
  priceLibraryPositions: Array<PriceLibraryPositionUnion>;
  totalRecords: Scalars['Int']['output'];
};

/** This Price Library element is derived from a bill of quantities created for a bid package. */
export type PriceLibraryRequestForProposalElement = {
  bidPackage: BidPackage;
  createdAt: Scalars['DateTimeISO']['output'];
  htmlLongText: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText: Maybe<Scalars['String']['output']>;
  shortText: Scalars['String']['output'];
  submission: Maybe<PriceLibrarySubmission>;
};

export type PriceLibraryRequestForProposalNote = PriceLibraryBaseElement &
  PriceLibraryNote &
  PriceLibraryRequestForProposalElement & {
    __typename: 'PriceLibraryRequestForProposalNote';
    bidPackage: BidPackage;
    createdAt: Scalars['DateTimeISO']['output'];
    htmlLongText: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    longText: Maybe<Scalars['String']['output']>;
    shortText: Scalars['String']['output'];
    submission: Maybe<PriceLibrarySubmission>;
  };

export type PriceLibraryRequestForProposalPosition = PriceLibraryBaseElement &
  PriceLibraryPosition &
  PriceLibraryRequestForProposalElement & {
    __typename: 'PriceLibraryRequestForProposalPosition';
    bidPackage: BidPackage;
    createdAt: Scalars['DateTimeISO']['output'];
    htmlLongText: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    longText: Maybe<Scalars['String']['output']>;
    shortText: Scalars['String']['output'];
    submission: Maybe<PriceLibrarySubmission>;
    unitTag: Scalars['String']['output'];
  };

export type PriceLibrarySubmission = {
  __typename: 'PriceLibrarySubmission';
  bid: SubmittedBid;
  value: Scalars['Float']['output'];
};

/** This Price Library element is derived from a bill of quantities template created in the BoQ Library. */
export type PriceLibraryTemplateElement = {
  boqTemplate: BoQTemplate;
  createdAt: Scalars['DateTimeISO']['output'];
  htmlLongText: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText: Maybe<Scalars['String']['output']>;
  shortText: Scalars['String']['output'];
};

export type PriceLibraryTemplateNote = PriceLibraryBaseElement &
  PriceLibraryNote &
  PriceLibraryTemplateElement & {
    __typename: 'PriceLibraryTemplateNote';
    boqTemplate: BoQTemplate;
    createdAt: Scalars['DateTimeISO']['output'];
    htmlLongText: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    longText: Maybe<Scalars['String']['output']>;
    shortText: Scalars['String']['output'];
  };

export type PriceLibraryTemplatePosition = PriceLibraryBaseElement &
  PriceLibraryPosition &
  PriceLibraryTemplateElement & {
    __typename: 'PriceLibraryTemplatePosition';
    boqTemplate: BoQTemplate;
    createdAt: Scalars['DateTimeISO']['output'];
    htmlLongText: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    longText: Maybe<Scalars['String']['output']>;
    shortText: Scalars['String']['output'];
    unitPrice: Maybe<Scalars['Float']['output']>;
    unitTag: Scalars['String']['output'];
  };

export type PricePredictionMeta = {
  __typename: 'PricePredictionMeta';
  version: Scalars['String']['output'];
};

export type PricePredictionResponse = {
  __typename: 'PricePredictionResponse';
  availableRanges: Array<PriceRangeDefinition>;
  defaultRange: PRICE_PREDICTION_RANGE;
  meta: PricePredictionMeta;
  predictionFailures: Scalars['JSONObject']['output'];
  predictions: Scalars['JSONObject']['output'];
};

export type PriceRange = {
  __typename: 'PriceRange';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type PriceRangeDefinition = {
  __typename: 'PriceRangeDefinition';
  identifier: PRICE_PREDICTION_RANGE;
  probability: Scalars['Float']['output'];
};

export type PrimaryContactPersonResponse = {
  __typename: 'PrimaryContactPersonResponse';
  email: Scalars['String']['output'];
  externalCompany: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  role: Maybe<Scalars['String']['output']>;
};

export type PrincipalSubmitBidInput = {
  absoluteDiscount?: InputMaybe<Scalars['Float']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sendConfirmationEmailToSubcontractor?: InputMaybe<Scalars['Boolean']['input']>;
  skontoDeadline?: InputMaybe<Scalars['Int']['input']>;
  skontoRate?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  totalNet?: InputMaybe<Scalars['Float']['input']>;
};

export type Project = AbstractEntity &
  GeocodedGraphQLEntity & {
    __typename: 'Project';
    /** @deprecated Deprecated in favor of marketplaceBidPackagesCount and bidPackagesCount */
    areAllBidPackagesPublishedOnMarketplace: Scalars['Boolean']['output'];
    bidPackages: Array<BidPackage>;
    /** @deprecated Deprecated due to changes in the reporting tab */
    bidPackagesAddendaTotalGross: Maybe<Scalars['Float']['output']>;
    /** @deprecated Deprecated due to changes in the reporting tab */
    bidPackagesAddendaTotalNet: Maybe<Scalars['Float']['output']>;
    /** @deprecated Deprecated due to changes in the reporting tab */
    bidPackagesAwardedBidTotalGross: Maybe<Scalars['Float']['output']>;
    /** @deprecated Deprecated due to changes in the reporting tab */
    bidPackagesAwardedBidTotalNet: Maybe<Scalars['Float']['output']>;
    bidPackagesCount: Scalars['Int']['output'];
    bidPackagesCurrencies: Maybe<Array<CURRENCY>>;
    bidPackagesTotalBudget: Maybe<Scalars['Float']['output']>;
    bidRequestsAwaitingResponseCount: Scalars['Int']['output'];
    /** @deprecated No longer used */
    bidRequestsToNotifyOfDeletionCount: Scalars['Int']['output'];
    billingRunStepUsers: Array<User>;
    budget: Maybe<Scalars['Float']['output']>;
    category: Maybe<PROJECT_CATEGORY>;
    closingConditions: ProjectClosingConditionsResponse;
    contactPersons: Array<ProjectUser>;
    costGroupCatalogs: Array<ProjectCostGroupCatalog>;
    costGroupType: COST_GROUP_TYPE;
    createdAt: Scalars['DateTimeISO']['output'];
    currency: CURRENCY;
    currentTerms: Maybe<Terms>;
    customFields: Maybe<Array<CustomFieldWithValue>>;
    customer: Maybe<Scalars['String']['output']>;
    customerCity: Maybe<Scalars['String']['output']>;
    customerCountryCode: Maybe<COUNTRY_CODE>;
    customerEmail: Maybe<Scalars['String']['output']>;
    customerFax: Maybe<Scalars['String']['output']>;
    customerPhone: Maybe<Scalars['String']['output']>;
    customerPostalCode: Maybe<Scalars['String']['output']>;
    customerStreet: Maybe<Scalars['String']['output']>;
    customerWebsite: Maybe<Scalars['String']['output']>;
    defaultTaxRate: Maybe<Scalars['Float']['output']>;
    description: Maybe<Scalars['String']['output']>;
    desiredSustainabilityCertification: Maybe<Scalars['String']['output']>;
    endsOn: Maybe<Scalars['String']['output']>;
    hasAnyCostAnalysisData: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    imageKeys: Array<Scalars['String']['output']>;
    isEstimating: Scalars['Boolean']['output'];
    isTermsAcceptanceRequired: Scalars['Boolean']['output'];
    lat: Maybe<Scalars['Float']['output']>;
    location: Scalars['String']['output'];
    locationCountryCode: Maybe<COUNTRY_CODE>;
    locationStateCode: Maybe<STATE_CODE>;
    long: Maybe<Scalars['Float']['output']>;
    marketplaceBidPackagesCount: Scalars['Int']['output'];
    marketplacePublishedBidPackagesCount: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    networkSubcontractorBidRequestsCount: Scalars['Int']['output'];
    notes: Maybe<Scalars['String']['output']>;
    number: Maybe<Scalars['String']['output']>;
    office: Office;
    preferredBoQFileFormat: BOQ_FILE_FORMAT;
    primaryContactUser: Maybe<User>;
    primaryUser: Maybe<User>;
    projectUsers: Array<ProjectUser>;
    requireAcceptingTerms: Scalars['Boolean']['output'];
    startsOn: Maybe<Scalars['String']['output']>;
    status: PROJECT_STATUS;
    tenderingStartsOn: Maybe<Scalars['Date']['output']>;
  };

export type ProjectbidRequestsAwaitingResponseCountArgs = {
  ignoreDueDate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectcustomFieldsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ProjectAuthActions {
  close = 'close',
  createBidPackage = 'createBidPackage',
  createBidPackage__withoutSelf = 'createBidPackage__withoutSelf',
  delete = 'delete',
  duplicate = 'duplicate',
  exportAllData = 'exportAllData',
  reopen = 'reopen',
  update = 'update',
  update__internalData = 'update__internalData',
  uploadInternalDocuments = 'uploadInternalDocuments',
  uploadSharedDocuments = 'uploadSharedDocuments',
  view = 'view',
  view__bim = 'view__bim',
  view__costAnalysis = 'view__costAnalysis',
  view__costEstimation = 'view__costEstimation',
  view__documents = 'view__documents',
  view__internalData = 'view__internalData',
  view__reportingData = 'view__reportingData',
  view__teams = 'view__teams',
}

export type ProjectAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type ProjectAuthInput = {
  action: ProjectAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectAuthArgsInput>;
};

export type ProjectClosingConditionsResponse = {
  __typename: 'ProjectClosingConditionsResponse';
  canSendNotification: Scalars['Boolean']['output'];
  mustNotifyBidders: Scalars['Boolean']['output'];
  shouldWarnAboutUnawardedBidders: Scalars['Boolean']['output'];
};

export type ProjectCostGroupCatalog = {
  __typename: 'ProjectCostGroupCatalog';
  catalogType: PROJECT_COST_CATALOG_TYPE;
  costGroupDefinitions: Array<CostGroupDefinition>;
  customCatalog: Maybe<CustomCostGroupCatalog>;
  customCatalogId: Maybe<Scalars['String']['output']>;
  customCatalogName: Maybe<Scalars['String']['output']>;
};

export type ProjectCostGroupCatalogInput = {
  catalogType: PROJECT_COST_CATALOG_TYPE;
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectCostGroupCatalogsResponse = {
  __typename: 'ProjectCostGroupCatalogsResponse';
  catalogType: PROJECT_COST_CATALOG_TYPE;
  customCatalogId: Maybe<Scalars['String']['output']>;
  customCatalogName: Maybe<Scalars['String']['output']>;
};

export type ProjectExportCompleteNotification = AbstractEntity &
  Notification & {
    __typename: 'ProjectExportCompleteNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: ProjectExportCompleteNotificationProps;
  };

export type ProjectExportCompleteNotificationProps = {
  __typename: 'ProjectExportCompleteNotificationProps';
  downloadUrl: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type ProjectInput = {
  billingRunStepUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<PROJECT_CATEGORY>;
  costGroupCatalogs: Array<ProjectCostGroupCatalogInput>;
  currency?: InputMaybe<CURRENCY>;
  currentTermsId?: InputMaybe<Scalars['ID']['input']>;
  customFields?: InputMaybe<Array<CustomFieldValueInput>>;
  customer: Scalars['String']['input'];
  customerCity?: InputMaybe<Scalars['String']['input']>;
  customerCountryCode?: InputMaybe<COUNTRY_CODE>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerFax?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  customerPostalCode?: InputMaybe<Scalars['String']['input']>;
  customerStreet?: InputMaybe<Scalars['String']['input']>;
  customerWebsite?: InputMaybe<Scalars['String']['input']>;
  defaultTaxRate?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  desiredSustainabilityCertification?: InputMaybe<Scalars['String']['input']>;
  endsOn?: InputMaybe<Scalars['String']['input']>;
  imageKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  isEstimating: Scalars['Boolean']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  location: Scalars['String']['input'];
  long?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  officeId: Scalars['ID']['input'];
  preferredBoQFileFormat: BOQ_FILE_FORMAT;
  primaryContactUserId?: InputMaybe<Scalars['ID']['input']>;
  primaryUserId: Scalars['ID']['input'];
  projectUsers: Array<ProjectUserInput>;
  requireAcceptingTerms?: Scalars['Boolean']['input'];
  startsOn?: InputMaybe<Scalars['String']['input']>;
  tenderingStartsOn?: InputMaybe<Scalars['Date']['input']>;
};

export type ProjectTemplateInput = {
  enableMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackageTeam?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesBidderList?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesBoQ?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesDescription?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeBidPackagesNumbering?: InputMaybe<Scalars['Boolean']['input']>;
  includeCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectDescription?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectEstimatedCost?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectImages?: InputMaybe<Scalars['Boolean']['input']>;
  includeProjectTeam?: InputMaybe<Scalars['Boolean']['input']>;
  templateProjectId: Scalars['ID']['input'];
};

export type ProjectUser = AbstractEntity & {
  __typename: 'ProjectUser';
  createdAt: Scalars['DateTimeISO']['output'];
  hasPendingMultiUserApprovalRequest: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isContactPerson: Scalars['Boolean']['output'];
  user: User;
  userRole: Scalars['String']['output'];
};

export type ProjectUserInput = {
  isContactPerson: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
  userRole: Scalars['String']['input'];
};

export type ProjectsResponse = {
  __typename: 'ProjectsResponse';
  hasAnyOpenProjects: Maybe<Scalars['Boolean']['output']>;
  projects: Array<Project>;
  totalRecords: Scalars['Int']['output'];
};

export type PublicNetworkSubcontractorProfile = AbstractEntity & {
  __typename: 'PublicNetworkSubcontractorProfile';
  agentCompanyId: Maybe<Scalars['ID']['output']>;
  certificateTypesReport: Array<CertificateTypeReport>;
  /** @deprecated Deprecated in favor of certificateTypesReport */
  certificates: Array<Certificate>;
  city: Maybe<Scalars['String']['output']>;
  companySize: Maybe<COMPANY_SIZE>;
  countryCode: Maybe<COUNTRY_CODE>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  isClaimedByAgentCompany: Scalars['Boolean']['output'];
  logoKey: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
  workCategories: Array<WorkCategoryForSubcontractor>;
};

export type PublicNetworkSubcontractorProfileWithMergedIntoRedirect =
  | MergedIntoSubcontractor
  | PublicNetworkSubcontractorProfile;

export type PublicSubcontractorProfile = AbstractEntity & {
  __typename: 'PublicSubcontractorProfile';
  agentCompanyId: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  isClaimedByAgentCompany: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type QuantityComponent = {
  __typename: 'QuantityComponent';
  result: Scalars['Float']['output'];
};

export type Query = {
  __typename: 'Query';
  addendum: Addendum;
  addendums: AddendumsResponse;
  adminAdmins: AdminsResponse;
  adminAiPlaygroundChat: AdminAiPlaygroundChat;
  adminAiPlaygroundChats: Array<AdminAiPlaygroundChat>;
  adminAiPlaygroundExperiment: AdminAiPlaygroundExperiment;
  adminAiPlaygroundExperiments: AdminAiPlaygroundExperimentsResponse;
  adminAiPlaygroundModels: Array<AdminAiPlaygroundModel>;
  adminAnalyticsEventsForTests: Array<AnalyticsEvent>;
  adminBidPackageBillOfQuantitiesRevisions: AdminBillOfQuantitiesRevisionsResponse;
  adminBidPackages: BidPackagesResponse;
  adminBidRequests: BidRequestsResponse;
  adminBillOfQuantities: AdminBillOfQuantitiesResponse;
  adminCheckResetPasswordToken: Scalars['Boolean']['output'];
  adminCompanies: CompaniesResponse;
  adminCompany: Company;
  adminCompanySubcontractors: AdminCompanySubcontractorsResponse;
  adminCompanyWorkCategories: WorkCategoriesResponse;
  adminDownloadUrlForBidPackageBoQPdf: Scalars['String']['output'];
  adminEmailTemplates: AdminEmailTemplatesResponse;
  adminGlobalCertificateTypes: AdminCertificateTypesResponse;
  adminInvitation: AdminInvitationResponse;
  adminMe: Maybe<Admin>;
  adminNetworkSubcontractorVersions: Array<SubcontractorVersion>;
  adminNetworkWorkCategories: Array<WorkCategory>;
  adminNetworkWorkCategory: WorkCategory;
  adminProjects: ProjectsResponse;
  adminSentEmail: SentEmail;
  adminSentEmailEventsForTests: Array<SentEmailEvent>;
  adminSentEmails: SentEmailsResponse;
  adminSentEmailsForTests: Array<SentEmail>;
  adminSignups: SignupsResponse;
  adminSubcontractor: SubcontractorForAdmin;
  adminSubcontractorBidRequests: BidRequestsResponse;
  adminSubcontractorImportRequests: AdminSubcontractorsImportRequestsResponse;
  adminSubcontractorMergeRequests: SubcontractorMergeRequestsResponse;
  adminSubcontractors: AdminSubcontractorsResponse;
  adminUser: User;
  adminUsers: AdminUsersResponse;
  adminWorkCategoryGroup: WorkCategoryGroup;
  adminWorkCategoryGroups: Array<WorkCategoryGroup>;
  agentBidRequestBidSubmittedEmailPreview: ExternalBidPreviewResponse;
  /** Returns the list of certificate types which are available for user */
  agentCertificateTypes: Array<CertificateType>;
  agentCertificateTypesReport: Array<CertificateTypeReport>;
  agentCompanyOnboarding: Array<AgentCompanyOnboardIncompleteItem>;
  agentCompanyProfilePrefill: AgentCompanyProfilePrefillResponse;
  applicableMultiUserApprovalRule: Maybe<MultiUserApprovalRule>;
  authorize: Scalars['Boolean']['output'];
  authorizeAdmin: Scalars['Boolean']['output'];
  authorizeMultiple: Array<Maybe<Scalars['Boolean']['output']>>;
  /** Returns a list of global certificate types that can be used by a subcontractor */
  availableGlobalCertificateTypes: Array<CertificateType>;
  awardedBidForAgent: AwardedBid;
  awardedBidForBidPackage: Maybe<AwardedBid>;
  awardedBidsForAgent: AwardedBidsForAgentResponse;
  bid: SubmittedBid;
  bidInvite: BidInvite;
  bidInviteDefaultIntro: Scalars['String']['output'];
  bidInvitePreview: TemplatePreview;
  bidPackage: BidPackage;
  bidPackageBoQEditorActions: BidPackageEditorActionsResponse;
  bidPackageChangedBiddersNotificationPreview: TemplatePreview;
  bidPackageChangedDefaultTemplate: Scalars['String']['output'];
  bidPackageCompletionStatus: Array<BidPackageCompletionResponse>;
  bidPackageListForMarketplace: BidPackagesForMarketplaceResponse;
  bidPackageListForPublicMarketplace: BidPackagesForMarketplaceResponse;
  bidPackages: BidPackagesResponse;
  bidPackagesAwaitingResponseCount: Scalars['Int']['output'];
  /** @deprecated No longer used, as we removed the callout in the frontend where this  */
  bidPackagesPublishedOnMarketplaceCount: Scalars['Int']['output'];
  bidRequest: BidRequest;
  bidRequestForSubcontractor: BidRequest;
  bidRequestLandingPreviewBidPackage: BidPackage;
  bidRequestNotes: Array<BidRequestNote>;
  bidRequests: BidRequestsResponse;
  bidRequestsForAgent: BidRequestsResponse;
  bidRequestsForAgentCounts: BidRequestsForAgentCountsResponse;
  bidderStatuses: Array<BidderStatus>;
  bids: BidsResponse;
  billOfQuantitiesForBidPackage: Maybe<BillOfQuantities>;
  billOfQuantitiesForBidRequest: Maybe<BillOfQuantities>;
  billOfQuantitiesForEditing: BillOfQuantitiesForEditingResponse;
  billOfQuantitiesFormalReview: BoQFormalReviewResponse;
  billingSubscriptionForRenewal: Maybe<BillingSubscriptionForRenewalResponse>;
  boqChangedNotificationDefaultTemplate: Scalars['String']['output'];
  boqChangedNotificationPreview: TemplatePreview;
  boqTemplate: BoQTemplate;
  boqTemplateBoQ: Maybe<BillOfQuantities>;
  boqTemplateBoQForEditing: BillOfQuantitiesForEditingResponse;
  boqTemplates: BoQTemplatesResponse;
  boqUploadUrl: FileUploadResponse;
  /** Returns a string "certificateOwner_certificateTypeName_currentDate.fileType". This query implies that a Certificate entity does not exist yet. For an existing certificate, please use "fileName" field resolver. */
  certificateFileName: Scalars['String']['output'];
  certificateRequest: Maybe<CertificateRequest>;
  certificateRequestPreview: CertificateRequestPreviewResponse;
  certificateRequestsForAgent: CertificateRequestsResponse;
  certificateUploadUrl: FileUploadResponse;
  /** @deprecated Replaced with more detailed calculation on frontend side */
  certificatesCountForSubcontractor: Scalars['Int']['output'];
  changedElementIdsSinceLatestSubmittedBid: Array<Scalars['String']['output']>;
  checkResetPasswordToken: CheckResetPasswordTokenResponse;
  checkWorkspace: LoginTokenResponse;
  /** Returns certificate types created by the principal company, combined with certificate types created by the requested subcontractor; field "certificates" consists of certificates from both sources, thus other certificate-related fields (such as "status" and "maxExpiryDate") are calculated based on certificates from both sources */
  combinedCertificateTypesReport: Array<CertificateTypeReport>;
  combinedFileTreeWithDocuments: CombinedFileTreeResponse;
  company: Company;
  /** Returns all certificate types with the type "company"; "company" certificate types are created by principal users */
  companyCertificateTypes: Array<CertificateType>;
  companyOnboarding: Array<CompanyOnboardingResponse>;
  companyTemplatePreview: TemplatePreview;
  companyTemplates: CompanyTemplatesResponse;
  contractBoQContent: Scalars['JSONObject']['output'];
  contractRunAgentStep: ContractRunAgentStep;
  costAnalysis: CostAnalysisResponse;
  costComparison: CostComparisonResponse;
  costEstimatesForProject: CostEstimatesForProjectResponse;
  costGroupDefinitions: CostGroupDefinitionResponse;
  countryNetworkSubcontractorsCount: Scalars['Float']['output'];
  customCostGroupCatalog: CustomCostGroupCatalog;
  customCostGroupCatalogs: CustomCostGroupCatalogsResponse;
  customEmailState: CustomEmailState;
  customFields: Array<CustomField>;
  customFieldsUsage: Array<CustomFieldsUsage>;
  customFieldsWithInitialValues: Maybe<Array<CustomFieldWithValue>>;
  defaultBidderIntroductionTemplateContent: Scalars['String']['output'];
  /**
   * Returns the first available grouping+breakdown for the cost analysis table with DIN 276 being the highest priority option. Grouping+breakdown is considered available if the cost analysis has non-zero value at any level of the tree for any cost item, including project, bid package, and all selected cost groups. Returns null if nothing is available.
   * @deprecated default breakdown is now hardcoded on the client side, for data availability use `Project.hasAnyCostAnalysisData` field
   */
  defaultCostAnalysisBreakdown: Maybe<CostAnalysisDefaultBreakdownResponse>;
  document: Document;
  downloadURLForBillOfQuantities: Scalars['String']['output'];
  downloadUrlForBidPackageBoQPdf: Scalars['String']['output'];
  downloadUrlForBidPackageDocuments: Scalars['String']['output'];
  downloadUrlForBidPdf: Scalars['String']['output'];
  downloadUrlForBidRequestInNegotiationDocuments: Scalars['String']['output'];
  downloadUrlForBidderStatusHistoryPdf: Scalars['String']['output'];
  downloadUrlForBiddersListExcel: Scalars['String']['output'];
  downloadUrlForBiddersListPdf: Scalars['String']['output'];
  downloadUrlForContractBoQ: Scalars['String']['output'];
  downloadUrlForCostAnalysisSpreadsheet: Scalars['String']['output'];
  downloadUrlForCostComparisonSpreadsheet: Scalars['String']['output'];
  downloadUrlForCostEstimationSpreadsheet: Scalars['String']['output'];
  downloadUrlForMessageThreadPdf: Scalars['String']['output'];
  downloadUrlForOverviewPdf: Scalars['String']['output'];
  downloadUrlForPriceComparisonPdf: Scalars['String']['output'];
  downloadUrlForPriceComparisonSpreadsheet: Scalars['String']['output'];
  downloadUrlForProjectDocuments: Scalars['String']['output'];
  downloadUrlForProjectOverviewPdf: Scalars['String']['output'];
  downloadUrlForRequestForProposalBoQPdf: Scalars['String']['output'];
  fileTreeAdditionsUploadData: FileTreeAdditionsUploadDataResponse;
  fileTreeWithDocuments: FileTreeResponse;
  findSimilarBidPackageNames: Array<Scalars['String']['output']>;
  germanRegistrationCourts: Array<RegistrationCourt>;
  getBoQPositionMassDeterminationForEditing: Maybe<MassDetermination>;
  getExternalCredentials: Array<ExternalCredentialResponse>;
  getSalesforceAccountDetails: SalesforceAccountDetailsForAdmin;
  hasImportedSubcontractors: Scalars['Boolean']['output'];
  hasVisibleBidPackages: Scalars['Boolean']['output'];
  hasVisibleClosedProjects: Scalars['Boolean']['output'];
  hasVisibleOpenProjects: Scalars['Boolean']['output'];
  heinzeAtBoQElements: Array<Scalars['JSONObject']['output']>;
  heinzeAtGuiUrl: HeinzeGuiUrlResponse;
  heinzeVobBoQElements: Array<Scalars['JSONObject']['output']>;
  heinzeVobGuiUrl: HeinzeGuiUrlResponse;
  imageUploadUrl: ImageUploadUrlResponse;
  incompleteCertificateRequestsCountForAgent: Scalars['Float']['output'];
  invitation: InvitationResponse;
  invoice: Invoice;
  invoiceCoverSheetUrl: Scalars['String']['output'];
  invoiceNotes: InvoiceNotesResponse;
  invoices: InvoicesResponse;
  isAgentCompanyAbleToSubmitBid: Scalars['Boolean']['output'];
  /** @deprecated Use signupForCompany query instead */
  isCompanyWaitingForSignupApproval: Scalars['Boolean']['output'];
  isPrincipalUserOnly: Maybe<IsPrincipalUserOnlyResponse>;
  lBHochbauTextProviderElementsTree: LbHochbauTextProviderElementsTreeResponse;
  lastCertificateRequest: Maybe<CertificateRequest>;
  lbHochbauRestrictedItemNumbers: LbHochbauRestrictedItemNumbersResponse;
  longRunningTask: LongRunningTask;
  marketplaceBidPackageSuggestions: Array<MarketplaceBidPackageSample>;
  marketplaceBidPackagesForMap: BidPackagesList;
  marketplaceBidSubmissionsCount: Scalars['Int']['output'];
  marketplaceLock: Maybe<MarketplaceLockResponse>;
  marketplaceSavedSearches: Array<MarketplaceSavedSearch>;
  marketplaceSuggestion: MarketplaceSuggestion;
  marketplaceSuggestionPreview: MarketplaceSuggestionPreviewResponse;
  marketplaceSuggestions: MarketplaceSuggestionsResponse;
  me: User;
  messageThread: MessageThread;
  messageThreads: MessageThreadResponse;
  messageThreadsForSubcontractor: MessageThreadResponse;
  messageThreadsInBidPackage: MessageThreadResponse;
  messageThreadsInBidRequest: MessageThreadResponse;
  multiUserApprovalRequest: Maybe<MultiUserApprovalRequest>;
  multiUserApprovalRules: Array<MultiUserApprovalRule>;
  multiUserApprovalSummary: MultiUserApprovalSummary;
  myTasksInStatusCount: Scalars['Int']['output'];
  networkSubcontractor: Maybe<ExtendedNetworkSubcontractorWithMergedIntoRedirect>;
  networkSubcontractors: NetworkSubcontractorsResponse;
  networkSubcontractorsByWorkCategorySlug: NetworkSubcontractorsByWorkCategoryResponse;
  networkSubcontractorsImport: NetworkSubcontractorsImport;
  notifications: NotificationsResponse;
  office: Office;
  offices: Array<Office>;
  organizations: Array<Organization>;
  parsedCompanyTemplatesByType: Array<CompanyTemplate>;
  parsedIfcFile: ParsedIfcFile;
  parsedIfcFileWithAssociatedCosts: ParsedIfcFile;
  permissionControlsConfig: PermissionControlsConfig;
  predictPriceForBidPackage: PricePredictionResponse;
  previewBidConfirmationEmailAfterPrincipalSubmission: TemplatePreview;
  priceLibraryElements: PriceLibraryElementsResponse;
  /** @deprecated Use `priceLibraryElements` to optionally receive notes instead of positions. */
  priceLibraryPositionsV2: PriceLibraryPositionsResponseV2;
  pricingTiers: Array<SubcontractorPricingTier>;
  project: Project;
  projectChangedBiddersNotificationPreview: TemplatePreview;
  projectCostGroupCatalogs: Array<ProjectCostGroupCatalogsResponse>;
  projectRatingsPerBidRequest: Array<SubcontractorRatingPerBidRequest>;
  projects: ProjectsResponse;
  projectsByIds: Array<Project>;
  projectsForDuplicatingBidPackages: ProjectsResponse;
  publicMarketplaceBidPackage: BidPackage;
  publicNetworkSubcontractorProfile: PublicNetworkSubcontractorProfileWithMergedIntoRedirect;
  publicSubcontractorProfile: PublicSubcontractorProfile;
  publicSubcontractorProfileForAwardedBid: PublicSubcontractorProfile;
  refreshStlbSession: StlbSessionResponse;
  reverseMarketplaceBidPackage: BidPackage;
  searchSalesforceAccounts: Array<SalesforceAccount>;
  /** @deprecated Deprecated in favor of CertificateTypeReportResolver.agentCertificateTypesReport */
  selectedGlobalCertificateTypes: Array<CertificateType>;
  sentEmailStatistics: Maybe<SentEmailStatisticsResponse>;
  shouldPromptWorkCategoriesUpdate: Scalars['Boolean']['output'];
  sideEffectFreeDraftBid: Maybe<DraftBid>;
  signup: Signup;
  signupForCompany: Signup;
  similarSubcontractors: SimilarSubcontractorsResponse;
  similarSubcontractorsByContactEmail: Array<Subcontractor>;
  similarSubcontractorsByName: Array<Subcontractor>;
  simulationChanges: SimulationChanges;
  ssoRedirectUrl: Scalars['String']['output'];
  stlbGetData: ParsedStlbDataResponse;
  stlbHomeUrl: Scalars['String']['output'];
  stlbWorkCategoryDefinitions: StlbWorkCategoryDefinitionResponse;
  subcontractor: Subcontractor;
  subcontractorBySentEmail: Maybe<Subcontractor>;
  subcontractorForProfile: SubcontractorWithMergedToRedirect;
  subcontractorForSuggestion: Subcontractor;
  subcontractorImportRequests: Array<SubcontractorImportRequest>;
  subcontractorLoginSuggestions: Array<LoginSuggestion>;
  subcontractorRatingByBidRequest: Array<SubcontractorRating>;
  subcontractorRatingPerBidRequest: Array<SubcontractorRatingPerBidRequest>;
  subcontractorRatingSummary: SubcontractorRatingSummaryResponse;
  subcontractorReferenceProject: SubcontractorReferenceProject;
  /** @deprecated Deprecated in favor of CertificateTypeReportResolver.combinedCertificateTypesReport */
  subcontractorSelectedGlobalCertificateTypes: Array<CertificateType>;
  subcontractorType: SUBCONTRACTOR_TYPE;
  subcontractors: SubcontractorsResponse;
  subcontractorsByAgent: Array<Subcontractor>;
  subcontractorsImports: SubcontractorsImportsResponse;
  /** Returns a list of global certificate types that can be used by a general contractor */
  suggestedGlobalCertificateTypes: SuggestedGlobalCertificateTypesResponse;
  task: Task;
  taskNotes: TaskNotesResponse;
  taskPublicData: TaskPublicDataResponse;
  tasks: TasksResponse;
  tempUploadUrl: FileUploadResponse;
  terms: Terms;
  termsForBidRequest: Terms;
  topWorkCategories: Array<WorkCategory>;
  totalAvailablePriceLibraryElements: Scalars['Int']['output'];
  /** @deprecated Use `totalAvailablePriceLibraryElements` to optionally count notes instead of positions. */
  totalAvailablePriceLibraryPositions: Scalars['Int']['output'];
  unreadMessageThreadsCount: Scalars['Float']['output'];
  users: UsersResponse;
  usersWithAccessToBidPackage: Array<User>;
  usersWithAccessToProject: Array<User>;
  validateBidMainOrderNumber: ValidateBidMainOrderNumberResponse;
  validateCostAnalysisForProject: CostAnalysisForProjectValidationResponse;
  validateEmail: EMAIL_VALIDATION_STATUS;
  validateSubcontractorsImport: SubcontractorsImportValidationResponse;
  validateWorkCategoryWithTranslationInput: Scalars['Boolean']['output'];
  workCategories: WorkCategoriesResponse;
  workCategorySuggestions: Array<WorkCategorySuggestion>;
};

export type QueryaddendumArgs = {
  id: Scalars['ID']['input'];
};

export type QueryaddendumsArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sortBy?: InputMaybe<ADDENDUM_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminAdminsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ADMINS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminAiPlaygroundChatArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminAiPlaygroundChatsArgs = {
  experimentId: Scalars['ID']['input'];
};

export type QueryadminAiPlaygroundExperimentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminAiPlaygroundExperimentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ADMIN_AI_PLAYGROUND_EXPERIMENT_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminBidPackageBillOfQuantitiesRevisionsArgs = {
  bidPackageId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ADMIN_BID_PACKAGE_BILL_OF_QUANTITIES_REVISIONS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminBidPackagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyInBoQContents?: InputMaybe<Scalars['Boolean']['input']>;
  onlyMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ADMIN_BID_PACKAGES_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminBidRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BID_REQUESTS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminBillOfQuantitiesArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminCheckResetPasswordTokenArgs = {
  token: Scalars['String']['input'];
};

export type QueryadminCompaniesArgs = {
  includeCreatedByAgentCompany?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<COMPANIES_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  type?: InputMaybe<COMPANY_TYPE>;
};

export type QueryadminCompanyArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminCompanySubcontractorsArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryadminCompanyWorkCategoriesArgs = {
  isStandardized?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<WORK_CATEGORY_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminDownloadUrlForBidPackageBoQPdfArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type QueryadminEmailTemplatesArgs = {
  language: LANGUAGE;
  templateName: EMAIL_TEMPLATES;
};

export type QueryadminGlobalCertificateTypesArgs = {
  countryCode: COUNTRY_CODE;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryadminInvitationArgs = {
  token: Scalars['String']['input'];
};

export type QueryadminNetworkSubcontractorVersionsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminNetworkWorkCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PROJECTS_SORT_FIELD>;
  sortById?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminSentEmailArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminSentEmailsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyFailed?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<RECIPIENT_ENTITY_TYPE>;
  shouldSearchMatchExactly?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<SENT_EMAILS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  statuses?: InputMaybe<Array<EMAIL_STATUS>>;
  subcontractorId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryadminSentEmailsForTestsArgs = {
  sentAfter?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type QueryadminSignupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SIGNUP_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  statuses?: InputMaybe<Array<SIGNUP_STATUS>>;
};

export type QueryadminSubcontractorArgs = {
  id: Scalars['ID']['input'];
};

export type QueryadminSubcontractorBidRequestsArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BID_REQUESTS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminSubcontractorImportRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ADMIN_SUBCONTRACTORS_IMPORT_REQUESTS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  statuses?: InputMaybe<Array<SUBCONTRACTOR_IMPORT_REQUEST_STATUS>>;
};

export type QueryadminSubcontractorMergeRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SUBCONTRACTOR_MERGE_REQUEST_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  statuses?: InputMaybe<Array<SUBCONTRACTOR_MERGE_REQUEST_STATUS>>;
};

export type QueryadminSubcontractorsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  filterType?: InputMaybe<ADMIN_SUBCONTRACTOR_FILTER_TYPE>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ADMIN_SUBCONTRACTORS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  withFailedEmails?: InputMaybe<Scalars['Boolean']['input']>;
  withUnconfirmedChanges?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryadminUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryadminUsersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<USERS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryadminWorkCategoryGroupArgs = {
  id: Scalars['ID']['input'];
};

export type QueryagentBidRequestBidSubmittedEmailPreviewArgs = {
  bidRequestId: Scalars['ID']['input'];
};

export type QueryagentCertificateTypesArgs = {
  countryCode: COUNTRY_CODE;
};

export type QueryapplicableMultiUserApprovalRuleArgs = {
  action: MULTI_USER_APPROVAL_ACTION;
  entityId: Scalars['ID']['input'];
  requestProps?: InputMaybe<MultiUserApprovalRequestPropsInput>;
};

export type QueryauthorizeArgs = {
  input: AuthorizeInput;
};

export type QueryauthorizeAdminArgs = {
  input: AuthorizeInput;
};

export type QueryauthorizeMultipleArgs = {
  inputs: Array<InputMaybe<AuthorizeInput>>;
};

export type QueryavailableGlobalCertificateTypesArgs = {
  countryCode: COUNTRY_CODE;
};

export type QueryawardedBidForAgentArgs = {
  contractRunAgentStepId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type QueryawardedBidForBidPackageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryawardedBidsForAgentArgs = {
  excludeContractSignedByAgent?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BIDS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerybidArgs = {
  id: Scalars['ID']['input'];
};

export type QuerybidInviteArgs = {
  bidInviteId: Scalars['ID']['input'];
};

export type QuerybidInviteDefaultIntroArgs = {
  projectId: Scalars['ID']['input'];
};

export type QuerybidInvitePreviewArgs = {
  bidPackageId: Scalars['ID']['input'];
  contactId?: InputMaybe<Scalars['String']['input']>;
  customBidsDueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  customInvitationEmailIntro?: InputMaybe<Scalars['HTML']['input']>;
};

export type QuerybidPackageArgs = {
  id: Scalars['ID']['input'];
};

export type QuerybidPackageBoQEditorActionsArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type QuerybidPackageChangedBiddersNotificationPreviewArgs = {
  comment?: InputMaybe<Scalars['HTML']['input']>;
  id: Scalars['ID']['input'];
  input: BidPackageInput;
};

export type QuerybidPackageChangedDefaultTemplateArgs = {
  bidPackageName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type QuerybidPackageCompletionStatusArgs = {
  id: Scalars['ID']['input'];
};

export type QuerybidPackageListForMarketplaceArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  allowBidsAfterDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  calculateDefaultFilters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceInKm?: InputMaybe<Scalars['Float']['input']>;
  dueDateInMinDays?: InputMaybe<Scalars['Int']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  excludeWorkCategoryIds?: InputMaybe<Array<WorkCategoryIds>>;
  geoCoords?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectCategories?: InputMaybe<Array<PROJECT_CATEGORY>>;
  query?: InputMaybe<Scalars['String']['input']>;
  saveRecentSearch?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<BID_PACKAGES_MARKETPLACE_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  startsOn?: InputMaybe<Scalars['Date']['input']>;
  workCategoryIds?: InputMaybe<Array<WorkCategoryIds>>;
};

export type QuerybidPackageListForPublicMarketplaceArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  allowBidsAfterDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  calculateDefaultFilters?: InputMaybe<Scalars['Boolean']['input']>;
  distanceInKm?: InputMaybe<Scalars['Float']['input']>;
  dueDateInMinDays?: InputMaybe<Scalars['Int']['input']>;
  endsOn?: InputMaybe<Scalars['Date']['input']>;
  excludeWorkCategoryIds?: InputMaybe<Array<WorkCategoryIds>>;
  geoCoords?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectCategories?: InputMaybe<Array<PROJECT_CATEGORY>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BID_PACKAGES_MARKETPLACE_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  startsOn?: InputMaybe<Scalars['Date']['input']>;
  workCategoryIds?: InputMaybe<Array<WorkCategoryIds>>;
};

export type QuerybidPackagesArgs = {
  excludeClosedProjects?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyIncludeAwaitingResponse?: InputMaybe<Scalars['Boolean']['input']>;
  onlyIncludeOwnBidPackages?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  projectPhase?: InputMaybe<PROJECT_PHASE>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BID_PACKAGES_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  statuses?: InputMaybe<Array<BID_PACKAGE_STATUS>>;
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerybidRequestArgs = {
  id: Scalars['ID']['input'];
};

export type QuerybidRequestForSubcontractorArgs = {
  bidRequestId: Scalars['ID']['input'];
};

export type QuerybidRequestLandingPreviewBidPackageArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type QuerybidRequestNotesArgs = {
  bidRequestId: Scalars['ID']['input'];
};

export type QuerybidRequestsArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  excludeDeletedSubcontractors?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  searchByContactNames?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<BID_REQUESTS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  statuses?: InputMaybe<Array<BID_REQUEST_STATUS>>;
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerybidRequestsForAgentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BID_REQUESTS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerybidderStatusesArgs = {
  id: Scalars['ID']['input'];
};

export type QuerybidsArgs = {
  fetchOwnBids: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectPhase?: InputMaybe<PROJECT_PHASE>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BIDS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerybillOfQuantitiesForBidPackageArgs = {
  bidPackageId: Scalars['ID']['input'];
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerybillOfQuantitiesForBidRequestArgs = {
  bidRequestId: Scalars['ID']['input'];
};

export type QuerybillOfQuantitiesForEditingArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type QuerybillOfQuantitiesFormalReviewArgs = {
  boqContainerId: Scalars['ID']['input'];
  boqContainerType: BOQ_CONTAINER_TYPE;
  selectedStandard?: InputMaybe<BOQ_FILE_FORMAT>;
  skipUnsavedBoQChanges?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuerybillingSubscriptionForRenewalArgs = {
  coupon: Scalars['String']['input'];
};

export type QueryboqChangedNotificationDefaultTemplateArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type QueryboqChangedNotificationPreviewArgs = {
  bidPackageId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['HTML']['input']>;
};

export type QueryboqTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryboqTemplateBoQArgs = {
  boqTemplateId: Scalars['ID']['input'];
};

export type QueryboqTemplateBoQForEditingArgs = {
  boqTemplateId: Scalars['ID']['input'];
};

export type QueryboqTemplatesArgs = {
  boqFileFormat?: InputMaybe<BOQ_FILE_FORMAT>;
  fetchOwnBoQTemplates: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BOQ_TEMPLATES_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerycertificateFileNameArgs = {
  certificateTypeId: Scalars['ID']['input'];
  fileType: CERTIFICATE_FILE_TYPE;
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerycertificateRequestArgs = {
  certificateRequestId?: InputMaybe<Scalars['ID']['input']>;
  subcontractorId: Scalars['ID']['input'];
};

export type QuerycertificateRequestPreviewArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  certificateTypeIds: Array<Scalars['ID']['input']>;
  contactId: Scalars['ID']['input'];
  dueDate?: InputMaybe<Scalars['String']['input']>;
  officeId: Scalars['ID']['input'];
};

export type QuerycertificateRequestsForAgentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CERTIFICATE_REQUESTS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerycertificatesCountForSubcontractorArgs = {
  subcontractorId: Scalars['ID']['input'];
};

export type QuerychangedElementIdsSinceLatestSubmittedBidArgs = {
  bidRequestId: Scalars['ID']['input'];
};

export type QuerycheckResetPasswordTokenArgs = {
  token: Scalars['String']['input'];
};

export type QuerycheckWorkspaceArgs = {
  workspaceId: Scalars['String']['input'];
};

export type QuerycombinedCertificateTypesReportArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  subcontractorId: Scalars['ID']['input'];
};

export type QuerycombinedFileTreeWithDocumentsArgs = {
  attachables: Array<AttachableInput>;
};

export type QuerycompanyTemplatePreviewArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['HTML']['input']>;
  salutationMode?: InputMaybe<EMAIL_SALUTATION_MODE>;
  templateType: COMPANY_TEMPLATE_TYPE;
};

export type QuerycompanyTemplatesArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<COMPANY_TEMPLATE_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  type?: InputMaybe<COMPANY_TEMPLATE_TYPE>;
};

export type QuerycontractBoQContentArgs = {
  bidPackageId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type QuerycontractRunAgentStepArgs = {
  bidPackageId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type QuerycostAnalysisArgs = {
  breakdown: COST_ANALYSIS_BREAKDOWN;
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  topLevelGrouping: COST_ANALYSIS_TOP_LEVEL_GROUPING;
};

export type QuerycostComparisonArgs = {
  bidIds: Array<Scalars['ID']['input']>;
  bidPackageId: Scalars['ID']['input'];
  catalogType: PROJECT_COST_CATALOG_TYPE;
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerycostEstimatesForProjectArgs = {
  catalogType: COST_CATALOG_TYPE;
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type QuerycostGroupDefinitionsArgs = {
  costGroupType: COST_GROUP_TYPE;
};

export type QuerycountryNetworkSubcontractorsCountArgs = {
  countryCode: COUNTRY_CODE;
};

export type QuerycustomCostGroupCatalogArgs = {
  id: Scalars['ID']['input'];
};

export type QuerycustomCostGroupCatalogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CUSTOM_COST_GROUP_CATALOGS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerycustomFieldsArgs = {
  entityType: CUSTOM_FIELD_ENTITY_TYPE;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<CUSTOM_FIELD_TYPE>>;
};

export type QuerycustomFieldsWithInitialValuesArgs = {
  entityType: CUSTOM_FIELD_ENTITY_TYPE;
};

export type QuerydefaultBidderIntroductionTemplateContentArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerydefaultCostAnalysisBreakdownArgs = {
  projectId: Scalars['ID']['input'];
};

export type QuerydocumentArgs = {
  id: Scalars['ID']['input'];
};

export type QuerydownloadURLForBillOfQuantitiesArgs = {
  id: Scalars['ID']['input'];
  options: BoQExportInput;
  type: BOQ_FILE_TYPE;
};

export type QuerydownloadUrlForBidPackageBoQPdfArgs = {
  bidPackageId: Scalars['ID']['input'];
  pdfSettings?: InputMaybe<BoQPdfSettings>;
};

export type QuerydownloadUrlForBidPackageDocumentsArgs = {
  id: Scalars['ID']['input'];
  orientation: ORIENTATION;
};

export type QuerydownloadUrlForBidPdfArgs = {
  id: Scalars['ID']['input'];
  pdfSettings?: InputMaybe<BidPdfSettings>;
};

export type QuerydownloadUrlForBidRequestInNegotiationDocumentsArgs = {
  id: Scalars['ID']['input'];
  orientation: ORIENTATION;
};

export type QuerydownloadUrlForBidderStatusHistoryPdfArgs = {
  bidRequestId: Scalars['ID']['input'];
};

export type QuerydownloadUrlForBiddersListExcelArgs = {
  bidPackageId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BID_REQUESTS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerydownloadUrlForBiddersListPdfArgs = {
  bidPackageId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BID_REQUESTS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerydownloadUrlForContractBoQArgs = {
  bidPackageId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  exportType: BOQ_FILE_TYPE_DOWNLOADABLE_FOR_CONTRACT;
  fileName: Scalars['String']['input'];
  sourceBoQContractDocumentId: Scalars['ID']['input'];
};

export type QuerydownloadUrlForCostAnalysisSpreadsheetArgs = {
  breakdown: COST_ANALYSIS_BREAKDOWN;
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  topLevelGrouping: COST_ANALYSIS_TOP_LEVEL_GROUPING;
};

export type QuerydownloadUrlForCostComparisonSpreadsheetArgs = {
  bidIds: Array<Scalars['ID']['input']>;
  bidPackageId: Scalars['ID']['input'];
  catalogType: PROJECT_COST_CATALOG_TYPE;
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  hiddenBidders: Array<HiddenBidder>;
};

export type QuerydownloadUrlForCostEstimationSpreadsheetArgs = {
  catalogType: COST_CATALOG_TYPE;
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type QuerydownloadUrlForMessageThreadPdfArgs = {
  language: LANGUAGE;
  messageThreadId: Scalars['ID']['input'];
};

export type QuerydownloadUrlForOverviewPdfArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type QuerydownloadUrlForPriceComparisonPdfArgs = {
  alternativePositionSelections: Array<AlternativePositionSelection>;
  bidColumnConfigs: Array<BidColumnConfig>;
  bidPackageId: Scalars['ID']['input'];
  hiddenBidders?: InputMaybe<Array<HiddenBidder>>;
  hiddenComparisonColumns: Array<BOQ_COMPARISON_MODE>;
  hiddenElementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  highlightPriceMode: HighlightPriceMode;
  outlierSettings?: InputMaybe<PriceComparisonOutlierSettings>;
  pdfSettings?: InputMaybe<PCTPdfSettings>;
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerydownloadUrlForPriceComparisonSpreadsheetArgs = {
  alternativePositionSelections: Array<AlternativePositionSelection>;
  bidColumnConfigs: Array<BidColumnConfig>;
  bidPackageId: Scalars['ID']['input'];
  hiddenBidders?: InputMaybe<Array<HiddenBidder>>;
  hiddenComparisonColumns: Array<BOQ_COMPARISON_MODE>;
  hiddenElementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  highlightPriceMode?: InputMaybe<HighlightPriceMode>;
  includeOptions?: InputMaybe<PriceComparisonSpreadsheetIncludeOptions>;
  outlierSettings?: InputMaybe<PriceComparisonOutlierSettings>;
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerydownloadUrlForProjectDocumentsArgs = {
  id: Scalars['ID']['input'];
  orientation: ORIENTATION;
};

export type QuerydownloadUrlForProjectOverviewPdfArgs = {
  id: Scalars['ID']['input'];
};

export type QuerydownloadUrlForRequestForProposalBoQPdfArgs = {
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
  boqId: Scalars['ID']['input'];
  pdfSettings?: InputMaybe<BoQPdfSettings>;
};

export type QueryfileTreeWithDocumentsArgs = {
  attachable: AttachableInput;
};

export type QueryfindSimilarBidPackageNamesArgs = {
  name: Scalars['String']['input'];
};

export type QuerygetBoQPositionMassDeterminationForEditingArgs = {
  billOfQuantitiesId: Scalars['ID']['input'];
  boqContainerId: Scalars['ID']['input'];
  boqContainerType: BOQ_CONTAINER_TYPE;
  boqPositionRowId: Scalars['ID']['input'];
};

export type QuerygetSalesforceAccountDetailsArgs = {
  id: Scalars['String']['input'];
};

export type QueryheinzeAtBoQElementsArgs = {
  file: Scalars['String']['input'];
};

export type QueryheinzeVobBoQElementsArgs = {
  token: Scalars['String']['input'];
};

export type QueryheinzeVobGuiUrlArgs = {
  forceAnonymous?: Scalars['Boolean']['input'];
};

export type QueryimageUploadUrlArgs = {
  filename: Scalars['String']['input'];
};

export type QueryinvitationArgs = {
  token: Scalars['String']['input'];
};

export type QueryinvoiceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryinvoiceCoverSheetUrlArgs = {
  id: Scalars['ID']['input'];
};

export type QueryinvoiceNotesArgs = {
  invoiceId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryinvoicesArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  requiresApprovalByCurrentUser?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<INVOICE_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QueryisAgentCompanyAbleToSubmitBidArgs = {
  bidPackageId: Scalars['ID']['input'];
  sentEmailId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryisCompanyWaitingForSignupApprovalArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryisPrincipalUserOnlyArgs = {
  email: Scalars['String']['input'];
};

export type QuerylastCertificateRequestArgs = {
  subcontractorId: Scalars['ID']['input'];
};

export type QuerylongRunningTaskArgs = {
  id: Scalars['ID']['input'];
};

export type QuerymarketplaceBidPackageSuggestionsArgs = {
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
};

export type QuerymarketplaceBidPackagesForMapArgs = {
  distanceInKm: Scalars['Int']['input'];
  geoCoords: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<BID_PACKAGES_MARKETPLACE_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerymarketplaceLockArgs = {
  sentEmailId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerymarketplaceSuggestionArgs = {
  id: Scalars['ID']['input'];
};

export type QuerymarketplaceSuggestionPreviewArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type QuerymarketplaceSuggestionsArgs = {
  bidPackageId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<MARKETPLACE_SUGGESTIONS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerymessageThreadArgs = {
  messageThreadId: Scalars['ID']['input'];
};

export type QuerymessageThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  showMessageThreadsFromAllProjects?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<MESSAGE_THREAD_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerymessageThreadsForSubcontractorArgs = {
  query: Scalars['String']['input'];
  showMessageThreadsFromAllProjects?: InputMaybe<Scalars['Boolean']['input']>;
  subcontractorId: Scalars['ID']['input'];
};

export type QuerymessageThreadsInBidPackageArgs = {
  bidPackageId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};

export type QuerymessageThreadsInBidRequestArgs = {
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
  query: Scalars['String']['input'];
};

export type QuerymultiUserApprovalRequestArgs = {
  action: MULTI_USER_APPROVAL_ACTION;
  entityId: Scalars['ID']['input'];
};

export type QuerymultiUserApprovalRulesArgs = {
  action: MULTI_USER_APPROVAL_ACTION;
};

export type QuerymyTasksInStatusCountArgs = {
  status: TASK_STATUS;
};

export type QuerynetworkSubcontractorArgs = {
  countryCode: COUNTRY_CODE;
  slug: Scalars['String']['input'];
};

export type QuerynetworkSubcontractorsArgs = {
  companySizes?: InputMaybe<Array<COMPANY_SIZE>>;
  countryCode?: InputMaybe<COUNTRY_CODE>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SUBCONTRACTORS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  workCategoryIdsList?: InputMaybe<Array<WorkCategoryIds>>;
};

export type QuerynetworkSubcontractorsByWorkCategorySlugArgs = {
  countryCode: COUNTRY_CODE;
  distance?: InputMaybe<Scalars['Float']['input']>;
  language: LANGUAGE;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  sortBy?: InputMaybe<SUBCONTRACTORS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
};

export type QuerynetworkSubcontractorsImportArgs = {
  id: Scalars['ID']['input'];
};

export type QuerynotificationsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type QueryofficeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryorganizationsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryparsedCompanyTemplatesByTypeArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
  emailTemplatePlaceholderInput?: InputMaybe<EmailTemplatePlaceholderInput>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  salutationMode?: InputMaybe<EMAIL_SALUTATION_MODE>;
  type: COMPANY_TEMPLATE_TYPE;
};

export type QueryparsedIfcFileArgs = {
  documentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type QueryparsedIfcFileWithAssociatedCostsArgs = {
  documentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type QuerypermissionControlsConfigArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userType: USER_TYPE;
};

export type QuerypredictPriceForBidPackageArgs = {
  bidPackageId: Scalars['ID']['input'];
  positionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pricePredictionContext?: InputMaybe<PRICE_PREDICTION_CONTEXT>;
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerypreviewBidConfirmationEmailAfterPrincipalSubmissionArgs = {
  bidRequestId: Scalars['ID']['input'];
  draftBidId: Scalars['ID']['input'];
};

export type QuerypriceLibraryElementsArgs = {
  elementType: PRICE_LIBRARY_BOQ_ELEMENT_TYPE;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  omitBidPackageId?: InputMaybe<Scalars['ID']['input']>;
  omitBidRequestId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PRICE_LIBRARY_POSITIONS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  workCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuerypriceLibraryPositionsV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  omitBidPackageId?: InputMaybe<Scalars['ID']['input']>;
  omitBidRequestId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PRICE_LIBRARY_POSITIONS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  workCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryprojectArgs = {
  id: Scalars['ID']['input'];
};

export type QueryprojectChangedBiddersNotificationPreviewArgs = {
  comment?: InputMaybe<Scalars['HTML']['input']>;
  id: Scalars['ID']['input'];
  input: ProjectInput;
};

export type QueryprojectCostGroupCatalogsArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryprojectRatingsPerBidRequestArgs = {
  projectId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryprojectsArgs = {
  fetchAllOfficeProjects?: InputMaybe<Scalars['Boolean']['input']>;
  fromCreationDate?: InputMaybe<Scalars['Date']['input']>;
  fromEndDate?: InputMaybe<Scalars['Date']['input']>;
  fromStartDate?: InputMaybe<Scalars['Date']['input']>;
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  officeId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phase?: InputMaybe<PROJECT_PHASE>;
  primaryUserId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PROJECTS_SORT_FIELD>;
  sortById?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  status?: InputMaybe<Scalars['String']['input']>;
  toCreationDate?: InputMaybe<Scalars['Date']['input']>;
  toEndDate?: InputMaybe<Scalars['Date']['input']>;
  toStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type QueryprojectsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QuerypublicMarketplaceBidPackageArgs = {
  slug: Scalars['String']['input'];
};

export type QuerypublicNetworkSubcontractorProfileArgs = {
  id: Scalars['ID']['input'];
};

export type QuerypublicSubcontractorProfileArgs = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<SUBCONTRACTOR_TYPE>;
};

export type QuerypublicSubcontractorProfileForAwardedBidArgs = {
  awardedBidId: Scalars['ID']['input'];
};

export type QueryrefreshStlbSessionArgs = {
  oldSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryreverseMarketplaceBidPackageArgs = {
  id: Scalars['ID']['input'];
  referrerUserId?: InputMaybe<Scalars['ID']['input']>;
  sentEmailId?: InputMaybe<Scalars['ID']['input']>;
  suggestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerysearchSalesforceAccountsArgs = {
  query: Scalars['String']['input'];
};

export type QuerysentEmailStatisticsArgs = {
  sentEmailId: Scalars['ID']['input'];
};

export type QueryshouldPromptWorkCategoriesUpdateArgs = {
  subcontractorId: Scalars['ID']['input'];
};

export type QuerysideEffectFreeDraftBidArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  bidRequestId: Scalars['ID']['input'];
};

export type QuerysignupArgs = {
  id: Scalars['ID']['input'];
};

export type QuerysignupForCompanyArgs = {
  companyId: Scalars['ID']['input'];
};

export type QuerysimilarSubcontractorsArgs = {
  bidPackageId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerysimilarSubcontractorsByContactEmailArgs = {
  email: Scalars['String']['input'];
};

export type QuerysimilarSubcontractorsByNameArgs = {
  name: Scalars['String']['input'];
};

export type QuerysimulationChangesArgs = {
  bidPackageId: Scalars['ID']['input'];
  revision?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryssoRedirectUrlArgs = {
  email: Scalars['String']['input'];
  expectedUserStatus: USER_STATUS;
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type QuerystlbGetDataArgs = {
  sessionId: Scalars['String']['input'];
};

export type QuerystlbHomeUrlArgs = {
  sessionId: Scalars['String']['input'];
};

export type QuerysubcontractorArgs = {
  id: Scalars['ID']['input'];
};

export type QuerysubcontractorBySentEmailArgs = {
  sentEmailId: Scalars['ID']['input'];
};

export type QuerysubcontractorForProfileArgs = {
  id: Scalars['ID']['input'];
};

export type QuerysubcontractorForSuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
};

export type QuerysubcontractorLoginSuggestionsArgs = {
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
  subcontractorId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerysubcontractorRatingByBidRequestArgs = {
  bidRequestId: Scalars['ID']['input'];
};

export type QuerysubcontractorRatingPerBidRequestArgs = {
  subcontractorId: Scalars['ID']['input'];
};

export type QuerysubcontractorRatingSummaryArgs = {
  subcontractorId: Scalars['ID']['input'];
};

export type QuerysubcontractorReferenceProjectArgs = {
  id: Scalars['ID']['input'];
};

export type QuerysubcontractorSelectedGlobalCertificateTypesArgs = {
  subcontractorId: Scalars['ID']['input'];
};

export type QuerysubcontractorTypeArgs = {
  id: Scalars['ID']['input'];
};

export type QuerysubcontractorsArgs = {
  companySizes?: InputMaybe<Array<InputMaybe<COMPANY_SIZE>>>;
  countryCode?: InputMaybe<COUNTRY_CODE>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  filters?: InputMaybe<SubcontractorFiltersInput>;
  frequentStatuses?: InputMaybe<Array<BID_REQUEST_STATUS>>;
  hasPQNumber?: InputMaybe<Scalars['Boolean']['input']>;
  isBanned?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isRated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationFilter>;
  matchAllWorkCategories?: InputMaybe<Scalars['Boolean']['input']>;
  maxYearlyRevenue?: InputMaybe<Scalars['Float']['input']>;
  minYearlyRevenue?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  ratings?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortBy?: InputMaybe<SUBCONTRACTORS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  sortMode?: InputMaybe<SUBCONTRACTORS_SORT_MODE>;
  type?: InputMaybe<SUBCONTRACTOR_LIST_TYPE>;
  workCategoryIdsList?: InputMaybe<Array<WorkCategoryIds>>;
};

export type QuerysubcontractorsByAgentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerysubcontractorsImportsArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerytaskArgs = {
  id: Scalars['ID']['input'];
};

export type QuerytaskNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  taskId: Scalars['ID']['input'];
};

export type QuerytaskPublicDataArgs = {
  id: Scalars['ID']['input'];
};

export type QuerytasksArgs = {
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
  fetchOwnTasks?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<TASKS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  statuses?: InputMaybe<Array<TASK_STATUS>>;
};

export type QuerytermsArgs = {
  termsId: Scalars['ID']['input'];
};

export type QuerytermsForBidRequestArgs = {
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerytotalAvailablePriceLibraryElementsArgs = {
  elementType: PRICE_LIBRARY_BOQ_ELEMENT_TYPE;
  omitBidPackageId?: InputMaybe<Scalars['ID']['input']>;
  omitBidRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerytotalAvailablePriceLibraryPositionsArgs = {
  omitBidPackageId?: InputMaybe<Scalars['ID']['input']>;
  omitBidRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryusersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  officeId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<USERS_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  statuses?: InputMaybe<Array<USER_STATUS>>;
  userRoles?: InputMaybe<Array<UserRoleInput>>;
};

export type QueryusersWithAccessToBidPackageArgs = {
  bidPackageId: Scalars['ID']['input'];
};

export type QueryusersWithAccessToProjectArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryvalidateBidMainOrderNumberArgs = {
  ignoreBidId?: InputMaybe<Scalars['ID']['input']>;
  mainOrderNumber: Scalars['String']['input'];
  officeId: Scalars['ID']['input'];
};

export type QueryvalidateCostAnalysisForProjectArgs = {
  catalogType: COST_CATALOG_TYPE;
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type QueryvalidateEmailArgs = {
  input: Scalars['String']['input'];
  validateDomain?: Scalars['Boolean']['input'];
  validateUsage?: Scalars['Boolean']['input'];
};

export type QueryvalidateSubcontractorsImportArgs = {
  id: Scalars['ID']['input'];
};

export type QueryvalidateWorkCategoryWithTranslationInputArgs = {
  input: Array<WorkCategoryWithTranslationsListInput>;
};

export type QueryworkCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  language?: InputMaybe<LANGUAGE>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<WORK_CATEGORY_SORT_FIELD>;
  sortDirection?: InputMaybe<SORT_DIRECTION>;
  type?: WORK_CATEGORY_TYPE_FILTER;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryworkCategorySuggestionsArgs = {
  categories: Array<Scalars['ID']['input']>;
  hints?: InputMaybe<WorkCategorySuggestionsHints>;
};

export enum RATING_CATEGORY {
  addenda = 'addenda',
  adherenceToDeadlines = 'adherenceToDeadlines',
  availability = 'availability',
  bidQuality = 'bidQuality',
  cleanliness = 'cleanliness',
  communication = 'communication',
  environmentalAspects = 'environmentalAspects',
  invoicingAndBilling = 'invoicingAndBilling',
  negotiation = 'negotiation',
  occupationalSafety = 'occupationalSafety',
  priceLevel = 'priceLevel',
  qualityOfWork = 'qualityOfWork',
  reliability = 'reliability',
  timeManagement = 'timeManagement',
}

export enum REASON_PROPOSAL_BOQ_IS_OUTDATED {
  requestBoQDeleted = 'requestBoQDeleted',
  requestBoQUpdated = 'requestBoQUpdated',
}

export enum RECIPIENT_ENTITY_TYPE {
  Account = 'Account',
  Admin = 'Admin',
  Contact = 'Contact',
  User = 'User',
}

export enum REQUEST_PASSWORDLESS_LOGIN_CODE_FAILURE_REASON {
  userMissingOrDeactivated = 'userMissingOrDeactivated',
}

export type ReasonableBidDueDate = {
  __typename: 'ReasonableBidDueDate';
  issue: Maybe<BP_PUBLICATION_REASONABLE_BID_DUE_DATE_ISSUE>;
};

export type RefreshEditingSessionResponse =
  | RefreshEditingSessionSuccess
  | RequestEditingSessionFailure;

export type RefreshEditingSessionSuccess = {
  __typename: 'RefreshEditingSessionSuccess';
  success: Scalars['Boolean']['output'];
};

export type RegistrationCourt = {
  __typename: 'RegistrationCourt';
  city: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type RenumberEntry = {
  __typename: 'RenumberEntry';
  code: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type RenumberEntryInput = {
  code: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type RenumberOperationDescriptor = {
  __typename: 'RenumberOperationDescriptor';
  entries: Array<RenumberEntry>;
  operation: BOQ_EDIT_OPERATION;
  operationId: Scalars['ID']['output'];
};

export type RequestEditingSessionFailure = {
  __typename: 'RequestEditingSessionFailure';
  existingSession: EditingSession;
};

export type RequestEditingSessionResponse =
  | RequestEditingSessionFailure
  | RequestEditingSessionSuccess;

export type RequestEditingSessionSuccess = {
  __typename: 'RequestEditingSessionSuccess';
  newSession: EditingSession;
};

export type RequestPasswordlessLoginCodeFailure = {
  __typename: 'RequestPasswordlessLoginCodeFailure';
  reason: REQUEST_PASSWORDLESS_LOGIN_CODE_FAILURE_REASON;
  success: Scalars['Boolean']['output'];
};

export type RequestPasswordlessLoginCodeResponse =
  | RequestPasswordlessLoginCodeFailure
  | RequestPasswordlessLoginCodeSuccess;

export type RequestPasswordlessLoginCodeSuccess = {
  __typename: 'RequestPasswordlessLoginCodeSuccess';
  success: Scalars['Boolean']['output'];
};

export type RequiredRejectionEmailTemplateNotificationInput = {
  emailTemplate?: InputMaybe<Scalars['HTML']['input']>;
};

export type RevampAgentSignupResponse = AgentSignupResponse | Signup;

export type RevealContactInfoInput = {
  contact: RevealContactInfoInputContact;
  subcontractorId: Scalars['ID']['input'];
  utm?: InputMaybe<RevealContactInfoInputUtm>;
};

export type RevealContactInfoInputContact = {
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type RevealContactInfoInputUtm = {
  campaign: Scalars['String']['input'];
  medium: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type RevealedContact = {
  __typename: 'RevealedContact';
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type RevealedContactInfo = {
  __typename: 'RevealedContactInfo';
  contacts: Array<RevealedContact>;
  street: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

export type ReviewedSuggestionsInput = {
  approvedContactSuggestionFieldIds: Array<Scalars['ID']['input']>;
  approvedSubcontractorSuggestionFieldIds: Array<Scalars['ID']['input']>;
  approvedSubcontractorSuggestionIds: Array<Scalars['ID']['input']>;
  autoDismissNonApproved?: Scalars['Boolean']['input'];
  dismissedContactSuggestionFieldIds: Array<Scalars['ID']['input']>;
  dismissedSubcontractorSuggestionFieldIds: Array<Scalars['ID']['input']>;
  dismissedSubcontractorSuggestionIds: Array<Scalars['ID']['input']>;
};

export type RowValidationConstraintError = {
  __typename: 'RowValidationConstraintError';
  error: Maybe<Scalars['String']['output']>;
  properties: Maybe<Array<Scalars['String']['output']>>;
  property: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  type: NETWORK_SUBCONTRACTOR_IMPORT_ROW_VALIDATION_CONSTRAINT;
  value: Maybe<Scalars['String']['output']>;
};

export enum SALESFORCE_PACKAGE_TYPE {
  bronze = 'bronze',
  enterprise = 'enterprise',
  freeTrial = 'freeTrial',
  gold = 'gold',
  noPricingPackage = 'noPricingPackage',
  silver = 'silver',
}

export enum SENT_EMAILS_SORT_FIELD {
  from = 'from',
  sentAt = 'sentAt',
  status = 'status',
  subject = 'subject',
  to = 'to',
}

export enum SIGNUP_SORT_FIELD {
  createdAt = 'createdAt',
  email = 'email',
  status = 'status',
}

export enum SIGNUP_STATUS {
  approved = 'approved',
  completed = 'completed',
  denied = 'denied',
  emailVerificationCode = 'emailVerificationCode',
  onHold = 'onHold',
  started = 'started',
}

export enum SIGNUP_TYPE {
  adminVerify = 'adminVerify',
  peerVerify = 'peerVerify',
  selfVerify = 'selfVerify',
}

export enum SIMULATION_CHANGE_STORE_ACTION {
  remove = 'remove',
  update = 'update',
}

export enum SIMULATION_CHANGE_TYPE {
  bidFreeQuantity = 'bidFreeQuantity',
  bidUnitPrice = 'bidUnitPrice',
  boqQuantity = 'boqQuantity',
  customBudgetFreeQuantity = 'customBudgetFreeQuantity',
  customBudgetUnitPrice = 'customBudgetUnitPrice',
}

export enum SORT_DIRECTION {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SSODomain = {
  __typename: 'SSODomain';
  domain: Scalars['String']['output'];
};

export type SSODomainInput = {
  domain: Scalars['String']['input'];
};

export enum STANDARD_USER_TYPE {
  administrator = 'administrator',
  collaborator = 'collaborator',
  employee = 'employee',
  guest = 'guest',
  manager = 'manager',
}

export enum STATE_CODE {
  DE_BB = 'DE_BB',
  DE_BE = 'DE_BE',
  DE_BW = 'DE_BW',
  DE_BY = 'DE_BY',
  DE_HB = 'DE_HB',
  DE_HE = 'DE_HE',
  DE_HH = 'DE_HH',
  DE_MV = 'DE_MV',
  DE_NI = 'DE_NI',
  DE_NW = 'DE_NW',
  DE_RP = 'DE_RP',
  DE_SH = 'DE_SH',
  DE_SL = 'DE_SL',
  DE_SN = 'DE_SN',
  DE_ST = 'DE_ST',
  DE_TH = 'DE_TH',
}

export enum STATUS_HISTORY_EMAIL_TEMPLATE_NAME {
  bidInvite = 'bidInvite',
  bidInviteNew = 'bidInviteNew',
  bidInviteReminder = 'bidInviteReminder',
  bidInviteReminderNew = 'bidInviteReminderNew',
  bidInviteReminderSC12989_V1 = 'bidInviteReminderSC12989_V1',
  bidInviteReminderSC12989_V2 = 'bidInviteReminderSC12989_V2',
  bidInviteSC12989_V1 = 'bidInviteSC12989_V1',
  bidInviteSC12989_V2 = 'bidInviteSC12989_V2',
  bidInviteSC12989_V3 = 'bidInviteSC12989_V3',
  bidInviteSC12989_V4 = 'bidInviteSC12989_V4',
  bidInviteSC12989_V5 = 'bidInviteSC12989_V5',
  bidInviteSC12989_V6 = 'bidInviteSC12989_V6',
  bidInviteSC22946_V1 = 'bidInviteSC22946_V1',
  bidInviteSC22946_V2 = 'bidInviteSC22946_V2',
  bidPackageChangedNotification = 'bidPackageChangedNotification',
  bidPackageClosed = 'bidPackageClosed',
  bidRequestAwardedNotification = 'bidRequestAwardedNotification',
  bidRequestRejectedNotification = 'bidRequestRejectedNotification',
  bidderIntroduction = 'bidderIntroduction',
  boqChangedNotification = 'boqChangedNotification',
  contractAgentRequest = 'contractAgentRequest',
  contractSignature = 'contractSignature',
  contractWithdrawn = 'contractWithdrawn',
  documentNotification = 'documentNotification',
  marketplaceBidRequestBidsDueNotification = 'marketplaceBidRequestBidsDueNotification',
  newMessageNotification = 'newMessageNotification',
}

export enum SUBCONTRACTORS_IMPORT_STATUS {
  failed = 'failed',
  initial = 'initial',
  pending = 'pending',
  running = 'running',
  succeeded = 'succeeded',
  validated = 'validated',
}

export enum SUBCONTRACTORS_SORT_FIELD {
  distance = 'distance',
  name = 'name',
}

export enum SUBCONTRACTORS_SORT_MODE {
  algorithmic = 'algorithmic',
  simple = 'simple',
}

export enum SUBCONTRACTOR_CLAIM_REFERENCE {
  bidInvite = 'bidInvite',
  marketplaceSuggestion = 'marketplaceSuggestion',
  sentEmail = 'sentEmail',
}

export enum SUBCONTRACTOR_IMPORT_ERROR_REASON {
  contactHasNoContactMethod = 'contactHasNoContactMethod',
  countryCodeMissing = 'countryCodeMissing',
  externalIdMissing = 'externalIdMissing',
  headersAreMissing = 'headersAreMissing',
  invalidContactEmailFormat = 'invalidContactEmailFormat',
  nameIsEmpty = 'nameIsEmpty',
  noContactsProvided = 'noContactsProvided',
  unsupportedCountryCode = 'unsupportedCountryCode',
}

export enum SUBCONTRACTOR_IMPORT_REQUEST_FILE_TYPE {
  auer = 'auer',
  brz = 'brz',
  cosuno = 'cosuno',
  itwo = 'itwo',
  microsoftTeams = 'microsoftTeams',
  nevaris = 'nevaris',
  orca = 'orca',
  other = 'other',
  outlook = 'outlook',
}

export enum SUBCONTRACTOR_IMPORT_REQUEST_STATUS {
  completed = 'completed',
  onHold = 'onHold',
  pending = 'pending',
}

export enum SUBCONTRACTOR_LIST_TYPE {
  company = 'company',
  companyAndNetwork = 'companyAndNetwork',
  network = 'network',
}

export enum SUBCONTRACTOR_MERGE_REQUEST_MATCH_TYPE {
  email = 'email',
  fuzzy = 'fuzzy',
  website = 'website',
}

export enum SUBCONTRACTOR_MERGE_REQUEST_SORT_FIELD {
  createdAt = 'createdAt',
  sourceSubcontractorName = 'sourceSubcontractorName',
  status = 'status',
  targetSubcontractorName = 'targetSubcontractorName',
}

export enum SUBCONTRACTOR_MERGE_REQUEST_STATUS {
  approved = 'approved',
  denied = 'denied',
  pending = 'pending',
}

export enum SUBCONTRACTOR_PRICING_TIER {
  tier1 = 'tier1',
  tier2 = 'tier2',
  tier3 = 'tier3',
  tier4 = 'tier4',
  tier5 = 'tier5',
}

export enum SUBCONTRACTOR_SUGGESTION_CHANGE_TYPE {
  delete = 'delete',
  update = 'update',
}

export enum SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE {
  append = 'append',
  remove = 'remove',
  set = 'set',
  unset = 'unset',
}

export enum SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME {
  city = 'city',
  companySize = 'companySize',
  countryCode = 'countryCode',
  description = 'description',
  foundingYear = 'foundingYear',
  logoKey = 'logoKey',
  name = 'name',
  nationalId = 'nationalId',
  orderAreaCountryCode = 'orderAreaCountryCode',
  orderAreaStateCodes = 'orderAreaStateCodes',
  orderAreaType = 'orderAreaType',
  orderRadius = 'orderRadius',
  ownerName = 'ownerName',
  postalCode = 'postalCode',
  pqNumber = 'pqNumber',
  registrationCity = 'registrationCity',
  registrationPostalCode = 'registrationPostalCode',
  revenueYear = 'revenueYear',
  street = 'street',
  taxId = 'taxId',
  website = 'website',
  workCategories = 'workCategories',
  yearlyRevenue = 'yearlyRevenue',
}

export enum SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT {
  approved = 'approved',
  dismissed = 'dismissed',
}

export enum SUBCONTRACTOR_TYPE {
  company = 'company',
  network = 'network',
}

export type SalesforceAccount = {
  __typename: 'SalesforceAccount';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SalesforceAccountDetailsForAdmin = {
  __typename: 'SalesforceAccountDetailsForAdmin';
  isEnterpriseOpportunity: Maybe<Scalars['Boolean']['output']>;
  licenseData: Maybe<SalesforceAccountLicenseData>;
  name: Scalars['String']['output'];
  packageType: Maybe<SALESFORCE_PACKAGE_TYPE>;
};

export type SalesforceAccountLicenseData = {
  __typename: 'SalesforceAccountLicenseData';
  fullUserLicenseCount: Scalars['Int']['output'];
  fullUserLicenseUnlimited: Scalars['Boolean']['output'];
  guestLicenseCount: Scalars['Int']['output'];
  guestLicenseUnlimited: Scalars['Boolean']['output'];
};

export type SaveCostEstimateForProjectResponse =
  | RequestEditingSessionFailure
  | SaveCostEstimateForProjectSuccess;

export type SaveCostEstimateForProjectSuccess = {
  __typename: 'SaveCostEstimateForProjectSuccess';
  success: Scalars['Boolean']['output'];
};

export type SavePriceComparisonResponse = RequestEditingSessionFailure | SavePriceComparisonSuccess;

export type SavePriceComparisonSuccess = {
  __typename: 'SavePriceComparisonSuccess';
  success: Scalars['Boolean']['output'];
};

export type SaveSimulationOptionsInput = {
  saveBoQ: Scalars['Boolean']['input'];
  saveCustomBudget: Scalars['Boolean']['input'];
  selectedBidIds: Array<Scalars['String']['input']>;
};

export type SendAwardingEmailInput = {
  awarding: EmailTemplateNotificationInput;
  bidRequestId: Scalars['ID']['input'];
  rejection: EmailTemplateNotificationInput;
};

export type SendRejectionEmailInput = {
  bidRequestId: Scalars['ID']['input'];
  rejection: RequiredRejectionEmailTemplateNotificationInput;
};

export type SentEmail = AbstractEntity & {
  __typename: 'SentEmail';
  attachments: Maybe<Scalars['JSON']['output']>;
  canBeResent: Scalars['Boolean']['output'];
  contentHtml: Maybe<Scalars['HTML']['output']>;
  contentText: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customId: Maybe<Scalars['ID']['output']>;
  fromEmail: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  recipient: Maybe<Contact>;
  replyToEmail: Maybe<Scalars['String']['output']>;
  resendAttempts: Array<SentEmail>;
  resendReason: Maybe<Scalars['String']['output']>;
  status: EMAIL_STATUS;
  subject: Maybe<Scalars['String']['output']>;
  template: Scalars['String']['output'];
  templateProps: Scalars['JSONObject']['output'];
  toEmail: Scalars['String']['output'];
  triggeredByAdmin: Maybe<Admin>;
};

export enum SentEmailAuthActions {
  resend = 'resend',
  view = 'view',
}

export type SentEmailAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type SentEmailAuthInput = {
  action: SentEmailAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SentEmailAuthArgsInput>;
};

export type SentEmailEvent = AbstractEntity & {
  __typename: 'SentEmailEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['JSONObject']['output'];
  sentEmailId: Scalars['ID']['output'];
  type: MAILJET_EVENT_TYPE;
};

export type SentEmailForStatusHistoryResponse = {
  __typename: 'SentEmailForStatusHistoryResponse';
  contact: Contact;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTimeISO']['output'];
  sentEmail: SentEmail;
  templateName: STATUS_HISTORY_EMAIL_TEMPLATE_NAME;
};

export type SentEmailStatisticsResponse = {
  __typename: 'SentEmailStatisticsResponse';
  messageDetails: MessageDetails;
  messageHistory: Array<MessageHistory>;
  messageId: Scalars['String']['output'];
};

export type SentEmailsResponse = {
  __typename: 'SentEmailsResponse';
  sentEmails: Array<SentEmail>;
  totalRecords: Scalars['Int']['output'];
};

export type SetMassDeterminationRowInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  factor?: InputMaybe<Scalars['Float']['input']>;
  formulaId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  localId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  value1?: InputMaybe<Scalars['Float']['input']>;
  value2?: InputMaybe<Scalars['Float']['input']>;
  value3?: InputMaybe<Scalars['Float']['input']>;
  value4?: InputMaybe<Scalars['Float']['input']>;
  value5?: InputMaybe<Scalars['Float']['input']>;
};

export type Signup = AbstractEntity & {
  __typename: 'Signup';
  agentPricingTier: Maybe<SUBCONTRACTOR_PRICING_TIER>;
  billingFrequency: Maybe<BILLING_FREQUENCY>;
  company: Company;
  contacts: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPremium: Scalars['Boolean']['output'];
  isWaitingForSubcontractorVerificationCode: Scalars['Boolean']['output'];
  language: LANGUAGE;
  lastName: Scalars['String']['output'];
  status: SIGNUP_STATUS;
  subcontractorId: Maybe<Scalars['String']['output']>;
  subcontractorName: Scalars['String']['output'];
  type: SIGNUP_TYPE;
  userId: Maybe<Scalars['String']['output']>;
};

export enum SignupAuthActions {
  approve = 'approve',
  delete = 'delete',
  deny = 'deny',
  onHold = 'onHold',
  view = 'view',
}

export type SignupAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type SignupAuthInput = {
  action: SignupAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SignupAuthArgsInput>;
};

export type SignupVerifyResponse = {
  __typename: 'SignupVerifyResponse';
  isWaitingForSubcontractorVerificationCode: Scalars['Boolean']['output'];
  loginToken: Scalars['String']['output'];
};

export type SignupsResponse = {
  __typename: 'SignupsResponse';
  signups: Array<Signup>;
  totalRecords: Scalars['Float']['output'];
};

export type SimilarBidPackageDetails = {
  __typename: 'SimilarBidPackageDetails';
  bidRequestCount: Scalars['Int']['output'];
  bidsDueAtSimilarity: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectLocationSimilarity: Scalars['Float']['output'];
  projectName: Scalars['String']['output'];
  submissionRate: Scalars['Float']['output'];
  submittedBidRequestCount: Scalars['Int']['output'];
  weightedSimilarity: Scalars['Float']['output'];
  workCategories: Array<WorkCategory>;
  workCategorySimilarity: Scalars['Float']['output'];
};

export type SimilarSubcontractorsResponse = {
  __typename: 'SimilarSubcontractorsResponse';
  subcontractors: Array<Subcontractor>;
  totalRecords: Scalars['Int']['output'];
};

export type SimulationBidChanges = {
  __typename: 'SimulationBidChanges';
  bidId: Scalars['ID']['output'];
  boqUnitPriceChanges: Array<SimulationNullableChange>;
  freeQuantityChanges: Array<SimulationNullableChange>;
};

export type SimulationChangeInput = {
  action: SIMULATION_CHANGE_STORE_ACTION;
  bidId?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  type: SIMULATION_CHANGE_TYPE;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type SimulationChanges = {
  __typename: 'SimulationChanges';
  bids: Array<SimulationBidChanges>;
  boqQuantityChanges: Array<SimulationQuantityChange>;
  customBudgetBoQFreeQuantityChanges: Array<SimulationNullableChange>;
  customBudgetBoQUnitPriceChanges: Array<SimulationNullableChange>;
};

export type SimulationNullableChange = {
  __typename: 'SimulationNullableChange';
  path: Scalars['String']['output'];
  value: Maybe<Scalars['Float']['output']>;
};

export type SimulationQuantityChange = {
  __typename: 'SimulationQuantityChange';
  path: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type StandardUserRole = {
  __typename: 'StandardUserRole';
  type: STANDARD_USER_TYPE;
};

export type StandardizedDescriptionResponse = {
  __typename: 'StandardizedDescriptionResponse';
  standardReferenceType: Scalars['String']['output'];
  stlbReference: StlbReferenceResponse;
};

export type StlbKeyResponse = {
  __typename: 'StlbKeyResponse';
  artIdentifier: Scalars['String']['output'];
  artIndex: Maybe<Scalars['String']['output']>;
  kindIdentifier: Maybe<Scalars['String']['output']>;
};

export type StlbReferenceResponse = {
  __typename: 'StlbReferenceResponse';
  catalogueName: Scalars['String']['output'];
  group: Scalars['String']['output'];
  keys: Array<StlbKeyResponse>;
  versionDate: Scalars['DateTimeISO']['output'];
};

export type StlbSessionResponse = {
  __typename: 'StlbSessionResponse';
  authorizationFailed: Scalars['Boolean']['output'];
  sessionId: Scalars['String']['output'];
};

export type StlbWorkCategoryDefinition = {
  __typename: 'StlbWorkCategoryDefinition';
  designation: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type StlbWorkCategoryDefinitionResponse = {
  __typename: 'StlbWorkCategoryDefinitionResponse';
  definitions: Array<StlbWorkCategoryDefinition>;
};

export type StoreSimulationChangesResponse =
  | RequestEditingSessionFailure
  | StoreSimulationChangesSuccess;

export type StoreSimulationChangesSuccess = {
  __typename: 'StoreSimulationChangesSuccess';
  success: Scalars['Boolean']['output'];
};

export type StringDiff = {
  __typename: 'StringDiff';
  new: Maybe<Scalars['String']['output']>;
  old: Maybe<Scalars['String']['output']>;
};

export type StringListDiff = {
  __typename: 'StringListDiff';
  new: Maybe<Array<Scalars['String']['output']>>;
  old: Maybe<Array<Scalars['String']['output']>>;
};

export type Subcontractor = AbstractEntity &
  GeocodedGraphQLEntity & {
    __typename: 'Subcontractor';
    aboutUs: Maybe<Scalars['HTML']['output']>;
    agentCompany: Maybe<Company>;
    agentCompanyId: Maybe<Scalars['String']['output']>;
    bidRequestsAwaitingResponseCount: Scalars['Int']['output'];
    bidRequestsCount: Maybe<Scalars['Int']['output']>;
    city: Maybe<Scalars['String']['output']>;
    company: Maybe<Company>;
    companyId: Maybe<Scalars['ID']['output']>;
    companySize: Maybe<COMPANY_SIZE>;
    confirmedByAgent: Scalars['Boolean']['output'];
    contacts: Array<Contact>;
    countryCode: Maybe<COUNTRY_CODE>;
    createdAt: Scalars['DateTimeISO']['output'];
    customFields: Maybe<Array<CustomFieldWithValue>>;
    description: Maybe<Scalars['String']['output']>;
    foundingYear: Maybe<Scalars['Float']['output']>;
    generatedDescription: Maybe<Scalars['String']['output']>;
    hasSustainableConstruction: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    imageKeys: Array<Scalars['String']['output']>;
    isBanned: Scalars['Boolean']['output'];
    isClaimedByAgentCompany: Scalars['Boolean']['output'];
    isDeleted: Scalars['Boolean']['output'];
    isFavorite: Scalars['Boolean']['output'];
    lat: Maybe<Scalars['Float']['output']>;
    logoKey: Maybe<Scalars['String']['output']>;
    long: Maybe<Scalars['Float']['output']>;
    moreInfo: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    nationalId: Maybe<Scalars['String']['output']>;
    notes: Maybe<Array<SubcontractorNote>>;
    notesCount: Maybe<Scalars['Int']['output']>;
    orderAreaCountryCode: Maybe<COUNTRY_CODE>;
    orderAreaStateCodes: Maybe<Array<STATE_CODE>>;
    orderAreaType: ORDER_AREA_TYPE;
    orderRadius: Maybe<ORDER_RADIUS>;
    ownerName: Maybe<Scalars['String']['output']>;
    postalCode: Maybe<Scalars['String']['output']>;
    pqNumber: Maybe<Scalars['String']['output']>;
    rating: Maybe<Scalars['Float']['output']>;
    referenceProjects: Array<SubcontractorReferenceProject>;
    registrationCity: Maybe<Scalars['String']['output']>;
    registrationPostalCode: Maybe<Scalars['String']['output']>;
    revenueYear: Maybe<Scalars['Float']['output']>;
    slug: Scalars['String']['output'];
    street: Maybe<Scalars['String']['output']>;
    /** Returns number of submitted certificate types (this includes certificates uploaded by both principal and agent users). Returns null if a user or company cannot access certificates */
    submittedCertificateTypesCount: Maybe<Scalars['Int']['output']>;
    suggestedChanges: Array<SubcontractorSuggestion>;
    suggestedNewContacts: Array<ContactCreationSuggestion>;
    sustainableConstructionDetails: Maybe<Scalars['String']['output']>;
    taxId: Maybe<Scalars['String']['output']>;
    type: SUBCONTRACTOR_TYPE;
    unreadMessageThreadsCount: Maybe<Scalars['Int']['output']>;
    website: Maybe<Scalars['String']['output']>;
    workCategories: Array<WorkCategoryForSubcontractor>;
    yearlyRevenue: Maybe<Scalars['Float']['output']>;
  };

export type SubcontractorbidRequestsCountArgs = {
  status?: InputMaybe<Array<BID_REQUEST_STATUS>>;
};

export enum SubcontractorAuthActions {
  addNote = 'addNote',
  ban = 'ban',
  changeSubcontractorAgentCompany = 'changeSubcontractorAgentCompany',
  createContact = 'createContact',
  createNetworkImport = 'createNetworkImport',
  delete = 'delete',
  favorite = 'favorite',
  importNetworkSubcontractors = 'importNetworkSubcontractors',
  manageCustomFields = 'manageCustomFields',
  managePrivateContacts = 'managePrivateContacts',
  merge = 'merge',
  rate = 'rate',
  requestCertificates = 'requestCertificates',
  restore = 'restore',
  submitCertificatesToRequest = 'submitCertificatesToRequest',
  suggestChanges = 'suggestChanges',
  update = 'update',
  uploadCertificateForSubcontractor = 'uploadCertificateForSubcontractor',
  view = 'view',
  viewNetworkImport = 'viewNetworkImport',
  view__bidRequests = 'view__bidRequests',
  view__certificates = 'view__certificates',
  view__notes = 'view__notes',
}

export type SubcontractorAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type SubcontractorAuthInput = {
  action: SubcontractorAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubcontractorAuthArgsInput>;
};

export type SubcontractorFiltersInput = {
  companySizes?: InputMaybe<Array<InputMaybe<COMPANY_SIZE>>>;
  countryCode?: InputMaybe<COUNTRY_CODE>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  frequentStatuses?: InputMaybe<Array<BID_REQUEST_STATUS>>;
  hasPQNumber?: InputMaybe<Scalars['Boolean']['input']>;
  isBanned?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isRated?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<LocationFilter>;
  matchAllWorkCategories?: InputMaybe<Scalars['Boolean']['input']>;
  maxYearlyRevenue?: InputMaybe<Scalars['Float']['input']>;
  minYearlyRevenue?: InputMaybe<Scalars['Float']['input']>;
  ratings?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortMode?: InputMaybe<SUBCONTRACTORS_SORT_MODE>;
  type: SUBCONTRACTOR_LIST_TYPE;
  workCategoryIdsList?: InputMaybe<Array<WorkCategoryIds>>;
};

export type SubcontractorForAdmin = AbstractEntity &
  GeocodedGraphQLEntity & {
    __typename: 'SubcontractorForAdmin';
    aboutUs: Maybe<Scalars['HTML']['output']>;
    agentCompany: Maybe<Company>;
    agentCompanyId: Maybe<Scalars['String']['output']>;
    bidRequestsAwaitingResponseCount: Scalars['Int']['output'];
    bidRequestsCount: Maybe<Scalars['Int']['output']>;
    city: Maybe<Scalars['String']['output']>;
    company: Maybe<Company>;
    companyId: Maybe<Scalars['ID']['output']>;
    companySize: Maybe<COMPANY_SIZE>;
    confirmedByAgent: Scalars['Boolean']['output'];
    contacts: Array<Contact>;
    contactsForAdmin: Array<Contact>;
    countryCode: Maybe<COUNTRY_CODE>;
    createdAt: Scalars['DateTimeISO']['output'];
    customFields: Maybe<Array<CustomFieldWithValue>>;
    description: Maybe<Scalars['String']['output']>;
    externalId: Maybe<Scalars['String']['output']>;
    externalSource: Maybe<Scalars['String']['output']>;
    foundingYear: Maybe<Scalars['Float']['output']>;
    generatedDescription: Maybe<Scalars['String']['output']>;
    hasSustainableConstruction: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    imageKeys: Array<Scalars['String']['output']>;
    isBanned: Scalars['Boolean']['output'];
    isBannedByPrincipalCompany: Scalars['Boolean']['output'];
    isClaimedByAgentCompany: Scalars['Boolean']['output'];
    isDeleted: Scalars['Boolean']['output'];
    isFavorite: Scalars['Boolean']['output'];
    lat: Maybe<Scalars['Float']['output']>;
    logoKey: Maybe<Scalars['String']['output']>;
    long: Maybe<Scalars['Float']['output']>;
    mergedIntoSubcontractor: Maybe<SubcontractorForAdmin>;
    moreInfo: Maybe<Scalars['String']['output']>;
    name: Scalars['String']['output'];
    nationalId: Maybe<Scalars['String']['output']>;
    notes: Maybe<Array<SubcontractorNote>>;
    notesCount: Maybe<Scalars['Int']['output']>;
    orderAreaCountryCode: Maybe<COUNTRY_CODE>;
    orderAreaStateCodes: Maybe<Array<STATE_CODE>>;
    orderAreaType: ORDER_AREA_TYPE;
    orderRadius: Maybe<ORDER_RADIUS>;
    ownerName: Maybe<Scalars['String']['output']>;
    postalCode: Maybe<Scalars['String']['output']>;
    pqNumber: Maybe<Scalars['String']['output']>;
    rating: Maybe<Scalars['Float']['output']>;
    referenceProjects: Array<SubcontractorReferenceProject>;
    registrationCity: Maybe<Scalars['String']['output']>;
    registrationPostalCode: Maybe<Scalars['String']['output']>;
    revenueYear: Maybe<Scalars['Float']['output']>;
    slug: Scalars['String']['output'];
    street: Maybe<Scalars['String']['output']>;
    /** Returns number of submitted certificate types (this includes certificates uploaded by both principal and agent users). Returns null if a user or company cannot access certificates */
    submittedCertificateTypesCount: Maybe<Scalars['Int']['output']>;
    suggestedChanges: Array<SubcontractorSuggestion>;
    suggestedNewContacts: Array<ContactCreationSuggestion>;
    sustainableConstructionDetails: Maybe<Scalars['String']['output']>;
    taxId: Maybe<Scalars['String']['output']>;
    type: SUBCONTRACTOR_TYPE;
    unreadMessageThreadsCount: Maybe<Scalars['Int']['output']>;
    website: Maybe<Scalars['String']['output']>;
    workCategories: Array<WorkCategoryForSubcontractor>;
    yearlyRevenue: Maybe<Scalars['Float']['output']>;
  };

export type SubcontractorForAdminbidRequestsCountArgs = {
  status?: InputMaybe<Array<BID_REQUEST_STATUS>>;
};

export type SubcontractorForAdmincontactsForAdminArgs = {
  includePrivateForNetworkSubcontractor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubcontractorImportRequest = {
  __typename: 'SubcontractorImportRequest';
  company: Company;
  createdAt: Scalars['DateTimeISO']['output'];
  fileName: Scalars['String']['output'];
  fileType: SUBCONTRACTOR_IMPORT_REQUEST_FILE_TYPE;
  fileUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: Maybe<Scalars['String']['output']>;
  status: SUBCONTRACTOR_IMPORT_REQUEST_STATUS;
  user: User;
};

export type SubcontractorImportRequestCompletedNotification = AbstractEntity &
  Notification & {
    __typename: 'SubcontractorImportRequestCompletedNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: SubcontractorImportRequestCompletedNotificationProps;
  };

export type SubcontractorImportRequestCompletedNotificationProps = {
  __typename: 'SubcontractorImportRequestCompletedNotificationProps';
  importRequestId: Scalars['ID']['output'];
};

export type SubcontractorInput = {
  aboutUs?: InputMaybe<Scalars['HTML']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<COMPANY_SIZE>;
  contacts: Array<ContactInput>;
  countryCode?: InputMaybe<COUNTRY_CODE>;
  customFields?: InputMaybe<Array<CustomFieldValueInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalSource?: InputMaybe<Scalars['String']['input']>;
  foundingYear?: InputMaybe<Scalars['Int']['input']>;
  hasSustainableConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  imageKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  isBanned?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  logoKey?: InputMaybe<Scalars['String']['input']>;
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nationalId?: InputMaybe<Scalars['String']['input']>;
  orderAreaCountryCode?: InputMaybe<COUNTRY_CODE>;
  orderAreaStateCodes?: InputMaybe<Array<STATE_CODE>>;
  orderAreaType: ORDER_AREA_TYPE;
  orderRadius?: InputMaybe<ORDER_RADIUS>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  pqNumber?: InputMaybe<Scalars['String']['input']>;
  referenceProjects?: InputMaybe<Array<SubcontractorReferenceProjectInput>>;
  registrationCity?: InputMaybe<Scalars['String']['input']>;
  registrationPostalCode?: InputMaybe<Scalars['String']['input']>;
  revenueYear?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suggestionComment?: InputMaybe<Scalars['String']['input']>;
  sustainableConstructionDetails?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workCategories?: InputMaybe<Array<WorkCategoryInput>>;
  yearlyRevenue?: InputMaybe<Scalars['Float']['input']>;
};

export type SubcontractorMergeRequest = AbstractEntity & {
  __typename: 'SubcontractorMergeRequest';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  matchType: SUBCONTRACTOR_MERGE_REQUEST_MATCH_TYPE;
  sourceSubcontractorId: Scalars['ID']['output'];
  sourceSubcontractorName: Scalars['String']['output'];
  status: SUBCONTRACTOR_MERGE_REQUEST_STATUS;
  targetSubcontractorId: Scalars['ID']['output'];
  targetSubcontractorName: Scalars['String']['output'];
};

export type SubcontractorMergeRequestsResponse = {
  __typename: 'SubcontractorMergeRequestsResponse';
  mergeRequests: Array<SubcontractorMergeRequest>;
  totalRecords: Scalars['Int']['output'];
};

export type SubcontractorNote = AbstractEntity &
  Note & {
    __typename: 'SubcontractorNote';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    text: Scalars['String']['output'];
    user: Maybe<User>;
  };

export enum SubcontractorNoteAuthActions {
  delete = 'delete',
  view = 'view',
}

export type SubcontractorNoteAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type SubcontractorNoteAuthInput = {
  action: SubcontractorNoteAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubcontractorNoteAuthArgsInput>;
};

export type SubcontractorPricingTier = {
  __typename: 'SubcontractorPricingTier';
  quarterlyPlanId: Scalars['String']['output'];
  quarterlyPrice: Scalars['Float']['output'];
  tier: SUBCONTRACTOR_PRICING_TIER;
  yearlyPlanId: Scalars['String']['output'];
  yearlyPrice: Scalars['Float']['output'];
};

export type SubcontractorRating = AbstractEntity & {
  __typename: 'SubcontractorRating';
  bidRequestId: Scalars['String']['output'];
  category: RATING_CATEGORY;
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  user: User;
};

export type SubcontractorRatingInput = {
  bidRequestId: Scalars['ID']['input'];
  category: RATING_CATEGORY;
  comment: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};

export type SubcontractorRatingPerBidRequest = {
  __typename: 'SubcontractorRatingPerBidRequest';
  bidPackageId: Scalars['ID']['output'];
  bidPackageName: Scalars['String']['output'];
  bidRequest: BidRequest;
  bidRequestId: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  ratingByCategory: Array<CategoryRating>;
  ratingCategories: Maybe<Array<RATING_CATEGORY>>;
  subcontractor: Subcontractor;
  userRatedCategories: Array<RATING_CATEGORY>;
};

export type SubcontractorRatingSummaryResponse = {
  __typename: 'SubcontractorRatingSummaryResponse';
  ratingByCategory: Array<CategoryRating>;
};

export type SubcontractorReferenceProject = AbstractEntity & {
  __typename: 'SubcontractorReferenceProject';
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['HTML']['output'];
  id: Scalars['ID']['output'];
  imageKeys: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  subcontractor: Subcontractor;
};

export type SubcontractorReferenceProjectInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  imageKeys: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Float']['input'];
};

export type SubcontractorResponse = {
  __typename: 'SubcontractorResponse';
  distanceInMeters: Maybe<Scalars['Float']['output']>;
  score: Scalars['Float']['output'];
  subcontractor: Subcontractor;
};

export type SubcontractorSuggestion = AbstractEntity & {
  __typename: 'SubcontractorSuggestion';
  changeType: SUBCONTRACTOR_SUGGESTION_CHANGE_TYPE;
  changes: Array<SubcontractorSuggestionField>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  suggestedByUser: Maybe<User>;
};

export type SubcontractorSuggestionCompanySizeField = AbstractSubcontractorSuggestionField & {
  __typename: 'SubcontractorSuggestionCompanySizeField';
  changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<COMPANY_SIZE>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SubcontractorSuggestionCountryCodeField = AbstractSubcontractorSuggestionField & {
  __typename: 'SubcontractorSuggestionCountryCodeField';
  changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<COUNTRY_CODE>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SubcontractorSuggestionField =
  | SubcontractorSuggestionCompanySizeField
  | SubcontractorSuggestionCountryCodeField
  | SubcontractorSuggestionNumberField
  | SubcontractorSuggestionOrderAreaCountryCodeField
  | SubcontractorSuggestionOrderAreaStateCodesField
  | SubcontractorSuggestionOrderAreaTypeField
  | SubcontractorSuggestionOrderRadiusField
  | SubcontractorSuggestionStringField
  | SubcontractorSuggestionWorkCategoryField;

export type SubcontractorSuggestionInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<COMPANY_SIZE>;
  countryCode?: InputMaybe<COUNTRY_CODE>;
  description?: InputMaybe<Scalars['String']['input']>;
  foundingYear?: InputMaybe<Scalars['Int']['input']>;
  logoKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nationalId?: InputMaybe<Scalars['String']['input']>;
  orderAreaCountryCode?: InputMaybe<COUNTRY_CODE>;
  orderAreaStateCodes?: InputMaybe<Array<STATE_CODE>>;
  orderAreaType?: InputMaybe<ORDER_AREA_TYPE>;
  orderRadius?: InputMaybe<ORDER_RADIUS>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  pqNumber?: InputMaybe<Scalars['String']['input']>;
  registrationCity?: InputMaybe<Scalars['String']['input']>;
  registrationPostalCode?: InputMaybe<Scalars['String']['input']>;
  revenueYear?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suggestionComment?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workCategories?: InputMaybe<Array<WorkCategoryInput>>;
  yearlyRevenue?: InputMaybe<Scalars['Float']['input']>;
};

export type SubcontractorSuggestionNumberField = AbstractSubcontractorSuggestionField & {
  __typename: 'SubcontractorSuggestionNumberField';
  changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SubcontractorSuggestionOrderAreaCountryCodeField =
  AbstractSubcontractorSuggestionField & {
    __typename: 'SubcontractorSuggestionOrderAreaCountryCodeField';
    changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
    fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
    fieldValue: Maybe<COUNTRY_CODE>;
    id: Scalars['ID']['output'];
    reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
    reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
  };

export type SubcontractorSuggestionOrderAreaStateCodesField =
  AbstractSubcontractorSuggestionField & {
    __typename: 'SubcontractorSuggestionOrderAreaStateCodesField';
    changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
    fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
    fieldValue: Maybe<STATE_CODE>;
    id: Scalars['ID']['output'];
    reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
    reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
  };

export type SubcontractorSuggestionOrderAreaTypeField = AbstractSubcontractorSuggestionField & {
  __typename: 'SubcontractorSuggestionOrderAreaTypeField';
  changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<ORDER_AREA_TYPE>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SubcontractorSuggestionOrderRadiusField = AbstractSubcontractorSuggestionField & {
  __typename: 'SubcontractorSuggestionOrderRadiusField';
  changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<ORDER_RADIUS>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SubcontractorSuggestionStringField = AbstractSubcontractorSuggestionField & {
  __typename: 'SubcontractorSuggestionStringField';
  changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SubcontractorSuggestionWorkCategory = {
  __typename: 'SubcontractorSuggestionWorkCategory';
  id: Scalars['String']['output'];
};

export type SubcontractorSuggestionWorkCategoryField = AbstractSubcontractorSuggestionField & {
  __typename: 'SubcontractorSuggestionWorkCategoryField';
  changeType: SUBCONTRACTOR_SUGGESTION_FIELDS_CHANGE_TYPE;
  fieldName: SUBCONTRACTOR_SUGGESTION_FIELDS_FIELD_NAME;
  fieldValue: Maybe<SubcontractorSuggestionWorkCategory>;
  id: Scalars['ID']['output'];
  reviewResult: Maybe<SUBCONTRACTOR_SUGGESTION_FIELDS_REVIEW_RESULT>;
  reviewedOn: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SubcontractorVersion = AbstractEntity & {
  __typename: 'SubcontractorVersion';
  agentCompanyId: Maybe<Scalars['ID']['output']>;
  changeReason: Maybe<Scalars['String']['output']>;
  changedByAdmin: Maybe<Admin>;
  changedByUser: Maybe<User>;
  city: Maybe<Scalars['String']['output']>;
  companySize: Maybe<COMPANY_SIZE>;
  contactVersions: Array<ContactVersion>;
  countryCode: Maybe<COUNTRY_CODE>;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Maybe<Scalars['String']['output']>;
  foundingYear: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  logoKey: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nationalId: Maybe<Scalars['String']['output']>;
  orderAreaCountryCode: Maybe<COUNTRY_CODE>;
  orderAreaStateCodes: Maybe<Array<STATE_CODE>>;
  orderAreaType: ORDER_AREA_TYPE;
  orderRadius: Maybe<ORDER_RADIUS>;
  ownerName: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  pqNumber: Maybe<Scalars['String']['output']>;
  registrationCity: Maybe<Scalars['String']['output']>;
  registrationPostalCode: Maybe<Scalars['String']['output']>;
  revenueYear: Maybe<Scalars['Float']['output']>;
  street: Maybe<Scalars['String']['output']>;
  taxId: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
  workCategories: Array<WorkCategoryForSubcontractor>;
  yearlyRevenue: Maybe<Scalars['Float']['output']>;
};

export type SubcontractorWithMergedToRedirect = MergedIntoSubcontractor | Subcontractor;

export type SubcontractorsImportStatusResponse = AbstractEntity & {
  __typename: 'SubcontractorsImportStatusResponse';
  allowDuplicateSubcontractors: Scalars['Boolean']['output'];
  company: Company;
  createdAt: Scalars['DateTimeISO']['output'];
  errors: Array<UpsertError>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  processed: Scalars['Boolean']['output'];
  progress: Scalars['Int']['output'];
  status: SUBCONTRACTORS_IMPORT_STATUS;
  updatedAt: Scalars['DateTimeISO']['output'];
  validated: Scalars['Boolean']['output'];
};

export type SubcontractorsImportValidationError = {
  __typename: 'SubcontractorsImportValidationError';
  line: Maybe<Scalars['Int']['output']>;
  reason: SUBCONTRACTOR_IMPORT_ERROR_REASON;
};

export type SubcontractorsImportValidationResponse = {
  __typename: 'SubcontractorsImportValidationResponse';
  errors: Array<SubcontractorsImportValidationError>;
};

export type SubcontractorsImportsResponse = {
  __typename: 'SubcontractorsImportsResponse';
  subcontractorsImports: Array<SubcontractorsImportStatusResponse>;
  totalRecords: Scalars['Int']['output'];
};

export type SubcontractorsResponse = {
  __typename: 'SubcontractorsResponse';
  subcontractors: Array<SubcontractorResponse>;
  totalRecords: Scalars['Int']['output'];
};

export type SubmittedBid = AbstractEntity & {
  __typename: 'SubmittedBid';
  absoluteDiscount: Maybe<Scalars['Float']['output']>;
  additionalCosts: Maybe<Scalars['Float']['output']>;
  bidRequest: BidRequest;
  billOfQuantities: Maybe<BillOfQuantities>;
  billOfQuantitiesRevision: BillOfQuantitiesRevision;
  billOfQuantitiesRevisionId: Scalars['String']['output'];
  boqEditingStatus: Maybe<BOQ_EDITING_STATUS>;
  createdAt: Scalars['DateTimeISO']['output'];
  discountRate: Maybe<Scalars['Float']['output']>;
  documentsCount: Scalars['Int']['output'];
  hasBoQ: Scalars['Boolean']['output'];
  hasHiddenTotalNet: Scalars['Boolean']['output'];
  hasOutdatedBoQ: Maybe<REASON_PROPOSAL_BOQ_IS_OUTDATED>;
  id: Scalars['ID']['output'];
  internalNote: Maybe<Scalars['String']['output']>;
  isEligibleForAwarding: Scalars['Boolean']['output'];
  isOutdatedBlindTenderBid: Scalars['Boolean']['output'];
  isSimulated: Maybe<Scalars['Boolean']['output']>;
  message: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTimeISO']['output'];
  parentBid: Maybe<Bid>;
  skontoDeadline: Scalars['Int']['output'];
  skontoRate: Scalars['Float']['output'];
  status: BID_STATUS;
  submittedAt: Scalars['DateTimeISO']['output'];
  submittedByUser: Maybe<User>;
  taxRate: Scalars['Float']['output'];
  taxValue: Scalars['Float']['output'];
  totalGross: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
  updatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  version: Scalars['Int']['output'];
  warningMetrics: BidWarningMetrics;
};

export type SubmittedBidHistoryItem = AbstractEntity & {
  __typename: 'SubmittedBidHistoryItem';
  absoluteDiscount: Maybe<Scalars['Float']['output']>;
  additionalCosts: Maybe<Scalars['Float']['output']>;
  bidRequest: BidRequest;
  billOfQuantities: Maybe<BillOfQuantities>;
  billOfQuantitiesRevision: BillOfQuantitiesRevision;
  billOfQuantitiesRevisionId: Scalars['String']['output'];
  boqEditingStatus: Maybe<BOQ_EDITING_STATUS>;
  createdAt: Scalars['DateTimeISO']['output'];
  discountRate: Maybe<Scalars['Float']['output']>;
  documentsCount: Scalars['Int']['output'];
  hasBoQ: Scalars['Boolean']['output'];
  hasHiddenTotalNet: Scalars['Boolean']['output'];
  hasOutdatedBoQ: Maybe<REASON_PROPOSAL_BOQ_IS_OUTDATED>;
  id: Scalars['ID']['output'];
  internalNote: Maybe<Scalars['String']['output']>;
  isEligibleForAwarding: Scalars['Boolean']['output'];
  isOutdatedBlindTenderBid: Scalars['Boolean']['output'];
  isSimulated: Maybe<Scalars['Boolean']['output']>;
  message: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTimeISO']['output'];
  parentBid: Maybe<Bid>;
  skontoDeadline: Scalars['Int']['output'];
  skontoRate: Scalars['Float']['output'];
  status: BID_STATUS;
  submittedAt: Scalars['DateTimeISO']['output'];
  submittedByUser: Maybe<User>;
  taxRate: Scalars['Float']['output'];
  taxValue: Scalars['Float']['output'];
  totalGross: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
  updatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  version: Scalars['Int']['output'];
  warningMetrics: BidWarningMetrics;
};

export type SubmittedOrGeneratedSubmittedBid = AbstractEntity & {
  __typename: 'SubmittedOrGeneratedSubmittedBid';
  absoluteDiscount: Maybe<Scalars['Float']['output']>;
  additionalCosts: Maybe<Scalars['Float']['output']>;
  bidRequest: BidRequest;
  billOfQuantities: Maybe<BillOfQuantities>;
  billOfQuantitiesRevision: BillOfQuantitiesRevision;
  billOfQuantitiesRevisionId: Scalars['String']['output'];
  boqEditingStatus: Maybe<BOQ_EDITING_STATUS>;
  createdAt: Scalars['DateTimeISO']['output'];
  discountRate: Maybe<Scalars['Float']['output']>;
  documentsCount: Scalars['Int']['output'];
  hasBoQ: Scalars['Boolean']['output'];
  hasHiddenTotalNet: Scalars['Boolean']['output'];
  hasOutdatedBoQ: Maybe<REASON_PROPOSAL_BOQ_IS_OUTDATED>;
  id: Scalars['ID']['output'];
  internalNote: Maybe<Scalars['String']['output']>;
  isEligibleForAwarding: Scalars['Boolean']['output'];
  isOutdatedBlindTenderBid: Scalars['Boolean']['output'];
  isSimulated: Maybe<Scalars['Boolean']['output']>;
  message: Maybe<Scalars['String']['output']>;
  parentBid: Maybe<Bid>;
  skontoDeadline: Scalars['Int']['output'];
  skontoRate: Scalars['Float']['output'];
  status: BID_STATUS;
  submittedAt: Maybe<Scalars['DateTimeISO']['output']>;
  submittedByUser: Maybe<User>;
  taxRate: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
  updatedAt: Maybe<Scalars['DateTimeISO']['output']>;
  version: Maybe<Scalars['Int']['output']>;
  warningMetrics: BidWarningMetrics;
};

export type SufficientNumberOfBidders = {
  __typename: 'SufficientNumberOfBidders';
  issue: Maybe<BP_PUBLICATION_SUFFICIENT_NUMBER_OF_BIDDERS_ISSUE>;
};

export type SuggestedGlobalCertificateTypesResponse = {
  __typename: 'SuggestedGlobalCertificateTypesResponse';
  certificateTypes: Array<Scalars['String']['output']>;
};

export type SurchargeOrDiscount = {
  discountMethod: DISCOUNT_METHOD;
  discountValue: Scalars['Float']['input'];
};

export enum TASKS_SORT_FIELD {
  assignee = 'assignee',
  bidPackageName = 'bidPackageName',
  dueAt = 'dueAt',
  name = 'name',
  projectName = 'projectName',
  status = 'status',
}

export enum TASK_ASSIGNEE_TYPE {
  myCompany = 'myCompany',
  subcontractor = 'subcontractor',
}

export enum TASK_STATUS {
  done = 'done',
  inProgress = 'inProgress',
  todo = 'todo',
}

export enum TOGGLE_CONTRACT_DOCUMENT_RESULT {
  documentInfected = 'documentInfected',
  toggledSuccessfully = 'toggledSuccessfully',
  togglingInProgress = 'togglingInProgress',
}

export enum TRIAL_MODULE {
  costEstimationAndControlling = 'costEstimationAndControlling',
  individualisation = 'individualisation',
}

export type Task = AbstractEntity & {
  __typename: 'Task';
  assignee: Maybe<User>;
  assigneeType: TASK_ASSIGNEE_TYPE;
  bidPackage: Maybe<BidPackage>;
  bidPackageId: Maybe<Scalars['ID']['output']>;
  bidRequest: Maybe<BidRequest>;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdBy: User;
  description: Maybe<Scalars['String']['output']>;
  dueAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Maybe<Project>;
  projectId: Maybe<Scalars['ID']['output']>;
  status: TASK_STATUS;
};

export type TaskAssignedNotification = AbstractEntity &
  Notification & {
    __typename: 'TaskAssignedNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: TaskAssignedNotificationProps;
  };

export type TaskAssignedNotificationProps = {
  __typename: 'TaskAssignedNotificationProps';
  taskId: Scalars['String']['output'];
  taskName: Scalars['String']['output'];
};

export enum TaskAuthActions {
  changeStatus = 'changeStatus',
  createNote = 'createNote',
  delete = 'delete',
  update = 'update',
  view = 'view',
}

export type TaskAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type TaskAuthInput = {
  action: TaskAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TaskAuthArgsInput>;
};

export type TaskCompletedNotification = AbstractEntity &
  Notification & {
    __typename: 'TaskCompletedNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: TaskCompletedNotificationProps;
  };

export type TaskCompletedNotificationProps = {
  __typename: 'TaskCompletedNotificationProps';
  taskId: Scalars['String']['output'];
  taskName: Scalars['String']['output'];
};

export type TaskInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  bidPackageId?: InputMaybe<Scalars['ID']['input']>;
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt: Scalars['DateTimeISO']['input'];
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskNote = AbstractEntity &
  Note & {
    __typename: 'TaskNote';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    text: Scalars['String']['output'];
    user: User;
  };

export enum TaskNoteAuthActions {
  delete = 'delete',
  view = 'view',
}

export type TaskNoteAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type TaskNoteAuthInput = {
  action: TaskNoteAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TaskNoteAuthArgsInput>;
};

export type TaskNotesResponse = {
  __typename: 'TaskNotesResponse';
  notes: Array<TaskNote>;
  totalRecords: Scalars['Int']['output'];
};

export type TaskPublicDataResponse = {
  __typename: 'TaskPublicDataResponse';
  bidPackageId: Maybe<Scalars['ID']['output']>;
  bidPackageName: Maybe<Scalars['String']['output']>;
  bidRequestId: Maybe<Scalars['ID']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  subcontractorId: Maybe<Scalars['ID']['output']>;
};

export type TasksResponse = {
  __typename: 'TasksResponse';
  tasks: Array<Task>;
  totalRecords: Scalars['Int']['output'];
};

export type TemplateBoQCostGroupCatalogsToImportInput = {
  catalogsToImport: Array<BoQTemplateCostGroupCatalogInput>;
};

export type TemplateBoQFieldsToImportInput = {
  netTotal: Scalars['Boolean']['input'];
  positionType: Scalars['Boolean']['input'];
  quantity: Scalars['Boolean']['input'];
  taxRate: Scalars['Boolean']['input'];
  unitPrice: Scalars['Boolean']['input'];
  unitTag: Scalars['Boolean']['input'];
};

export type TemplateData = {
  __typename: 'TemplateData';
  content: Scalars['HTML']['output'];
  name: Scalars['String']['output'];
};

export type TemplatePreview = {
  __typename: 'TemplatePreview';
  content: Scalars['HTML']['output'];
  fromEmail: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type TemporaryUploadUrlResponse = {
  __typename: 'TemporaryUploadUrlResponse';
  storageKey: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Terms = AbstractEntity & {
  __typename: 'Terms';
  createdAt: Scalars['DateTimeISO']['output'];
  downloadUrls: TermsUrls;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  size: Scalars['Int']['output'];
};

export type TermsAcceptanceResponse = {
  __typename: 'TermsAcceptanceResponse';
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTimeISO']['output'];
  user: Maybe<User>;
};

export type TermsUrls = {
  __typename: 'TermsUrls';
  openInNewTabUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TogglePositionTypeOperationDescriptor = {
  __typename: 'TogglePositionTypeOperationDescriptor';
  index: Scalars['Int']['output'];
  operation: BOQ_EDIT_OPERATION;
  operationId: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  positionType: BOQ_POSITION_TYPE;
};

export type TranslationUpdateInput = {
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type Trial = {
  __typename: 'Trial';
  endsAt: Scalars['DateTimeISO']['output'];
  module: TRIAL_MODULE;
};

export enum USERS_SORT_FIELD {
  company = 'company',
  department = 'department',
  email = 'email',
  jobTitle = 'jobTitle',
  lastActivityAt = 'lastActivityAt',
  name = 'name',
  status = 'status',
  userType = 'userType',
}

export enum USER_STATUS {
  active = 'active',
  adminApprovalPending = 'adminApprovalPending',
  approvalPending = 'approvalPending',
  inactive = 'inactive',
  inviteCanceled = 'inviteCanceled',
  inviteFailed = 'inviteFailed',
  inviteRequested = 'inviteRequested',
  invited = 'invited',
}

export enum USER_TYPE {
  administrator = 'administrator',
  collaborator = 'collaborator',
  custom = 'custom',
  employee = 'employee',
  guest = 'guest',
  manager = 'manager',
}

export type UpdateAddendumInput = {
  bidPackageId: Scalars['ID']['input'];
  boqContent: Scalars['JSONObject']['input'];
  contractRefNumber?: InputMaybe<Scalars['String']['input']>;
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['Int']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAwardedBidInput = {
  absoluteDiscount?: InputMaybe<Scalars['Float']['input']>;
  absoluteDiscountCalculated?: InputMaybe<Scalars['Float']['input']>;
  additionalCosts?: InputMaybe<Scalars['Float']['input']>;
  awardedSumType?: InputMaybe<BID_AWARDED_SUM_TYPE>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  discountRateCalculated?: InputMaybe<Scalars['Float']['input']>;
  mainOrderNumber?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  skontoDeadline?: InputMaybe<Scalars['Int']['input']>;
  skontoRate?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  taxValue?: InputMaybe<Scalars['Float']['input']>;
  totalGross?: InputMaybe<Scalars['Float']['input']>;
  totalGrossWithSkonto?: InputMaybe<Scalars['Float']['input']>;
  totalNet?: InputMaybe<Scalars['Float']['input']>;
  totalNetWithDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBidPackageEstimateForProjectResponse = {
  __typename: 'UpdateBidPackageEstimateForProjectResponse';
  bidPackageCostGroups: Array<CostEstimationBidPackageCostGroup>;
  catalogType: COST_CATALOG_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  customCatalogId: Maybe<Scalars['String']['output']>;
  hasUnsavedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
};

export type UpdateBidRequestDeclinedReasonByAgentInput = {
  declinedReason: BID_REQUEST_DECLINED_REASON;
  declinedReasonOther: Scalars['String']['input'];
  id: Scalars['String']['input'];
  orderAreaCountryCode?: InputMaybe<COUNTRY_CODE>;
  orderAreaStateCodes?: InputMaybe<Array<STATE_CODE>>;
  orderAreaType?: InputMaybe<ORDER_AREA_TYPE>;
  orderRadius?: InputMaybe<ORDER_RADIUS>;
  workCategories?: InputMaybe<Array<WorkCategoryInput>>;
};

export type UpdateBoQFieldResponse = {
  __typename: 'UpdateBoQFieldResponse';
  groups: Array<UpdateBoQFieldResponseGroup>;
  id: Scalars['ID']['output'];
  notes: Array<UpdateBoQFieldResponseNote>;
  positions: Array<UpdateBoQFieldResponsePosition>;
  subDescriptions: Array<UpdateBoQFieldResponseSubDescription>;
};

export type UpdateBoQFieldResponseGroup = {
  __typename: 'UpdateBoQFieldResponseGroup';
  absoluteDeduction: Maybe<Scalars['Float']['output']>;
  deductedPrice: Scalars['Float']['output'];
  deductionFactor: Scalars['Float']['output'];
  path: Scalars['String']['output'];
  totalPrice: Scalars['Float']['output'];
  totalPriceGross: Maybe<Scalars['Float']['output']>;
  totalPriceGrossDeducted: Maybe<Scalars['Float']['output']>;
};

export type UpdateBoQFieldResponseNote = {
  __typename: 'UpdateBoQFieldResponseNote';
  htmlLongText: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
};

export type UpdateBoQFieldResponsePosition = {
  __typename: 'UpdateBoQFieldResponsePosition';
  complementingPricePercentage: Maybe<Scalars['Float']['output']>;
  deductedPrice: Scalars['Float']['output'];
  deductionFactor: Scalars['Float']['output'];
  htmlLongText: Maybe<Scalars['String']['output']>;
  labourComponents: UpdateBoQFieldResponsePositionLabourPriceComponent;
  longText: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  priceComponents: Array<UpdateBoQFieldResponsePositionPriceComponent>;
  quantity: Scalars['Float']['output'];
  quantityComponents: Array<QuantityComponent>;
  taxRate: Maybe<Scalars['Float']['output']>;
  totalPrice: Scalars['Float']['output'];
  totalPriceGross: Maybe<Scalars['Float']['output']>;
  totalPriceGrossDeducted: Maybe<Scalars['Float']['output']>;
  unitPrice: Scalars['Float']['output'];
};

export type UpdateBoQFieldResponsePositionLabourPriceComponent = {
  __typename: 'UpdateBoQFieldResponsePositionLabourPriceComponent';
  label: Maybe<Scalars['String']['output']>;
  totalTime: Scalars['Float']['output'];
  values: Maybe<Array<UpdateBoQFieldResponsePositionPriceCalculation>>;
};

export type UpdateBoQFieldResponsePositionPriceCalculation = {
  __typename: 'UpdateBoQFieldResponsePositionPriceCalculation';
  result: Scalars['Float']['output'];
};

export type UpdateBoQFieldResponsePositionPriceComponent = {
  __typename: 'UpdateBoQFieldResponsePositionPriceComponent';
  label: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  values: Maybe<Array<UpdateBoQFieldResponsePositionPriceCalculation>>;
};

export type UpdateBoQFieldResponseSubDescription = {
  __typename: 'UpdateBoQFieldResponseSubDescription';
  htmlLongText: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
};

export type UpdateBoQTemplateFailure = {
  __typename: 'UpdateBoQTemplateFailure';
  success: Scalars['Boolean']['output'];
};

export type UpdateBoQTemplateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBoQTemplateResponse = UpdateBoQTemplateFailure | UpdateBoQTemplateSuccess;

export type UpdateBoQTemplateSuccess = {
  __typename: 'UpdateBoQTemplateSuccess';
  template: BoQTemplate;
};

export type UpdateCostEstimateForProjectResponse =
  | UpdateBidPackageEstimateForProjectResponse
  | UpdateCustomCatalogEstimateForProjectResponse
  | UpdateStandardCatalogEstimateForProjectResponse
  | UpdateStlbWorkCategoryEstimateForProjectResponse;

export type UpdateCostItemInput = {
  factor?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCustomCatalogEstimateForProjectResponse = {
  __typename: 'UpdateCustomCatalogEstimateForProjectResponse';
  catalogType: COST_CATALOG_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  customCatalogCostGroups: Array<CostEstimationCustomCatalogCostGroup>;
  customCatalogId: Maybe<Scalars['String']['output']>;
  hasUnsavedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
};

export type UpdateCustomCostGroupCatalogInput = {
  costGroups?: InputMaybe<Array<CustomCostGroupDefinitionInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CUSTOM_COST_GROUP_CATALOG_STATUS>;
};

export type UpdateDocumentInput = {
  uploaded: Scalars['Boolean']['input'];
};

export type UpdateFillableBoQComplementingPricePercentageInput = {
  path: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFillableBoQDescriptionInput = {
  path: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFillableBoQFreeQuantityInput = {
  path: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFillableBoQPriceComponentInput = {
  path: Scalars['String']['input'];
  priceComponentIndex: Scalars['Float']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFillableBoQPriceInput = {
  path: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFillableBoQSurchargeOrDiscountInput = {
  path: Scalars['String']['input'];
  value?: InputMaybe<SurchargeOrDiscount>;
};

export type UpdateFillableBoQTimeTrackingInput = {
  path: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateInvoiceInput = {
  approvedTotalNet: Scalars['Float']['input'];
  bidPackageId: Scalars['ID']['input'];
  cashDiscountDeadline?: InputMaybe<Scalars['String']['input']>;
  cashDiscountValue: Scalars['Float']['input'];
  customRows: Array<InvoiceCustomRowForUpdate>;
  discountValue: Scalars['Float']['input'];
  fileId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  insuranceValue: Scalars['Float']['input'];
  issuedAt: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nonApprovedTotalNet: Scalars['Float']['input'];
  numberExternal?: InputMaybe<Scalars['String']['input']>;
  numberInternal?: InputMaybe<Scalars['String']['input']>;
  partialInvoiceNumber?: InputMaybe<Scalars['Int']['input']>;
  paymentDeadline: Scalars['String']['input'];
  receiptDate?: InputMaybe<Scalars['String']['input']>;
  retentionValue: Scalars['Float']['input'];
  subcontractorBic?: InputMaybe<Scalars['String']['input']>;
  subcontractorCity?: InputMaybe<Scalars['String']['input']>;
  subcontractorCountryCode?: InputMaybe<COUNTRY_CODE>;
  subcontractorEmail?: InputMaybe<Scalars['String']['input']>;
  subcontractorIban?: InputMaybe<Scalars['String']['input']>;
  subcontractorName?: InputMaybe<Scalars['String']['input']>;
  subcontractorPhone?: InputMaybe<Scalars['String']['input']>;
  subcontractorPostalCode?: InputMaybe<Scalars['String']['input']>;
  subcontractorStreet?: InputMaybe<Scalars['String']['input']>;
  taxRate: Scalars['Float']['input'];
};

export type UpdateMeInput = {
  customDepartmentName?: InputMaybe<Scalars['String']['input']>;
  departmentType?: InputMaybe<DEPARTMENT_TYPE>;
  email: Scalars['String']['input'];
  externalCompany?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParsedIfcFileNodeAssociatedCost = {
  bidPackageId?: InputMaybe<Scalars['String']['input']>;
  costGroupLocalId?: InputMaybe<Scalars['String']['input']>;
  factor?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantityFormula?: InputMaybe<Scalars['String']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateParsedIfcFileWithAssociatedCostsResponse = {
  __typename: 'UpdateParsedIfcFileWithAssociatedCostsResponse';
  affectedNodes: Array<ParsedIfcFileNode>;
  id: Scalars['ID']['output'];
};

export type UpdateProjectInformationOperationBoQStructureDescriptor = {
  __typename: 'UpdateProjectInformationOperationBoQStructureDescriptor';
  tierDataType: BOQ_TIER_DATA_TYPE;
  tierDigits: Scalars['Float']['output'];
  tierName: Scalars['String']['output'];
  tierType: BOQ_TIER_TYPE;
};

export type UpdateProjectInformationOperationDescriptor = {
  __typename: 'UpdateProjectInformationOperationDescriptor';
  boqStructure: Maybe<Array<UpdateProjectInformationOperationBoQStructureDescriptor>>;
  labourTimeLabel: Maybe<Scalars['String']['output']>;
  operation: BOQ_EDIT_OPERATION;
  operationId: Scalars['ID']['output'];
  priceComponents: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateStandardCatalogEstimateForProjectResponse = {
  __typename: 'UpdateStandardCatalogEstimateForProjectResponse';
  catalogType: COST_CATALOG_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  customCatalogId: Maybe<Scalars['String']['output']>;
  hasUnsavedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  standardCatalogCostGroups: Array<CostEstimationStandardCatalogCostGroup>;
};

export type UpdateStlbWorkCategoryEstimateForProjectResponse = {
  __typename: 'UpdateStlbWorkCategoryEstimateForProjectResponse';
  catalogType: COST_CATALOG_TYPE;
  createdAt: Scalars['DateTimeISO']['output'];
  customCatalogId: Maybe<Scalars['String']['output']>;
  hasUnsavedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  stlbWorkCategoryCostGroups: Array<CostEstimationStlbWorkCategoryCostGroup>;
};

export type UpsertError = {
  __typename: 'UpsertError';
  externalId: Scalars['String']['output'];
  line: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UpsertSubcontractorInput = {
  aboutUs?: InputMaybe<Scalars['HTML']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<COMPANY_SIZE>;
  contacts: Array<ContactInput>;
  countryCode?: InputMaybe<COUNTRY_CODE>;
  customFields?: InputMaybe<Array<CustomFieldValueInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  externalSource: Scalars['String']['input'];
  foundingYear?: InputMaybe<Scalars['Int']['input']>;
  hasSustainableConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  imageKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  isBanned?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  logoKey?: InputMaybe<Scalars['String']['input']>;
  moreInfo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nationalId?: InputMaybe<Scalars['String']['input']>;
  orderAreaCountryCode?: InputMaybe<COUNTRY_CODE>;
  orderAreaStateCodes?: InputMaybe<Array<STATE_CODE>>;
  orderAreaType: ORDER_AREA_TYPE;
  orderRadius?: InputMaybe<ORDER_RADIUS>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  pqNumber?: InputMaybe<Scalars['String']['input']>;
  referenceProjects?: InputMaybe<Array<SubcontractorReferenceProjectInput>>;
  registrationCity?: InputMaybe<Scalars['String']['input']>;
  registrationPostalCode?: InputMaybe<Scalars['String']['input']>;
  revenueYear?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suggestionComment?: InputMaybe<Scalars['String']['input']>;
  sustainableConstructionDetails?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workCategories?: InputMaybe<Array<WorkCategoryInput>>;
  yearlyRevenue?: InputMaybe<Scalars['Float']['input']>;
};

export type User = AbstractEntity & {
  __typename: 'User';
  celloToken: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  customDepartmentName: Maybe<Scalars['String']['output']>;
  customSignature: Maybe<Scalars['HTML']['output']>;
  departmentType: Maybe<DEPARTMENT_TYPE>;
  email: Scalars['String']['output'];
  externalApiAccessKey: Scalars['String']['output'];
  externalCompany: Maybe<Scalars['String']['output']>;
  fax: Maybe<Scalars['String']['output']>;
  featureFlags: Scalars['JSONObject']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intercomHash: Scalars['String']['output'];
  invitationLink: Scalars['String']['output'];
  isActiveCompanyOnboarding: Maybe<Scalars['Boolean']['output']>;
  isAwaitingApproval: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isNavatticEnabled: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  language: LANGUAGE;
  lastActivityAt: Maybe<Scalars['DateTimeISO']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  mfaLastResetAt: Maybe<Scalars['DateTimeISO']['output']>;
  mfaMethod: Maybe<MFA_METHOD>;
  mfaPhoneCensored: Maybe<Scalars['String']['output']>;
  notificationConfig: UserNotificationConfig;
  offices: Array<Office>;
  passwordPolicy: Maybe<CompanyPasswordPolicy>;
  permissions: Array<AdminUserPermissionResponse>;
  phone: Maybe<Scalars['String']['output']>;
  role: UserRole;
  ssoEnabled: Scalars['Boolean']['output'];
  status: USER_STATUS;
  type: USER_TYPE;
  workspaces: Array<Workspace>;
};

export type UserApprovalPendingNotification = AbstractEntity &
  Notification & {
    __typename: 'UserApprovalPendingNotification';
    createdAt: Scalars['DateTimeISO']['output'];
    id: Scalars['ID']['output'];
    isRead: Scalars['Boolean']['output'];
    props: UserApprovalPendingNotificationProps;
  };

export type UserApprovalPendingNotificationProps = {
  __typename: 'UserApprovalPendingNotificationProps';
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export enum UserAuthActions {
  approveOrDeleteJoinRequest = 'approveOrDeleteJoinRequest',
  confirmOrDeleteInviteRequest = 'confirmOrDeleteInviteRequest',
  deactivateOrReactivate = 'deactivateOrReactivate',
  delete = 'delete',
  deleteFailedInvite = 'deleteFailedInvite',
  resetMfaConfig = 'resetMfaConfig',
  resetPassword = 'resetPassword',
  update = 'update',
  update__personalInfo = 'update__personalInfo',
  update__typeAndOffices = 'update__typeAndOffices',
  view = 'view',
  view__mfaLastResetAt = 'view__mfaLastResetAt',
  view__mfaMethod = 'view__mfaMethod',
  view__privateData = 'view__privateData',
}

export type UserAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type UserAuthInput = {
  action: UserAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserAuthArgsInput>;
};

export type UserNotificationConfig = AbstractEntity & {
  __typename: 'UserNotificationConfig';
  appAgentSignedContract: Scalars['Boolean']['output'];
  appBidPackageStatusChanged: Scalars['Boolean']['output'];
  appBidRequestDeclined: Scalars['Boolean']['output'];
  appBiddersAwaitingResponse: Scalars['Boolean']['output'];
  appBiddingPeriodEnded: Scalars['Boolean']['output'];
  appBiddingPeriodEnding: Scalars['Boolean']['output'];
  appCertificateExpired: Scalars['Boolean']['output'];
  appCertificateExpiring: Scalars['Boolean']['output'];
  appCertificateNotProvidedInTime: Scalars['Boolean']['output'];
  appCertificateUploadedBySubcontractor: Scalars['Boolean']['output'];
  appContractMultiSigningCompleted: Scalars['Boolean']['output'];
  appNewBid: Scalars['Boolean']['output'];
  appTaskAssigned: Scalars['Boolean']['output'];
  appTaskDone: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  emailAgentSignedContract: Scalars['Boolean']['output'];
  emailBidPackageStatusChanged: Scalars['Boolean']['output'];
  emailBidRequestDeclined: Scalars['Boolean']['output'];
  emailBiddersAwaitingResponse: Scalars['Boolean']['output'];
  emailBiddingPeriodEnded: Scalars['Boolean']['output'];
  emailBiddingPeriodEnding: Scalars['Boolean']['output'];
  emailCertificateExpired: Scalars['Boolean']['output'];
  emailCertificateExpiring: Scalars['Boolean']['output'];
  emailCertificateNotProvidedInTime: Scalars['Boolean']['output'];
  emailCertificateUploadedBySubcontractor: Scalars['Boolean']['output'];
  emailContractMultiSigningCompleted: Scalars['Boolean']['output'];
  emailNewBid: Scalars['Boolean']['output'];
  emailNewMessageFromSubcontractor: Scalars['Boolean']['output'];
  emailSummaryOfRecentMarketplaceSearch: Scalars['Boolean']['output'];
  emailTaskAssigned: Scalars['Boolean']['output'];
  emailTaskDone: Scalars['Boolean']['output'];
  emailTaskInProgress: Scalars['Boolean']['output'];
  emailTaskReminder: Scalars['Boolean']['output'];
  emailUserAddedToBidPackageTeam: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type UserNotificationConfigInput = {
  appAgentSignedContract?: InputMaybe<Scalars['Boolean']['input']>;
  appBidPackageStatusChanged: Scalars['Boolean']['input'];
  appBidRequestDeclined: Scalars['Boolean']['input'];
  appBiddersAwaitingResponse: Scalars['Boolean']['input'];
  appBiddingPeriodEnded: Scalars['Boolean']['input'];
  appBiddingPeriodEnding: Scalars['Boolean']['input'];
  appCertificateExpired: Scalars['Boolean']['input'];
  appCertificateExpiring: Scalars['Boolean']['input'];
  appCertificateNotProvidedInTime: Scalars['Boolean']['input'];
  appCertificateUploadedBySubcontractor: Scalars['Boolean']['input'];
  appContractMultiSigningCompleted: Scalars['Boolean']['input'];
  appNewBid: Scalars['Boolean']['input'];
  appTaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  appTaskDone?: InputMaybe<Scalars['Boolean']['input']>;
  emailAgentSignedContract?: InputMaybe<Scalars['Boolean']['input']>;
  emailBidPackageStatusChanged: Scalars['Boolean']['input'];
  emailBidRequestDeclined: Scalars['Boolean']['input'];
  emailBiddersAwaitingResponse: Scalars['Boolean']['input'];
  emailBiddingPeriodEnded: Scalars['Boolean']['input'];
  emailBiddingPeriodEnding: Scalars['Boolean']['input'];
  emailCertificateExpired: Scalars['Boolean']['input'];
  emailCertificateExpiring: Scalars['Boolean']['input'];
  emailCertificateNotProvidedInTime: Scalars['Boolean']['input'];
  emailCertificateUploadedBySubcontractor: Scalars['Boolean']['input'];
  emailContractMultiSigningCompleted: Scalars['Boolean']['input'];
  emailNewBid: Scalars['Boolean']['input'];
  emailNewMessageFromSubcontractor: Scalars['Boolean']['input'];
  emailSummaryOfRecentMarketplaceSearch?: InputMaybe<Scalars['Boolean']['input']>;
  emailTaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  emailTaskDone?: InputMaybe<Scalars['Boolean']['input']>;
  emailTaskInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  emailTaskReminder?: InputMaybe<Scalars['Boolean']['input']>;
  emailUserAddedToBidPackageTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserRole = CustomUserRole | StandardUserRole;

export type UserRoleInput = {
  customTypeId?: InputMaybe<Scalars['ID']['input']>;
  type: USER_TYPE;
};

export type UserToInviteInput = {
  customUserRoleId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  officeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: USER_TYPE;
};

export type UserWithConnectedUsers = {
  __typename: 'UserWithConnectedUsers';
  connectedUsers: Array<User>;
  user: User;
};

export type UsersResponse = {
  __typename: 'UsersResponse';
  totalRecords: Scalars['Int']['output'];
  users: Array<User>;
};

export enum VALIDATE_PASSWORDLESS_LOGIN_FAILURE_REASON {
  tokenExpired = 'tokenExpired',
}

export type ValidateBidMainOrderNumberResponse = {
  __typename: 'ValidateBidMainOrderNumberResponse';
  isValid: Scalars['Boolean']['output'];
};

export type ValidatePasswordlessLoginFailure = {
  __typename: 'ValidatePasswordlessLoginFailure';
  reason: VALIDATE_PASSWORDLESS_LOGIN_FAILURE_REASON;
};

export type ValidatePasswordlessLoginResponse =
  | CheckCredentialsResponse
  | ValidatePasswordlessLoginFailure;

export enum WORK_CATEGORY_SORT_FIELD {
  name = 'name',
  subcontractorsCount = 'subcontractorsCount',
}

export enum WORK_CATEGORY_TYPE {
  company = 'company',
  network = 'network',
}

export enum WORK_CATEGORY_TYPE_FILTER {
  allAvailable = 'allAvailable',
  company = 'company',
  network = 'network',
  onlyAssigned = 'onlyAssigned',
}

export type WorkCategoriesResponse = {
  __typename: 'WorkCategoriesResponse';
  totalRecords: Scalars['Int']['output'];
  workCategories: Array<WorkCategory>;
};

export type WorkCategory = AbstractEntity & {
  __typename: 'WorkCategory';
  aliasSuggestions: Array<Scalars['String']['output']>;
  aliases: Array<Scalars['String']['output']>;
  baseName: Scalars['String']['output'];
  correspondingNetworkWorkCategories: Array<WorkCategory>;
  createdAt: Scalars['DateTimeISO']['output'];
  group: Maybe<WorkCategoryGroup>;
  id: Scalars['ID']['output'];
  isNew: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  slug: Maybe<Scalars['String']['output']>;
  slugs: Array<Array<Scalars['String']['output']>>;
  translation: WorkCategoryTranslation;
  translations: Array<WorkCategoryTranslation>;
  type: WORK_CATEGORY_TYPE;
};

export type WorkCategoryaliasesArgs = {
  language: LANGUAGE;
};

export type WorkCategorynameArgs = {
  language?: InputMaybe<LANGUAGE>;
};

export type WorkCategoryslugArgs = {
  language?: InputMaybe<LANGUAGE>;
};

export type WorkCategorytranslationArgs = {
  language: LANGUAGE;
};

export enum WorkCategoryAuthActions {
  createNetworkWorkCategory = 'createNetworkWorkCategory',
  deleteNetworkWorkCategory = 'deleteNetworkWorkCategory',
  updateNetworkWorkCategory = 'updateNetworkWorkCategory',
  update__correspondingNetworkWorkCategories = 'update__correspondingNetworkWorkCategories',
  view = 'view',
}

export type WorkCategoryAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type WorkCategoryAuthInput = {
  action: WorkCategoryAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorkCategoryAuthArgsInput>;
};

export type WorkCategoryForSubcontractor = AbstractEntity & {
  __typename: 'WorkCategoryForSubcontractor';
  aliasSuggestions: Array<Scalars['String']['output']>;
  aliases: Array<Scalars['String']['output']>;
  baseName: Scalars['String']['output'];
  correspondingNetworkWorkCategories: Array<WorkCategory>;
  createdAt: Scalars['DateTimeISO']['output'];
  group: Maybe<WorkCategoryGroup>;
  id: Scalars['ID']['output'];
  isNew: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Maybe<Scalars['String']['output']>;
  slugs: Array<Array<Scalars['String']['output']>>;
  translation: WorkCategoryTranslation;
  translations: Array<WorkCategoryTranslation>;
  type: WORK_CATEGORY_TYPE;
};

export type WorkCategoryForSubcontractoraliasesArgs = {
  language: LANGUAGE;
};

export type WorkCategoryForSubcontractornameArgs = {
  language?: InputMaybe<LANGUAGE>;
};

export type WorkCategoryForSubcontractorslugArgs = {
  language?: InputMaybe<LANGUAGE>;
};

export type WorkCategoryForSubcontractortranslationArgs = {
  language: LANGUAGE;
};

export type WorkCategoryGroup = AbstractEntity & {
  __typename: 'WorkCategoryGroup';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  translation: Scalars['String']['output'];
  translations: Array<WorkCategoryGroupTranslation>;
  workCategories: Array<WorkCategory>;
};

export type WorkCategoryGrouptranslationArgs = {
  language?: InputMaybe<LANGUAGE>;
};

export type WorkCategoryGroupInput = {
  name: Scalars['String']['input'];
  translations: Array<WorkCategoryGroupTranslationInput>;
};

export type WorkCategoryGroupTranslation = AbstractEntity & {
  __typename: 'WorkCategoryGroupTranslation';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  language: LANGUAGE;
  name: Scalars['String']['output'];
};

export type WorkCategoryGroupTranslationInput = {
  language: LANGUAGE;
  name: Scalars['String']['input'];
};

export type WorkCategoryIds = {
  ids: Array<Scalars['ID']['input']>;
};

export type WorkCategoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type WorkCategorySuggestion = {
  __typename: 'WorkCategorySuggestion';
  score: Scalars['Float']['output'];
  workCategory: WorkCategory;
};

export type WorkCategorySuggestionsHints = {
  bidRequestId?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkCategoryTranslation = AbstractEntity & {
  __typename: 'WorkCategoryTranslation';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  language: LANGUAGE;
  name: Scalars['String']['output'];
};

export enum WorkCategoryTranslationAuthActions {
  update = 'update',
}

export type WorkCategoryTranslationAuthArgsInput = {
  id: Scalars['ID']['input'];
};

export type WorkCategoryTranslationAuthInput = {
  action: WorkCategoryTranslationAuthActions;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorkCategoryTranslationAuthArgsInput>;
};

export type WorkCategoryTranslationInput = {
  language: LANGUAGE;
  name: Scalars['String']['input'];
};

export type WorkCategoryWithTranslationsListInput = {
  name: Scalars['String']['input'];
  translations: Array<WorkCategoryTranslationInput>;
};

export type Workspace = {
  __typename: 'Workspace';
  company: Company;
  id: Scalars['String']['output'];
  isCurrent: Scalars['Boolean']['output'];
  mfaEnabled: Scalars['Boolean']['output'];
  mfaRequired: Scalars['Boolean']['output'];
  ssoEnabled: Scalars['Boolean']['output'];
};

export type TrackExperimentImpressionMutationVariables = Exact<{
  experimentFlagName: EXPERIMENT_NAME;
}>;

export type TrackExperimentImpressionMutation = {
  __typename: 'Mutation';
  trackExperimentImpression: boolean;
};

export type TrackExperimentMetricMutationVariables = Exact<{
  metricName: Scalars['String']['input'];
}>;

export type TrackExperimentMetricMutation = {
  __typename: 'Mutation';
  trackExperimentMetric: boolean;
};

export const TrackExperimentImpressionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TrackExperimentImpression' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'experimentFlagName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EXPERIMENT_NAME' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trackExperimentImpression' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'experimentFlagName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'experimentFlagName' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrackExperimentImpressionMutation,
  TrackExperimentImpressionMutationVariables
>;
export const TrackExperimentMetricDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TrackExperimentMetric' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'metricName' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trackExperimentMetric' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'metricName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'metricName' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackExperimentMetricMutation, TrackExperimentMetricMutationVariables>;
